/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 3);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(5);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__output_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__output_json__);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var fuzzysort = __webpack_require__(10);
var lunr = __webpack_require__(11);
__webpack_require__(12)(lunr);
__webpack_require__(13)(lunr);
__webpack_require__(14)(lunr);
__webpack_require__(15)(lunr);
__webpack_require__(16)(lunr);
__webpack_require__(17)(lunr);
__webpack_require__(18)(lunr);
__webpack_require__(19)(lunr);
__webpack_require__(20)(lunr);

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    data: function data() {
        return {
            search: '',
            resultsActual: '',
            list: __WEBPACK_IMPORTED_MODULE_0__output_json___default.a,
            resultsCount: 0
        };
    },


    methods: {
        queryResults: function queryResults() {

            if (this.search.trim() === '') {
                return '';
            }
            //   else if(this.search.trim().length < 3){
            //     this.resultsActual = new Array();
            //     this.resultsCount = 0;
            //   }
            else {
                    var documents = this.list;

                    var idx = lunr(function () {
                        this.use(lunr.ja);
                        this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'));
                        this.ref('UUID');
                        this.field('title');
                        this.field('descFull');
                        this.metadataWhitelist = ['position'];

                        documents.forEach(function (doc) {
                            this.add(doc);
                        }, this);
                    });

                    var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
                    // var searchTerms = this.search;
                    searchTerms = this.removeStopWords(searchTerms);
                    var searchRawTerms = searchTerms;
                    // searchTerms  =  searchTerms.split(" ").join(" +");
                    // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

                    console.log(searchTerms);
                    var results = idx.search(searchTerms);

                    console.log(results);

                    results = results.map(function (res) {
                        var linkRes = documents.find(function (elem) {
                            return elem.UUID == res.ref;
                        });
                        var keywords_array = new Array();
                        var keywords_arrays = new Array();
                        var keywords_arrays_title = new Array();

                        Object.keys(res.matchData.metadata).map(function (kys) {
                            var positions_title = res.matchData.metadata[kys].title;
                            var positions_desc = res.matchData.metadata[kys].descFull;

                            if (typeof positions_title !== 'undefined') {
                                positions_title.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays_title.push(val[0], val[1]);
                                });
                            }

                            if (typeof positions_desc !== 'undefined') {
                                positions_desc.position.forEach(function (val, i, arr) {
                                    keywords_array.push(linkRes.descFull.substring(val[0], val[0] + val[1]));
                                    keywords_arrays.push(val[0], val[1]);
                                });
                            }
                        });

                        res.link = linkRes.link;
                        res.desc = linkRes.desc;
                        res.title = linkRes.title;
                        res.full = linkRes.descFull;
                        res.titleArray = keywords_arrays_title;
                        res.descArray = keywords_arrays;
                        keywords_array = keywords_array.filter(function (item, index) {
                            return searchRawTerms.indexOf(item) >= 0;
                        });
                        var keywords_set = new Set(keywords_array);
                        res.keywords = [].concat(_toConsumableArray(keywords_set)).toString();
                        // res.keywords = ["ramon","joe","gudz"]
                        return res;
                    });

                    var existingPagesInResult = new Array();

                    results = results.filter(function (item, index) {

                        if (existingPagesInResult.includes(item.link)) {

                            return false;
                        } else {
                            existingPagesInResult.push(item.link);
                            return true;
                        }

                        if (res.keywords == "") {
                            return false;
                        }
                    });

                    console.log(results);
                    this.resultsActual = results;
                    this.resultsCount = results.length;
                }
        },


        clearResult: function clearResult() {
            this.search = "";
            this.resultsActual = undefined;
            this.resultsCount = 0;
            reload("cover.html", "");
        },

        removeStopWords: function removeStopWords(queryString) {
            var stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"];

            var cleanQueryString = new Array();
            queryString.split(" ").forEach(function (word) {
                if (!stopWords.includes(word)) {
                    cleanQueryString.push(word);
                }
            });

            return cleanQueryString.join(" ");
        }

    }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(7);



new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.10
 * (c) 2014-2019 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Techinically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a speical value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack becaues all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.10';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (parentElm, vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(parentElm, oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(elm, oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes(parentElm, [oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecesarry `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being pased as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anyting as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving the component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function\s*(?:[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stipped = exp.replace(stripStringRE, '');
  var keywordMatch = stipped.match(unaryOperatorsRE);
  if (keywordMatch && stipped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0), __webpack_require__(1).setImmediate))

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0), __webpack_require__(6)))

/***/ }),
/* 6 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(2);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae512af_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(21);
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ae512af_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 8 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 9 */
/***/ (function(module, exports) {

module.exports = [{"UUID":"773c42eb-4d40-46e0-a8c5-f3f769d584be","title":"Oboznámenie sa s tlačiarňou","link":"finding-information-about-printer-topic.html","desc":"Vyhľadávanie informácií o tlačiarni Zdroje a kde","descFull":"Vyhľadávanie informácií o tlačiarni Zdroje a kde ich možno nájsť Čo hľadáte? Kde hľadať Pokyny na prvú inštaláciu Prezrite si dokumentáciu k inštalácii dodanú s tlačiarňou. Softvér tlačiarne Ovládač tlače alebo faxu Firmvér tlačiarne Pomôcka Prejdite na adresu  www.lexmark.com/downloads , vyhľadajte svoj model tlačiarne a potom v ponuke Typ vyberte požadovaný ovládač, firmvér alebo pomôcku. Výber a skladovanie papiera a špeciálnych médií Vkladanie papiera Konfigurácia nastavení tlačiarne Zobrazovanie a tlač dokumentov a fotografií Konfigurácia tlačiarne v rámci siete Starostlivosť o tlačiareň a jej údržba Riešenie a odstraňovanie problémov Informačné centrum – Prejdite na adresu  https://infoserve.lexmark.com . Videá s návodom – Prejdite na adresu  https://infoserve.lexmark.com/idv/ . Informácie pomocníka na používanie softvéru tlačiarne. Pomocník pre operačné systémy Microsoft Windows alebo Macintosh – otvorte program alebo aplikáciu softvéru tlačiarne a kliknite na položku  Pomocník . Kliknutím na tlačidlo   zobrazíte kontextové informácie. Pomocník sa nainštaluje automaticky spolu so softvérom tlačiarne. V závislosti od operačného systému sa softvér tlačiarne nachádza v priečinku programov tlačiarne alebo na pracovnej ploche. Dokumentácia Podpora cez chat naživo E‑mailová podpora Hlasová podpora Prejdite na adresu  https://support.lexmark.com . Vyberte svoju krajinu alebo región a potom aj produkt, pre ktorý chcete zobraziť stránku podpory. Kontaktné informácie podpory pre vašu krajinu alebo región nájdete na webovej lokalite alebo na záručnom liste, ktorý ste dostali s tlačiarňou. Keď kontaktujete podporu pre zákazníkov, vopred si pripravte tieto informácie: Miesto a dátum nákupu Typ zariadenia a sériové číslo Ďalšie informácie nájdete v časti  . Bezpečnostné informácie Regulačné informácie Informácie o záruke Environmentálne informácie Informácie o záruke sa v jednotlivých krajinách alebo regiónoch líšia: V USA  – Pozrite si záručný list (Vyhlásenie o obmedzenej záruke) dodaný s tlačiarňou alebo prejdite na adresu  https://support.lexmark.com . V iných krajinách a regiónoch  – Pozrite si vytlačený záručný list dodaný s tlačiarňou. Príručka s informáciami o produkte  – Pozrite si dokumentáciu dodanú s tlačiarňou alebo prejdite na adresu  https://support.lexmark.com . Informácie o digitálnom pase Lexmark Prejdite na adresu  https://csr.lexmark.com/digital-passport.php . vyhľadanie informácií o tlačiarni"},{"UUID":"d102b9b1-572d-4cd7-9a8b-179c9f08cfe9","title":"Oboznámenie sa s tlačiarňou","link":"finding-printer-serial-number-topic.html","desc":"Vyhľadanie sériového čísla tlačiarne Otvorte","descFull":"Vyhľadanie sériového čísla tlačiarne Otvorte dvierka A. Vyhľadajte sériové číslo. sériové číslo tlačiarne vyhľadanie sériové číslo, tlačiareň vyhľadanie"},{"UUID":"13045ddd-41de-4fd1-83e3-66a6c3601e87","title":"Oboznámenie sa s tlačiarňou","link":"printer-configurations-topic.html","desc":"Konfigurácie tlačiarne Inštalácia jedného alebo","descFull":"Konfigurácie tlačiarne Inštalácia jedného alebo viacerých voliteľných prvkov k tlačiarni alebo multifunkčnej tlačiarni môže vyžadovať základňu na kolieskach, nábytok alebo iné pomôcky, ktoré zabránia nestabilite a následným možným zraneniam. Viac informácií o podporovaných konfiguráciách nájdete na adrese  www.lexmark.com/multifunctionprinters . Inštalácia jedného alebo viacerých voliteľných prvkov k tlačiarni alebo multifunkčnej tlačiarni môže vyžadovať základňu na kolieskach, nábytok alebo iné pomôcky, ktoré zabránia nestabilite a následným možným zraneniam. Ak chcete získať viac informácií o podporovaných konfiguráciách, obráťte sa na miesto, kde ste zakúpili tlačiareň. Ak chcete znížiť riziko nestability zariadenia, do každého zásobníka vkladajte papier samostatne. Všetky ostatné zásobníky nechajte zatvorené dovtedy, kým ich nepotrebujete. Tlačiareň môžete nakonfigurovať pridaním troch voliteľných 250- alebo 550-hárkových zásobníkov. Ďalšie informácie nájdete v časti  . Súčasti tlačiarne 1 Automatický podávač dokumentov (ADF) 2 Zásobník automatického podávača dokumentov 3 Priehradka automatického podávača dokumentov 4 Ovládací panel 5 Štandardná priehradka 6 Viacúčelový podávač 7 Štandardný zásobník na 550 hárkov 8 Voliteľný 250- alebo 550‑hárkový zásobník konfigurácie tlačiarne"},{"UUID":"cf3d8247-088d-4c23-8ba1-935db5377294","title":"Oboznámenie sa s tlačiarňou","link":"using-control-panel-topic.html","desc":"Používanie ovládacieho panela Časti ovládacieho","descFull":"Používanie ovládacieho panela Časti ovládacieho panela a ich funkcie Časť ovládacieho panela Funkcia 1 Tlačidlo napájania Zapnutie alebo vypnutie tlačiarne. Tlačiareň vypnete stlačením a podržaním tlačidla napájania na päť sekúnd. Prepnutie tlačiarne do režimu spánku. Obnova tlačiarne z režimu spánku alebo dlhodobého spánku. 2 Displej Zobrazí správy tlačiarne a stav spotrebného materiálu. Nastavenie a ovládanie tlačiarne. 3 Svetlo indikátora Kontrola stavu tlačiarne. ovládací panel používanie používanie ovládacieho panela"},{"UUID":"547d93ea-99cf-49ac-beb9-c1051f5d1170","title":"Oboznámenie sa s tlačiarňou","link":"understanding-status-of-power-button-and-indicator-light-topic.html","desc":"Vysvetlenie stavu svetla indikátora Farba","descFull":"Vysvetlenie stavu svetla indikátora Farba svetla indikátora a príslušný stav tlačiarne Svetlo indikátora Stav tlačiarne Vypnutá Tlačiareň je vypnutá. Svieti namodro Tlačiareň je pripravená. Bliká namodro Tlačiareň tlačí alebo spracováva údaje. Bliká načerveno Tlačiareň vyžaduje zásah používateľa. Trvalé jantárové Tlačiareň je v režime spánku. Blikajúce jantárové Tlačiareň je v režime hlbokého spánku alebo dlhodobého spánku. svetlo indikátora vysvetlenie stavu stav tlačiarne"},{"UUID":"0ae54008-b9d4-4872-b624-67733663d1e9","title":"Výber papiera","link":"selecting-paper-group.html","desc":"Pokyny na používanie papiera Používaním","descFull":"Pokyny na používanie papiera Používaním vhodného papiera môžete zabrániť zaseknutiam a zaistiť bezproblémovú tlač. Vždy používajte nový, nepoškodený papier. Pred vložením papiera skontrolujte, ktorá strana papiera sa odporúča na potlač. Táto informácia je zvyčajne uvedená na balení papiera. Nepoužívajte papier, ktorý bol ručne odstrihnutý alebo orezaný. Nepoužívajte rôzne veľkosti, typy alebo hmotnosti papiera v jednom zásobníku. Miešaním papiera môže dôjsť k zaseknutiam. Nepoužívajte kriedové papiere, pokiaľ nie sú výslovne určené na elektrofotografickú tlač. Ďalšie informácie nájdete v  Sprievodcovi pre papier a špeciálne médiá . papier výber pokyny na používanie papiera"},{"UUID":"1148acdb-c15f-4969-9bcc-e2c3aab09613","title":"Výber papiera","link":"selecting-paper-group.html","desc":"Vlastnosti papiera Nasledujúce vlastnosti papiera","descFull":"Vlastnosti papiera Nasledujúce vlastnosti papiera ovplyvňujú kvalitu a spoľahlivosť tlače. Pred tlačou zvážte tieto faktory. Hmotnosť Zásobníky môžu podávať papier s rôznou hmotnosťou. Papier ľahší než 60  g/m 2  (16 lb) nemusí byť dostatočne pevný na to, aby sa správne podával, a môže spôsobiť zaseknutie. Ďalšie informácie nájdete v téme „Podporované hmotnosti papiera”. Vlnenie Vlnenie je tendencia papiera vlniť sa po jeho okrajoch. Nadmerné vlnenie môže spôsobovať problémy s podávaním papiera. Vlnenie môže nastať po prechode papiera tlačiarňou, kde je papier vystavený vysokým teplotám. Skladovanie rozbaleného papiera na horúcich, vlhkých, chladných alebo suchých miestach môže prispieť k vlneniu papiera pred samotnou tlačou a spôsobiť problémy s podávaním. Hladkosť Stupeň hladkosti papiera priamo ovplyvňuje kvalitu tlače. Ak je papier príliš drsný, toner sa do papiera nezataví správne. Ak je papier príliš hladký, môže spôsobiť problémy s podávaním papiera alebo kvalitou tlače. Odporúčame použiť papier s hodnotou 50 sheffieldskych bodov. Obsah vlhkosti Množstvo vlhkosti v papieri ovplyvňuje kvalitu tlače aj schopnosť tlačiarne správne podávať papier. Papier vyberte z pôvodného balenia, až keď ho budete chcieť použiť. Vystavenie papiera zmenám vlhkosti môže znížiť jeho kvalitu. Pred tlačou uchovávajte papier v pôvodnom obale po dobu 24 až 48 hodín. Prostredie, v ktorom sa papier ukladá, musí byť rovnaké ako prostredie tlačiarne. Ak sa podmienky uskladnenia alebo podmienky pri preprave papiera veľmi líšia od okolitého prostredia tlačiarne, uvedený čas predĺžte na niekoľko dní. Hrubý papier môže tiež vyžadovať dlhší čas na prispôsobenie sa podmienkam. Smer vlákien Vlákno zodpovedá zarovnaniu vlákien papiera na hárku papiera. Vlákno je buď  dlhé , v smere dĺžky papiera, alebo  krátke , v smere šírky papiera. Odporúčaný smer vlákna nájdete v téme „Podporované hmotnosti papiera“. Zloženie vlákna Väčšina vysokokvalitného xerografického papiera je vyrobená zo 100 % chemicky ošetreného vláknitého dreva. Toto zloženie poskytuje papieru vysoký stupeň stability, výsledkom čoho sú menšie problémy s podávaním papiera a lepšia kvalita tlače. Papier obsahujúci vlákna napr. z bavlny má vlastnosti, ktoré môžu mať negatívny vplyv na manipuláciu s papierom. vlastnosti papiera"},{"UUID":"de04cff0-7892-463e-826e-e27486cdd187","title":"Výber papiera","link":"selecting-paper-group.html","desc":"Neprijateľný papier Použitie nasledujúcich typov","descFull":"Neprijateľný papier Použitie nasledujúcich typov papiera v tlačiarni sa neodporúča: Chemicky ošetrené papiere, ktoré sa používajú na výrobu kópií bez indiga. Sú známe aj ako samoprepisovací papier, bezkarbónový kopírovací papier (CCP) alebo papier bez potreby indiga (NCR). Vopred potlačený papier s chemikáliami, ktoré by mohli kontaminovať tlačiareň. Vopred potlačený papier, na ktorý vplýva teplota fixačnej jednotky tlačiarne. Vopred potlačený papier vyžadujúci registráciu (presnú polohu tlače na stránke) väčšiu než ±2,3 mm (±0,09 palca), napríklad formuláre na optické rozpoznávanie znakov (OCR). Niekedy je možné upraviť registráciu pomocou softvérovej aplikácie tak, aby bola tlač na tieto formuláre možná. Papier s povrchovou úpravou (zmazateľný dokumentový), syntetický papier, termálny papier. Papier s drsnými okrajmi, drsný alebo veľmi štruktúrovaný či pokrčený papier. Papier, ktorý nespĺňa normu EN12281:2002 (Európa). Papier s hmotnosťou menej ako 60g/m 2  (16 libier). Formuláre alebo dokumenty, ktoré sa skladajú z viacerých častí. neprijateľný papier"},{"UUID":"40e3755e-683f-4cb3-8fb1-4df5b1979b3a","title":"Výber papiera","link":"selecting-paper-group.html","desc":"Skladovanie papiera Použite tento postup","descFull":"Skladovanie papiera Použite tento postup skladovania papiera a predíďte tak zaseknutiam a nerovnomernej kvalite tlače: 24 až 48 hodín pred tlačou papier zabalený v pôvodnom obale uskladnite v prostredí s rovnakými podmienkami, akým je vystavená tlačiareň. Ak sa podmienky uskladnenia alebo podmienky pri preprave papiera veľmi líšia od okolitého prostredia tlačiarne, uvedený čas predĺžte na niekoľko dní. Hrubý papier môže tiež vyžadovať dlhší čas na prispôsobenie sa podmienkam. Najlepšie výsledky dosiahnete, ak budete papier skladovať na miestach s teplotou 21 °C (70 °F) a relatívnou vlhkosťou 40 %. Väčšina značkových výrobcov odporúča tlačiť v priestoroch s teplotou v rozmedzí 18 – 24 °C (65 – 75 °F) a s relatívnou vlhkosťou v rozmedzí 40 až 60 %. Papier skladujte v škatuliach na palete alebo polici, nie na zemi. Jednotlivé balíky skladujete na rovnom povrchu. Na jednotlivé balíky papiera nič neodkladajte. Papier vyberajte zo škatule alebo obalu, až keď ho chcete vložiť do tlačiarne. Škatuľa a obal udržiavajú papier čistý, suchý a vyrovnaný. skladovanie papiera"},{"UUID":"6d7e0fed-8747-4c6a-819c-77284968b37f","title":"Výber papiera","link":"selecting-paper-group.html","desc":"Výber predtlačených formulárov a hlavičkového papiera","descFull":"Výber predtlačených formulárov a hlavičkového papiera Používajte papier s dlhým vláknom. Používajte iba formuláre a hlavičkový papier potlačený s použitím ofsetovej tlače alebo gravírovania. Nepoužívajte drsný ani veľmi štruktúrovaný papier. Používajte atramenty, na ktoré nemá vplyv živica v toneri. Tieto požiadavky spĺňajú atramenty schnúce pomocou oxidácie a atramenty založené na báze ropy. Latexové atramenty ich nespĺňajú. Než zakúpite veľké množstvo predtlačených formulárov a hlavičkového papiera, ktoré zvažujete, skúste najskôr vytlačiť niekoľko vzoriek. Takto zistíte, či atrament použitý na predtlačenom formulári alebo hlavičkovom papieri ovplyvňuje kvalitu tlače. V prípade pochybností kontaktujte dodávateľa papiera. Pri tlači na hlavičkový papier vložte papier v správnej orientácii pre tlačiareň. Ďalšie informácie nájdete v  Sprievodcovi pre papier a špeciálne médiá . Pri tlači na hlavičkový papier vložte papier v správnej orientácii pre tlačiareň. papier predtlačené formuláre predtlačené formuláre výber papier hlavičkový papier hlavičkový papier výber"},{"UUID":"4a3829fd-326d-4a71-b4c3-3008a4525e14","title":"Výber papiera","link":"selecting-paper-group.html","desc":"Podporované veľkosti papiera Podporované veľkosti","descFull":"Podporované veľkosti papiera Podporované veľkosti papiera Veľkosť papiera Štandardný zásobník na 550 hárkov Voliteľný 250- alebo 550‑hárkový zásobník Viacúčelový podávač Obojstranná tlač Skenovacie sklo Automatický podávač dokumentov 1  Podpora podávania papiera krátkym okrajom je predvolená. 2  Keď sa vyberie možnosť Univerzálne, nastaví sa formát strany 215,90 x 355,60 mm (8,5 x 14 palcov), pokiaľ veľkosť neurčuje aplikácia. 3  Pri obojstrannej tlači musí mať papier šírku najmenej 210 mm (8,27 palca) a dĺžku 279,4 mm (11 palcov). A4 210 x 297 mm (8,27 x 11,7 palca) A5 na výšku (SEF) 148 x 210 mm (5,83 x 8,27 palca) X A5 na šírku (LEF) 1 210 x 148 mm (8,27 x 5,83 palca) X X A6 105 x 148 mm (4,13 x 5,83 palca) X X JIS B5 182 x 257 mm (7,17 x 10,1 palcov) X Oficio (Mexiko) 216 x 340 mm (8,5 x 13,4 palcov) Hagaki 100 x 148 mm (3,93 x 5,83 palcov) X X X X Statement 139,7 x 215,9 mm (5,5 x 8,5 palcov) X Executive 184,2 x 266,7 mm (7,25 x 10,5 palcov) X Letter 215,9 x 279,4 mm (8,5 x 11 palcov) Legal 215,9 x 355,6 mm (8,5 x 14 palcov) Folio 215,9 x 330,2 mm (8,5 x 13 palcov) Univerzálne 2 105 x 148 mm až 215,9 x 359,92 mm (4,13 x 5,83 palca) až 8,5 x 14,17 palca) X 3 X Univerzálne 2 76,2 x 127 mm až 215,9 x 359,92 mm (3 x 5,83 palca až 8,5 x 14,17 palca) X X X X X Univerzálne 2 25,4 x 25,4 mm až 215,9 x 355,6 mm (1 x 1 palca až 8,5 x 14 palcov) X X X X X Obálka 7 3/4 98,4 x 190,5 mm (3,875 x 7,5 palcov) X X X X Obálka 9 98,4 x 225,4 mm (3,875 x 8,9 palcov) X X X X Obálka 10 104,8 x 241,3 mm (4,12 x 9,5 palcov) X X X X Obálka DL 110 x 220 mm (4,33 x 8,66 palcov) X X X X Obálka C5 162 x 229 mm (6,38 x 9,01 palcov) X X X X Obálka B5 176 x 250 mm (6,93 x 9,84 palcov) X X X X Iná obálka 76,2 x 127 mm až 215,9 x 359,92 mm (3 x 5,83 palca až 8,5 x 14,17 palca) X X X X podporované veľkosti papiera veľkosti papiera, podporované"},{"UUID":"b3c7fd56-167a-4e29-a4d1-f092528aca2e","title":"Výber papiera","link":"selecting-paper-group.html","desc":"Podporované typy papiera Podporované typy","descFull":"Podporované typy papiera Podporované typy papiera Typ papiera Štandardný zásobník na 550 hárkov Voliteľný 250- alebo 550‑hárkový zásobník Viacúčelový podávač Obojstranná tlač Automatický podávač dokumentov * Jednostranné papierové štítky sú podporované na príležitostné používanie menej ako 20 strán za mesiac. Vinylové, farmaceutické a obojstranné štítky nie sú podporované. Obyčajný papier Kartón X X X X Recyklovaný papier Papierové štítky * X X Kancelársky papier Hlavičkový papier Predtlačený papier Farebný papier Ľahký papier Ťažký papier Pevný/bavlnený Obálka X X X X Pevná obálka X X X X podporované typy papiera druhy papiera, podporované"},{"UUID":"b86d1b4c-81f8-4d0d-b56d-e1be39576762","title":"Výber papiera","link":"selecting-paper-group.html","desc":"Podporované hmotnosti papiera Podporované hmotnosti","descFull":"Podporované hmotnosti papiera Podporované hmotnosti papiera Podporované hmotnosti papiera Štandardný zásobník na 550 hárkov Voliteľný 250- alebo 550‑hárkový zásobník Viacúčelový podávač Obojstranná tlač* Automatický podávač dokumentov * Nepodporuje kartón, štítky ani obálky. 60 – 120 g/m 2 (16–32 lb kancelársky) 60 – 120 g/m 2 (16–32 lb kancelársky) 60 – 216 g/m 2 (16–58 lb kancelársky) 60 – 120 g/m 2 (16–32 lb kancelársky) 52 – 120 g/m 2 (14–32 lb kancelársky) podporované hmotnosti papiera hmotnosti papiera, podporované"},{"UUID":"c5d99742-0406-4877-87ad-5ca564b20bac","title":"Príprava na používanie, inštalácia a konfigurácia","link":"selecting-location-printer-topic.html","desc":"Výber miesta pre tlačiareň Ponechajte","descFull":"Výber miesta pre tlačiareň Ponechajte dostatok miesta na otvorenie zásobníkov, krytov a dvierok a na inštaláciu voliteľného hardvéru. Tlačiareň umiestnite blízko elektrickej zásuvky. Riziku požiaru alebo zásahu elektrickým prúdom sa vyhnete tak, že zapojíte napájací kábel do riadne označenej a správne uzemnenej elektrickej zásuvky, ktorá sa nachádza blízko produktu a je ľahko dostupná. Produkt neumiestňujte blízko vody ani vlhkých oblastí, aby ste predišli riziku zasiahnutia elektrickým prúdom. Uistite sa, že prúdenie vzduchu v miestnosti zodpovedá poslednej úprave normy ASHRAE 62 alebo norme technickej komisie CEN 156. Zabezpečte rovný, pevný a stabilný povrch. Tlačiareň by mala byť: čistá, suchá a bez prachu, mimo oblasti s voľnými spinkami a sponkami na papier, mimo priameho prúdenia vzduchu klimatizácie, ohrievačov alebo ventilátorov, mimo priameho slnečného svetla a priveľkej vlhkosti. Dodržujte odporúčané teploty a zabráňte veľkým zmenám: Odporúčané teploty Teplota okolia Teplota skladovania Okolo tlačiarne ponechajte nasledujúci odporúčaný priestor, aby vzduch mohol správne prúdiť: Odporúčaný priestor okolo tlačiarne 1 Horná strana 2 Zadná strana 3 Pravá strana 4 Predná strana 5 Ľavá strana tlačiareň výber miesta pre výber miesta pre tlačiareň tlačiareň minimálny voľný priestor premiestnenie tlačiarne"},{"UUID":"06541f3c-10f3-4da0-bc78-801d77db798e","title":"Príprava na používanie, inštalácia a konfigurácia","link":"attaching-cables-topic.html","desc":"Pripájanie káblov Toto zariadenie nenastavujte","descFull":"Pripájanie káblov Toto zariadenie nenastavujte ani nevytvárajte žiadne elektrické či káblové pripojenie (napríklad sieťové napájanie, funkcia faxu alebo telefón) počas búrky, aby ste sa vyhli riziku zasiahnutia elektrickým prúdom. Riziku požiaru alebo zásahu elektrickým prúdom sa vyhnete tak, že zapojíte napájací kábel do riadne označenej a správne uzemnenej elektrickej zásuvky, ktorá sa nachádza blízko produktu a je ľahko dostupná. Riziku požiaru a zásahu elektrickým prúdom sa vyhnete tak, že budete používať len napájací kábel dodaný s týmto produktom alebo náhradu schválenú výrobcom. Ak chcete predísť vzniku požiaru, pripájajte zariadenie k verejnej telefónnej sieti výlučne prostredníctvom kábla 26 AWG alebo väčšieho telekomunikačného kábla (RJ-11). Pre používateľov v Austrálii: kábel musí schváliť austrálsky štátny orgán pre komunikáciu a médiá. Ak chcete predísť strate údajov alebo zlyhaniu tlačiarne, nedotýkajte sa počas prebiehajúcej tlače kábla USB, žiadneho adaptéra bezdrôtovej siete ani tlačiarne v zobrazenej oblasti. Porty tlačiarne a ich funkcie Port tlačiarne Funkcia 1 Zásuvka napájania Pripojenie tlačiarne k správne uzemnenej elektrickej zásuvke. 2 Ethernetový port Pripojenie tlačiarne k sieti. 3 Port USB Pripojte klávesnicu alebo iný kompatibilný voliteľný prvok. 4 Port tlačiarne USB Pripojenie tlačiarne k počítaču. 5 port EXT Pripojenie ďalších zariadení (napríklad telefónu alebo záznamníka) k tlačiarni a telefónnej linke. Tento port používajte v prípade, ak pre tlačiareň nemáte samostatnú faxovú linku a ak je tento spôsob pripojenia podporovaný vo vašej krajine alebo regióne. 6 Port LINE Pripojenie tlačiarne k aktívnej telefónnej linke prostredníctvom štandardnej sieťovej zásuvky (RJ‑11), filtra DSL, adaptéra VoIP alebo akéhokoľvek iného adaptéra, ktorý vám umožní prístup k telefónnej linke na odosielanie a prijímanie faxov. pripojenie káblov Port tlačiarne USB Ethernetový port Port LINE port EXT zásuvka na napájací kábel"},{"UUID":"3af75ced-871a-42f3-8d00-0192abda2e71","title":"Nastavenie a používanie aplikácií na domovskej obrazovke","link":"using-home-screen-topic.html","desc":"Používanie domovskej obrazovky Vaša domovská","descFull":"Používanie domovskej obrazovky Vaša domovská obrazovka môže byť iná v závislosti od nastavení prispôsobenia obrazovky, administratívneho nastavenia a aktívnych integrovaných riešení. Ikony domovskej obrazovky a ich funkcie # Ikona Funkcia 1 Tlačidlo Stop alebo Zrušiť Zastavenie aktuálnej úlohy. 2 Kopírovanie Vytvorí kópie. 3 Zmeniť jazyk Zmena jazyka na displeji tlačiarne. 4 E‑mail Odoslanie e-mailov. 5 Nastavenia Prístup k ponukám tlačiarne. 6 Fax Odoslanie faxu. 7 Adresár Zobrazenie, vytváranie a riadenie kontaktov. 8 Stav/spotrebný materiál Výstraha tlačiarne alebo chybové hlásenie sa zobrazí vždy, keď tlačiareň vyžaduje zásah používateľa, aby mohla ďalej pracovať. Pozrite si ďalšie informácie o výstrahách alebo hláseniach tlačiarne a o tom, ako ich odstrániť. K tomuto nastaveniu sa dostanete aj vtedy, keď sa dotknete hornej časti domovskej obrazovky. 9 Pozastavené úlohy Zobrazí všetky zadržané tlačové úlohy. 10 Poradie úloh Zobrazí všetky aktuálne tlačové úlohy. K tomuto nastaveniu sa dostanete aj vtedy, keď sa dotknete hornej časti domovskej obrazovky. 11 Jednotka USB Zobrazujte, vyberajte alebo tlačte fotografie a dokumenty z pamäťovej jednotky flash. 12 Profily skenovania Skenujte a ukladajte dokumenty priamo do počítača. 13 FTP Skenujte a ukladajte dokumenty priamo na server FTP. 14 Záložky Organizujte všetky záložky. 15 Pevný disk Zobrazte, vyberte a spravujte dokumenty z pevného disku alebo disku s inteligentným ukladaním. 16 Sieťový priečinok Skenovanie do sieťového priečinka alebo sieťového umiestnenia. 17 Tlačidlo spustenia Spustenie úlohy v závislosti od vybratého režimu. 18 Klávesnica na obrazovke Zadávanie čísel a symbolov do vstupného poľa. používanie domovskej obrazovky domovská obrazovka používanie"},{"UUID":"f08cc959-0b56-412a-8b20-be2da9846d07","title":"Nastavenie a používanie aplikácií na domovskej obrazovke","link":"using-home-screen-topic.html","desc":"Prispôsobenie domovskej obrazovky Otvorte webový","descFull":"Prispôsobenie domovskej obrazovky Otvorte webový prehliadač a do poľa adresy zadajte adresu IP tlačiarne. Pozrite si adresu IP tlačiarne na domovskej obrazovke tlačiarne. IP Adresa sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Ak používate server proxy, dočasne ho vypnite, aby sa webová stránka správne načítala. Kliknite na položky  Nastavenia Zariadenie Prispôsobenie domovskej obrazovky . Vykonajte jeden alebo niekoľko nasledujúcich postupov: Ak chcete pridať ikonu na domovskú obrazovku, kliknite na položku  , vyberte názov aplikácie a potom kliknite na položku  Pridať . Ak chcete odstrániť ikonu domovskej obrazovky, vyberte názov aplikácie a potom kliknite na položku  Odstrániť . Ak chcete prispôsobiť názov aplikácie, vyberte názov aplikácie, kliknite na položku  Upraviť  a potom priraďte názov. Ak chcete obnoviť názov aplikácie, vyberte názov aplikácie, kliknite na položku  Upraviť  a potom vyberte položku  Obnoviť štítok aplikácie . Ak chcete pridať priestor medzi aplikáciami, kliknite na položku  , vyberte položku  PRÁZDNE MIESTO  a potom kliknite na položku  Pridať . Ak chcete usporiadať aplikácie, potiahnite myšou ich názvy do želané poradia. Ak chcete obnoviť predvolenú domovskú obrazovku, kliknite na položku  Obnoviť domovskú obrazovku . Použite zmeny. ikony domovskej obrazovky zobrazenie ikony na domovskej obrazovke zobrazovanie domovská obrazovka prispôsobenie zobrazenie aplikácií na domovskej obrazovke pridávanie aplikácií na domovskú obrazovku"},{"UUID":"29c0a5e4-b3b9-443f-a3ef-67f4387f15b4","title":"Nastavenie a používanie aplikácií na domovskej obrazovke","link":"using-home-screen-topic.html","desc":"Podporované aplikácie Aplikácie a nimi podporované","descFull":"Podporované aplikácie Aplikácie a nimi podporované modely tlačiarní Aplikácia Modely tlačiarní Centrum skenovania MX532, MX632, XM3350 Centrum skratiek MX532, MX632, XM3350 Kopírovanie preukazov MX532, MX632, XM3350 Prispôsobenie displeja MX532, MX632, XM3350 Podpora pre zákazníkov XM3350 Kvóty zariadení XM3350 podporované aplikácie aplikácie tlačiarne"},{"UUID":"2513b810-0ada-4699-a5a4-819b0ddde541","title":"Nastavenie a používanie aplikácií na domovskej obrazovke","link":"using-home-screen-topic.html","desc":"Nastavenie Scan Centra Na domovskej","descFull":"Nastavenie Scan Centra Na domovskej obrazovke sa dotknite položky  Scan Centrum . Vyberte a vytvorte cieľové miesto a potom nakonfigurujte nastavenia. Pri vytváraní sieťového cieľového miesta zaistite overenie a úpravu nastavení tak, aby sa nevyskytovali žiadne chyby. Uložia sa iba miesta vytvorené na vloženom webovom serveri. Ďalšie informácie nájdete v dokumentácii dodanej s riešením. Uložte zmeny. Scan Centrum nastavenie"},{"UUID":"0ad5298b-15e1-406b-a59f-870f2600868e","title":"Nastavenie a používanie aplikácií na domovskej obrazovke","link":"using-home-screen-topic.html","desc":"Vytvorenie odkazu Na domovskej obrazovke","descFull":"Vytvorenie odkazu Na domovskej obrazovke sa dotknite položky  Centrum skratiek . Ikona a názov môžu byť zmenené. Ďalšie informácie získate od svojho správcu. Vyberte funkciu tlačiarne a potom sa dotknite položky  Vytvoriť skratku . Funkcia Zabezpečený e-mail nie je podporovaná. Nakonfigurujte nastavenia a potom sa dotknite položky  Uložiť . Zadajte jedinečný názov skratky. Ak chcete zabrániť skráteniu názvov na domovskej obrazovke, zadajte najviac 25 znakov. Dotknite sa položky  OK . Aplikácia automaticky vygeneruje jedinečné číslo skratky. Ak chcete spustiť odkaz, dotknite sa položky  , potom položky  #  a zadajte číslo odkazu. vytváranie skratiek skratky vytvorenie skratka Kopírovanie skratka E-mail skratka Fax skratka FTP"},{"UUID":"a9cfbee6-ad45-4057-981c-6e8ff43670dd","title":"Nastavenie a používanie aplikácií na domovskej obrazovke","link":"using-home-screen-topic.html","desc":"Nastavenie kopírovania preukazov Otvorte webový","descFull":"Nastavenie kopírovania preukazov Otvorte webový prehliadač a do poľa adresy zadajte adresu IP tlačiarne. Pozrite si adresu IP tlačiarne na domovskej obrazovke tlačiarne. IP Adresa sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Ak používate server proxy, dočasne ho vypnite, aby sa webová stránka správne načítala. Kliknite na položky  Aplikácie Kopírovanie preukazov Konfigurovať . Uistite sa, že položka  Zobraziť ikonu  je povolená. Skontrolujte, či sú nakonfigurované časti  Nastavenia e-mailov  a  Nastavenia zdieľaného sieťového priečinka . Pri skenovaní preukazu sa uistite, že rozlíšenie skenovania nie je vyššie ako 200 dpi pri farebnom a 400 dpi pri čiernobielom skenovaní. Pri skenovaní viacerých preukazov sa uistite, že rozlíšenie skenovania nie je vyššie ako 150 dpi pri farebnom a 300 dpi pri čiernobielom skenovaní. Použite zmeny. Na skenovanie viacerých preukazov treba pevný disk tlačiarne alebo disk s inteligentným ukladaním. Kopírovanie preukazov nastavenie"},{"UUID":"7e206134-d5c6-41ea-a8e0-8c308bdce800","title":"Nastavenie a používanie aplikácií na domovskej obrazovke","link":"using-home-screen-topic.html","desc":"Používanie funkcie Prispôsobenie displeja Pred","descFull":"Používanie funkcie Prispôsobenie displeja Pred použitím aplikácie nezabudnite zapnúť a nakonfigurovať nastavenia šetriča obrazovky, prezentácie a tapety z nástroja Embedded Web Server. Správa obrázkov šetriča obrazovky a prezentácie V nástroji Embedded Web Server kliknite na možnosti  Aplikácie Prispôsobenie displeja Konfigurácia . V časti Obrázky šetriča obrazovky a prezentácie pridajte, upravte alebo odstráňte obrázok. Môžete pridať až 10 obrázkov. Ak je táto funkcia aktivovaná, ikony stavu sa zobrazia na šetriči obrazovky len v prípade chýb, upozornení alebo oznámení z cloudu. Použite zmeny. Zmena obrázka tapety Na domovskej obrazovke klepnite na položku  Zmeniť tapetu . Zvoľte obrázok, ktorý chcete použiť. Použite zmeny. Spustenie prezentácie z jednotky flash Vložte jednotku flash do predného portu USB. Na domovskej obrazovke sa dotknite tlačidla  Prezentácia . Po spustení prezentácie môžete odpojiť jednotku flash, ale obrázky sa neuložia do tlačiarne. Ak sa prezentácia zastaví, na zobrazenie obrázkov znova vložte jednotku flash. Prispôsobenie displeja používanie používanie funkcie Prispôsobenie displeja prispôsobenie displeja zmena tapety spustenie prezentácie správa šetriča obrazovky"},{"UUID":"4ea2dc7b-c1bb-4dbc-9fd5-0199202d8333","title":"Nastavenie a používanie aplikácií na domovskej obrazovke","link":"using-home-screen-topic.html","desc":"Používanie aplikácie Podpora pre zákazníkov","descFull":"Používanie aplikácie Podpora pre zákazníkov Túto aplikáciu podporujú len niektoré modely tlačiarne. Ďalšie informácie nájdete v časti  . Túto aplikáciu podporujú len niektoré modely tlačiarne. Informácie o konfigurácii nastavení aplikácie nájdete v  Príručke správcu Podpory pre zákazníkov. Na domovskej obrazovke sa dotknite položky  Podpora pre zákazníkov . Informáciu vytlačte alebo ju pošlite e-mailom. Podpora pre zákazníkov používanie používanie  Podpora pre zákazníkov"},{"UUID":"e66f745b-951b-48a3-9ee0-90357ef09530","title":"Nastavenie a používanie aplikácií na domovskej obrazovke","link":"using-home-screen-topic.html","desc":"Nastavenie kvót zariadenia Túto aplikáciu","descFull":"Nastavenie kvót zariadenia Túto aplikáciu podporujú len niektoré modely tlačiarne. Ďalšie informácie nájdete v časti  . Túto aplikáciu podporujú len niektoré modely tlačiarne. Informácie o tom, ako konfigurovať nastavenia aplikácie, nájdete v dokumente  Príručka správcu kvót zariadenia . Otvorte webový prehliadač a do poľa adresy zadajte adresu IP tlačiarne. Pozrite si adresu IP tlačiarne na domovskej obrazovke tlačiarne. IP Adresa sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Ak používate server proxy, dočasne ho vypnite, aby sa webová stránka správne načítala. Kliknite na položky  Aplikácie Kvóty zariadenia Konfigurovať . V časti  Používateľské účty  môžete pridať alebo upraviť používateľa a potom nastaviť jeho kvótu. Použite zmeny. nastavenie  kvót zariadenia Kvóty zariadení nastavenie"},{"UUID":"dabc6997-81a1-433e-a66b-22cd1a96c0df","title":"Správa záložiek","link":"using-home-screen-topic.html","desc":"Vytváranie záložiek Záložky používajte pri","descFull":"Vytváranie záložiek Záložky používajte pri tlači dokumentov, ku ktorým často pristupujete, uložených na serveroch alebo na webe. Otvorte webový prehliadač a do poľa adresy zadajte adresu IP tlačiarne. Pozrite si adresu IP tlačiarne na domovskej obrazovke tlačiarne. IP Adresa sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Ak používate server proxy, dočasne ho vypnite, aby sa správne načítala webová stránka. Kliknite na položku  Záložky Pridať záložku  a potom zadajte názov záložky. Vyberte typ protokolu adresy a potom vykonajte jeden z týchto krokov: Pre HTTP a HTTPS: zadajte prepojenie URL, pre ktoré chcete vytvoriť záložku. Pre HTTPS: dbajte na to, aby ste namiesto IP adresy použili názov hostiteľa. Zadajte napríklad  myWebsite.com/sample.pdf , nie  123.﻿123.123.123/sample.pdf . Skontrolujte tiež, že názov hostiteľa sa zhoduje s hodnotou bežného názvu (CN) v serverovom certifikáte. Ďalšie informácie o tom, ako zistiť hodnotu CN v serverom certifikáte, nájdete v pomocníkovi webového prehľadávača. Pre FTP: zadajte adresu FTP. Napríklad  myServer/myDirectory . Zadajte port FTP. Predvoleným portom na odosielanie príkazov je port 21. V prípade protokolu SMB zadajte adresu sieťového priečinka. Napríklad  myServer/myShare/myFile.pdf . Zadajte názov sieťovej domény. V prípade potreby vyberte typ overenia pre FTP a SMB. Ak chcete obmedziť prístup k záložke, zadajte PIN. Aplikácia podporuje nasledujúce typy súborov: PDF, JPEG, TIFF a webové stránky HTML. Ostatné typy súborov, napr. DOCX a XLXS, podporujú len niektoré modely tlačiarne. Kliknite na možnosť  Uložiť . záložky vytvorenie vytváranie záložiek"},{"UUID":"55109407-def5-4cbe-80c5-1d3b8b0065d2","title":"Správa záložiek","link":"using-home-screen-topic.html","desc":"Vytváranie priečinkov Otvorte webový prehliadač","descFull":"Vytváranie priečinkov Otvorte webový prehliadač a do poľa adresy zadajte adresu IP tlačiarne. Pozrite si adresu IP tlačiarne na domovskej obrazovke tlačiarne. IP Adresa sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Ak používate server proxy, dočasne ho vypnite, aby sa správne načítala webová stránka. Kliknite na položku  Záložky Pridať priečinok  a potom zadajte názov priečinka. Ak chcete obmedziť prístup k priečinku, zadajte PIN. Kliknite na možnosť  Uložiť . V priečinku môžete vytvoriť ďalšie priečinky alebo záložky. Ak chcete vytvoriť záložku, pozrite si časť  . záložky vytváranie priečinkov na vytváranie priečinkov na záložky"},{"UUID":"7dc8af6a-f9bb-4644-8552-54cbb3b085c8","title":"Nastavenie a používanie aplikácií na domovskej obrazovke","link":"using-home-screen-topic.html","desc":"Adresár Správa kontaktov Na domovskej","descFull":"Adresár Správa kontaktov Na domovskej obrazovke sa dotknite položky  Adresár . Vykonajte jeden alebo niekoľko nasledujúcich postupov: Ak chcete pridať kontakt, dotknite sa položky   v hornej časti obrazovky a potom sa dotknite položky  Vytvoriť kontakt . V prípade potreby špecifikujte spôsob prihlasovania, čím umožníte prístup aplikácii. Ak chcete odstrániť kontakt, dotknite sa položky   v hornej časti obrazovky, potom položky  Odstrániť kontakty  a vyberte kontakt. Ak chcete upraviť kontaktné údaje, dotknite sa mena kontaktu. Ak chcete vytvoriť skupinu, dotknite sa položky   v hornej časti obrazovky a potom sa dotknite položky  Vytvoriť skupinu . V prípade potreby špecifikujte spôsob prihlasovania, čím umožníte prístup aplikácii. Ak chcete odstrániť skupinu, dotknite sa položky   v hornej časti obrazovky, potom položky  Odstrániť skupiny  a potom vyberte skupinu. Ak chcete upraviť skupinu kontaktov, dotknite sa položky  SKUPINY  vyberte názov skupiny  vyberte akciu, ktorú chcete vykonať. Použite zmeny. pridávanie kontaktov odstránenie kontaktov pridanie skupín kontaktov odstránenie skupín kontaktov úprava kontaktov Adresár používanie"},{"UUID":"bc5c42c2-bf71-4d11-8c9e-5dc29fca3fcd","title":"Nastavenie a používanie funkcií zjednodušenia ovládania","link":"activating-voice-guidance-topic.html","desc":"Aktivácia hlasových pokynov na domovskej","descFull":"Aktivácia hlasových pokynov na domovskej obrazovke, Jedným pohybom pomaly posuňte jeden prst po displeji doľava a potom nahor, až kým sa neprehrá hlasová správa. V prípade modelov tlačiarní bez zabudovaných reproduktorov si môžete správu vypočuť pomocou slúchadiel. Dvoma prstami sa dotknite tlačidla  OK . Ak toto gesto nefunguje, vyviňte väčší tlak. Pomocou klávesnice Stlačte a podržte stlačený kláves  5 , kým sa neprehrá hlasová správa. V prípade modelov tlačiarní bez zabudovaných reproduktorov si môžete správu vypočuť pomocou slúchadiel. Stlačte kláves  Tab , aby sa kurzor presunul na tlačidlo OK, a potom stlačte  Enter . Keď sú hlasové pokyny aktivované, vždy použite dva prsty na výber ktorejkoľvek položky na displeji. Hlasové pokyny majú obmedzenú jazykovú podporu. Hlasové pokyny aktivácia aktivácia hlasových pokynov"},{"UUID":"8270b2c1-1690-4984-820b-849cf74b25e5","title":"Nastavenie a používanie funkcií zjednodušenia ovládania","link":"activating-voice-guidance-topic.html","desc":"Deaktivácia hlasových pokynov Jedným pohybom","descFull":"Deaktivácia hlasových pokynov Jedným pohybom pomaly posuňte jeden prst po displeji doľava a potom nahor, až kým sa neprehrá hlasová správa. V prípade modelov tlačiarní bez zabudovaných reproduktorov si môžete správu vypočuť pomocou slúchadiel. Pomocou dvoch prstov vykonajte jeden z týchto krokov: Dotknite sa položky  Hlasové pokyny  a potom sa dotknite položky  OK . Dotknite sa položky  Zrušiť . Ak toto gesto nefunguje, vyviňte väčší tlak. Hlasové navádzanie môžete deaktivovať aj jedným z týchto spôsobov: Dvoma prstami dvakrát ťuknite na domovskú obrazovku. Stlačením tlačidla napájania uveďte tlačiareň do režimu spánku alebo dlhodobého spánku. Hlasové pokyny deaktivácia Deaktivácia hlasových pokynov"},{"UUID":"8de85477-b9cb-4a3a-ab3d-061ca3d0ff4f","title":"Nastavenie a používanie funkcií zjednodušenia ovládania","link":"activating-voice-guidance-topic.html","desc":"Navigácia na obrazovke pomocou gest","descFull":"Navigácia na obrazovke pomocou gest Väčšina gest sa používa, len keď sú aktivované hlasové pokyny. Povoľte zväčšenie, aby ste mohli využívať gestá na priblíženie (oddialenie) a posunutie. Pomocou fyzickej klávesnice môžete zadávať znaky a upraviť niektoré nastavenia. Gestá a ich funkcie Gesto Funkcia Potiahnite prstom doľava a potom nahor Spustite režim zjednodušenia ovládania. Na opustenie režimu zjednodušenia ovládania použite rovnaké gesto. Toto gesto je použiteľné aj v prípade, že je tlačiareň v normálnom režime. Dvakrát ťuknite jedným prstom Výber možnosti alebo položky na obrazovke. Dvakrát‑ťuknite na domovskú ikonu dvoma prstami Deaktivujte režim zjednodušenia ovládania. Trikrát ťuknite jedným prstom Priblíženie alebo oddialenie textu alebo obrázkov. Potiahnite prstom doprava alebo nadol Posun na ďalšiu položku na obrazovke. Potiahnite prstom doľava alebo nahor Posun na predchádzajúcu položku na obrazovke. Potiahnite prstom nahor a potom nadol Posun na prvú položku na obrazovke. Posunutie Získanie prístupu k častiam približovaného obrázka, ktoré sú za hranicou obrazovky. Pomocou dvoch prstov potiahnite zväčšený obrázok. Potiahnite prstom nahor a potom doprava Zvýšenie hlasitosti. Toto gesto je použiteľné aj v prípade, že je tlačiareň v normálnom režime. Potiahnite prstom nadol a potom doprava Zníženie hlasitosti. Toto gesto je použiteľné aj v prípade, že je tlačiareň v normálnom režime. Potiahnite prstom nahor a potom doľava Ukončenie aplikácie a návrat na domovskú obrazovku. Potiahnite prstom nadol a potom doľava Návrat na predchádzajúce nastavenie. navigácia na obrazovke pomocou gest navigácia na obrazovke pomocou gest"},{"UUID":"c38f2bf6-c3d5-4b2d-a807-593ff3891d21","title":"Nastavenie a používanie funkcií zjednodušenia ovládania","link":"activating-voice-guidance-topic.html","desc":"Používanie klávesnice na obrazovke Keď","descFull":"Používanie klávesnice na obrazovke Keď sa zobrazí klávesnica na obrazovke, vyskúšajte jedno alebo viaceré z nasledujúcich riešení: Dotknite sa klávesu, aby ste oznámili a napísali znak do poľa. Potiahnutím prsta po rôznych znakoch oznamujete a píšte znaky do poľa. Dotknite sa dvoma prstami textového poľa, aby ste oznámili znaky v poli. Dotykom klávesu  Backspace  môžete znaky vymazať. klávesnica na obrazovke používanie"},{"UUID":"790b1123-0d9a-41bd-8144-e8723629086e","title":"Nastavenie a používanie funkcií zjednodušenia ovládania","link":"activating-voice-guidance-topic.html","desc":"Zapnutie režimu zväčšenia Jedným pohybom","descFull":"Zapnutie režimu zväčšenia Jedným pohybom pomaly posuňte jeden prst po displeji doľava a potom nahor, až kým sa neprehrá hlasová správa. V prípade modelov tlačiarní bez zabudovaných reproduktorov si môžete správu vypočuť pomocou slúchadiel. Pomocou dvoch prstov vykonajte nasledujúce kroky: Dotknite sa  Režimu zväčšenia . Dotknite sa položky  OK . Ak toto gesto nefunguje, vyviňte väčší tlak. Ďalšie informácie o používaní zväčšenej obrazovky nájdete v časti  . režim zväčšenia povolenie zapnutie režimu zväčšenia"},{"UUID":"2edc2f15-21a4-4f7e-ae8d-6785d26487b5","title":"Nastavenie a používanie funkcií zjednodušenia ovládania","link":"activating-voice-guidance-topic.html","desc":"Úprava rýchlosti reči hlasových pokynov","descFull":"Úprava rýchlosti reči hlasových pokynov Na domovskej obrazovke sa dotknite položiek  Nastavenia Zariadenie Zjednodušenie ovládania Rýchlosť reči. Vyberte rýchlosť reči Hlasové pokyny rýchlosť reči Rýchlosť reči hlasových pokynov nastavenie úprava rýchlosti reči Hlasové pokyny"},{"UUID":"6617e563-e0ad-4d61-bf9a-122b42219912","title":"Nastavenie a používanie funkcií zjednodušenia ovládania","link":"activating-voice-guidance-topic.html","desc":"Úprava predvolenej hlasitosti slúchadiel Na","descFull":"Úprava predvolenej hlasitosti slúchadiel Na domovskej obrazovke sa dotknite položiek  Nastavenia Zariadenie Zjednodušenie ovládania . Nastavenie hlasitosti slúchadiel. Hlasitosť sa obnoví na predvolenú hodnotu po tom, ako používateľ ukončí režim Zjednodušenie ovládania alebo po prebudení tlačiarne z režimu spánku alebo dlhodobého spánku. predvolená hlasitosť slúchadiel nastavenie nastavenie predvolenej hlasitosti slúchadlo"},{"UUID":"35e4baf1-6eb3-4061-99d3-26bcfb7ced5d","title":"Nastavenie a používanie funkcií zjednodušenia ovládania","link":"activating-voice-guidance-topic.html","desc":"Nastavenie predvolenej hlasitosti vnútorného reproduktora","descFull":"Nastavenie predvolenej hlasitosti vnútorného reproduktora Na domovskej stránke sa dotknite položky  . Nastavte hlasitosť. Ak je zapnutý tichý režim, zvukové upozornenia sú vypnuté. Toto nastavenie tiež spomaľuje výkon tlačiarne. Hlasitosť sa obnoví na predvolenú hodnotu po tom, ako používateľ ukončí režim Zjednodušenie ovládania alebo po prebudení tlačiarne z režimu spánku alebo dlhodobého spánku. predvolená hlasitosť reproduktora nastavenie nastavenie predvolenej hlasitosti reproduktor"},{"UUID":"5e7c6864-7692-47b4-9474-22e3b31b2447","title":"Nastavenie a používanie funkcií zjednodušenia ovládania","link":"activating-voice-guidance-topic.html","desc":"Zapnutie čítania hesiel alebo osobných","descFull":"Zapnutie čítania hesiel alebo osobných identifikačných čísel Na domovskej obrazovke sa dotknite položiek  Nastavenia Zariadenie Zjednodušenie ovládania Prečítať heslá/kódy PIN. Zapnite nastavenie. čítanie hesiel povolenie osobné identifikačné čísla povolenie zapnutie čítania hesiel zapnutie osobných identifikačných čísel"},{"UUID":"624eccfc-e362-4aca-9a3c-c0a9a9ba6bba","title":"Nastavenie tlačiarne na faxovanie","link":"setting-up-printer-to-fax-group.html","desc":"Podporovaný fax Modely tlačiarní a podporované","descFull":"Podporovaný fax Modely tlačiarní a podporované faxy Model tlačiarne Analógový fax etherFAX 1 Faxový server Fax cez IP (FoIP) 2 1  Vyžaduje predplatné. Ďalšie informácie nájdete na adrese  https://www.etherfax.net/lexmark  alebo sa obráťte na miesto, kde ste si zakúpili tlačiareň. 2  Vyžaduje nainštalovaný licencovaný balík. Ak chcete získať viac informácií, obráťte sa na miesto, kde ste zakúpili tlačiareň. MX532adwe MX632adwe XM3350 podporovaný fax"},{"UUID":"c08b3a2c-7673-491e-b527-b429faab9fa4","title":"Nastavenie tlačiarne na faxovanie","link":"setting-up-printer-to-fax-group.html","desc":"Nastavenie faxu pomocou funkcie analógového","descFull":"Nastavenie faxu pomocou funkcie analógového faxu Niektoré pripojenia sú dostupné len v niektorých krajinách alebo regiónoch. Ak je funkcia faxu zapnutá, ale nebolo dokončené jej nastavenie, indikátor môže blikať červenou farbou. Ak nemáte k dispozícii prostredie TCP/IP, na nastavenie faxu použite ovládací panel. Ak chcete predísť strate údajov alebo poruche tlačiarne, počas aktívneho odosielania alebo prijímania faxu sa nedotýkajte káblov ani zobrazených častí tlačiarne. Používanie ovládacieho panela Na domovskej obrazovke sa dotknite položiek  Nastavenia Fax Nastavenie faxu Všeobecné nastavenia faxu . Nakonfigurujte nastavenia. Prostredníctvom nástroja Embedded Web Server Otvorte webový prehliadač a do poľa adresy zadajte adresu IP tlačiarne. Pozrite si adresu IP tlačiarne na domovskej obrazovke. Adresa IP sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Ak používate server proxy, dočasne ho vypnite, aby sa webová stránka správne načítala. Kliknite na položky  Nastavenia Fax Nastavenie faxu Všeobecné nastavenia faxu . Nakonfigurujte nastavenia. Použite zmeny. analógový fax nastavenie nastavenie analógového faxu"},{"UUID":"fe14bf51-d68a-46d6-ab17-139cd6a86105","title":"Nastavenie tlačiarne na faxovanie","link":"setting-up-printer-to-fax-group.html","desc":"Nastavenie funkcie faxu pomocou služby","descFull":"Nastavenie funkcie faxu pomocou služby etherFAX Firmvér tlačiarne je potrebné aktualizovať na najnovšiu verziu. Ďalšie informácie nájdete v časti  . V tlačiarni musí byť nainštalovaný príslušný licenčný balík. V tlačiarni musí byť nainštalovaný príslušný licenčný balík. Uistite sa, že ste zaregistrovali svoju tlačiareň na portáli etherFAX. Ďalšie informácie nájdete na adrese  https://www.etherfax.net/lexmark . Pri registrácii sa vyžaduje sériové číslo tlačiarne. S nájdením sériového čísla vám pomôže článok  . Otvorte webový prehliadač a do poľa adresy zadajte adresu IP tlačiarne. Pozrite si adresu IP tlačiarne na domovskej obrazovke. IP Adresa sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Ak používate server proxy, dočasne ho vypnite, aby sa webová stránka správne načítala. Kliknite na položky  Nastavenia Fax Nastavenie faxu Všeobecné nastavenia faxu. Položka  Nastavenie faxu  sa zobrazí iba vtedy, ak je  Režim faxu  nastavený na  Fax . Do poľa  Názov faxu  zadajte jedinečný názov. Do poľa  Faxové číslo  zadajte faxové číslo poskytnuté službou etherFAX. V ponuke  Prenos faxu  vyberte  etherFAX . Táto ponuka sa zobrazí len vtedy, keď je k dispozícii viac ako jeden prenos faxu. Ak má tlačiareň nainštalovanú len službu etherFAX, automaticky sa nakonfiguruje. Použite zmeny. etherFAX nastavenie funkcie faxu nastavenie funkcie faxu s použitím služby etherFAX"},{"UUID":"07ac485c-2ed7-4b16-ba23-6a4b52f24b3b","title":"Nastavenie tlačiarne na faxovanie","link":"setting-up-printer-to-fax-group.html","desc":"Nastavenie funkcie faxu pomocou faxového","descFull":"Nastavenie funkcie faxu pomocou faxového servera Táto funkcia umožňuje odosielať faxové správy poskytovateľovi faxových služieb, ktorý podporuje prijímanie e‑mailov. Táto funkcia podporuje len odchádzajúce faxové správy. Ak chcete podporiť príjem faxov, uistite sa, že máte v tlačiarni nakonfigurovaný fax založený na zariadení, ako napríklad analógový fax, éterFAX alebo fax cez IP (FoIP). Táto funkcia podporuje len odchádzajúce faxové správy. Ak chcete podporiť príjem faxov, uistite sa, že máte v tlačiarni nakonfigurovaný fax založený na zariadení, ako napríklad analógový fax alebo fax cez IP (FoIP). Otvorte webový prehliadač a do poľa adresy zadajte adresu IP tlačiarne. Pozrite si adresu IP tlačiarne na domovskej obrazovke. IP Adresa sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Ak používate server proxy, dočasne ho vypnite, aby sa webová stránka správne načítala. Kliknite na položky  Nastavenia Fax . V ponuke  Režim faxu  vyberte položku Server faxu  a potom kliknite na položku  Uložiť . Kliknite na položku  Nastavenie servera faxu . Do poľa  Cieľový formát  zadajte  [#]@myfax.com , kde  [#]  je číslo faxu a  myfax.com  je doména poskytovateľa faxu. V prípade potreby nakonfigurujte polia  Adresa pre odpoveď ,  Predmet , or  Správa . Ak chcete, aby tlačiareň mohla prijímať faxové správy, povoľte nastavenie príjmu faxu na založené na zariadení. Uistite sa, že máte nakonfigurovaný fax založený na zariadení. Kliknite na možnosť  Uložiť . Kliknite na položku  Nastavenie e‑mailu faxového servera  a potom vykonajte niektorý z nasledujúcich krokov: Povoľte možnosť  Použitie e-mailového servera SMTP . Ak nie sú nakonfigurované nastavenia SMTP e‑mailu, prečítajte si časť . Nakonfigurujte nastavenia SMTP. Ďalšie informácie získate od poskytovateľa e-mailových služieb. Použite zmeny. faxový server, používanie nastavenie funkcie faxu nastavenie funkcie faxu pomocou faxového servera"},{"UUID":"9f932cdd-d830-46ae-b572-f7a7803af05c","title":"Nastavenie tlačiarne na faxovanie","link":"setting-up-printer-to-fax-group.html","desc":"Nastavenie faxu cez štandardnú telefónnu","descFull":"Nastavenie faxu cez štandardnú telefónnu linku Tieto pokyny sa vzťahujú len na tlačiarne s podporou analógového faxu. Ďalšie informácie nájdete v časti  . Tieto pokyny sa vzťahujú len na tlačiarne s podporou analógového faxu. Toto zariadenie nenastavujte ani nevytvárajte žiadne elektrické či káblové pripojenie (napríklad sieťové napájanie, funkcia faxu alebo telefón) počas búrky, aby ste sa vyhli riziku zasiahnutia elektrickým prúdom. Ak chcete zabrániť riziku úrazu elektrickým prúdom, nepoužívajte funkciu faxu počas búrky. Ak chcete predísť vzniku požiaru, pripájajte zariadenie k verejnej telefónnej sieti výlučne prostredníctvom kábla 26 AWG alebo väčšieho telekomunikačného kábla (RJ-11). Pre používateľov v Austrálii: kábel musí schváliť austrálsky štátny orgán pre komunikáciu a médiá. Nastavenie 1: Tlačiareň je pripojená k samostatnej faxovej linke Jeden koniec telefónneho kábla pripojte k portu LINE tlačiarne. Druhý koniec kábla pripojte do aktívnej analógovej telefónnej zásuvky. Tlačiareň môžete nastaviť na automatické (položku  Automatická odpoveď  nastavte na možnosť  Zapnuté ) alebo manuálne (položku  Automatická odpoveď  nastavte na možnosť  Vypnuté ) prijímanie faxov. Ak chcete prijímať faxy automaticky, nastavte reakciu tlačiarne na konkrétny počet zvonení. Nastavenie 2: Tlačiareň zdieľa linku s telefónnym záznamníkom Ak máte predplatenú službu osobitného zvonenia, tlačiareň sa musí nastaviť na správne zvonenie. Inak tlačiareň nebude prijímať faxy, aj keby bola nastavená na automatické prijímanie faxov. Pripojené k rozličným telefónnym zásuvkám Jeden koniec telefónneho kábla pripojte k portu LINE tlačiarne. Druhý koniec kábla pripojte do aktívnej analógovej telefónnej zásuvky. Ak na telefónnej linke máte len jedno telefónne číslo, nastavte tlačiareň na automatické prijímanie faxov. Tlačiareň nastavte tak, aby zdvihla volanie dve zvonenia po telefónnom záznamníku. Ak napríklad telefónny záznamník zdvihne hovor po štyroch zvoneniach, nastavte funkciu tlačiarne  Počet zvonení pred odpoveďou  na hodnotu  6 . nastavenie faxu pripojenie štandardnou telefónnou linkou nastavenie faxu pripojenie štandardnou telefónnou linkou telefónny záznamník nastavenie"},{"UUID":"877dad38-99f7-4a37-8d06-90b5f7e36554","title":"Nastavenie tlačiarne na faxovanie","link":"setting-up-printer-to-fax-group.html","desc":"Nastavenie tlačiarne v krajinách alebo regiónoch","descFull":"Nastavenie tlačiarne v krajinách alebo regiónoch s inými telefónnymi zásuvkami alebo zástrčkami Tieto pokyny sa vzťahujú len na tlačiarne s podporou analógového faxu. Ďalšie informácie nájdete v časti  . Tieto pokyny sa vzťahujú len na tlačiarne s podporou analógového faxu. Toto zariadenie nenastavujte ani nevytvárajte žiadne elektrické či káblové pripojenie (napríklad sieťové napájanie, funkcia faxu alebo telefón) počas búrky, aby ste sa vyhli riziku zasiahnutia elektrickým prúdom. Ak chcete zabrániť riziku úrazu elektrickým prúdom, nepoužívajte funkciu faxu počas búrky. Ak chcete predísť vzniku požiaru, pripájajte zariadenie k verejnej telefónnej sieti výlučne prostredníctvom kábla 26 AWG alebo väčšieho telekomunikačného kábla (RJ-11). Pre používateľov v Austrálii: kábel musí schváliť austrálsky štátny orgán pre komunikáciu a médiá. Vo väčšine krajín a regiónov je štandardnou telefónnou zásuvkou typ RJ‑11. Ak telefónna zásuvka alebo vybavenie vo vašich priestoroch nie sú kompatibilné s týmto typom pripojenia, použite telefónny adaptér. Adaptér pre vašu krajinu alebo región nemusí byť dodaný s tlačiarňou a môže byť potrebné ho zakúpiť samostatne. V telefónnej zásuvke tlačiarne môže byť nainštalovaná adaptérová zástrčka. Ak sa pripájate k telefónnemu systému so sériovým alebo kaskádovým zapojením, nevyberajte adaptérovú zástrčku z telefónneho portu tlačiarne. Číslo súčasti adaptérovej zástrčky Názov súčasti Číslo súčasti Adaptérová zástrčka Lexmark 40X8519 Pripojenie tlačiarne k telefónnej zásuvke iného typu ako RJ‑11 Jeden koniec telefónneho kábla pripojte k portu LINE tlačiarne. Druhý koniec kábla pripojte k adaptéru RJ‑11, potom adaptér zapojte do telefónnej zásuvky. Ak chcete k rovnakej telefónnej zásuvke pripojiť iné ďalšie zariadenie s konektorom iného typu ako RJ‑11, pripojte ho priamo k telefónnemu adaptéru. nastavenie faxu pomocou rôznych nástenných konektorov nastavenie faxu pomocou rôznych zástrčiek nastavenie faxu pomocou rôznych nástenných konektorov nastavenie faxu pomocou rôznych zástrčiek adaptér RJ11"},{"UUID":"6f645fc5-435a-43f9-9b0a-134b24cecbe7","title":"Nastavenie tlačiarne na faxovanie","link":"setting-up-printer-to-fax-group.html","desc":"Pripojenie k službe osobitného zvonenia Vďaka","descFull":"Pripojenie k službe osobitného zvonenia Vďaka službe osobitného zvonenia môžete mať na jednej telefónnej linke viac telefónnych čísel. Každé telefónne číslo ma pridelené iné zvonenie. Tieto pokyny sa vzťahujú len na tlačiarne s podporou analógového faxu. Ďalšie informácie nájdete v časti  . Tieto pokyny sa vzťahujú len na tlačiarne s podporou analógového faxu. Na domovskej obrazovke stlačte  Nastavenia Fax Nastavenie faxu Nastavenia príjmu faxov Ovládacie prvky správcu Odpoveď zapnutá . Vyberte zvonenie. osobitné zvonenie nastavenie faxu umožňuje osobitné zvonenia priradenie tlačiarne ku kruhovému vzoru"},{"UUID":"55d8dd7e-5829-47de-b857-818f8b50a03a","title":"Nastavenie tlačiarne na faxovanie","link":"setting-up-printer-to-fax-group.html","desc":"Nastavenie dátumu a času faxu Skontrolujte,","descFull":"Nastavenie dátumu a času faxu Skontrolujte, či je fax nakonfigurovaný. Ďalšie informácie nájdete v časti   Nastavenie tlačiarne na fax . Na domovskej obrazovke sa dotknite položiek  Nastavenia Zariadenie Preferencie Dátum a čas Konfigurácia . Nakonfigurujte nastavenia. faxovanie nastavenie dátumu a času dátum a čas nastavenia faxu"},{"UUID":"acd5a288-122b-4080-bb7f-9bf803301350","title":"Nastavenie tlačiarne na faxovanie","link":"setting-up-printer-to-fax-group.html","desc":"Konfigurácia letného/zimného času Skontrolujte, či","descFull":"Konfigurácia letného/zimného času Skontrolujte, či je fax nakonfigurovaný. Ďalšie informácie nájdete v časti   Nastavenie tlačiarne na fax . Na domovskej obrazovke sa dotknite položiek  Nastavenia Zariadenie Preferencie Dátum a čas Konfigurácia . V ponuke  Časové pásmo  sa dotknite položky  (UTC+používateľský) Vlastné . Dotknite sa položky  Posun voči času UTC (GMT)  a nakonfigurujte nastavenia. konfigurácia letného času letný čas konfigurácia"},{"UUID":"0baf5559-0beb-42c3-8024-cf96f985d2e9","title":"Nastavenie tlačiarne na faxovanie","link":"setting-up-printer-to-fax-group.html","desc":"Konfigurácia nastavení reproduktora faxu Skontrolujte,","descFull":"Konfigurácia nastavení reproduktora faxu Skontrolujte, či je fax nakonfigurovaný. Ďalšie informácie nájdete v časti   Nastavenie tlačiarne na fax . Na domovskej obrazovke sa dotknite položiek  Nastavenia Fax Nastavenie faxu Nastavenia reproduktora . Postupujte nasledovne: Nastavte  Režim reproduktora  na možnosť  Vždy zapnuté . Nastavte  Hlasitosť reproduktora  na možnosť  Vysoká . Zapnite možnosť  Hlasitosť zvonenia . konfigurácia nastavení reproduktora faxu nastavenia reproduktora faxu konfigurácia"},{"UUID":"13283402-b93d-4f12-b905-684059db5618","title":"Príprava na používanie, inštalácia a konfigurácia","link":"configuring-smtp-server-for-e-mail-topic.html","desc":"Konfigurácia nastavení protokolu e‑mail SMTP","descFull":"Konfigurácia nastavení protokolu e‑mail SMTP Nakonfigurujte nastavenia protokolu SMTP (Simple Mail Transfer Protocol) na odosielanie naskenovaného dokumentu prostredníctvom e-mailu Nastavenia sú odlišné pre každého poskytovateľa e‑mailových služieb. Pred začatím skontrolujte, či je tlačiareň pripojená k sieti a sieť je pripojená k internetu. Prostredníctvom nástroja Embedded Web Server Otvorte webový prehliadač a do poľa adresy zadajte adresu IP tlačiarne. Pozrite si adresu IP tlačiarne na domovskej obrazovke tlačiarne. Adresa IP sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Ak používate server proxy, dočasne ho vypnite, aby sa webová stránka správne načítala. Kliknite na položku  Nastavenia E‑mail . V časti  Nastavenie e‑mailu  nakonfigurujte nastavenia. Ďalšie informácie nájdete v zozname  poskytovateľov e-mailových služieb . V prípade poskytovateľov e‑mailových služieb, ktorí nie sú v zozname, sa obráťte na svojho poskytovateľa a požiadajte ho o nastavenia. Kliknite na možnosť  Uložiť . Používanie ponuky  Nastavenia  v tlačiarni Na domovskej obrazovke klepnite sa dotknite položky  Nastavenia E‑mail Nastavenie e-mailu . Nakonfigurujte nastavenia. Ďalšie informácie nájdete v zozname  poskytovateľov e-mailových služieb . V prípade poskytovateľov e‑mailových služieb, ktorí nie sú v zozname, sa obráťte na svojho poskytovateľa a požiadajte ho o nastavenia. Poskytovatelia e-mailových služieb AOL Mail Comcast Mail Gmail iCloud Mail Mail.com NetEase Mail (mail.126.com) NetEase Mail (mail.163.com) NetEase Mail (mail.yeah.net) Outlook Live or Microsoft 365 QQ Mail Sina Mail Sohu Mail Yahoo! Mail Zoho Mail Ak sa pri použití poskytnutých nastavení vyskytnú chyby, obráťte sa na poskytovateľa e‑mailových služieb. V prípade poskytovateľov e‑mailových služieb, ktorí nie sú v zozname, sa obráťte na svojho poskytovateľa. AOL Mail Nastavenia pre službu AOL Mail Nastavenie Hodnota Primárna brána SMTP smtp.aol.com Port primárnej brány SMTP 587 Použiť nástroj SSL/TLS Požadované Potrebný dôveryhodný certifikát Vypnuté Adresa pre odpoveď Vaša e-mailová adresa Overenie servera SMTP Prihlásenie/obyčajné E-mail vytvorený na základe zariadenia Použiť poverenia SMTP zariadenia ID používateľa zariadenia Vaša e-mailová adresa Heslo zariadenia Heslo aplikácie  Ak chcete vytvoriť heslo aplikácie, prejdite na stránku  Zabezpečenie účtu AOL , prihláste sa do svojho účtu a potom kliknite na položku  Vytvoriť heslo aplikácie . Comcast Mail Nastavenia pre službu Comcast Mail Nastavenie Hodnota Primárna brána SMTP smtp.comcast.net Port primárnej brány SMTP 587 Použiť nástroj SSL/TLS Požadované Potrebný dôveryhodný certifikát Vypnuté Adresa pre odpoveď Vaša e-mailová adresa Overenie servera SMTP Prihlásenie/obyčajné E-mail vytvorený na základe zariadenia Použiť poverenia SMTP zariadenia ID používateľa zariadenia Vaša e-mailová adresa Heslo zariadenia Heslo účtu Skontrolujte, či máte vo svojom účte aktivované nastavenie zabezpečenia prístupu pre tretiu stranu. Ďalšie informácie nájdete na  stránke pomocníka Comcast Xfinity Connect . Gmail Skontrolujte, či máte v účte Google aktivované dvojkrokové overovanie. Ak chcete povoliť dvojkrokové overovanie prejdite na stránku  Zabezpečenie účtu Google , prihláste sa do svojho účtu a potom v časti „ Prihlásenie do služby Google “ kliknite na položku  2‑krokové overovanie . Nastavenia protokolu SMTP pre službu Gmail Nastavenie Hodnota Primárna brána SMTP smtp.gmail.com Port primárnej brány SMTP 587 Použiť nástroj SSL/TLS Požadované Potrebný dôveryhodný certifikát Vypnuté Adresa pre odpoveď Vaša e-mailová adresa Overenie servera SMTP Prihlásenie/obyčajné E-mail vytvorený na základe zariadenia Použiť poverenia SMTP zariadenia ID používateľa zariadenia Vaša e-mailová adresa Heslo zariadenia Heslo aplikácie Ak chcete vytvoriť heslo aplikácie prejdite na stránku  Zabezpečenie účtu Google , prihláste sa do svojho účtu a potom v časti „ Prihlásenie do služby Google “ kliknite na položku  Heslá aplikácií . Položka „ Heslá aplikácií “ sa zobrazuje iba v prípade, ak je povolené dvojkrokové overovanie. iCloud Mail Skontrolujte, či máte aktivované dvojkrokové overovanie. Nastavenia pre službu iCloud Mail Nastavenie Hodnota Primárna brána SMTP smtp.mail.me.com Port primárnej brány SMTP 587 Použiť nástroj SSL/TLS Požadované Potrebný dôveryhodný certifikát Vypnuté Adresa pre odpoveď Vaša e-mailová adresa Overenie servera SMTP Prihlásenie/obyčajné E-mail vytvorený na základe zariadenia Použiť poverenia SMTP zariadenia ID používateľa zariadenia Vaša e-mailová adresa Heslo zariadenia Heslo aplikácie Ak chcete vytvoriť heslo aplikácie prejdite na stránku  Správa účtu iCloud , prihláste sa do svojho účtu a potom v časti  Zabezpečenie  kliknite na položku  Vygenerovať heslo . Mail.com Nastavenia pre službu Mail.com Nastavenie Hodnota Primárna brána SMTP smtp.mail.com Port primárnej brány SMTP 587 Použiť nástroj SSL/TLS Požadované Potrebný dôveryhodný certifikát Vypnuté Adresa pre odpoveď Vaša e-mailová adresa Overenie servera SMTP Prihlásenie/obyčajné E-mail vytvorený na základe zariadenia Použiť poverenia SMTP zariadenia ID používateľa zariadenia Vaša e-mailová adresa Heslo zariadenia Heslo účtu NetEase Mail (mail.126.com) Skontrolujte, či máte aktivovanú službu SMTP vo svojom účte. Ak chcete službu zapnúť, na domovskej stránke služby NetEase Mail kliknite na položky  Nastavenia POP3/SMTP/IMAP  a potom povoľte možnosť  Služba IMAP/SMTP  alebo  Služba POP3/SMTP . Nastavenia pre službu NetEase Mail (mail.126.com) Nastavenie Hodnota Primárna brána SMTP smtp.126.com Port primárnej brány SMTP 465 Použiť nástroj SSL/TLS Požadované Potrebný dôveryhodný certifikát Vypnuté Adresa pre odpoveď Vaša e-mailová adresa Overenie servera SMTP Prihlásenie/obyčajné E-mail vytvorený na základe zariadenia Použiť poverenia SMTP zariadenia ID používateľa zariadenia Vaša e-mailová adresa Heslo zariadenia Autorizačné heslo Autorizačné heslo sa poskytuje, keď je povolená  služba IMAP/SMTP  alebo  služba POP3/SMTP . NetEase Mail (mail.163.com) Skontrolujte, či máte aktivovanú službu SMTP vo svojom účte. Ak chcete službu zapnúť, na domovskej stránke služby NetEase Mail kliknite na položky  Nastavenia POP3/SMTP/IMAP  a potom povoľte možnosť  Služba IMAP/SMTP  alebo  Služba POP3/SMTP . Nastavenia pre službu NetEase Mail (mail.163.com) Nastavenie Hodnota Primárna brána SMTP smtp.163.com Port primárnej brány SMTP 465 Použiť nástroj SSL/TLS Požadované Potrebný dôveryhodný certifikát Vypnuté Adresa pre odpoveď Vaša e-mailová adresa Overenie servera SMTP Prihlásenie/obyčajné E-mail vytvorený na základe zariadenia Použiť poverenia SMTP zariadenia ID používateľa zariadenia Vaša e-mailová adresa Heslo zariadenia Autorizačné heslo Autorizačné heslo sa poskytuje, keď je povolená  služba IMAP/SMTP  alebo  služba POP3/SMTP . NetEase Mail (mail.yeah.net) Skontrolujte, či máte aktivovanú službu SMTP vo svojom účte. Ak chcete službu zapnúť, na domovskej stránke služby NetEase Mail kliknite na položky  Nastavenia POP3/SMTP/IMAP  a potom povoľte možnosť  Služba IMAP/SMTP  alebo  Služba POP3/SMTP . Nastavenia pre službu NetEase Mail (mail.yeah.net) Nastavenie Hodnota Primárna brána SMTP smtp.yeah.net Port primárnej brány SMTP 465 Použiť nástroj SSL/TLS Požadované Potrebný dôveryhodný certifikát Vypnuté Adresa pre odpoveď Vaša e-mailová adresa Overenie servera SMTP Prihlásenie/obyčajné E-mail vytvorený na základe zariadenia Použiť poverenia SMTP zariadenia ID používateľa zariadenia Vaša e-mailová adresa Heslo zariadenia Autorizačné heslo Autorizačné heslo sa poskytuje, keď je povolená  služba IMAP/SMTP  alebo  služba POP3/SMTP . Outlook Live or Microsoft 365 Tieto nastavenia sa vzťahujú na e-mailové domény outlook.com a hotmail.com a na účty v službe Microsoft 365. Nastavenia pre Outlook Live alebo Microsoft 365 Nastavenie Hodnota Primárna brána SMTP smtp.office365.com Port primárnej brány SMTP 587 Použiť nástroj SSL/TLS Požadované Potrebný dôveryhodný certifikát Vypnuté Adresa pre odpoveď Vaša e-mailová adresa Overenie servera SMTP Prihlásenie/obyčajné E-mail vytvorený na základe zariadenia Použiť poverenia SMTP zariadenia ID používateľa zariadenia Vaša e-mailová adresa Heslo zariadenia Heslo účtu alebo heslo aplikácie V prípade účtov s deaktivovaným dvojkrokovým overovaním použite heslo účtu. V prípade účtov na doménach outlook.com alebo hotmail.com s aktivovaným dvojkrokovým overovaním použite heslo aplikácie. Ak chcete vytvoriť heslo aplikácie, prejdite na stránku  Správa účtu Outlook Live  a potom sa prihláste do svojho účtu. Ďalšie možnosti nastavenia pre podniky pri používaní služby Microsoft 365 nájdete na  stránke pomoci služby Microsoft 365 . QQ Mail Skontrolujte, či máte aktivovanú službu SMTP vo svojom účte. Ak chcete službu zapnúť, na domovskej stránke služby QQ Mail kliknite na položky  Nastavenia Účet . V časti  Služba POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV  povoľte  službu POP3/SMTP  alebo  službu IMAP/SMTP . Nastavenia pre službu QQ Mail Nastavenie Hodnota Primárna brána SMTP smtp.qq.com Port primárnej brány SMTP 587 Použiť nástroj SSL/TLS Požadované Potrebný dôveryhodný certifikát Vypnuté Adresa pre odpoveď Vaša e-mailová adresa Overenie servera SMTP Prihlásenie/obyčajné E-mail vytvorený na základe zariadenia Použiť poverenia SMTP zariadenia ID používateľa zariadenia Vaša e-mailová adresa Heslo zariadenia Autorizačný kód Ak chcete vygenerovať autorizačný kód, na domovskej stránke služby QQ Mail kliknite na položky  Nastavenia Účet  a v časti  Služba POP3/IMAP/SMTP/Exchange/CardDAV/CalDAV  kliknite na položku  Generovať autorizačný kód . Sina Mail Skontrolujte, či máte aktivovanú službu POP3/SMTP vo svojom účte. Ak chcete službu zapnúť, na domovskej stránke služby Sina Mail kliknite na položky  Nastavenia Ďalšie nastavenia Používateľ služby POP/IMAP/SMTP  a potom povoľte možnosť  Služba POP3/SMTP . Nastavenia pre službu Sina Mail Nastavenie Hodnota Primárna brána SMTP smtp.sina.com Port primárnej brány SMTP 587 Použiť nástroj SSL/TLS Požadované Potrebný dôveryhodný certifikát Vypnuté Adresa pre odpoveď Vaša e-mailová adresa Overenie servera SMTP Prihlásenie/obyčajné E-mail vytvorený na základe zariadenia Použiť poverenia SMTP zariadenia ID používateľa zariadenia Vaša e-mailová adresa Heslo zariadenia Autorizačný kód Ak chcete vytvoriť autorizačný kód, na domovskej stránke e-mailu kliknite na položky  Nastavenia Ďalšie nastavenia Používateľ služby POP/IMAP/SMTP  a potom povoľte položku  Stav autorizačného kódu . Sohu Mail Skontrolujte, či máte aktivovanú službu SMTP vo svojom účte. Ak chcete službu zapnúť, na domovskej stránke služby Sohu Mail kliknite na položky  Možnosti Nastavenia POP3/SMTP/IMAP  a potom povoľte možnosť  Služba IMAP/SMTP  alebo  Služba POP3/SMTP . Nastavenia pre službu Sohu Mail Nastavenie Hodnota Primárna brána SMTP smtp.sohu.com Port primárnej brány SMTP 465 Použiť nástroj SSL/TLS Požadované Potrebný dôveryhodný certifikát Vypnuté Adresa pre odpoveď Vaša e-mailová adresa Overenie servera SMTP Prihlásenie/obyčajné E-mail vytvorený na základe zariadenia Použiť poverenia SMTP zariadenia ID používateľa zariadenia Vaša e-mailová adresa Heslo zariadenia Nezávislé heslo Nezávislé heslo sa poskytuje, keď je povolená  služba IMAP/SMTP  alebo  služba POP3/SMTP . Yahoo! Mail Nastavenia pre službu Yahoo! Mail Nastavenie Hodnota Primárna brána SMTP smtp.mail.yahoo.com Port primárnej brány SMTP 587 Použiť nástroj SSL/TLS Požadované Potrebný dôveryhodný certifikát Vypnuté Adresa pre odpoveď Vaša e-mailová adresa Overenie servera SMTP Prihlásenie/obyčajné E-mail vytvorený na základe zariadenia Použiť poverenia SMTP zariadenia ID používateľa zariadenia Vaša e-mailová adresa Heslo zariadenia Heslo aplikácie  Ak chcete vytvoriť heslo aplikácie, prejdite na stránku  Zabezpečenie účtu Yahoo , prihláste sa do svojho účtu a potom kliknite na položku  Vytvoriť heslo aplikácie . Zoho Mail Nastavenia pre službu Zoho Mail Nastavenie Hodnota Primárna brána SMTP smtp.zoho.com Port primárnej brány SMTP 587 Použiť nástroj SSL/TLS Požadované Potrebný dôveryhodný certifikát Vypnuté Adresa pre odpoveď Vaša e-mailová adresa Overenie servera SMTP Prihlásenie/obyčajné E-mail vytvorený na základe zariadenia Použiť poverenia SMTP zariadenia ID používateľa zariadenia Vaša e-mailová adresa Heslo zariadenia Heslo účtu alebo heslo aplikácie V prípade účtov s deaktivovaným dvojkrokovým overovaním použite heslo účtu. V prípade účtov s aktivovaným dvojkrokovým overovaním použite heslo aplikácie. Ak chcete vytvoriť heslo aplikácie prejdite na stránku  Zabezpečenie účtu Zoho Mail , prihláste sa do svojho účtu a potom v časti  Heslá pre konkrétne aplikácie  kliknite na položku  Vygenerovať nové heslo . poskytovatelia e-mailových služieb konfigurácia nastavení e‑mailového servera nastavenia SMTP konfigurácia funkcia e-mailu nastavenie e‑mailový server konfigurácia"},{"UUID":"28ad2edb-3a0b-428a-addc-03e36d70f3f7","title":"Vkladanie papiera a špeciálnych médií","link":"setting-paper-size-and-type-topic.html","desc":"Nastavenie veľkosti a typu papiera Na","descFull":"Nastavenie veľkosti a typu papiera Na domovskej obrazovke sa dotknite položiek  Nastavenia Papier Konfigurácia zásobníkov Veľkosť/typ papiera  vyberte zdroj papiera. Nastavte veľkosť a typ papiera. nastavenie veľkosti papiera nastavenie typu papiera"},{"UUID":"cf2856e5-8474-4158-8b06-220f32e557d0","title":"Vkladanie papiera a špeciálnych médií","link":"setting-paper-size-and-type-topic.html","desc":"Konfigurácia univerzálnych nastavení papiera Na","descFull":"Konfigurácia univerzálnych nastavení papiera Na domovskej obrazovke sa dotknite položiek  Nastavenia Papier Konfigurácia médií Univerzálne nastavenie . Nakonfigurujte nastavenia. papier nastavenie univerzálnej veľkosti nastavenie univerzálnej veľkosti papiera univerzálna veľkosť papiera nastavenie"},{"UUID":"71db96c2-7d1a-4b3b-a96c-c260523a0282","title":"Vkladanie papiera a špeciálnych médií","link":"setting-paper-size-and-type-topic.html","desc":"Vkladanie do zásobníkov Ak chcete","descFull":"Vkladanie do zásobníkov Ak chcete znížiť riziko nestability zariadenia, do každého zásobníka vkladajte papier samostatne. Všetky ostatné zásobníky nechajte zatvorené dovtedy, kým ich nepotrebujete. Vyberte zásobník. Aby ste sa vyhli zaseknutiu papiera, zásobník nevyberajte, keď tlačiareň pracuje. Nastavte vodiace lišty tak, aby zodpovedali veľkosti vkladaného papiera. Pred vložením papier ohnite, rozdeľte a zarovnajte jeho okraje. Stoh papiera vložte tak, aby strana, na ktorú sa tlačí, smerovala nadol. Potom sa uistite, že bočné vodiace lišty jemne tlačia na papier. V prípade jednostrannej tlače vložte hlavičkový papier lícovou stranou nadol tak, aby hlavička smerovala k prednej časti zásobníka. V prípade obojstrannej tlače vložte hlavičkový papier lícovou stranou nahor tak, aby hlavička smerovala k zadnej časti zásobníka. Papier do zásobníka nezasúvajte. Aby ste sa vyhli zaseknutiam papiera, uistite sa, či výška stohu nepresahuje indikátor maximálneho množstva papiera. Vložte zásobník. V prípade potreby nastavte na ovládacom paneli veľkosť a typ papiera tak, aby zodpovedali vloženému papieru. vkladanie do zásobníkov vkladanie papiera vkladanie hlavičkového papiera"},{"UUID":"03efa1a8-893a-4385-89ac-c240714e7ee0","title":"Vkladanie papiera a špeciálnych médií","link":"setting-paper-size-and-type-topic.html","desc":"Vkladanie do viacúčelového podávača Otvorte","descFull":"Vkladanie do viacúčelového podávača Otvorte viacúčelový podávač. Pred vložením papier ohnite, rozdeľte a zarovnajte jeho okraje. Vložte papier stranou určenou na tlač smerom nahor. V prípade jednostrannej tlače vložte hlavičkový papier lícovou stranou nahor tak, aby hlavička smerovala k zadnej časti tlačiareň. V prípade obojstrannej tlače vložte hlavičkový papier lícovou stranou nadol tak, aby hlavička smerovala k prednej časti tlačiareň. Vložte obálky s otváracou stranou vľavo smerom nadol. Nepoužívajte obálky so známkami, sponami, cvočkami, okienkami, špeciálnou obrubou alebo samolepiacimi prvkami. Nastavte vodiacu lištu tak, aby zodpovedala veľkosti vkladaného papiera. Na ovládacom paneli nastavte veľkosť a typ papiera tak, aby zodpovedali vloženému papieru. viacúčelový podávač vkladanie vkladanie hlavičkového papiera vo viacúčelovom podávači vkladanie obálok vo viacúčelovom podávači"},{"UUID":"8a114372-3425-4944-82d6-56165877cf29","title":"Vkladanie papiera a špeciálnych médií","link":"setting-paper-size-and-type-topic.html","desc":"Prepojenie zásobníkov Na domovskej obrazovke","descFull":"Prepojenie zásobníkov Na domovskej obrazovke sa dotknite položiek  Nastavenia Papier Konfigurácia zásobníkov a zvoľte zdroj papiera. Pre zásobníky, ktoré prepájate, nastavte rovnakú veľkosť a typ papiera. Na domovskej obrazovke sa dotknite položiek  Nastavenia Zariadenie Údržba Ponuka konfigurácie Konfigurácia zásobníkov Prepojenie na zásobník . Stlačte  Automatické . Ak chcete zrušiť prepojenie zásobníkov, uistite sa, že žiadne zásobníky nemajú rovnaké nastavenia veľkosti a typu papiera. Teplota fixačnej jednotky sa môže meniť v závislosti od špecifikovaného typu papiera. Ak sa chcete vyhnúť problémom pri tlači, nastavenie typu papiera v tlačiarni by malo zodpovedať papieru vloženému v zásobníku. zrušenie prepojenia zásobníkov prepojenie zásobníkov zásobníky prepojenie zásobníky zrušenie prepojenia"},{"UUID":"c01f6128-3a86-428c-b409-191bec2da920","title":"Inštalácia a aktualizácia softvéru, ovládačov a firmvéru","link":"installing-printer-software-topic.html","desc":"Inštalácia softvéru tlačiarne Ovládač tlače","descFull":"Inštalácia softvéru tlačiarne Ovládač tlače je súčasťou softvérového inštalačného balíka. V prípade počítačov Macintosh s verziou operačného systému macOS 10.7 alebo novším nie je potrebné inštalovať ovládač pre tlač na tlačiareň s certifikáciou AirPrint. Ak si chcete prispôsobiť funkcie tlače, stiahnite si ovládač tlačiarne. Získajte kópiu softvérového inštalačného balíka. Z disku CD so softvérom dodanom s tlačiarňou. Prejdite na adresu  www.lexmark.com/downloads . Prejdite na adresu  www.dell.com/support/printers . Z našej webovej stránky alebo u predajcu, od ktorého ste si tlačiareň zakúpili. Spustite inštalátor a postupujte podľa pokynov na obrazovke počítača. inštalácia softvéru tlačiarne softvér tlačiarne inštalácia inštalácia ovládača tlače ovládač tlačiarne inštalácia"},{"UUID":"0362ca13-4d13-4b9a-84e2-ee0844b551d6","title":"Inštalácia a aktualizácia softvéru, ovládačov a firmvéru","link":"installing-printer-software-topic.html","desc":"Inštalácia ovládača faxu Prejdite na","descFull":"Inštalácia ovládača faxu Prejdite na stránku  www.lexmark.com/downloads , vyhľadajte model svojej tlačiarne a potom stiahnite príslušný inštalačný balík. Prejdite na náš web alebo na miesto, kde ste tlačiareň zakúpili, a získajte inštalačný balík. Prejdite na stránku  www.dell.com/support  a potom si stiahnite príslušný inštalačný balík. V počítači kliknite na položku  Vlastnosti tlačiarne  a potom prejdite na kartu  Konfigurácia . Spustite inštalátor a postupujte podľa pokynov na obrazovke počítača. Vyberte položku  Fax  a potom kliknite na možnosť  Použiť . ovládač faxu inštalácia inštalácia ovládača faxu"},{"UUID":"d5d10312-8387-4ec4-a4a4-535fe8731b09","title":"Inštalácia a aktualizácia softvéru, ovládačov a firmvéru","link":"installing-printer-software-topic.html","desc":"Pridávanie tlačiarní do počítača Skôr","descFull":"Pridávanie tlačiarní do počítača Skôr než začnete, vykonajte jeden z týchto krokov: Pripojte tlačiareň a počítač k rovnakej sieti. Ďalšie informácie o pripájaní tlačiarne k sieti nájdete v časti  . Pripojte počítač k tlačiarni. Ďalšie informácie nájdete v časti  . Pomocou kábla USB pripojte tlačiareň k počítaču. Ďalšie informácie nájdete v časti  . Kábel USB sa predáva samostatne. Používatelia systému Windows Pomocou počítača nainštalujte ovládač tlačiarne. Ďalšie informácie nájdete v časti  . Otvorte priečinok s tlačiarňami a potom kliknite na položku  Pridať tlačiareň alebo skener . V závislosti od pripojenia tlačiarne vykonajte jeden z nasledujúcich krokov: Vyberte tlačiareň zo zoznamu a kliknite na tlačidlo  Pridať zariadenie . Kliknite na položku  Zobraziť tlačiarne s funkciou Wi‑Fi Direct , vyberte tlačiareň a potom kliknite na položku  Pridať zariadenie . Kliknite na možnosť  Požadovaná tlačiareň nie je v zozname uvedená  a potom v okne  Pridať tlačiareň  vykonajte nasledujúce kroky: Vyberte možnosť  Pridať tlačiareň pomocou adresy TCP/IP alebo názvu hostiteľa  a potom kliknite na možnosť  Ďalej . Do poľa  Názov hostiteľa alebo adresa IP  zadajte adresu IP tlačiarne a potom kliknite na možnosť  Ďalej . Pozrite si adresu IP tlačiarne na domovskej obrazovke tlačiarne. Adresa IP sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Ak používate server proxy, dočasne ho vypnite, aby sa webová stránka správne načítala. Vyberte ovládač tlačiarne a kliknite na tlačidlo  Ďalej . Vyberte možnosť  Použiť aktuálne nainštalovaný ovládač tlačiarne (odporúča sa)  a potom kliknite na možnosť  Ďalej . Zadajte názov tlačiarne a kliknite na možnosť  Ďalej . Vyberte možnosť zdieľania tlačiarne a potom kliknite na možnosť  Ďalej . Kliknite na položku  Dokončiť . Používatelia systému Macintosh V počítači otvorte položku  Tlačiarne a skenery . Kliknite na ikonu  a potom vyberte tlačiareň. V ponuke  Použiť   vyberte ovládač tlačiarne. Ak chcete použiť ovládač tlačiarne Macintosh, vyberte možnosť  AirPrint  alebo  Secure AirPrint . Ak si chcete prispôsobiť funkcie tlače, vyberte ovládač tlačiarne Lexmark. Informácie o inštalácii ovládača nájdete v časti  . Ak si chcete prispôsobiť funkcie tlače, vyberte ovládač výrobcu tlačiarne. Informácie o inštalácii ovládača nájdete v časti  . Pridať tlačiareň. pridávanie tlačiarní do počítača"},{"UUID":"cb20b741-411c-47e6-bd16-16aea0768c81","title":"Inštalácia a aktualizácia softvéru, ovládačov a firmvéru","link":"installing-printer-software-topic.html","desc":"Aktualizácia firmvéru Ak chcete zvýšiť","descFull":"Aktualizácia firmvéru Ak chcete zvýšiť výkon tlačiarne a odstrániť problémy, pravidelne aktualizujte firmvér tlačiarne. Ďalšie informácie o aktualizácii firmvéru získate od zástupcu spoločnosti Lexmark. Ďalšie informácie o aktualizácii firmvéru získate od zástupcu spoločnosti Dell. Ďalšie informácie o aktualizácii firmvéru získate od vášho obchodného zástupcu. Ak chcete získať najnovší firmvér, prejdite na adresu   www.lexmark.com/downloads  a potom vyhľadajte svoj model tlačiarne. Otvorte webový prehliadač a do poľa adresy zadajte adresu IP tlačiarne. Pozrite si adresu IP tlačiarne na domovskej obrazovke tlačiarne. Adresa IP sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Ak používate server proxy, dočasne ho vypnite, aby sa webová stránka správne načítala. Kliknite na položky  Nastavenia Zariadenie Aktualizovať firmvér . Vykonajte niektorý z týchto krokov: Kliknite na položky  Skontrolovať aktualizácie Súhlasím, spustiť aktualizáciu . Nahrajte súbor flash. Prejdite na súbor flash. Uistite sa, že ste rozbalili súbor zip firmvéru. Kliknite na položky  Odovzdať Spustiť . aktualizácia firmvéru firmvér, aktualizácia"},{"UUID":"5147be09-49b4-41d3-a66e-9a4a13d1c1b4","title":"Inštalácia a aktualizácia softvéru, ovládačov a firmvéru","link":"installing-printer-software-topic.html","desc":"Export alebo import konfiguračného súboru","descFull":"Export alebo import konfiguračného súboru Konfiguračné nastavenia tlačiarne možno exportovať do textového súboru a potom tento súbor importovať do inej tlačiarne, kde sa použijú dané nastavenia. Otvorte webový prehliadač a do poľa adresy zadajte adresu IP tlačiarne. Pozrite si adresu IP tlačiarne na domovskej obrazovke tlačiarne. IP Adresa sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Ak používate server proxy, dočasne ho vypnite, aby sa správne načítala webová stránka. V nástroji Embedded Web Server kliknite na položku  Exportovať konfiguráciu  alebo  Importovať konfiguráciu . Postupujte podľa pokynov na obrazovke. Ak tlačiareň podporuje aplikácie, potom postupujte takto: Kliknite na položku  Aplikácie vyberte aplikáciu Konfigurovať . Kliknite na položku  Exportovať  alebo  Importovať . export konfiguračného súboru prostredníctvom nástroja Embedded Web Server import konfiguračného súboru prostredníctvom nástroja Embedded Web Server"},{"UUID":"6ddbdbc2-bc83-4318-a857-deae808d1e1f","title":"Inštalácia a aktualizácia softvéru, ovládačov a firmvéru","link":"installing-printer-software-topic.html","desc":"Pridávanie dostupných voliteľných prvkov do ovládača","descFull":"Pridávanie dostupných voliteľných prvkov do ovládača tlačiarne Používatelia systému Windows Otvorte priečinok tlačiarní. Vyberte tlačiareň, ktorú chcete aktualizovať, a vykonajte jeden z týchto krokov: V operačnom systéme Windows 7 alebo novšom vyberte položku  Vlastnosti tlačiarne . V predchádzajúcich verziách vyberte položku  Vlastnosti . Prejdite na kartu Konfigurácia a vyberte položku  Aktualizovať teraz – spýtať sa tlačiarne . Uložte zmeny. Používatelia systému Macintosh V položke Systémové preferencie v ponuke Apple prejdite na tlačiareň a vyberte položku  Možnosti a spotrebný materiál . Prejdite na zoznam hardvérových voliteľných prvkov a pridajte nainštalované voliteľné prvky. Uložte zmeny. pridávanie hardvérových voliteľných prvkov ovládač tlačiarne ovládač tlačiarne hardvérové voliteľné prvky, pridávanie pridávanie interných voliteľných prvkov ovládač tlačiarne hardvérové voliteľné prvky, pridávanie ovládač tlačiarne interné voliteľné prvky, pridávanie ovládač tlačiarne"},{"UUID":"bb135dbc-b997-4aa1-b9f3-d05c82fdbe07","title":"Inštalácia hardvérových voliteľných prvkov","link":"available-internal-options-topic.html","desc":"Dostupné interné voliteľné prvky Disk","descFull":"Dostupné interné voliteľné prvky Disk s inteligentným ukladaním Písma Zjednodušená čínština Tradičná čínština Japončina Kórejčina Arabčina Veľkokapacitné ukladanie Pevný disk Licencované funkcie IPDS Čiarový kód Port interných riešení Karta sériového rozhrania RS-232C Karta paralelného rozhrania 1284-B MarkNet  N8230 Fiber Ethernet MarkNet  Bezdrôtový tlačový server N8450 Modul dôveryhodnej platformy Na aktiváciu funkcie Forms Merge a niektorých funkcií IPDS je potrebný disk s inteligentným ukladaním alebo pevný disk. Na aktiváciu funkcie Forms Merge a niektorých funkcií IPDS je potrebný disk s inteligentným ukladaním alebo pevný disk. Niektoré možnosti sú k dispozícii len pri niektorých modeloch tlačiarní. Ak chcete získať viac informácií, obráťte sa na miesto, kde ste zakúpili tlačiareň. Na aktiváciu funkcie Forms Merge a niektorých funkcií IPDS je potrebný disk s inteligentným ukladaním alebo pevný disk. Niektoré možnosti sú k dispozícii len pri niektorých modeloch tlačiarní. Ďalšie informácie získate od svojho predajcu. interné voliteľné prvky karta s firmvérom voliteľné karty pevný disk disk s inteligentným ukladaním"},{"UUID":"efb012a8-6b98-4cc8-abbe-00ac061d305c","title":"Inštalácia hardvérových voliteľných prvkov","link":"available-internal-options-topic.html","desc":"Inštalácia voliteľných zásobníkov Ak pristupujete","descFull":"Inštalácia voliteľných zásobníkov Ak pristupujete k riadiacej jednotke alebo inštalujete voliteľný hardvérový prvok či pamäťové zariadenie po inštalácii tlačiarne, tlačiareň vypnite a odpojte napájací kábel z elektrickej zásuvky, aby ste sa vyhli riziku zasiahnutia elektrickým prúdom. Ak sú k tlačiarni pripojené iné zariadenia, tiež ich vypnite a odpojte všetky káble, ktoré smerujú do tlačiarne. Vypnite tlačiareň. Vytiahnite napájací kábel zo sieťovej zásuvky a potom z tlačiarne. Vybaľte voliteľný zásobník a odstráňte všetok obalový materiál. Zarovnajte tlačiareň s voliteľným zásobníkom a potom spustite tlačiareň nadol na požadované miesto. Ak je hmotnosť tlačiarne väčšia ako 20 kg (44 libier), na jej bezpečné zdvihnutie môžu byť potrebné dve alebo viaceré osoby. Napájací kábel pripojte k tlačiarni a potom do elektrickej zásuvky. Riziku požiaru alebo zásahu elektrickým prúdom sa vyhnete tak, že zapojíte napájací kábel do riadne označenej a správne uzemnenej elektrickej zásuvky, ktorá sa nachádza blízko produktu a je ľahko dostupná. Zapnite tlačiareň. Pridajte zásobník do ovládača tlačiarne, aby bol k dispozícii pre tlačové úlohy. Ďalšie informácie nájdete v časti  . inštalácia zásobníkov zásobníky inštalácia hardvérové voliteľné prvky zásobníky"},{"UUID":"0d613d7b-498f-4f7b-b4d5-b4eda7bbe668","title":"Inštalácia hardvérových voliteľných prvkov","link":"available-internal-options-topic.html","desc":"Inštalácia disku s inteligentným ukladaním","descFull":"Inštalácia disku s inteligentným ukladaním Ak pristupujete k riadiacej jednotke alebo inštalujete voliteľný hardvérový prvok či pamäťové zariadenie po inštalácii tlačiarne, tlačiareň vypnite a odpojte napájací kábel z elektrickej zásuvky, aby ste sa vyhli riziku zasiahnutia elektrickým prúdom. Ak sú k tlačiarni pripojené iné zariadenia, tiež ich vypnite a odpojte všetky káble, ktoré smerujú do tlačiarne. Vypnite tlačiareň. Vytiahnite napájací kábel zo sieťovej zásuvky a potom z tlačiarne. Pomocou skrutkovača s plochou hlavou otvorte prístupový kryt riadiacej jednotky. Elektronické súčasti riadiacej jednotky sa môžu ľahko poškodiť statickou elektrinou. Skôr ako sa dotknete akejkoľvek súčasti alebo konektora riadiacej dosky, dotknite sa kovového povrchu tlačiarne. Vyberte faxovú kartu. Rozbaľte disk s inteligentným ukladaním. Nedotýkajte sa konektorov pozdĺž disku. Vyhľadajte konektor disku ISD. Vložte disk ISD do konektora. Nasaďte faxovú kartu a potom nasaďte skrutky. Zatvorte prístupový kryt riadiacej jednotky a potom nasaďte skrutku. Napájací kábel pripojte k tlačiarni a potom do elektrickej zásuvky. Riziku požiaru alebo zásahu elektrickým prúdom sa vyhnete tak, že zapojíte napájací kábel do riadne označenej a správne uzemnenej elektrickej zásuvky, ktorá sa nachádza blízko produktu a je ľahko dostupná. Zapnite tlačiareň. disk s inteligentným ukladaním inštalácia inštalácia interných voliteľných prvkov disk s inteligentným ukladaním"},{"UUID":"4dacbf2e-ec7f-485c-8171-0a4770a9a351","title":"Inštalácia hardvérových voliteľných prvkov","link":"available-internal-options-topic.html","desc":"Inštalácia pevného disku tlačiarne Tieto","descFull":"Inštalácia pevného disku tlačiarne Tieto pokyny sa vzťahujú len na tlačiarne s podporou pevného disku tlačiarne. Ak pristupujete k riadiacej jednotke alebo inštalujete voliteľný hardvérový prvok či pamäťové zariadenie po inštalácii tlačiarne, tlačiareň vypnite a odpojte napájací kábel z elektrickej zásuvky, aby ste sa vyhli riziku zasiahnutia elektrickým prúdom. Ak sú k tlačiarni pripojené iné zariadenia, tiež ich vypnite a odpojte všetky káble, ktoré smerujú do tlačiarne. Vypnite tlačiareň. Vytiahnite napájací kábel zo sieťovej zásuvky a potom z tlačiarne. Pomocou skrutkovača s plochou hlavou otvorte prístupový kryt riadiacej jednotky. Elektronické súčasti riadiacej jednotky sa môžu ľahko poškodiť statickou elektrinou. Skôr ako sa dotknete akejkoľvek súčasti alebo konektora riadiacej dosky, dotknite sa kovového povrchu tlačiarne. Rozbaľte pevný disk. Pripojte pevný disk k riadiacej jednotke a potom nasaďte skrutky. Nedotýkajte sa stredu pevného disku, ani naň netlačte. Pripojte kábel rozhrania pevného disku k riadiacej jednotke. Zatvorte prístupový kryt riadiacej jednotky a potom nasaďte skrutku. Napájací kábel pripojte k tlačiarni a potom do elektrickej zásuvky. Riziku požiaru alebo zásahu elektrickým prúdom sa vyhnete tak, že zapojíte napájací kábel do riadne označenej a správne uzemnenej elektrickej zásuvky, ktorá sa nachádza blízko produktu a je ľahko dostupná. Zapnite tlačiareň. inštalácia pevného disku tlačiarne inštalácia voliteľných prvkov pevný disk tlačiarne interné voliteľné prvky pevný disk tlačiarne"},{"UUID":"7624d637-defb-44fe-a5fd-ff6b5addbd18","title":"Inštalácia hardvérových voliteľných prvkov","link":"available-internal-options-topic.html","desc":"Inštalácia portu interných riešení Ak","descFull":"Inštalácia portu interných riešení Ak pristupujete k riadiacej jednotke alebo inštalujete voliteľný hardvérový prvok či pamäťové zariadenie po inštalácii tlačiarne, tlačiareň vypnite a odpojte napájací kábel z elektrickej zásuvky, aby ste sa vyhli riziku zasiahnutia elektrickým prúdom. Ak sú k tlačiarni pripojené iné zariadenia, tiež ich vypnite a odpojte všetky káble, ktoré smerujú do tlačiarne. Vypnite tlačiareň. Vytiahnite napájací kábel zo sieťovej zásuvky a potom z tlačiarne. Rozbaľte súpravu portu interných riešení (ISP). Obsah súpravy ISP 1 ISP Karta sériového rozhrania RS-232C Karta paralelného rozhrania 1284-B MarkNet  N8230 Fiber Ethernet 2 Predĺžený kábel portu interných riešení 3 Montážny držiak 4 Skrutky 5 Kryt Odpojte predinštalovaný pripojovací kábel zo zariadenia ISP. Namontujte zariadenie ISP do krytu. Upevnite zariadenie ISP na mieste a následne pripojte predĺžený kábel zariadenia ISP. Pomocou skrutkovača s plochou hlavou odstráňte prístupový kryt riadiacej jednotky. Elektronické súčasti riadiacej jednotky sa môžu ľahko poškodiť statickou elektrinou. Skôr ako sa dotknete akejkoľvek elektronickej súčasti alebo konektora riadiacej jednotky, dotknite sa kovového povrchu tlačiarne. Pripojte súpravu zariadenia ISP k tlačiarni. Zatvorte súpravu zariadenia ISP a potom nasaďte skrutku. Napájací kábel pripojte k tlačiarni a potom do elektrickej zásuvky. Riziku požiaru alebo zásahu elektrickým prúdom sa vyhnete tak, že zapojíte napájací kábel do riadne označenej a správne uzemnenej elektrickej zásuvky, ktorá sa nachádza blízko produktu a je ľahko dostupná. Zapnite tlačiareň. port interných riešení inštalácia inštalácia interných voliteľných prvkov port interných riešení"},{"UUID":"83237955-8960-45a2-8d76-7231394f6185","title":"Inštalácia hardvérových voliteľných prvkov","link":"available-internal-options-topic.html","desc":"Inštalácia pohodlnej zošívačky Vypnite tlačiareň.","descFull":"Inštalácia pohodlnej zošívačky Vypnite tlačiareň. Vytiahnite napájací kábel zo sieťovej zásuvky a potom z tlačiarne. Vybaľte pohodlnú zošívačku. Odstráňte kryty stĺpika. Kryty stĺpika nezahadzujte. Vložte zdroj napájania cez tlačiareň a potom ho pripojte k pohodlnej zošívačke. Aby ste predišli poškodeniu pohodlnej zošívačky, používajte iba zdroj napájania, ktorý je s ňou dodaný. Nainštalujte pohodlnú zošívačku. Správne umiestnite zdroj napájania. Pripojte kryt stĺpika. Správne zaistite zdroj napájania. Pripojte jeden koniec napájacieho kábla zošívačky do zdroja napájania a druhý do elektrickej zásuvky. Pripojte jeden koniec napájacieho kábla tlačiarne do tlačiarne a druhý do elektrickej zásuvky. Riziku požiaru alebo zásahu elektrickým prúdom sa vyhnete tak, že zapojíte napájací kábel do riadne označenej a správne uzemnenej elektrickej zásuvky, ktorá sa nachádza blízko produktu a je ľahko dostupná. Zapnite tlačiareň. pohodlná zošívačka inštalácia inštalácia pohodlnej zošívačky"},{"UUID":"ea4d1985-1f10-436b-aed4-2ec0792e2ede","title":"Pripojenie k sieti","link":"wireless-support-topic.html","desc":"Bezdrôtová podpora Modely tlačiarní a","descFull":"Bezdrôtová podpora Modely tlačiarní a ich bezdrôtová podpora Model tlačiarne Typ zariadenia Číslo modelu Bezdrôtové MX532adwe 7020 476 X 486 MX635adwe 676 X 686 XM3350 689 bezdrôtová podpora"},{"UUID":"7107830c-06db-4ae8-ace6-f72cb49f93f2","title":"Pripojenie k sieti","link":"wireless-support-topic.html","desc":"Pripojenie tlačiarne k sieti Wi-Fi Skontrolujte,","descFull":"Pripojenie tlačiarne k sieti Wi-Fi Skontrolujte, či je položka  Aktívny adaptér  nastavená na možnosť  Automaticky . Na domovskej obrazovke sa dotknite položky  Nastavenia Sieť/porty Prehľad siete Aktívny adaptér . Pomocou ovládacieho panela Na domovskej obrazovke sa dotknite položiek  Nastavenia Sieť/porty Bezdrôtové nastavenie na paneli tlačiarne Vybrať sieť . Vyberte sieť Wi-Fi a potom zadajte heslo siete. V prípade modelov tlačiarní, ktoré podporujú pripojenie k sieti Wi-Fi, sa počas úvodného nastavenia zobrazí výzva na nastavenie siete Wi-Fi. Používanie mobilného asistenta spoločnosti Lexmark V závislosti od vášho mobilného zariadenia si stiahnite mobilného asistenta spoločnosti Lexmark buď v internetovom obchode  Google Play , alebo v internetovom obchode App Store. Na domovskej obrazovke tlačiarne sa dotknite položiek  Nastavenia Sieť/porty Bezdrôtové nastavenie pomocou mobilnej aplikácie Identifikátor tlačiarne . Spustite aplikáciu zo svojho mobilného zariadenia a potom prijmite podmienky používania. Ak je to potrebné, udeľte povolenia. Ťuknite na položku  Pripojiť k tlačiarni Prejsť na nastavenia siete Wi‑Fi . Pripojte svoje mobilné zariadenie k bezdrôtovej sieti tlačiarne. Vráťte sa do aplikácie a potom ťuknite na položku  Nastaviť pripojenie Wi-Fi . Vyberte sieť Wi-Fi a potom zadajte heslo siete. Ťuknite na možnosť  Hotovo . bezdrôtová sieť pripojenie tlačiarne k pripojenie tlačiarne k bezdrôtovej sieti bezdrôtové siete"},{"UUID":"a60dc48e-9053-4f8c-ba1c-6b3fe6dc4b78","title":"Pripojenie k sieti","link":"wireless-support-topic.html","desc":"Pripojenie tlačiarne k bezdrôtovej sieti","descFull":"Pripojenie tlačiarne k bezdrôtovej sieti prostredníctvom WPS (Wi-Fi Protected Setup – nastavenie zabezpečenia siete Wi-Fi) Pred začatím skontrolujte nasledujúce: Prístupový bod (bezdrôtový smerovač) je certifikovaný pre WPS alebo kompatibilný s WPS. Ďalšie informácie získate v dokumentácii k prístupovému bodu. V tlačiarni je nainštalovaný adaptér bezdrôtovej siete. Ďalšie informácie získate v návode k adaptéru. Aktívny adaptér  je nastavený na možnosť  Automaticky . Na domovskej obrazovke sa dotknite položky  Nastavenia Sieť/porty Prehľad siete Aktívny adaptér . Metóda stlačenia tlačidla Na domovskej obrazovke sa dotknite položky  Nastavenia Sieť/porty Bezdrôtové Wi‑Fi Protected Setup (WPS – nastavenie zabezpečenia siete Wi-Fi) Spustenie metódou stlačenia tlačidla . Postupujte podľa pokynov na displeji. Metóda osobného identifikačného čísla (PIN) Na domovskej obrazovke sa dotknite položky  Nastavenia Sieť/porty Bezdrôtové Wi‑Fi Protected Setup (WPS – nastavenie zabezpečenia siete Wi-Fi) Spustenie metódou PIN . Skopírujte osemčíselný kód WPS PIN. Otvorte webový prehliadač a do poľa adresy zadajte adresu IP vášho prístupového bodu. Ak chcete zistiť IP adresu, pozrite si dokumentáciu k prístupovému bodu. Ak používate server proxy, dočasne ho vypnite, aby sa správne načítala webová stránka. Otvorte nastavenia WPS. Ďalšie informácie získate v dokumentácii k prístupovému bodu. Zadajte osemčíselný kód PIN a uložte zmeny. Wi‑Fi Protected Setup (WPS – nastavenie zabezpečenia siete Wi-Fi) bezdrôtová sieť bezdrôtová sieť Wi‑Fi Protected Setup (WPS – nastavenie zabezpečenia siete Wi-Fi) pripojenie k bezdrôtovej sieti využívanie metódy PIN metóda osobného identifikačného čísla pripojenie k bezdrôtovej sieti využívanie metódy stlačenia tlačidla metóda stlačenia tlačidla"},{"UUID":"49ca3095-222f-4e42-8d51-c6166dc49cb9","title":"Pripojenie k sieti","link":"wireless-support-topic.html","desc":"Konfigurácia funkcie Wi-Fi Direct Wi-Fi","descFull":"Konfigurácia funkcie Wi-Fi Direct Wi-Fi Direct  je technológia typu peer-to-peer, ktorá umožňuje bezdrôtovým zariadeniam priamo sa pripojiť k tlačiarni s aktivovanou sieťou Wi-Fi Direct bez používania prístupového bodu (bezdrôtový smerovač). Skontrolujte, či je položka  Aktívny adaptér  nastavená na možnosť  Automaticky . Na domovskej obrazovke sa dotknite položky  Nastavenia Sieť/porty Prehľad siete Aktívny adaptér. Na domovskej obrazovke sa dotknite položiek  Nastavenia Sieť/porty Wi-Fi Direct . Nakonfigurujte nastavenia. Povoliť funkciu siete Wi‑Fi Direct  – funkcia umožňuje tlačiarni vysielať v svojej vlastnej sieti Wi‑Fi Direct. Názov siete Wi‑Fi Direct  – funkcia priradí názov sieti Wi‑Fi Direct. Heslo siete Wi‑Fi Direct  – funkcia priradí heslo na nastavenie zabezpečenia bezdrôtovej komunikácie pri používaní pripojenia typu peer-to-peer. Zobraziť heslo na stránke Nastavenie  – zobrazí heslo na stránke nastavenia siete. Automaticky prijať požiadavky stlačením tlačidla – funkcia umožňuje tlačiarni prijímať požiadavky na pripojenie automaticky. Prijímanie požiadaviek stlačením tlačidla nie je zabezpečené. V predvolenom nastavení sa na displeji tlačiarne nezobrazuje heslo siete Wi-Fi Direct. Ak chcete zobraziť heslo, aktivujte ikonu náhľadu hesla. Na domovskej obrazovke sa dotknite položiek  Nastavenia Zabezpečenie Rôzne Povoliť odhalenie hesla/kódu PIN. Heslo siete Wi-Fi Direct môžete zobraziť bez toho, aby ste ho zobrazili na displeji tlačiarne. Na domovskej obrazovke sa dotknite položiek  Nastavenia Správy Sieť Stránka nastavenia siete. Wi‑Fi Direct konfigurácia konfigurácia siete Wi-Fi Direct"},{"UUID":"fb5d2fa8-363d-497a-bad3-739f878ccbd8","title":"Pripojenie k sieti","link":"wireless-support-topic.html","desc":"Pripojenie mobilného zariadenia k tlačiarni Pred","descFull":"Pripojenie mobilného zariadenia k tlačiarni Pred pripojením mobilného zariadenia sa uistite, že je nakonfigurovaná funkcia Wi‑Fi Direct. Ďalšie informácie nájdete v časti  . Pripojte sa pomocou funkcie Wi-Fi Direct Tieto pokyny sa vzťahujú len na mobilné zariadenia so systémom Android. Z mobilného zariadenia prejdite do ponuky nastavení. Povoľte sieť  Wi‑Fi  a potom ťuknite na funkciu  Wi‑Fi Direct . Vyberte názov tlačiarne v sieti Wi-Fi Direct. Potvrďte pripojenie na ovládacom paneli tlačiarne. Pripojenie pomocou siete Wi‑Fi Z mobilného zariadenia prejdite do ponuky nastavení. Ťuknite na položku  Wi-Fi  a potom vyberte názov tlačiarne v sieti Wi‑Fi Direct. Pred názov siete Wi-Fi Direct sa pridá reťazec DIRECT-xy (kde x a y sú dva náhodné znaky). Zadajte heslo siete Wi‑Fi Direct. pripojenie mobilného zariadenia k tlačiarni mobilné zariadenie pripojenie k tlačiarni Wi‑Fi Direct povolenie povolenie funkcie Wi-Fi Direct"},{"UUID":"acd37758-a3d1-4c59-8eec-026be48bac70","title":"Pripojenie k sieti","link":"wireless-support-topic.html","desc":"Wi‑Fi Direct Pripojenie počítača k","descFull":"Wi‑Fi Direct Pripojenie počítača k tlačiarni Pred pripojením počítača sa uistite, že je nakonfigurovaná funkcia Wi‑Fi Direct. Ďalšie informácie nájdete v časti  . Používatelia systému Windows Otvorte priečinok s tlačiarňami a potom kliknite na položku  Pridať tlačiareň alebo skener . Kliknite na položku  Zobraziť tlačiarne Wi-Fi Direct  a potom vyberte názov tlačiarne Wi‑Fi Direct. Z displeja tlačiarne si poznačte osemciferný kód PIN tlačiarne. Zadajte kód PIN v počítači. Ak ešte nie je nainštalovaný ovládač tlačiarne, systém Windows prevezme príslušný ovládač. Používatelia systému Macintosh Kliknite na ikonu bezdrôtového pripojenia a potom vyberte názov siete Wi-Fi Direct tlačiarne. Pred názov siete Wi-Fi Direct sa pridá reťazec DIRECT-xy (kde x a y sú dva náhodné znaky). Zadajte heslo Wi‑Fi Direct. Po odpojení od siete Wi-Fi Direct prepnite počítač späť na predchádzajúcu sieť. počítač pripojenie k počítaču pripojenie počítača k tlačiarni"},{"UUID":"c90be4ec-3418-43a2-bdbe-80b37b27ad2f","title":"Pripojenie k sieti","link":"wireless-support-topic.html","desc":"Deaktivácia siete Wi-Fi Na domovskej","descFull":"Deaktivácia siete Wi-Fi Na domovskej obrazovke sa dotknite položky  Nastavenia Sieť/porty Prehľad siete Aktívny adaptér Štandardná sieť . Postupujte podľa pokynov na displeji. sieť Wi‑Fi deaktivuje sa deaktivácia siete Wi-Fi"},{"UUID":"4b8e041a-e66c-453f-9902-adde51b2747e","title":"Pripojenie k sieti","link":"wireless-support-topic.html","desc":"Kontrola pripojenia tlačiarne Na domovskej","descFull":"Kontrola pripojenia tlačiarne Na domovskej obrazovke sa dotknite položiek  Nastavenia Správy Sieť Strana nastavenia siete . Skontrolujte prvú časť strany nastavenia siete a potvrďte, že ukazuje stav „pripojené“. Ak stav nie je označený ako „pripojené“, prepojenie LAN môže byť neaktívne alebo môže byť poškodený sieťový kábel. Vyhľadajte pomoc u svojho správcu. tlač strana nastavenia siete tlač strany nastavenia siete strana nastavenia siete tlač"},{"UUID":"6eaa2456-6462-444c-919d-2873762fd3a7","title":"Zabezpečenie tlačiarne","link":"locating-security-slot-topic.html","desc":"Umiestnenie bezpečnostnej zásuvky Tlačiareň je","descFull":"Umiestnenie bezpečnostnej zásuvky Tlačiareň je vybavená bezpečnostným zámkom. Tlačiareň zamknete na mieste tak, že pripevníte bezpečnostný zámok kompatibilný s väčšinou prenosných počítačov na miesto zobrazené na obrázku. bezpečnostná zásuvka umiestnenie umiestnenie bezpečnostnej zásuvky"},{"UUID":"81301b54-ca94-49b4-86ac-b934112ca361","title":"Zabezpečenie tlačiarne","link":"erasing-printer-memory-topic.html","desc":"Vymazanie pamäte tlačiarne Ak chcete","descFull":"Vymazanie pamäte tlačiarne Ak chcete vymazať nestálu pamäť alebo údaje vo vyrovnávacej pamäti tlačiarne, tlačiareň vypnite. Ak chcete vymazať stálu pamäť, nastavenia zariadenia a siete, nastavenia zabezpečenia a integrované riešenia, postupujte takto: Na domovskej obrazovke sa dotknite položiek  Nastavenia Zariadenie Údržba Vymazanie mimo prevádzky. Dotknite sa začiarkavacieho políčka  Ošetriť všetky informácie stabilnej pamäte  a potom položky  VYMAZAŤ . Dotknite sa položky  Spustiť sprievodcu úvodným nastavením  alebo  Ponechať tlačiareň v režime offline  a potom sa dotknite položky  Ďalej . Spustite operáciu. Tento proces zároveň zničí šifrovací kľúč, ktorý sa používa na ochranu používateľských údajov. Po zničení šifrovacieho kľúča údaje už nemožno obnoviť. nestála pamäť vymazanie permanentná pamäť vymazanie pamäť tlačiarne vymazanie vymazanie pamäť tlačiarne"},{"UUID":"c8159a1a-92ff-4251-a528-cf77b6d0b715","title":"Zabezpečenie tlačiarne","link":"erasing-printer-storage-drive-topic.html","desc":"Vymazanie úložného disku tlačiarne Na","descFull":"Vymazanie úložného disku tlačiarne Na domovskej obrazovke sa dotknite položiek  Nastavenia Zariadenie Údržba Vymazanie mimo prevádzky. V závislosti od úložného disku nainštalovaného v tlačiarni vykonajte niektorý z týchto krokov: Ak chcete použiť pevný disk, dotknite sa začiarkavacieho políčka  Ošetriť všetky informácie na pevnom disku , položky  VYMAZAŤ  a potom vyberte spôsob vymazania údajov. Tento proces na ošetrenie pevného disku môže trvať niekoľko minút alebo aj dlhšie ako hodinu. Počas tohto času bude tlačiareň nedostupná pre iné úlohy. Ak chcete vymazať všetky používateľské údaje na disku s inteligentným ukladaním (ISD), dotknite sa položky  Vymazať disk s inteligentným ukladaním  a potom položky  VYMAZAŤ . Spustite operáciu. úložný disk vymazanie vymazanie úložného disku tlačiarne pevný disk vymazanie disk s inteligentným ukladaním vymazanie"},{"UUID":"9678ef21-b10f-4704-bcb0-421e7c2d692b","title":"Zabezpečenie tlačiarne","link":"restoring-factory-default-settings-topic.html","desc":"Obnovenie predvolených výrobných nastavení Na","descFull":"Obnovenie predvolených výrobných nastavení Na domovskej obrazovke sa dotknite položky  Nastavenia Zariadenie Obnoviť predvolené výrobné nastavenia . Dotknite sa položky  Obnoviť nastavenia vyberte nastavenia, ktoré chcete obnoviť OBNOVIŤ . Spustite operáciu. predvolené výrobné nastavenia obnova nastavenia tlačiarne obnovenie predvolených výrobných nastavení"},{"UUID":"aaa30100-1f55-487c-be03-57c685c03e71","title":"Zabezpečenie tlačiarne","link":"statement-of-volatility-topic.html","desc":"Vyhlásenie o nestálosti Typy pamätí","descFull":"Vyhlásenie o nestálosti Typy pamätí a ich popis. Typ pamäte Opis Nestála pamäť Tlačiareň využíva štandardnú pamäť s náhodným prístupom (RAM) na dočasné ukladanie používateľských dát do vyrovnávacej pamäte pri jednoduchých tlačových a kopírovacích úlohách. Stála pamäť Tlačiareň využíva dva druhy stálej pamäte: EEPROM a NAND (pamäť flash). V oboch typoch sa ukladá operačný systém, nastavenia tlačiarne a sieťové informácie. Ukladajú sa v nich aj nastavenia skenera a záložiek a integrované riešenia. Jednotka pevného disku s ukladaním Niektoré tlačiarne môžu mať nainštalovanú jednotku pevného disku. Pevný disk tlačiarne je navrhnutý na špecifické funkcie tlačiarne. Pevný disk umožňuje tlačiarni uchovávať používateľské údaje komplexných úloh tlače z vyrovnávacej pamäte, údaje formulárov a údaje písiem. Disk s inteligentným ukladaním (ISD) Niektoré tlačiarne môžu mať nainštalovaný disk ISD. Disk ISD používa stálu pamäť flash na ukladanie používateľských údajov z komplexných tlačových úloh, údajov formulára a údajov písma. Obsah všetkých nainštalovaných pamätí tlačiarne vymažte v nasledujúcich prípadoch: Tlačiareň sa vyradí z prevádzky. Vymení sa pevný disk alebo disk ISD tlačiarne. Tlačiareň sa presunie na iné oddelenie alebo na iné miesto. Na tlačiarni vykoná servis osoba, ktorá nie je z vašej organizácie. Tlačiareň sa odošle na servis mimo priestory vašej organizácie. Tlačiareň sa predá inej organizácii. Ak chcete zlikvidovať úložný disk, postupujte podľa zásad a postupov vašej organizácie. vyhlásenie o nestálosti nestála pamäť stála pamäť jednotka pevného disku s ukladaním disk s inteligentným ukladaním vymazanie pamäte tlačiarne zabezpečenie údajov tlačiarne"},{"UUID":"638b7f80-9522-4b01-982c-da8b335519a1","title":"Tlač","link":"printing-from-computer-h2-topic.html","desc":"Tlač z počítača V prípade","descFull":"Tlač z počítača V prípade štítkov, kartónového papiera a obálok nastavte pred tlačou dokumentu veľkosť a typ papiera. V dokumente, ktorý chcete tlačiť, otvorte dialógové okno Tlač. V prípade potreby nastavenia upravte. Vytlačte dokument. tlač z počítača dokumenty, tlač z počítača tlač z počítača"},{"UUID":"ef8c47e1-447f-4501-b090-fc049c8112ce","title":"Tlač z mobilného zariadenia","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Tlač z mobilného zariadenia pomocou Mobilnej","descFull":"Tlač z mobilného zariadenia pomocou Mobilnej tlače Lexmark Tlač z mobilného zariadenia pomocou Mobilnej tlače Lexmark Lexmark  Mobilná tlač umožňuje odosielať dokumenty a obrázky priamo do podporovanej tlačiarne Lexmark. Otvorte dokument a potom ho odošlite alebo zdieľajte do Mobilnej tlače Lexmark. Niektoré aplikácie tretích strán nemusia podporovať funkcie odosielania a zdieľania. Ďalšie informácie nájdete v dokumentácii dodanej s aplikáciou. Vyberte tlačiareň. Vytlačte dokument. Mobilná tlač Lexmark používanie dokumenty, tlač z mobilného zariadenia mobilné zariadenie tlač z"},{"UUID":"6c116729-d2b5-439e-8fc8-df22bed2dfed","title":"Tlač z mobilného zariadenia","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Tlač z mobilného zariadenia pomocou aplikácie","descFull":"Tlač z mobilného zariadenia pomocou aplikácie Lexmark Print Lexmark  Tlač je riešenie mobilnej tlače určené pre mobilné zariadenia používajúce systém  Android  verzie 6.0 alebo novší. Umožňuje odosielať dokumenty a obrázky do tlačiarní pripojených k sieti a na servery správy tlače. Uistite sa, že ste prevzali aplikáciu Tlač Lexmark z obchodu  Google Play  a povolili ju v mobilnom zariadení. Skontrolujte, či sú tlačiareň a mobilné zariadenie pripojené k rovnakej sieti. Vo vašom mobilnom zariadení vyberte dokument zo správcu súborov. Odošlite alebo zdieľajte dokument do aplikácie Tlač Lexmark. Niektoré aplikácie tretích strán nemusia podporovať funkcie odosielania a zdieľania. Ďalšie informácie nájdete v dokumentácii dodanej s aplikáciou. Vyberte tlačiareň a v prípade potreby upravte nastavenia. Vytlačte dokument. Lexmark Print používanie dokumenty, tlač z mobilného zariadenia mobilné zariadenie tlač z"},{"UUID":"084c290d-9f05-4475-ada4-26bedb104b89","title":"Tlač z mobilného zariadenia","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Tlač z mobilného zariadenia pomocou tlačovej","descFull":"Tlač z mobilného zariadenia pomocou tlačovej služby Mopria. Mopria  Tlačová služba je riešenie mobilnej tlače určené pre mobilné zariadenia používajúce systém  Android  verzie 5.0 alebo novší. Umožňuje priamu tlač na ľubovoľnú tlačiareň certifikovanú na používanie služby Mopria. Uistite sa, že ste prevzali aplikáciu Mopria Print Service z obchodu  Google Play  a povolili ju v mobilnom zariadení. Vo vašom mobilnom zariadení so systémom Android otvorte dokument alebo vyberte dokument zo svojho správcu súborov. Ťuknite na možnosť  Tlačiť . Vyberte tlačiareň a v prípade potreby upravte nastavenia. Ťuknite na položku  . tlačová služba Mopria tlač z mobilného zariadenia mobilné zariadenie tlač z tlač pomocou tlačovej služby Mopria"},{"UUID":"c6858c2a-25f2-4fe2-80c8-e3e5eea3c297","title":"Tlač z mobilného zariadenia","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Tlač z mobilného zariadenia pomocou funkcie","descFull":"Tlač z mobilného zariadenia pomocou funkcie AirPrint Funkcia softvéru AirPrint predstavuje riešenie mobilnej tlače umožňujúce tlačiť priamo zo zariadení Apple na tlačiareň s certifikáciou AirPrint. Skontrolujte, či zariadenie Apple a tlačiareň sú v tej istej sieti. Ak má sieť viacero bezdrôtových rozbočovačov, skontrolujte, či sú obe zariadenia pripojené do tej istej podsiete. Táto aplikácia je podporovaná iba na niektorých zariadeniach Apple. Z vášho mobilného zariadenia vyberte dokument zo správcu súborov alebo spustite kompatibilnú aplikáciu. Ťuknite na možnosť  Tlačiť . Vyberte tlačiareň a v prípade potreby upravte nastavenia. Vytlačte dokument. AirPrint používanie tlač z mobilného zariadenia mobilné zariadenie tlač z"},{"UUID":"d7c56ac3-559c-47ab-90da-679084983282","title":"Tlač z mobilného zariadenia","link":"printing-from-mobile-device-using-lexmark-print-topic.html","desc":"Tlač z mobilného zariadenia pomocou technológie","descFull":"Tlač z mobilného zariadenia pomocou technológie Wi‑Fi Direct® Wi‑Fi Direct  je služba tlače, ktorá vám umožňuje tlačiť na ľubovoľnej tlačiarni s podporou technológie Wi‑Fi Direct. Skontrolujte, či je mobilné zariadenie pripojené k bezdrôtovej sieti tlačiarne. Ďalšie informácie nájdete v časti  . Vo vašom mobilnom zariadení spustite kompatibilnú aplikáciu alebo vyberte dokument zo svojho správcu súborov. V závislosti od mobilného zariadenia vykonajte jeden z nasledujúcich krokov: Ťuknite na možnosť  Print  (Tlačiť). Ťuknite na možnosť  Print  (Tlačiť). Ťuknite na možnosť  Print  (Tlačiť). Vyberte tlačiareň a v prípade potreby upravte nastavenia. Vytlačte dokument. Wi‑Fi Direct tlač z mobilného zariadenia tlač z mobilného zariadenia mobilné zariadenie tlač z tlač pomocou funkcie Wi-Fi Direct"},{"UUID":"3162c0f1-3e26-49c5-b4f8-5163cb2ca9cb","title":"Tlač","link":"printing-from-flash-drive-topic.html","desc":"Tlač z pamäťovej jednotky flash Vložte","descFull":"Tlač z pamäťovej jednotky flash Vložte pamäťovú jednotku flash. Ak pamäťovú jednotku flash vložíte, keď sa objaví chybové hlásenie, tlačiareň bude pamäťovú jednotku flash ignorovať. Ak pamäťovú jednotku flash vložíte, keď tlačiareň spracúva iné tlačové úlohy, na displeji sa zobrazí správa  Zaneprázdnené . Na displeji sa dotknite dokumentu, ktorý chcete vytlačiť. V prípade potreby nakonfigurujte nastavenia tlače. Vytlačte dokument. Ak chcete vytlačiť iný dokument, dotknite sa položky  Jednotka USB . Ak chcete predísť strate údajov alebo zlyhaniu tlačiarne, počas aktívnej tlače, načítavania alebo zapisovania na pamäťové zariadenie sa nedotýkajte jednotky flash ani tlačiarne v zobrazenej oblasti. tlač z pamäťovej jednotky flash jednotka flash tlač z"},{"UUID":"9e14846d-6baa-4ce3-8c0f-99918f4924f0","title":"Tlač","link":"supported-flash-drives-and-file-types-topic.html","desc":"Podporované jednotky flash a typy súborov","descFull":"Podporované jednotky flash a typy súborov Pamäťové jednotky flash Pamäťové jednotky flash, ktoré podporujú rozhranie USB 2.0 alebo nižšie. Pamäťové jednotky flash, ktoré podporujú systém súborov New Technology File System (NFTS) alebo File Allocation Table (FAT32). Typy súborov Podporované typy súborov Dokumenty Obrázky PDF (verzia 1.7 alebo staršia verzia) Formáty súborov Microsoft (DOC, DOCX, XLS, XLSX, PPT, PPTX) JPEG alebo JPG TIFF alebo TIF GIF BMP PNG PCX DCX podporované jednotky flash podporované typy súborov"},{"UUID":"62a832e2-2fe1-4533-a133-d9d6dd6a9fa6","title":"Tlač","link":"configuring-confidential-jobs-topic.html","desc":"Konfigurácia dôverných úloh Na domovskej","descFull":"Konfigurácia dôverných úloh Na domovskej obrazovke sa dotknite položiek  Nastavenia Zabezpečenie Nastavenie dôvernej tlače . Nakonfigurujte nastavenia. Položky ponuky  Nastavenie dôvernej tlače  a ich popis Nastavenie Opis Max. počet neplatných kódov PIN Nastavte limit pre počet zadaní neplatného kódu PIN. Po dosiahnutí limitu sa odstránia tlačové úlohy pre dané meno používateľa. Koniec platnosti dôvernej úlohy Nastavte individuálnu dobu uplynutia platnosti každej pozastavenej úlohy pred jej automatickým vymazaním z pamäte tlačiarne, pevného disku alebo z disku s inteligentným ukladaním. Pozastavená úloha je  dôverná ,  opakovaná ,  rezervovaná  alebo  overovaná . Koniec platnosti opakovaných úloh Nastavte dobu uplynutia platnosti tlačových úloh, ktoré chcete opakovať. Koniec platnosti overenia úlohy Nastavte dobu uplynutia platnosti tlače kópie úlohy na kontrolu jej kvality pred vytlačením zostávajúcich kópií. Koniec platnosti rezervovanej úlohy Nastavte dobu uplynutia platnosti úloh, ktoré chcete v tlačiarni uložiť na neskoršie vytlačenie. Je potrebné, aby sa zadržali všetky úlohy Nastavenie tlačiarne, aby zadržala všetky tlačové úlohy. Zachovať duplicitné dokumenty Nastavenie tlačiarne, aby zachovala všetky dokumenty s rovnakým názvom súboru. úlohy dôvernej tlače konfigurácia pozastavené úlohy nastavenie doby uplynutia platnosti uloženie tlačových úloh opakované tlačové úlohy overenie tlačových úloh"},{"UUID":"7ca74736-fb59-4eda-b0f4-724c528db838","title":"Tlač","link":"printing-confidential-and-other-held-jobs-topic.html","desc":"Tlač dôverných a iných zadržaných úloh","descFull":"Tlač dôverných a iných zadržaných úloh Používatelia systému Windows Po otvorení dokumentu kliknite na položky  Súbor Tlač . Vyberte tlačiareň a kliknite na položky  Vlastnosti ,  Predvoľby ,  Možnosti  alebo  Nastavenie . Kliknite na možnosť  Tlačiť a zadržať . Vyberte možnosť  Tlačiť a zadržať  a potom priraďte meno používateľa. Vyberte typ tlačovej úlohy (dôverná, opakovaná, rezervovaná alebo overenie). Ak vyberiete možnosť  Dôverná , tlačovú úlohu zabezpečte osobným identifikačným číslom (PIN). Kliknite na tlačidlo  OK  alebo  Tlačiť . Na úvodnej obrazovke tlačiarne uvoľnite tlačovú úlohu. Pri dôverných tlačových úlohách sa dotknite položiek  Pozastavené úlohy  vyberte svoje meno používateľa Dôverné  zadajte svoj kód PIN  vyberte tlačovú úlohu  nakonfigurujte nastavenia Tlačiť . Pri ostatných tlačových úlohách sa dotknite položiek  Pozastavené úlohy  vyberte svoje meno používateľa  vyberte tlačovú úlohu  nakonfigurujte nastavenia Tlačiť . Používatelia systému Macintosh Používanie funkcie AirPrint Po otvorení dokumentu vyberte položky  Súbor Tlač . Vyberte tlačiareň a potom z rozbaľovacej ponuky po ponuke  Orientácia  vyberte položku  Tlač pomocou kódu PIN . Povoľte  Tlač pomocou kódu PIN  a zadajte štvorciferný kód PIN. Kliknite na tlačidlo  Tlačiť . Na úvodnej obrazovke tlačiarne uvoľnite tlačovú úlohu. Dotknite sa položiek  Pozastavené úlohy  vyberte svoje meno používateľa Dôverné  zadajte svoj kód PIN  vyberte tlačovú úlohu Tlačiť . Používanie ovládača tlače Po otvorení dokumentu vyberte položky  Súbor Tlač . Vyberte tlačiareň a potom z rozbaľovacej ponuky po ponuke  Orientácia  vyberte položku  Tlačiť a zadržať . Vyberte možnosť  Dôverná tlač  a zadajte štvorciferný kód PIN. Kliknite na tlačidlo  Tlačiť . Na úvodnej obrazovke tlačiarne uvoľnite tlačovú úlohu. Dotknite sa položky  Pozastavené úlohy  vyberte názov počítača Dôverné vyberte tlačovú úlohu  zadajte kód PIN Tlačiť . tlač pozastavené úlohy tlač úlohy dôvernej tlače úlohy dôvernej tlače tlač pozastavené úlohy tlač"},{"UUID":"400fc68b-c55c-48b8-80e9-58b20ffb4661","title":"Tlač","link":"printing-font-sample-list-h2-topic.html","desc":"Tlač zoznamu ukážok písiem Na","descFull":"Tlač zoznamu ukážok písiem Na domovskej obrazovke sa dotknite položiek  Nastavenia Správy Tlačiť Tlačiť písma . Dotknite sa položiek  Písma PCL  alebo  Písma PS . tlač zoznam ukážok písiem tlač zoznamu ukážok písiem zoznam ukážok písiem tlač"},{"UUID":"9c021115-dc06-46be-beed-f76d454ec264","title":"Tlač","link":"printing-directory-list-h2-topic.html","desc":"Tlač zoznamu adresára Na domovskej","descFull":"Tlač zoznamu adresára Na domovskej obrazovke sa dotknite položky  Nastavenia Správy Tlačiť Tlačiť adresár . tlač zoznam adresára tlač zoznamu adresára zoznam adresára tlač"},{"UUID":"26fd4c65-cd06-46b7-99c8-6f10b076287d","title":"Tlač","link":"placing-separator-sheets-topic.html","desc":"Umiestnenie oddeľovacích hárkov medzi kópie","descFull":"Umiestnenie oddeľovacích hárkov medzi kópie Na domovskej obrazovke sa dotknite položke  Nastavenia Tlač Rozloženie Oddeľovacie listy Medzi kópiami . Vytlačte dokument. oddeľovacie hárky umiestnenie umiestnenie oddeľovacích hárkov"},{"UUID":"c374b087-44d3-4a11-a5a0-a772f79a83d1","title":"Tlač","link":"canceling-print-job-topic.html","desc":"Zrušenie tlačovej úlohy Na domovskej","descFull":"Zrušenie tlačovej úlohy Na domovskej stránke sa dotknite položky  . Vyberte úlohu, ktorú chcete zrušiť. Úlohu môžete zrušiť aj dotykom na položku  Poradie úloh . tlačová úloha zrušenie zrušenie tlačovej úlohy"},{"UUID":"8858f1ec-61f4-4eee-963f-c481da4856ca","title":"Tlač","link":"adjusting-toner-darkness-topic.html","desc":"Úprava tmavosti tonera Na domovskej","descFull":"Úprava tmavosti tonera Na domovskej obrazovke sa dotknite položiek  Nastavenia Tlač Kvalita Tmavosť tonera . Upravte nastavenie. tmavosť tonera nastavenie nastavenie tmavosti tonera"},{"UUID":"46011d7d-6619-40fd-98c3-d24ef1819f17","title":"Kopírovanie","link":"using-ADF-and-scanner-glass-copy-topic.html","desc":"Používanie automatického podávača dokumentov a skenovacieho","descFull":"Používanie automatického podávača dokumentov a skenovacieho skla Vkladanie papiera do zásobníka automatického podávača dokumentov a na skenovacie sklo Automatický podávač dokumentov (ADF) Skenovacie sklo Automatický podávač dokumentov používajte pre viacstranové alebo obojstranne tlačené dokumenty. Vložte zdrojový dokument stranou určenou na skenovanie smerom nahor. Pri viacstranových dokumentoch sa pred ich vložením ubezpečte, že je zarovnaná čelná hrana. Skontrolujte, či sú vodiace lišty automatického podávača dokumentov nastavené tak, aby zodpovedali šírke vkladaného papiera. Skenovacie sklo používajte na jednostranové dokumenty, strany kníh, malé položky (napr. pohľadnice alebo fotografie), priehľadné fólie, fotografický papier alebo tenké médiá (napr. výstrižky z časopisov). Umiestnite dokument stranou určenou na skenovanie smerom nadol do rohu so šípkou. kopírovanie používanie automatického podávača dokumentov (ADF) kopírovanie používanie skenovacieho skla"},{"UUID":"46e168de-354f-4cbd-854c-282af671a7fe","title":"Kopírovanie","link":"making-copies-topic.html","desc":"Vytváranie kópií Zdrojový dokument vložte","descFull":"Vytváranie kópií Zdrojový dokument vložte do zásobníka automatického podávača dokumentov alebo ho položte na skenovacie sklo. Ak chcete zabrániť tomu, aby bol obrázok orezaný, uistite sa, že pôvodný dokument aj výstup sú rovnakej veľkosti papiera. Na domovskej obrazovke sa dotknite tlačidla  Kopírovanie  a zadajte počet kópií. V prípade potreby upravte nastavenia kopírovania. Skopírujte dokument. Ak chcete vytvoriť rýchlu kópiu, na domovskej obrazovke stlačte tlačidlo  . vytváranie kópií používanie automatického podávača dokumentov kopírovanie používanie skenovacieho skla kopírovanie kopírovanie z vybraného zásobníka kopírovanie dokumentov rôznych veľkostí rôzne veľkosti papiera, kopírovanie"},{"UUID":"d407a37b-5b61-4ea8-a869-90e7a6ceb737","title":"Kopírovanie","link":"copying-photos-topic.html","desc":"Kopírovanie fotografií Položte fotografiu na","descFull":"Kopírovanie fotografií Položte fotografiu na skenovacie sklo. Na domovskej obrazovke sa dotknite položiek  Kopírovanie Nastavenia Obsah Typ obsahu Fotografia . Dotknite sa položky  Zdroj obsahu  a potom vyberte nastavenie, ktoré najlepšie zodpovedá pôvodnej fotografii. Skopírujte fotografiu. kopírovanie fotografie fotografie, kopírovanie"},{"UUID":"4c492010-067a-467c-b508-a5e56ba0e79c","title":"Kopírovanie","link":"copying-transparencies-or-letterhead-topic.html","desc":"Kopírovanie na hlavičkový papier Zdrojový","descFull":"Kopírovanie na hlavičkový papier Zdrojový dokument vložte do zásobníka automatického podávača dokumentov alebo ho položte na skenovacie sklo. Na domovskej obrazovke sa dotknite položiek  Kopírovanie Kopírovať z vyberte veľkosť pôvodného dokumentu. Dotknite sa položky  Kopírovať do  a potom vyberte zdroj papiera, ktorý obsahuje hlavičkový papier. Ak ste hlavičkový papier vložili do viacúčelového podávača, dotknite sa položky  Kopírovať do Viacúčelový podávač vyberte veľkosť hlavičkového papiera . Skopírujte dokument. kopírovanie na hlavičkový papier hlavičkový papier kopírovanie na"},{"UUID":"93a3b716-82f4-4f9d-b1d4-6e8ac17f9d85","title":"Kopírovanie","link":"copying-on-both-sides-of-paper-topic.html","desc":"Kopírovanie na obe strany papiera","descFull":"Kopírovanie na obe strany papiera Zdrojový dokument vložte do zásobníka automatického podávača dokumentov alebo ho položte na skenovacie sklo. Na domovskej obrazovke sa dotknite tlačidla  Kopírovanie Nastavenia Strany . Vyberte možnosť  Jednostranné na obojstranné  alebo  Obojstranné na obojstranné . Skopírujte dokument. kopírovanie na obe strany papiera obojstranné kopírovanie"},{"UUID":"c9b67516-f9bd-4d23-86fa-58095ba839b9","title":"Kopírovanie","link":"reducing-enlarging-copies-topic.html","desc":"Zmenšenie alebo zväčšenie kópií Zdrojový","descFull":"Zmenšenie alebo zväčšenie kópií Zdrojový dokument vložte do zásobníka automatického podávača dokumentov alebo ho položte na skenovacie sklo. Na domovskej obrazovke sa dotknite položky  Kopírovanie Nastavenia Mierka a vyberte hodnotu mierky. Ak sa zmení veľkosť pôvodného dokumentu alebo výstupu po nastavení položky  Mierka , zmení sa hodnota mierky na možnosť  Automatické . Skopírujte dokument. zmenšenie veľkosti kopírovania zväčšenie veľkosti kopírovania"},{"UUID":"2121da2a-cda5-41fb-9ef2-15640d694c02","title":"Kopírovanie","link":"collating-copies-topic.html","desc":"Zoradenie kópií Zdrojový dokument vložte","descFull":"Zoradenie kópií Zdrojový dokument vložte do zásobníka automatického podávača dokumentov alebo ho položte na skenovacie sklo. Na domovskej obrazovke sa dotknite položky  Kopírovať Zoradiť Zap.[1,2,1,2,1,2] . Skopírujte dokument. zoradenie kópií zoraďujú sa viaceré kópie"},{"UUID":"bba1701f-666b-4957-b05e-2d22a64189e3","title":"Kopírovanie","link":"placing-separator-sheets-between-copies-topic.html","desc":"Umiestnenie oddeľovacích hárkov medzi kópie","descFull":"Umiestnenie oddeľovacích hárkov medzi kópie Zdrojový dokument vložte do zásobníka automatického podávača dokumentov alebo ho položte na skenovacie sklo. Na ovládacom paneli prejdite na: Kopírovanie Nastavenia Oddeľovacie listy upravte nastavenia. Skopírujte dokument. kopírovanie oddeľovacie hárky medzi kópiami umiestnenie oddeľovacích hárkov medzi kópie"},{"UUID":"6176d153-923b-4744-8138-fd9550ca1b9b","title":"Kopírovanie","link":"saving-paper-topic.html","desc":"Kopírovanie viacerých stránok na jeden","descFull":"Kopírovanie viacerých stránok na jeden hárok Zdrojový dokument vložte do zásobníka automatického podávača dokumentov alebo ho položte na skenovacie sklo. Na domovskej obrazovke sa dotknite tlačidla  Kopírovanie Nastavenia Počet stránok na stranu . Povoľte nastavenie a potom vyberte počet na stranu a orientáciu strany. Skopírujte dokument. kopírovanie viacerých stránok na jeden hárok úspora papiera"},{"UUID":"ff1c6cdb-b67e-4595-9ab1-54c44e97ea64","title":"Kopírovanie","link":"copying-cards-topic.html","desc":"Kopírovanie preukazov Vložte preukaz na","descFull":"Kopírovanie preukazov Vložte preukaz na skenovacie sklo. Na domovskej obrazovke sa dotknite tlačidla  Kopírovanie preukazov . V prípade potreby upravte nastavenia skenovania. Dotknite sa položky  Skenovať . Ak chcete získať viac kópií preukazu, dotknite sa položky  Tlačiť kópiu . kopírovanie preukazov Kopírovanie preukazov"},{"UUID":"c96d92d7-c4e1-4457-9f82-33bc484fedc6","title":"Kopírovanie","link":"creating-copy-shortcut-topic.html","desc":"Vytvorenie skratky na kopírovanie Na","descFull":"Vytvorenie skratky na kopírovanie Na domovskej obrazovke sa dotknite tlačidla  Kopírovanie . Nakonfigurujte nastavenia a potom sa dotknite tlačidla  . Vytvorenie skratky. vytvorenie odkazu kopírovanie pridanie skratky kopírovanie skratka, vytvorenie kopírovanie"},{"UUID":"c59ad21a-f14c-42d4-a829-dcfea7c04c5a","title":"E-mail","link":"using-ADF-and-scanner-glass-e-mail-topic.html","desc":"Používanie automatického podávača dokumentov a skenovacieho","descFull":"Používanie automatického podávača dokumentov a skenovacieho skla Vkladanie papiera do zásobníka automatického podávača dokumentov a na skenovacie sklo Automatický podávač dokumentov (ADF) Skenovacie sklo Automatický podávač dokumentov používajte pre viacstranové alebo obojstranne tlačené dokumenty. Vložte zdrojový dokument stranou určenou na skenovanie smerom nahor. Pri viacstranových dokumentoch sa pred ich vložením ubezpečte, že je zarovnaná čelná hrana. Skontrolujte, či sú vodiace lišty automatického podávača dokumentov nastavené tak, aby zodpovedali šírke vkladaného papiera. Skenovacie sklo používajte na jednostranové dokumenty, strany kníh, malé položky (napr. pohľadnice alebo fotografie), priehľadné fólie, fotografický papier alebo tenké médiá (napr. výstrižky z časopisov). Umiestnite dokument stranou určenou na skenovanie smerom nadol do rohu so šípkou. odosielanie e-mailov používanie automatického podávača dokumentov (ADF) odosielanie e-mailov používanie skenovacieho skla"},{"UUID":"232061e2-af01-4ae3-9542-03ea215120cf","title":"E-mail","link":"sending-email-topic.html","desc":"Odoslanie e-mailovej správy Pred začatím","descFull":"Odoslanie e-mailovej správy Pred začatím skontrolujte, či sú nakonfigurované nastavenia SMTP. Ďalšie informácie nájdete v časti  . Zdrojový dokument vložte do zásobníka automatického podávača dokumentov alebo ho položte na skenovacie sklo. Na domovskej stránke sa dotknite tlačidla  E-mail  a zadajte požadované údaje. V prípade potreby nakonfigurujte nastavenia skenovania. Odošlite e-mail. e‑mail odosielanie odosielanie e-mailu"},{"UUID":"da171a95-341b-4ecc-9f7e-cb424bd2b42c","title":"E-mail","link":"creating-email-shortcut-topic.html","desc":"Vytvorenie skratky pre e-mail Na","descFull":"Vytvorenie skratky pre e-mail Na domovskej obrazovke sa dotknite tlačidla  E-mail . Nakonfigurujte nastavenia a potom sa dotknite tlačidla  . Vytvorenie skratky. vytvorenie skratky e‑mail pridanie skratky e‑mail skratka, vytvorenie e‑mail skratka pre e-mail vytvorenie"},{"UUID":"c6ed8381-58f4-4587-813a-38902a71ed4c","title":"Fax","link":"using-ADF-and-scanner-glass-fax-topic.html","desc":"Používanie automatického podávača dokumentov a skenovacieho","descFull":"Používanie automatického podávača dokumentov a skenovacieho skla Vkladanie papiera do zásobníka automatického podávača dokumentov a na skenovacie sklo Automatický podávač dokumentov (ADF) Skenovacie sklo Automatický podávač dokumentov používajte pre viacstranové alebo obojstranne tlačené dokumenty. Vložte zdrojový dokument stranou určenou na skenovanie smerom nahor. Pri viacstranových dokumentoch sa pred ich vložením ubezpečte, že je zarovnaná čelná hrana. Skontrolujte, či sú vodiace lišty automatického podávača dokumentov nastavené tak, aby zodpovedali šírke vkladaného papiera. Skenovacie sklo používajte na jednostranové dokumenty, strany kníh, malé položky (napr. pohľadnice alebo fotografie), priehľadné fólie, fotografický papier alebo tenké médiá (napr. výstrižky z časopisov). Umiestnite dokument stranou určenou na skenovanie smerom nadol do rohu so šípkou. faxovanie používanie automatického podávača dokumentov (ADF) faxovanie používanie skenovacieho skla"},{"UUID":"0f818180-177d-47e2-b5b7-92db8d0c202e","title":"Fax","link":"sending-fax-topic.html","desc":"Odoslanie faxu Skontrolujte, či je","descFull":"Odoslanie faxu Skontrolujte, či je fax nakonfigurovaný. Ďalšie informácie nájdete v časti   Nastavenie tlačiarne na fax . Používanie ovládacieho panela Zdrojový dokument vložte do zásobníka automatického podávača dokumentov alebo ho položte na skenovacie sklo. Na domovskej obrazovke sa dotknite tlačidla  Fax  a zadajte požadované údaje. V prípade potreby nastavenia upravte. Odošlite fax. Použitie počítača Pred začatím sa uistite, že je nainštalovaný ovládač faxu. Ďalšie informácie nájdete v časti  . Používatelia systému Windows V dokumente, ktorý chcete odoslať faxom, otvorte dialógové okno  Tlač . Vyberte tlačiareň a kliknite na položky  Vlastnosti ,  Predvoľby ,  Možnosti  alebo  Nastavenie . Kliknite na položky  Fax Povoliť fax Pred faxovaním vždy zobraziť nastavenia  a potom zadajte číslo príjemcu. V prípade potreby nakonfigurujte ďalšie nastavenia faxu. Odošlite fax. Používatelia systému Macintosh Po otvorení dokumentu vyberte položky  Súbor Tlač . Vyberte tlačiareň, za ktorej názvom sa nachádza položka   ‑ Fax . Do poľa  Komu  zadajte číslo príjemcu. V prípade potreby nakonfigurujte ďalšie nastavenia faxu. Odošlite fax. odoslanie faxu fax odosielanie"},{"UUID":"bd93687c-1e64-43b5-82eb-6bc1ddb479c9","title":"Fax","link":"scheduling-fax-topic.html","desc":"Naplánovanie odoslania faxu Skontrolujte, či","descFull":"Naplánovanie odoslania faxu Skontrolujte, či je fax nakonfigurovaný. Ďalšie informácie nájdete v časti   Nastavenie tlačiarne na fax . Zdrojový dokument vložte do zásobníka automatického podávača dokumentov alebo ho položte na skenovacie sklo. Na domovskej stránke sa dotknite tlačidla  Fax Komu zadajte faxové číslo Hotovo . Dotknite sa položky  Čas odoslania , nakonfigurujte dátum a čas a potom sa dotknite položky  Hotovo . Odošlite fax. naplánovanie odoslania faxu fax, plánovanie"},{"UUID":"dcd0cbe8-c1a8-4528-9093-fef1cbbcf125","title":"Fax","link":"creating-fax-destination-shortcut-topic.html","desc":"Vytvorenie skratky pre cieľové umiestnenie","descFull":"Vytvorenie skratky pre cieľové umiestnenie pre fax Skontrolujte, či je fax nakonfigurovaný. Ďalšie informácie nájdete v časti   Nastavenie tlačiarne na fax . Na domovskej obrazovke sa dotknite položiek  Fax Komu . Zadajte číslo príjemcu a dotknite sa položky  Hotovo . Nakonfigurujte nastavenia a potom sa dotknite tlačidla  . Vytvorenie skratky. vytvorenie skratky cieľové umiestnenie pre fax pridanie odkazu cieľové umiestnenie pre fax skratka, vytvorenie cieľové umiestnenie pre fax skratka cieľového umiestnenia pre fax vytvorenie"},{"UUID":"2ee0e54b-dad0-4686-820c-7d8c864e91a1","title":"Fax","link":"changing-fax-resolution-topic.html","desc":"Zmena rozlíšenia faxu Skontrolujte, či","descFull":"Zmena rozlíšenia faxu Skontrolujte, či je fax nakonfigurovaný. Ďalšie informácie nájdete v časti   Nastavenie tlačiarne na fax . Zdrojový dokument vložte do zásobníka automatického podávača dokumentov alebo ho položte na skenovacie sklo. Na domovskej obrazovke sa dotknite tlačidla  Fax  a zadajte požadované údaje. Dotknite sa položiek  Nastavenia Rozlíšenie  a vyberte nastavenie. Odošlite fax. rozlíšenie faxu zmena zmena rozlíšenia faxu"},{"UUID":"aec3acd1-f7ef-4c7e-99b1-ccecaf7cf7e7","title":"Fax","link":"adjusting-fax-darkness-topic.html","desc":"Nastavenie tmavosti faxu Skontrolujte, či","descFull":"Nastavenie tmavosti faxu Skontrolujte, či je fax nakonfigurovaný. Ďalšie informácie nájdete v časti   Nastavenie tlačiarne na fax . Zdrojový dokument vložte do zásobníka automatického podávača dokumentov alebo ho položte na skenovacie sklo. Na domovskej obrazovke sa dotknite tlačidla  Fax  a zadajte požadované údaje. Dotknite sa položiek  Nastavenia Tmavosť a upravte nastavenia. Odošlite fax. nastavenie tmavosti faxu tmavosť faxu nastavenie"},{"UUID":"18707195-2052-4ad5-a641-72203ec0d18c","title":"Fax","link":"printing-fax-log-topic.html","desc":"Tlač denníka faxov Skontrolujte, či","descFull":"Tlač denníka faxov Skontrolujte, či sú analógový fax alebo služba etherFAX nakonfigurované. Ďalšie informácie nájdete v časti   Nastavenie tlačiarne na fax . Skontrolujte, či je fax nakonfigurovaný. Ďalšie informácie nájdete v časti   Nastavenie tlačiarne na fax . Na domovskej obrazovke sa dotknite položiek  Nastavenia Správy Fax . Dotknite sa položiek  Denník úloh faxovania  alebo  Denník faxových hovorov . denník faxov tlač tlač denník faxov"},{"UUID":"fafef381-55f8-4fd3-b2da-227516e7208f","title":"Fax","link":"blocking-junk-faxes-topic.html","desc":"Blokovanie nevyžiadaných faxov Skontrolujte, či","descFull":"Blokovanie nevyžiadaných faxov Skontrolujte, či sú analógový fax alebo služba etherFAX nakonfigurované. Ďalšie informácie nájdete v časti   Nastavenie tlačiarne na fax . Skontrolujte, či je fax nakonfigurovaný. Ďalšie informácie nájdete v časti   Nastavenie tlačiarne na fax . Na domovskej obrazovke stlačte  Nastavenia Fax Nastavenie faxu Nastavenia príjmu faxov Ovládacie prvky správcu . Nastavte položku  Blokovať faxy bez názvu  na možnosť  Zapnuté . nevyžiadané faxy blokovanie blokovanie nevyžiadaných faxov"},{"UUID":"8cf56b80-5f6c-4a0c-a7c3-a19d1119d4dd","title":"Fax","link":"holding-faxes-topic.html","desc":"Zadržiavanie faxov Skontrolujte, či sú","descFull":"Zadržiavanie faxov Skontrolujte, či sú analógový fax alebo služba etherFAX nakonfigurované. Ďalšie informácie nájdete v časti   Nastavenie tlačiarne na fax . Skontrolujte, či je fax nakonfigurovaný. Ďalšie informácie nájdete v časti   Nastavenie tlačiarne na fax . Na domovskej stránke sa dotknite položiek  Nastavenia Fax Nastavenie faxu Nastavenia príjmu faxov Zadržiavanie faxov . Vyberte režim. zadržiavanie faxov prijaté faxy zadržanie"},{"UUID":"d1cf36ba-e09e-4720-87cd-79c7b3dafca4","title":"Fax","link":"forwarding-fax-topic.html","desc":"Posielanie faxov ďalej Skontrolujte, či","descFull":"Posielanie faxov ďalej Skontrolujte, či sú analógový fax alebo služba etherFAX nakonfigurované. Ďalšie informácie nájdete v časti   Nastavenie tlačiarne na fax . Skontrolujte, či je fax nakonfigurovaný. Ďalšie informácie nájdete v časti   Nastavenie tlačiarne na fax . Vytvorte skratku na cieľové umiestnenie. Otvorte webový prehliadač a do poľa adresy zadajte adresu IP tlačiarne. Pozrite si adresu IP tlačiarne na domovskej obrazovke. IP Adresa sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Ak používate server proxy, dočasne ho vypnite, aby sa webová stránka správne načítala. Kliknite na možnosť  Odkazy Pridať odkaz . Vyberte typ skratky a potom nakonfigurujte nastavenia. Poznačte si číslo skratky. Použite zmeny. Kliknite na  Nastavenia Fax Nastavenie faxu Nastavenia príjmu faxov Ovládacie prvky správcu . V ponuke  Poslanie faxu ďalej  vyberte možnosť  Poslať ďalej  alebo  Vytlačiť a poslať ďalej. V ponuke  Poslať ďalej  vyberte typ cieľového umiestnenia a potom zadajte číslo skratky. Použite zmeny. posielanie faxu ďalej"},{"UUID":"86507db4-0e79-46f4-8a1d-4899df26122f","title":"Skenovanie","link":"using-ADF-and-scanner-glass-scan-topic.html","desc":"Používanie automatického podávača dokumentov a skenovacieho","descFull":"Používanie automatického podávača dokumentov a skenovacieho skla Vkladanie papiera do zásobníka automatického podávača dokumentov a na skenovacie sklo Automatický podávač dokumentov (ADF) Skenovacie sklo Automatický podávač dokumentov používajte pre viacstranové alebo obojstranne tlačené dokumenty. Vložte zdrojový dokument stranou určenou na skenovanie smerom nahor. Pri viacstranových dokumentoch sa pred ich vložením ubezpečte, že je zarovnaná čelná hrana. Skontrolujte, či sú vodiace lišty automatického podávača dokumentov nastavené tak, aby zodpovedali šírke vkladaného papiera. Skenovacie sklo používajte na jednostranové dokumenty, strany kníh, malé položky (napr. pohľadnice alebo fotografie), priehľadné fólie, fotografický papier alebo tenké médiá (napr. výstrižky z časopisov). Umiestnite dokument stranou určenou na skenovanie smerom nadol do rohu so šípkou. skenovanie používanie automatického podávača dokumentov (ADF) skenovanie používanie skenovacieho skla"},{"UUID":"cff4d89b-c95e-4bbf-ad34-d71be341c0ac","title":"Skenovanie","link":"scanning-to-computer-topic.html","desc":"Skenovanie do počítača Pred začatím","descFull":"Skenovanie do počítača Pred začatím skontrolujte, či sú počítač a tlačiareň pripojené k rovnakej sieti. Používatelia systému Windows Použitie nástroja Lexmark ScanBack Utility V počítači spustite nástroj Lexmark Scanback Utility a potom kliknite na možnosť  Ďalej . Ak chcete prevziať nástroj, prejdite na lokalitu  www.lexmark.com/downloads . Kliknite na položku  Nastavenie  a potom pridajte adresu IP tlačiarne. Pozrite si adresu IP tlačiarne na domovskej obrazovke tlačiarne. Adresa IP sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Kliknite na položky  Zavrieť Ďalej. Vyberte veľkosť originálneho dokumentu a potom kliknite na položku  Ďalej . Vyberte formát súboru a rozlíšenie skenovania a potom kliknite na položku  Ďalej . Zadajte jedinečný názov profilu skenovania a potom kliknite na položku   Ďalej . Prejdite na umiestnenie, kam chcete skenovaný dokument uložiť, nastavte názov súboru a potom kliknite na položku  Ďalej . Ak chcete znova použiť profil skenovania, povoľte možnosť  Vytvoriť odkaz  a potom zadajte jedinečný názov odkazu. Kliknite na položku  Dokončiť . Pôvodný dokument vložte do automatického podávača dokumentov alebo ho položte na skenovacie sklo. Na domovskej obrazovke tlačiarne sa dotknite položiek  Profily skenovania Skenovanie do počítača  a potom vyberte profil skenovania. Používatelia systému Windows Používanie faxovania a skenovania pre systém Windows Skontrolujte, či je tlačiareň pridaná do počítača. Ďalšie informácie nájdete v časti  . Pôvodný dokument vložte do automatického podávača dokumentov alebo ho položte na skenovacie sklo. V počítači otvorte položku  Faxovanie a skenovanie pre systém Windows . Kliknite na položku  Nové skenovanie  a vyberte zdroj skenera. V prípade potreby upravte nastavenia skenovania. Naskenujte dokument. Kliknite na položku  Uložiť ako , zadajte názov súboru a potom kliknite na položku  Uložiť . Používatelia systému Macintosh Skontrolujte, či je tlačiareň pridaná do počítača. Ďalšie informácie nájdete v časti  . Pôvodný dokument vložte do automatického podávača dokumentov alebo ho položte na skenovacie sklo. V počítači vykonajte jeden z týchto krokov: Otvorte aplikáciu  Záznam obrazu . Otvorte položku  Tlačiarne a skenery  a potom vyberte tlačiareň. Kliknite na položky  Skenovať Otvoriť skener. V okne  Skener  vyskúšajte jedno alebo viaceré z nasledujúcich riešení: Vyberte umiestnenie, do ktorého sa má uložiť naskenovaný dokument. Výber veľkosti originálneho dokumentu. Ak chcete skenovať z automatického podávača dokumentov (ADF) v položke  Podávač dokumentov  z ponuky  Ponuka skenovania  alebo aktivujte možnosť  Použiť podávač dokumentov . V prípade potreby nakonfigurujte nastavenia skenovania. Kliknite na položku  Skenovať . skenovanie do počítača počítač, skenovanie do Lexmark ScanBack Utility"},{"UUID":"8d5314c1-31a1-4910-9c73-7c5240a17926","title":"Skenovanie","link":"scanning-ftp-server-using-control-panel-topic.html","desc":"Skenovanie na server FTP Zdrojový","descFull":"Skenovanie na server FTP Zdrojový dokument vložte do zásobníka automatického podávača dokumentov alebo ho položte na skenovacie sklo. Na domovskej stránke sa dotknite položky  FTP  a zadajte požadované údaje. V prípade potreby nakonfigurujte ďalšie nastavenia FTP. Odošlite úlohu pomocou protokolu FTP. skenovanie na server FTP používanie ovládacieho panela skenovanie na server FTP skenovanie na server FTP používanie ovládacieho panela"},{"UUID":"04c05ecb-2fdb-44f1-857f-95b54a5f5c42","title":"Skenovanie","link":"creating-FTP-shortcut-topic.html","desc":"Vytvorenie skratky pre FTP Na","descFull":"Vytvorenie skratky pre FTP Na domovskej obrazovke sa dotknite tlačidla  FTP . Zadajte adresu FTP a potom sa dotknite tlačidla  . Vytvorenie skratky. vytvorenie skratky adresa FTP pridanie skratky adresa FTP adresa FTP vytvorenie skratky skratka, vytvorenie adresa FTP"},{"UUID":"6067345b-60a2-4d69-9491-77915d52151d","title":"Skenovanie","link":"s2a-scanning-to-network-folders-topic.html","desc":"Skenovanie do sieťového priečinka Vložte","descFull":"Skenovanie do sieťového priečinka Vložte dokument do zásobníka automatického podávača dokumentov alebo ho položte na skenovacie sklo. Na domovskej obrazovke sa dotknite položky  Scan Centrum . Ikona a názov môžu byť zmenené. Ďalšie informácie získate od svojho správcu. Vykonajte niektorý z týchto krokov: Vyberte cieľové umiestnenie. V prípade SFTP nastavte číslo portu na hodnotu  22 . Ak chcete použiť skratku, dotknite sa ikony   a potom vyberte skratku zo zoznamu. Naskenujte dokument. skenovanie do sieťového priečinka SMB skenovanie"},{"UUID":"34b123cf-af3a-47bd-aa89-155acd900841","title":"Skenovanie","link":"creating-network-folder-shortcut-topic.html","desc":"Vytvorenie skratky pre sieťový priečinok","descFull":"Vytvorenie skratky pre sieťový priečinok Otvorte webový prehliadač a do poľa adresy zadajte adresu IP tlačiarne. Pozrite si adresu IP tlačiarne na domovskej obrazovke tlačiarne. IP Adresa sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Ak používate server proxy, dočasne ho vypnite, aby sa správne načítala webová stránka. Kliknite na možnosť  Skratky Pridať skratku . V kontextovej ponuke Typ skratky vyberte položku  Sieťový priečinok  a potom nakonfigurujte nastavenia. Uložte zmeny. sieťový priečinok vytvorenie odkazu vytvorenie odkazu sieťový priečinok"},{"UUID":"fc889df2-7896-4c6e-9f31-3622e6143d79","title":"Skenovanie","link":"scanning-to-flash-drive-topic.html","desc":"Skenovanie na pamäťovú jednotku flash","descFull":"Skenovanie na pamäťovú jednotku flash Zdrojový dokument vložte do zásobníka automatického podávača dokumentov alebo ho položte na skenovacie sklo. Vložte pamäťovú jednotku flash. Klepnite na položku  Skenovať do jednotky USB  a v prípade potreby upravte nastavenia. Ak chcete naskenovaný dokument uložiť do priečinka, dotknite sa položky  Skenovanie do , vyberte priečinok a potom sa dotknite položky  Skenovať sem . Ak sa obrazovka  Jednotka USB  nezobrazí, dotknite sa položky  Jednotka USB  na ovládacom paneli. Naskenujte dokument. Ak chcete predísť strate údajov alebo zlyhaniu tlačiarne, počas aktívnej tlače, načítavania alebo zapisovania na pamäťové zariadenie sa nedotýkajte jednotky flash ani tlačiarne v zobrazenej oblasti. skenovanie na jednotku flash jednotka flash skenovanie do"},{"UUID":"00244fbc-6a34-409d-9187-74609d8c9083","title":"Používanie ponúk tlačiarne","link":"menu-map-mfp-topic.html","desc":"Mapa ponúk 1  Zobrazí","descFull":"Mapa ponúk 1  Zobrazí sa iba na serveri Embedded Web Server. 2  Zobrazí sa len v prípade, že je nainštalovaný pevný disk alebo disk s inteligentným ukladaním. Zariadenie Predvoľby Úsporný režim Vzdialený ovládací panel Oznámenia Správa napájania Anonymný zber údajov Zjednodušenie ovládania Obnovenie predvolených výrobných nastavení Údržba Prispôsobenie domovskej obrazovky 1 Aktualizovať firmvér Informácie o tlačiarni Tlač Rozloženie Nastavenie Kvalita Štatistika úloh PDF PostScript PCL Obrázok Papier Konfigurácia zásobníkov Konfigurácia médií Kopírovanie Predvolené hodnoty kopírovania Fax Predvolené nastavenia faxu E‑mail Nastavenie e-mailu Predvolené hodnoty e-mailu Nastavenie webového prepojenia FTP Predvolené hodnoty FTP Jednotka USB Skenovanie do pamäťovej jednotky flash Tlač z pamäťovej jednotky flash Sieť/porty Prehľad siete Bezdrôtové Wi‑Fi Direct AirPrint Správa mobilných služieb Ethernet TCP/IP SNMP IPSec 802.1x Konfigurácia LPD Nastavenia HTTP/FTP ThinPrint USB Obmedzenie prístupu do externej siete Zabezpečenie Spôsoby prihlásenia Plánovanie zariadení USB Denník auditu zabezpečenia Obmedzenia prihlásenia Nastavenie dôvernej tlače Šifrovanie disku Vymazanie dočasných údajových súborov Nastavenia LDAP riešení Rôzne Cloudové služby Registrácia do cloudových služieb Správy Strana nastavení ponúk Zariadenie Tlač Skratky Fax Sieť Riešenie problémov Tlač strany testu kvality Čistenie skenera Forms Merge 2 Forms Merge ponuky tlačiarne"},{"UUID":"db470b0f-9b80-4ebc-82f3-f6851d3a63e8","title":"Zariadenie","link":"preferences-topic.html","desc":"Predvoľby Položky ponuky  Predvoľby","descFull":"Predvoľby Položky ponuky  Predvoľby  a ich opis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Zobrazovaný jazyk [Zoznam jazykov] Nastavenie jazyka, v ktorom sa zobrazuje text na displeji. Krajina/región [Zoznam krajín alebo regiónov] Identifikácia krajiny alebo regiónu, pre ktorý je tlačiareň nakonfigurovaná. Spustiť úvodné nastavenie Vypnuté * Zapnuté Spustenie sprievodcu nastavením. Klávesnica Typ klávesnice [Zoznam jazykov] Výber jazyka ako typu klávesnice. Nemusia sa zobraziť všetky hodnoty pre položku  Typ klávesnice , prípadne môžu na svoje zobrazenie vyžadovať špeciálny hardvér. Zobrazené informácie Zobrazený text 1  ( IP adresa *) Zobrazený text 2  ( dátum/čas *) Vlastný text 1 Vlastný text 2 Stanovenie, aké informácie sa budú zobrazovať na domovskej obrazovke. Dátum a čas Konfigurácia Aktuálny dátum a čas Manuálne nastaviť dátum a čas Formát dátumu  (MM‑DD‑RRRR*) Formát času  (12-hodinový formát AM/PM*) Časové pásmo Posun voči času UTC (GMT) Začiatok let. času Koniec let. času Posun voči let. času Protokol času siete Povoliť protokol NTP  ( Zapnuté *) Server NTP Povoliť overenie  (  Nikdy  *) ID kľúča Heslo Konfigurácia dátumu a času tlačiarne a protokolu času siete. MM‑DD‑RRRR  je americké predvolené výrobné nastavenie.  DD-MM-RRRR  je medzinárodné predvolené výrobné nastavenie. Možnosti  Posun voči času UTC (GMT) ,   Začiatok let. času, ,   Koniec let. času  a  Posun voči let. času  sa zobrazia iba v prípade, ak je pre   Časovú zónu  je nastavená možnosť  (UTC+používateľský) Vlastné . Položky  ID kľúča  a  Heslo  sa zobrazia len v prípade, že je položka  Povoliť overenie  nastavená na možnosť  Kľúč MD5 . Veľkosti papiera Americké * Metrické Určenie mernej jednotky veľkostí papiera. Krajina alebo región vybratý v sprievodcovi úvodným nastavením určuje počiatočné nastavenie veľkosti papiera. Jas obrazovky 20 – 100 % (100*) Upravenie jasu displeja. Prístup k jednotke flash Vypnuté Povolené * Povolenie prístupu k jednotke flash. Povoliť odstránenie pozadia Vypnuté Zapnuté * Nastavenie, či bude povolené odstrániť pozadie. Povoliť vlastné skenovacie úlohy Vypnuté Zapnuté * Stanovenie, či sa má nastavenie  Vlastná úloha skenovania  zobraziť pre kopírovanie, skenovanie a faxovanie. Táto položka ponuky sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk s inteligentným ukladaním. Skenovanie jednej strany z plochého skla Vypnuté * Zapnuté Nastavenie tlačiarne tak, aby skenovala akýkoľvek typ úlohy s využitím skenovacieho skla ako jednu stránku. Po jednorazovom naskenovaní obsahu z plochého skenera sa tlačiareň vráti na domovskú obrazovku a nezobrazí výzvy. Zvuky zariadenia Stlmenie všetkých zvukov  ( Vypnuté *) Spätná väzba tlačidiel  ( Zapnuté *) Objem  (5*) Pípnutie pri naplnení aut. podávača dokumentov  ( Zapnuté *) Ovládač alarmu  ( Jeden *) Upozornenie kazety  ( Vypnuté *) Režim reproduktora  ( Vždy vypnuté *) Hlasitosť zvonenia  ( Vypnuté *) Konfigurácia nastavení zvuku na tlačiarni. Časový limit obrazovky 5 – 300 sekúnd (60*) Nastavenie času nečinnosti v sekundách pred zobrazením domovskej obrazovky na displeji alebo pred automatickým odhlásením používateľského účtu. ponuka Predvoľby"},{"UUID":"453be18c-21f0-4480-b139-46be2507011b","title":"Zariadenie","link":"preferences-topic.html","desc":"Ekonomický režim Položky ponuky ","descFull":"Ekonomický režim Položky ponuky  Úsporný režim  a ich opisy Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Tlač Strany Jednostranne * Obojstranne Zadajte, či tlačiť na jednej alebo oboch stranách papiera. Tlač Počet stránok na stranu Vypnuté * 2 stránky na stranu 3 stránky na stranu 4 stránky na stranu 6 stránok na stranu 9 stránok na stranu 12 stránok na stranu 16 stránok na stranu Tlač obrázkov na viacerých stránkach na jednu stranu jedného listu papiera. Tlač Tmavosť tonera 1–10 (8*) Nastavenie svetlosti alebo tmavosti textových obrázkov. Kopírovanie Strany Jednostranné na jednostranné * Jednostranné na obojstranné Obojstranné na jednostranné Obojstranné na obojstranné Určenie priebehu skenovania na základe zdrojového dokumentu. Kopírovanie Počet stránok na stranu Vypnuté * 2 stránky na výšku 4 stránky na výšku 2 stránky na šírku 4 stránky na šírku Určenie priebehu skenovania na základe zdrojového dokumentu. Kopírovanie Tmavosť 1 – 9 (5*) Úprava tmavosti naskenovaných obrázkov textu. ponuka úsporný režim"},{"UUID":"be0260d5-4ba4-4fea-bf97-b9162040fbc7","title":"Zariadenie","link":"preferences-topic.html","desc":"Vzdialený ovládací panel Položky ponuky","descFull":"Vzdialený ovládací panel Položky ponuky  Vzdialený ovládací panel  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Externé pripojenie VNC Nepovoliť * Povoliť Pripojenie externého klienta VNC na používanie vzdialeného ovládacieho panela. Typ overenia Žiadne * Štandardné overenie Nastavenie typu overenia pri prístupe klientom na server VNC. Heslo pre server VNC Uvedenie hesla na pripojenie klienta na server VNC. Táto položka ponuky sa zobrazí len v prípade, že je položka  Typ overenia  nastavená na možnosť  Štandardné overenie . ponuka Vzdialený ovládací panel"},{"UUID":"9e778f96-1fd3-4abf-8fc7-9d4402828167","title":"Zariadenie","link":"preferences-topic.html","desc":"Oznámenia Položky ponuky  Oznámenia","descFull":"Oznámenia Položky ponuky  Oznámenia  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Pípnutie pri naplnení automatického podávača dokumentov Vypnuté Zapnuté * Povolenie zvukového upozornenia pri vkladaní papiera do zásobníka automatického podávača dokumentov. Signalizácia Vypnuté Raz * Nepretržite Nastavenie, koľkokrát zaznie upozornenie, keď tlačiareň vyžaduje zásah používateľa. Spotrebný materiál Zobraziť odhadované hodnoty spotrebného materiálu Zobraziť odhadované hodnoty * Nezobrazovať odhadované hodnoty Zobrazenie odhadu stavu spotrebného materiálu tlačiarne. Spotrebný materiál Signalizácia pre kazetu Vypnuté * Jednotlivo Nepretržite Nastavenie, koľkokrát zaznie upozornenie, keď je tonerová kazeta takmer prázdna. Spotrebný materiál Vlastné upozornenia o spotrebnom materiáli Konfigurácia nastavení upozornenia, keď tlačiareň vyžaduje zásah používateľa. Táto položka ponuky je k dispozícii iba na serveri Embedded Web Server. Nastavenie upozornení e-mailom Primárna brána SMTP Port primárnej brány SMTP  (25*) Sekundárna brána SMTP Port sekundárnej brány SMTP  (25*) Časový limit SMTP  (30 sekúnd*) Adresa pre odpoveď Vždy použiť predvolenú adresu servera SMTP na odpoveď  ( Vypnuté *) Použiť nástroj SSL/TLS  ( Vypnuté *) Je potrebný dôveryhodný certifikát  ( Zapnuté *) Overenie servera SMTP  ( Nevyžaduje sa žiadne overenie *) E-mail vytvorený na základe zariadenia  ( Žiadne *) E-mail vytvorený na základe používateľa  ( Žiadne *) Použiť poverenia zariadenia služby Active Directory  ( Vypnuté *) ID používateľa zariadenia Heslo zariadenia Kerberos 5 REALM Doména NTLM Vypnúť chybu „Nie je nastavený server SMTP“  ( Vypnuté *) Nastavenie tlačiarne na odosielaní upozornení e‑mailom na kontakty v zozname, keď tlačiareň vyžaduje zásah používateľa. Nastavenie upozornení e-mailom Nastavenie zoznamu e-mailov a upozornení e-mailom Zoznam e-mailov 1 Zoznam e-mailov 2 Text predmetu Udalosti e-mailov Zadajte e-mailové adresy a povoľte upozornenia e-mailom. Táto položka ponuky je k dispozícii iba na serveri Embedded Web Server. Predchádzanie chybám Asistencia pri zaseknutí papiera Vypnuté Zapnuté * Nastavenie tlačiarne na automatické vysunutie prázdnych alebo čiastočne potlačených strán po odstránení zaseknutej strany. Predchádzanie chybám Automaticky pokračovať Zapnuté 5 – 255 (5*) Umožnenie tlačiarni automaticky pokračovať v spracovaní alebo tlači úlohy po vyriešení určitých stavov vyžadujúcich pozornosť. Predchádzanie chybám Automatické reštartovanie Automatické reštartovanie Reštartovať pri nečinnosti Vždy reštartovať * Nikdy nereštartovať Nastavenie reštartovania tlačiarne v prípade výskytu chyby. Predchádzanie chybám Automatické reštartovanie Maximálny počet automatických reštartovaní 1 – 20 (2*) Nastavenie počtu možných automatických reštartovaní tlačiarne. Predchádzanie chybám Automatické reštartovanie Okno automatického reštartovania 1 – 525600 (720*) Nastavenie počtu sekúnd, ktoré tlačiareň počká pred automatickým reštartovaním. Predchádzanie chybám Automatické reštartovanie Počítadlo automatických reštartovaní Zobrazenie informácií počítadla reštartovaní iba na čítanie. Predchádzanie chybám Automatické reštartovanie Obnoviť nastavenia počítadla automatického reštartovania Zrušiť Pokračovať Vynulovanie hodnôt  Počítadla automatických reštartovaní. Predchádzanie chybám Zobraziť chybu krátkeho papiera Zapnuté Automatické odstránenie * Nastavenie zobrazovania hlásenia tlačiarne v prípade, že sa vyskytne chyba krátkeho papiera. Krátky papier sa vzťahuje na veľkosť vloženého papiera. Predchádzanie chybám Ochrana strany Vypnuté * Zapnuté Nastavenie tlačiarne na spracovanie celej strany do pamäte pred jej vytlačením. Obnovenie zaseknutého obsahu Obnova po zaseknutí Vypnuté Zapnuté Automaticky * Nastavenie tlačiarne na opätovnú tlač zaseknutých strán. Obnovenie zaseknutého obsahu Obnova po zaseknutí v skeneri Úroveň úlohy Úroveň strany * Stanovenie, ako reštartovať úlohu skenovania po odstránení zaseknutého papiera. ponuka Oznámenia"},{"UUID":"a83b7c2d-6ba7-4cc6-ae63-648864dd7f05","title":"Zariadenie","link":"preferences-topic.html","desc":"Správa napájania Položky ponuky ","descFull":"Správa napájania Položky ponuky  Správa napájania  a ich popisy Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Profil režimu spánku Tlačiť z režimu spánku Po tlači zostať v činnosti Po tlači prejsť do režimu spánku * Nastavenie tlačiarne tak, aby po tlači zostala v činnosti alebo prešla do režimu spánku. Profil režimu spánku Prebudenie z hlbokého spánku dotykom Vypnutá Zapnuté * Prebudenie tlačiarne z režimu hlbokého spánku dotykom na displej tlačiarne. Časové limity Režim spánku 1 – 114 min (15*) Nastavenie doby nečinnosti pred prechodom tlačiarne do režimu Spánok. Časové limity Časový limit režimu dlhodobého spánku Vypnuté 1 hodina 2 hodiny 3 hodiny 6 hodín 1 deň 2 dni 3 dni * 1 týždeň 2 týždne 1 mesiac Nastavenie času pred vypnutím tlačiarne. Časové limity Časový limit dlhodobého spánku pri pripojení Prejsť do režimu dlhodobého spánku Neprechádzať do režimu dlhodobého spánku * Nastavenie položky  Časový limit dlhodobého spánku , aby sa tlačiareň vypla, aj keď je aktívne pripojenie k sieti Ethernet. Naplánovať režimy napájania Plány Pridať nový plán Plánovanie doby prechodu tlačiarne do režimu spánku alebo dlhodobého spánku. ponuka Správa napájania"},{"UUID":"c117d37c-fd2a-43a6-8e57-1d8ffee5740b","title":"Zariadenie","link":"preferences-topic.html","desc":"Anonymný zber údajov Anonymný zber","descFull":"Anonymný zber údajov Anonymný zber údajov  položky menu a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Anonymný zber údajov Informácie o používaní a výkone zariadenia Žiadne * Odoslať informácie o používaní tlačiarne a výkonnosti spoločnosti Lexmark. Odoslať informácie o používaní tlačiarne a výkonnosti výrobcovi. Čas odosielania anonymných údajov  sa zobrazí len vtedy, keď nastavíte  Anonymný zber údajov  na  Informácie o používaní a výkone zariadenia . Čas odoslania anonymných údajov Počiatočný čas Čas zastavenia ponuka Anonymný zber údajov"},{"UUID":"47781e61-4168-4663-baf3-34d068055022","title":"Zariadenie","link":"preferences-topic.html","desc":"Zjednodušenie ovládania Položky ponuky Zjednodušenie","descFull":"Zjednodušenie ovládania Položky ponuky Zjednodušenie ovládania a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Interval opakovaného stlačenia klávesu 0 – 5 (0*) Nastavenie časového intervalu v sekundách, počas ktorého tlačiareň ignoruje opakované stláčanie klávesov na pripojenej klávesnici. Počiatočné oneskorenie opakovania klávesov 0,25 – 5 (1*) Nastavenie počiatočnej dĺžky oneskorenia v sekundách, kým sa opakované stlačenie klávesu začne opakovať. Rýchlosť opakovania klávesov 0,5 – 30 (30*) Nastavenie počtu stlačení za sekundu na zopakovanie klávesu. Predĺžiť časový limit obrazovky Vypnuté * Zapnuté Ponechá používateľa na rovnakom umiestnení a namiesto návratu na domovskú obrazovku po uplynutí obnoví položku  Časový limit obrazovky . Hlasitosť slúchadla 1 – 10 (5*) Nastavenie hlasitosti slúchadiel. Pri pripojení slúchadiel povoliť hlasové pokyny. Vypnuté * Zapnuté Zapnutie hlasových pokynov, keď sú k tlačiarni pripojené slúchadlá. Prečítať heslá/kódy PIN Vypnuté * Zapnuté Nastavenie tlačiarne na hlasné prečítanie hesiel alebo osobných identifikačných čísiel. Frekvencia reči Veľmi pomalá Pomalá Normálne * Rýchla Skôr rýchla Veľmi rýchla Extrémne rýchla Veľmi extrémne rýchla Najrýchlejšia Nastavenie rýchlosti reči hlasových pokynov. ponuka Zjednodušenie ovládania"},{"UUID":"b865a9f5-78f0-42c8-988f-f76f83bdee91","title":"Zariadenie","link":"preferences-topic.html","desc":"Obnovenie predvolených výrobných nastavení Položky","descFull":"Obnovenie predvolených výrobných nastavení Položky ponuky  Obnoviť výrobné nastavenia  a ich popis Položka ponuky Opis Obnoviť nastavenia Obnoviť všetky nastavenia Obnoviť nastavenia tlačiarne Obnoviť nastavenia siete Obnoviť nastavenia faxu Obnoviť nastavenia aplikácií Obnovenie výrobných nastavení tlačiarne. ponuka Obnovenie predvolených výrobných nastavení"},{"UUID":"d62a2fea-0868-4ef0-9277-a9f5c388e1b6","title":"Údržba","link":"preferences-topic.html","desc":"Ponuka konfigurácie Položky  Ponuky","descFull":"Ponuka konfigurácie Položky  Ponuky konfigurácie  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Konfigurácia USB Zariadenie USB s technológiou PnP 1* 2 Zmeňte režim jednotky USB tlačiarne, aby ste zlepšili jej kompatibilitu s osobným počítačom. Konfigurácia USB Skenovať do lokálnej jednotky USB Zapnuté * Vypnuté Nastavenie toho, či sa ovládač zariadenia USB uvádza ako jednoduché zariadenie USB (jedno rozhranie) alebo ako zložené zariadenie USB (viacero rozhraní). Konfigurácia USB Rýchlosť USB Full Automatický * Nastavte port USB, aby fungoval plnou rýchlosťou, a vypnite jeho vysokorýchlostné možnosti. Konfigurácia zásobníkov Prepojenie na zásobník Automaticky * Vypnuté Nastavenie tlačiarne na prepojenie zásobníkov s rovnakými nastaveniami typu a veľkosti papiera. Konfigurácia zásobníkov Pri vložení zásobníka zobraziť hlásenie Zasúvací zásobník Vypnuté Len pre neznáme veľkosti * Vždy Po vložení zásobníka zobraziť hlásenie, ktoré používateľovi umožní zmeniť nastavenia veľkosti a typu papiera. Konfigurácia zásobníkov Vkladanie formátu A5 Krátky okraj * Dlhý okraj Určiť predvolenú orientáciu vkladania pre papier veľkosti A5 vo všetkých zdrojoch papiera. Konfigurácia zásobníkov Výzvy na vloženie papiera Automatický * Viacúčelový podávač Manuálny podávač papiera Nastavenie zdroja papiera, ktorý používateľ naplní po zobrazení výzvy na vloženie papiera. Ak chcete, aby sa zobrazila položka  Viacúčelový podávač , v ponuke  Papier  nastavte položku  Konfigurácia multifunkčného podávača  na možnosť  Kazeta . Konfigurácia zásobníkov Výzvy na vloženie obálok Automatický * Viacúčelový podávač Manuálny podávač obálok Nastavenie zdroja papiera, ktorý používateľ naplní po zobrazení výzvy na vloženie obálok. Ak chcete, aby sa zobrazila položka  Viacúčelový podávač , v ponuke  Papier  nastavte položku  Konfigurácia multifunkčného podávača  na možnosť  Kazeta . Konfigurácia zásobníkov Postup pri výzvach Vyzvať používateľa * Pokračovať Použiť aktuálny Nastavenie tlačiarne na riešenie výziev na výmenu papiera alebo obálok. Konfigurácia zásobníkov Viaceré univerzálne veľkosti Vypnuté * Zapnuté Nastavte zásobník tak, aby podporoval viacero univerzálnych veľkostí papiera. Správy Strana nastavení ponúk Denník udalostí Zhrnutie denníka udalostí Tlač správ o nastaveniach ponuky tlačiarne, stave a denníkoch udalostí. Počítadlá používania spotrebného materiálu Vymazať históriu používania spotrebného materiálu Vymazanie histórie používania spotrebného materiálu, napríklad zostávajúceho počtu strán alebo dní, na výrobné nastavenia. Počítadlá používania spotrebného materiálu Vynulovať počítadlo údržby Vynulovanie počítadla po nainštalovaní novej súpravy na údržbu. Emulácie tlačiarne Emulácia jazyka PPDS Vypnuté * Zapnuté Nastavenie tlačiarne na rozpoznanie a používanie prúdu údajov jazyka PPDS. Emulácie tlačiarne Emulácia jazyka PS Vypnuté Zapnuté * Nastavenie tlačiarne na rozpoznanie a používanie prúdu údajov jazyka PS. Emulácie tlačiarne Použite natívne pásma ISD Vypnuté * Zapnuté Umožnite tlačiarni použiť natívne alebo voľné písma na tlač v inteligentnom pamäťovom disku (ISD). Emulácie tlačiarne Povoliť funkciu Formsmerge Vypnuté Zapnuté * Aktivujte možnosť Forms Merge (Zlúčiť formuláre), aby ste uložili formuláre na pevný disk alebo ISD. Musí byť nainštalovaná licencia pre funkciu Forms Merge (Zlúčiť formuláre). Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk ISD. Emulácie tlačiarne Povoliť funkciu Prescribe Vypnuté * Zapnuté Aktivujte funkciu Prescribe. Musí byť nainštalovaná licencia pre funkciu Prescribe. Emulácie tlačiarne Zabezpečenie emulátora Časový limit stránky 0 – 60 (60*) Nastavenie časového limitu stránky počas emulácie. Emulácie tlačiarne Zabezpečenie emulátora Obnoviť nastavenia emulátora po úlohe Vypnuté * Zapnuté Obnovenie nastavenia emulátora po skončení tlačovej úlohy. Emulácie tlačiarne Zabezpečenie emulátora Zakázať prístup k hláseniam tlačiarne Vypnuté Zapnuté * Zakázať prístup k hláseniam tlačiarne počas emulácie. Konfigurácia faxu Podpora zníženej spotreby faxu Zakázať režim spánku Povoliť režim spánku Automatický * Nastaviť prepnutie faxu do režimu spánku vždy, keď to tlačiareň určí. Konfigurácia faxu Umiestnenie ukladacieho priestoru pre faxy NAND Disk * Nastavenie umiestnenia na uloženie všetkých faxov. Táto položka ponuky sa zobrazí len v prípade, že je nainštalovaný disk ISD. Konfigurácia tlače Zvýšenie ostrosti písma 0 – 150 (24*) Nastavte hodnotu bodovej veľkosti textu, pod ktorou sa pri tlači údajov písiem použijú vysokofrekvenčné obrazovky. Ak je napríklad hodnota 24, potom všetky písma s veľkosťou 24 bodov alebo menej použijú vysokofrekvenčné obrazovky. Konfigurácia tlače Hustota tlače Vypnuté 1 – 5 (3*) Nastavenie hustoty tonera pri tlači dokumentov. Konfigurácia tlače Hustota kopírovania Vypnuté 1 – 5 (3*) Nastavenie hustoty tonera pri kopírovaní dokumentov. Operácie zariadenia Tichý režim Vypnuté * Zapnuté Prepnutie tlačiarne do prevádzky v režime  Tichý režim . Povolením týchto nastavení sa tlačiareň celkovo spomalí. Operácie zariadenia Bezpečný režim Vypnuté * Zapnuté Nastavenie tlačiarne na prevádzku v špeciálnom režime, v ktorom sa pokúša naďalej ponúkať čo najviac funkcií aj napriek známym problémom. Ak je napríklad nastavená možnosť  Zapnuté  a zariadenie pre obojstrannú tlač nefunguje, tlačiareň vykoná jednostrannú tlač dokumentov, a to aj v prípade, ak úloha obsahuje obojstrannú tlač. Operácie zariadenia Minimálna pamäť na kopírovanie 20 MB* 30 MB 50 MB 80 MB 100 MB Nastavenie minimálneho pridelenia pamäte na ukladanie kopírovacích úloh. Operácie zariadenia Vymazať vlastný stav Vymazanie používateľom definovaných reťazcov pre  Predvolené  alebo  Alternatívne  vlastné správy. Operácie zariadenia Vymazať všetky správy o inštalácii na diaľku Vymazanie správ, ktoré boli nainštalované na diaľku. Operácie zariadenia Automaticky zobraziť chybové obrazovky Vypnuté Zapnuté * Zobrazenie existujúcich chybových hlásení na displeji, keď tlačiareň bude neaktívna, na domovskej obrazovke na nastavený čas. Operácie zariadenia Povoliť orientáciu na rýchlom kopírovaní Vypnuté * Zapnuté Povoliť tlačiarni používať nastavenia orientácie v ponuke  Kopírovanie  pri odosielaní rýchlych kopírovacích úloh. Konfigurácia aplikácie Aplikácie LES Vypnuté Zapnuté * Povolenie aplikácií Lexmark Embedded Solutions (LES). Konfigurácia skenera Manuálna registrácia skenera Rýchly test tlače Vytlačenie stránky na rýchly test cieľa. Uistite sa, že odsadenie okrajov na cieľovej stránke je jednotné všade okolo cieľa. Ak nie je, je nutné obnoviť nastavenie okrajov tlačiarne. Konfigurácia skenera Manuálna registrácia skenera Registrácia predného automatického podávača dokumentov Registrácia zadného automatického podávača dokumentov Registrácia plochého skenera Manuálna registrácia plochého skenera a automatického podávača dokumentov po výmene automatického podávača dokumentov, skenovacieho skla alebo riadiacej jednotky. Konfigurácia skenera Vynulovať počítadlo údržby Po výmene súpravy na údržbu ADF obnovte nastavenia počítadla. Konfigurácia skenera Vymazanie okrajov Vymazanie okrajov plochého skenera  (3*) Vymazanie okrajov automatického podávača dokumentov  (3*) Nastavenie veľkosti netlačiteľnej oblasti okolo automatického podávača alebo plochého skenera v milimetroch. Konfigurácia skenera Vypnúť skener Nie * Áno Len podávač ADF Ak skener nefunguje správne, vypnite ho. Konfigurácia skenera Zoradenie položiek vo formáte TIFF podľa veľkosti v bajtoch Endianita procesora * Little Endian Big Endian Zadanie poradia bajtov pre výstup skenovania vo formáte TIFF. Konfigurácia skenera Presný počet riadkov na pás vo formáte TIFF Zapnuté * Vypnuté Nastavenie hodnoty značky RowsPerStrip pre výstup skenovania vo formáte TIFF. ponuka Ponuka konfigurácie"},{"UUID":"56d2e8a5-5814-43a6-8d96-e23fecf8361b","title":"Údržba","link":"preferences-topic.html","desc":"Vymazanie mimo prevádzky Položky ponuky","descFull":"Vymazanie mimo prevádzky Položky ponuky  Vymazanie mimo prevádzky  a ich popis Položka ponuky Opis Vymazanie mimo prevádzky Posledné ošetrenie pamäte Dátum posledného ošetrenia pevného disku ISD naposledy vymazaný Zobrazenie informácií len na čítanie o poslednom vymazaní pamäte alebo pamäťového disku tlačiarne. Položky  Dátum posledného ošetrenia pevného disku  a  ISD naposledy vymazaný  sa zobrazia len v prípade, že je nainštalovaný úložný disk. Vymazanie mimo prevádzky Ošetriť všetky informácie stabilnej pamäte Vymazať všetky nastavenia tlačiarne a siete Vymazať všetky aplikácie a nastavenia aplikácií Vymazať všetky odkazy a nastavenia odkazov Ošetriť všetky informácie na pevnom disku Vymazať prevzaté súbory (vymažú sa všetky makrá, písma, možnosti PFO atď.) Odstrániť úlohy vo vyrovnávacej pamäti Vymazať podržané úlohy Vymazať disk s inteligentným ukladaním Vymazanie všetkých informácií v stálej pamäti a informácií na úložnom disku. Položky  Ošetriť všetky informácie na pevnom disku  a  Vymazať disk s inteligentným ukladaním  sa zobrazia len v prípade, že je nainštalovaný úložný disk. ponuka Vymazanie mimo prevádzky"},{"UUID":"e8b5bba7-0b0c-4d78-ba70-3656d4a760f7","title":"Zariadenie","link":"preferences-topic.html","desc":"Prispôsobenie domovskej obrazovky Táto ponuka","descFull":"Prispôsobenie domovskej obrazovky Táto ponuka je k dispozícii iba na serveri Embedded Web Server. Položka ponuky  Prispôsobenie domovskej obrazovky  a jej opis Ponuka Opis Kopírovanie E-mail Fax Zadržané faxy Uvoľniť zadržané faxy Stav/spotrebný materiál Poradie úloh Nastavenia Zmeniť jazyk Adresár Záložky Pozastavené úlohy Jednotka USB FTP Profily skenovania Zamknúť zariadenie Centrum skenovania Kopírovanie preukazov Centrum skratiek Stanovenie, ktoré ikony sa budú zobrazovať na domovskej obrazovke. ponuka Prispôsobenie domovskej obrazovky"},{"UUID":"01c2f19f-f246-43a4-9a95-86bc768a7740","title":"Zariadenie","link":"preferences-topic.html","desc":"Aktualizovať firmvér Položky ponuky ","descFull":"Aktualizovať firmvér Položky ponuky  Aktualizovať firmvér  a ich popisy Položka ponuky Opis Aktuálna verzia Zobrazenie aktuálnej verzie firmvéru nainštalovanej v tlačiarni. Vyhľadať dostupné aktualizácie Kontrola dostupnosti aktualizácií firmvéru. Automaticky skontrolovať aktualizácie Nastavenie tlačiarne na automatickú kontrolu aktualizácií firmvéru. ponuka Aktualizovať firmvér"},{"UUID":"f7296856-2a39-4a76-be7e-c3cc29fa5046","title":"Zariadenie","link":"preferences-topic.html","desc":"Informácie o tlačiarni Položky ponuky ","descFull":"Informácie o tlačiarni Položky ponuky  Informácie o tlačiarni  a ich popis Položka ponuky Opis Značka zariadenia Zadanie identity tlačiarne. Maximálna dĺžka je 32 znakov. Umiestnenie tlačiarne Určenie umiestnenia tlačiarne. Maximálna dĺžka je 63 znakov. Kontaktujte oddelenie Zadanie kontaktných údajov pre tlačiareň. Maximálna dĺžka je 63 znakov. Verzia firmvéru Zobrazenie verzie firmvéru nainštalovanej v tlačiarni. Systém Zobrazenie systémového čísla tlačiarne. Sériové číslo Zobrazenie sériového čísla tlačiarne. Exportovať súbor konfigurácie na jednotku USB Export konfiguračného súboru na jednotku flash. Exportovať komprimovaný súbor denníkov na jednotku USB Export komprimovaných súborov denníkov na jednotku flash. Odoslať denníky Odoslanie informácií z denníkov tlačiarne spoločnosti Lexmark. ponuka Informácie o tlačiarni"},{"UUID":"1f2a648c-0694-4f4a-9188-31a33d868d34","title":"Tlač","link":"layout-topic.html","desc":"Rozloženie Položky ponuky  Rozloženie","descFull":"Rozloženie Položky ponuky  Rozloženie  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Strany Jednostranne * Obojstranne Určenie, či sa má tlačiť na jednej alebo oboch stranách papiera. Štýl preklopenia Dlhý okraj * Krátky okraj Určenie toho, ktorá strana papiera sa zviaže pri obojstrannej tlači. Prázdne strany Tlač Netlačiť * Tlač prázdnych strán, ktoré sú súčasťou tlačovej úlohy. Zoradiť Vypnuté (1, 1, 1, 2, 2, 2) Zapnuté (1, 2, 1, 2, 1, 2) * Stohovanie strán tlačovej úlohy v správnom poradí najmä pri tlači viacerých kópií tlačovej úlohy. Oddeľovacie listy Žiadne * Medzi kópiami Medzi úlohami Medzi stranami Vkladanie prázdnych oddeľovacích listov pri tlači. Zdroj oddeľovacích listov Zásobník  [x] (1*) Viacúčelový podávač Stanovenie zdroja papiera pre oddeľovacie listy. Počet stránok na stranu Vypnuté * 2 stránky na stranu 3 stránky na stranu 4 stránky na stranu 6 stránok na stranu 9 stránok na stranu 12 stránok na stranu 16 stránok na stranu Tlač obrázkov na viacerých stránkach na jednu stranu jedného listu papiera. Zoradenie stránok na strane Vodorovne * Obrátene vodorovne Zvislé Obrátene zvislo Stanovenie polohy obrázkov na viacerých stránkach pri použití ponuky  Počet stránok na stranu . Orientácia stránok na strane Automaticky * Na šírku Na výšku Stanovenie orientácie obrázkov na viacerých stránkach pri použití ponuky  Počet stránok na stranu . Okraje stránok na strane Žiadne * Plný Pri použití ponuky  Počet stránok na stranu  sa vytlačí okraj okolo obrázka každej strany. Kópie 1 – 9999 (1*) Stanovenie počtu kópií každej tlačovej úlohy. Oblasť tlače Normálne * Celá strana Nastavenie oblasti tlače na liste papiera. ponuka Rozloženie"},{"UUID":"f2c65606-8f4b-4f8d-a04d-957fffd48f30","title":"Tlač","link":"layout-topic.html","desc":"Nastavenie Položky ponuky  Nastavenie","descFull":"Nastavenie Položky ponuky  Nastavenie  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Jazyk tlačiarne Emulácia jazyka PCL * Emulácia jazyka PS Nastavenie jazyka tlačiarne. Nastavenie predvoleného jazyka tlačiarne nezabráni softvérovému programu odosielať tlačové úlohy využívajúce iný jazyk tlačiarne. Čakajúca úloha Vypnuté * Zapnuté Zachovanie tlačových úloh vyžadujúcich spotrebný materiál tak, aby bolo možné vytlačiť úlohy, na ktoré chýbajúci materiál nie je potrebný. Táto položka ponuky sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk s inteligentným ukladaním (ISD). Časový limit pozastavenia úlohy 0 – 255  ( 30 *) Nastavenie času v sekundách, počas ktorého bude tlačiareň čakať na zásah používateľa pred pozastavením úlohy požadujúcej nedostupné zdroje. Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk ISD. Cieľ preberania RAM * Disk Nastavenie miesta, kde sa uložia všetky trvalé zdroje prevzaté do tlačiarne. Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk ISD. Ukladanie zdrojov Vypnuté * Zapnuté Nastavenie toho, čo tlačiareň urobí s prevzatými zdrojmi, keď dostane úlohu vyžadujúcu viac pamäte, než je dostupná. Pri nastavení na možnosť  Vypnuté  tlačiareň uchová prevzaté zdroje len dovtedy, kým je potrebná pamäť. Zdroje súvisiace s neaktívnym jazykom tlačiarne sa odstránia. Pri nastavení možnosti  Zapnuté  tlačiareň uchováva všetky trvalo prevzaté zdroje pre všetky nastavené jazyky. V prípade potreby tlačiareň namiesto odstránenia trvalých zdrojov zobrazí hlásenie o zaplnení pamäte. Poradie pri tlači všetkých súborov Abecedné * Najprv najnovšie Najprv najstaršie Určite poradie, ak chcete vytlačiť všetky podržané a dôverné úlohy. ponuka Nastavenie"},{"UUID":"bdfb8987-a426-4274-afb8-4561ebccac84","title":"Tlač","link":"layout-topic.html","desc":"Kvalita Položky ponuky  Kvalita","descFull":"Kvalita Položky ponuky  Kvalita  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Rozlíšenie tlače 600 dpi 1200 Obrázok Q * 2400 Obrázok Q 1200 dpi 300 dpi Nastavenie rozlíšenia tlačového výstupu. Zvýšenie počtu pixelov Vypnuté * Písma * Horizontálne Vertikálne V oboch smeroch Z hľadiska jasnosti tlače umožňuje tlač viacerých pixelov v blokoch na účely vylepšenia obrázkov horizontálne alebo vertikálne alebo na účely vylepšenia fontov. Tmavosť tonera 1 až 10 (8*) Nastavenie svetlosti alebo tmavosti textových obrázkov. Poltón Normálne * Detailne Vylepšenie tlačeného výstupu na dosiahnutie plynulejších čiar s ostrejšími okrajmi. Jas –6 až 6 (0*) Úprava výtlačku jeho zosvetlením alebo stmavením. Kontrast 0 až 5 (0*) Upravte kontrast vytlačených objektov. Korekcia sivej Vypnuté Automatický * Povolenie algoritmu korekcie sivej tlačiarne na vytlačených obrázkoch na úrovni strednej sivej. ponuka Kvalita"},{"UUID":"7f674792-d294-436a-8dbc-6ba2354048e3","title":"Tlač","link":"layout-topic.html","desc":"Štatistika úloh Položky ponuky ","descFull":"Štatistika úloh Položky ponuky  Štatistika úloh  a ich popisy Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Štatistika úloh Vypnuté * Zapnuté Nastavenie tlačiarne na vytváranie denníka prijatých tlačových úloh. Frekvencia denníka štatistiky Denne Týždenne Mesačne * Nastavenie, ako často má tlačiareň vytvárať súbor denníka. Činnosť, ktorá sa má vykonať s denníkom na konci intervalu Žiadne * Odoslať aktuálny denník e-mailom Odoslať aktuálny denník e-mailom a odstrániť ho Uverejniť aktuálny denník Uverejniť aktuálny denník a odstrániť ho Nastavenie spôsobu, akým tlačiareň reaguje na uplynutie prahovej hodnoty obdobia. Hodnota určená v nastavení  Frekvencia denníka štatistiky  určuje čas aktivácie tohto úkonu. Zaznamenať, keď je pevný disk takmer plný Vypnuté Zapnuté * (5) Nastavenie maximálnej veľkosti súboru denníka, pred dosiahnutím ktorej sa spustí  činnosť, ktorá sa má vykonať, keď je pevný disk takmer plný . Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk ISD. Činnosť, ktorá sa má vykonať, keď je pevný disk takmer plný Žiadne * Odoslať aktuálny denník e-mailom Odoslať aktuálny denník e-mailom a odstrániť ho Odoslať aktuálny denník e-mailom a odstrániť najstarší denník Uverejniť aktuálny denník Uverejniť aktuálny denník a odstrániť ho Uverejniť aktuálny denník a odstrániť najstarší denník Odstrániť aktuálny denník Odstrániť najstarší denník Odstrániť všetky denníky okrem aktuálneho Odstrániť všetky denníky Nastavenie reakcie tlačiarne, keď sú pevný disk alebo disk ISD takmer plné. Hodnota určená v nastavení  Zaznamenať, keď je pevný disk takmer plný  určuje čas aktivácie tohto úkonu. Činnosť, ktorá sa má vykonať, keď je pevný disk plný Žiadne * Odoslať aktuálny denník e-mailom a odstrániť ho Odoslať aktuálny denník e-mailom a odstrániť najstarší denník Uverejniť aktuálny denník a odstrániť ho Uverejniť aktuálny denník a odstrániť najstarší denník Odstrániť aktuálny denník Odstrániť najstarší denník Odstrániť všetky denníky okrem aktuálneho Odstrániť všetky denníky Nastavenie reakcie tlačiarne v prípade, že využitie pevného disku alebo disku ISD dosiahne maximálny limit (100 MB). Adresa URL na zverejnenie denníka Stanovenie miesta, kde tlačiareň zverejňuje denníky štatistiky úloh. E-mailová adresa na odoslanie denníkov Stanovenie e-mailovej adresy, na ktorú tlačiareň odosiela denníky štatistiky úloh. Predvoľba súboru denníka Stanovenie predvoľby súborov denníka. Aktuálny názov hostiteľa nastavený v ponuke  TCP/IP  sa používa ako predvolená predvoľba súboru denníka. ponuka Štatistika úloh"},{"UUID":"2e54f0b4-662d-4be1-97da-358bb01f060f","title":"Tlač","link":"layout-topic.html","desc":"PDF Položky ponuky  PDF","descFull":"PDF Položky ponuky  PDF  a ich popisy Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Podľa veľkosti Vypnuté * Zapnuté Úprava obsahu strany podľa vybratej veľkosti papiera. Anotácie Tlač Netlačiť * Stanovenie, či sa majú tlačiť anotácie v súbore PDF. Tlačiť chybu PDF Vypnuté Zapnuté * Povolenie tlače chyby PDF. ponuka PDF"},{"UUID":"218fcfbc-f6bd-402b-9039-182d109c6dcf","title":"Tlač","link":"layout-topic.html","desc":"PostScript Položky ponuky  PostScript","descFull":"PostScript Položky ponuky  PostScript  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Tlačiť chybu PS Vypnuté * Zapnuté Tlač strany s opisom chyby jazyka PostScript®. Keď sa vyskytne chyba, zastaví sa spracovanie úlohy, tlačiareň vytlačí chybové hlásenie a zvyšok tlačovej úlohy sa vypustí. Minimálna šírka čiary 1 – 30 (2*) Nastavenie minimálnej šírky ťahu. Úlohy tlačené v rozlíšení 1 200 dpi uplatňujú túto hodnotu priamo. Zamknúť režim spustenia PS Vypnuté Zapnuté * Zakázať súbor SysStart. Povolenie súboru SysStart vystavuje vašu tlačiareň alebo sieť bezpečnostnému riziku. Priorita písma Zabudované * Flash/Disk Stanovenie postupnosti vyhľadávania písma. V prípade nastavenia  Zabudované  tlačiareň hľadá požadované písmo vo vlastnej pamäti a až potom prehľadáva pevný disk a disk s inteligentným ukladaním (ISD). V prípade nastavenia  Flash/Disk  tlačiareň hľadá požadované písmo na pevnom disku a na disku ISD a až potom prehľadáva pamäť tlačiarne. Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk ISD. Časový limit čakania Vypnuté Zapnuté * ( 40 sekúnd ) Povolenie, aby tlačiareň čakala na ďalšie údaje pred zrušením tlačovej úlohy. ponuka PostScript"},{"UUID":"01158310-bd63-491a-98e7-c6fe88375f2f","title":"Tlač","link":"layout-topic.html","desc":"PCL Položky ponuky  PCL","descFull":"PCL Položky ponuky  PCL  a ich popisy Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Zdroj písma Zabudované * Disk Prevziať Flash Karta písiem Všetky Výber zdroja, ktorý obsahuje predvolený výber písiem. Možnosti  Disk  a  Jednotka Flash  sa zobrazia len v prípade, ak je nainštalovaný pevný disk alebo disk s inteligentným ukladaním (ISD) obsahujúci písma. Možnosť  Prevziať  sa zobrazí len v prípade, ak v pamäti tlačiarne existujú prevzaté písma. Karta písiem  sa zobrazí len vtedy, keď je nainštalovaný disk ISD. Názov písma [Zoznam dostupných písiem] ( Courier *) Výber písma z uvedeného zdroja písiem. Súprava symbolov [Zoznam dostupnej súpravy symbolov] (10U PC‑8*) Stanovenie súpravy symbolov pre každý názov písma. Súprava symbolov predstavuje súpravu abecedných a číselných znakov, znamienok a špeciálnych znakov. Súpravy symbolov podporujú rôzne jazyky alebo určité programy, ako napríklad matematické symboly pre vedecký text. Rozstup 0,08 – 100,00 (10,00*) Zadanie rozstupu pre pevné písmo alebo písmo s rovnakým rozstupom. Rozstup  predstavuje počet pevných medzier vodorovne v texte s dĺžkou jedného palca. Orientácia Na výšku * Na šírku Obrátene na výšku Obrátene na šírku Stanovenie orientácie textu a grafických prvkov na strane. Počet riadkov na stranu 1 – 255 Zadanie počtu riadkov textu pre jednotlivé strany vytlačené cez dátový prenos PCL®. Touto položkou ponuky sa aktivuje vertikálne krokovanie, vďaka ktorému sa medzi predvolené okraje strany vytlačí zvolený požadovaný počet riadkov. 60 je americké predvolené výrobné nastavenie. Medzinárodné predvolené výrobné nastavenie je 64. Minimálna šírka čiary v ovládači PCL5 1 – 30 (2*) Nastavenie počiatočnej minimálnej šírky ťahu. Minimálna šírka čiary v ovládači PCLXL 1 – 30 (2*) Šírka formátu A4 198 mm* 203 mm Nastavenie šírky logickej strany na papieri formátu A4. Logická strana je plocha na fyzickej strane, na ktorú sa tlačia údaje. Automaticky CR po LF Zapnuté Vypnuté * Nastavenie tlačiarne na vykonanie návratu vozíka po riadiacom príkaze na posun o riadok. Návrat vozíka predstavuje mechanizmus, ktorý tlačiarni prikazuje presunúť polohu kurzora na prvú polohu v rovnakom riadku. Automaticky LF po CR Zapnuté Vypnuté * Nastavenie tlačiarne na vykonanie posunu o riadok po riadiacom príkaze na návrat vozíka. Zmena čísla zásobníka Priradiť viacúčelový podávač Priradiť zásobník  [x] Priradiť manuálny podávač papiera Priradiť manuálny podávač obálok Konfigurácia tlačiarne na prácu s rôznymi ovládačmi tlače alebo vlastnou aplikáciou, ktorá používa odlišný súbor zdrojových úloh na požiadanie daného zdroja papiera. Vyberte z nasledujúcich možností: Vypnuté * – Tlačiareň používa úlohy predvoleného zdroja papiera z výroby. Žiadne  – Zdroj papiera ignoruje príkaz výberu možnosti podávania papiera. 0 – 199 – Vyberte číselnú hodnotu na priradenie vlastnej hodnoty zdroju papiera. Zmena čísla zásobníka Zobraziť predvolené výrobné nastavenia Zobrazenie predvolenej hodnoty z výroby priradenej každému zdroju papiera. Zmena čísla zásobníka Obnoviť predvolené Obnova hodnôt zmeny čísla zásobníka na ich hodnoty z výroby. Časový limit tlače Vypnuté Zapnuté*  (90 sekúnd) Nastavenie tlačiarne na ukončenie tlačovej úlohy po dobe nečinnosti, ktorá trvala vymedzený čas. Dĺžka časového limitu tlače  sa zobrazí len v prípade, ak je povolená možnosť  Časový limit tlače . ponuka PCL"},{"UUID":"524082d2-6be6-4c1c-8e2a-2562a2384a04","title":"Tlač","link":"layout-topic.html","desc":"Obrázok Položky ponuky  Obrázok","descFull":"Obrázok Položky ponuky  Obrázok  a ich popisy Položka ponuky Popis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Automaticky prispôsobiť Zapnuté Vypnuté * Vzhľadom na obrázok sa vyberie najlepšia dostupná veľkosť papiera a nastavenie jeho orientácie. V prípade nastavenia na možnosť  Zapnuté  táto položka ponuky upraví nastavenia zmeny veľkosti a orientácie obrázka. Invertovať Vypnuté * Zapnuté Invertovanie dvojfarebných monochromatických obrázkov. Táto položka ponuky sa nevzťahuje na obrázky vo formáte GIF ani JPEG. Zmena veľkosti Ukotviť vľavo hore Prispôsobiť * Ukotviť v strede Prispôsobiť výšku/šírku Prispôsobiť výšku Prispôsobiť šírku Obrázok sa prispôsobí veľkosti tlačenej plochy. Keď je funkcia  Automaticky prispôsobiť  nastavená na možnosť  Zapnutá , položka  Zmena veľkosti  sa automaticky nastaví na možnosť  Prispôsobiť . Orientácia Na výšku * Na šírku Obrátene na výšku Obrátene na šírku Stanovenie orientácie textu a grafických prvkov na strane. ponuka Obrázok"},{"UUID":"8115e74e-82f8-4ce5-a439-d068bce5127c","title":"Papier","link":"tray-configuration-topic.html","desc":"Konfigurácia zásobníkov Položky ponuky ","descFull":"Konfigurácia zásobníkov Položky ponuky  Konfigurácia zásobníkov  a ich popisy Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Predvolený zdroj Zásobník  [x] (1*) Viacúčelový podávač Manuálny podávač papiera Manuálny podávač obálok Nastavenie zdroja papiera pre všetky tlačové úlohy. Veľkosť/typ papiera Zásobník  [x] Viacúčelový podávač Manuálny podávač papiera Manuálny podávač obálok Stanovenie veľkosti papiera alebo typu papiera vloženého do každého zo zdrojov papiera. Nahradiť veľkosť Vypnuté Letter/A4 Všetky uvedené * Nastavenie tlačiarne na nahradenie uvedenej veľkosti papiera, ak papier požadovanej veľkosti nie je vložený v žiadnom zdroji papiera. Nastavenie  Vypnuté  vyzve používateľa na vloženie papiera požadovanej veľkosti. Možnosť  Všetky uvedené  umožňuje všetky dostupné nahradenia. Konfigurácia Kazeta * Manuálny režim Prvý Stanovenie správania viacúčelového podávača. Možnosť  Kazeta  nakonfiguruje viacúčelový podávač ako automatický zdroj papiera. Možnosť  Manuálne  nastaví viacúčelový podávač iba pre tlačové úlohy podávané manuálne. Možnosť  Prvý  nakonfiguruje viacúčelový podávač ako primárny zdroj papiera. ponuka Konfigurácia zásobníkov"},{"UUID":"c2bf8688-e1a9-40e3-acc8-95dc8c4bcf84","title":"Konfigurácia médií","link":"tray-configuration-topic.html","desc":"Univerzálne nastavenie Položky ponuky ","descFull":"Univerzálne nastavenie Položky ponuky  Univerzálne nastavenie  a ich popisy Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Merné jednotky Palce Milimetre Stanovenie mernej jednotky univerzálneho papiera. Palce  sú americké predvolené výrobné nastavenie.  Milimetre  sú medzinárodné predvolené výrobné nastavenie. Na výšku – šírka 3,5 – 19 palcov (8,5*) 88,9 – 482,6 mm (216*) Nastavenie šírky univerzálneho papiera pri tlači na výšku. Na výšku – výška 3,5 – 19 palcov (14*) 88,9 – 482,6 mm (356*) Nastavenie výšky univerzálneho papiera pri tlači na výšku. Smer podávania Krátky okraj * Dlhý okraj Nastavenie tlačiarne na podávanie papiera krátkym alebo dlhým okrajom. Možnosť  Dlhý okraj  sa zobrazuje len v prípade, že najdlhší okraj papiera je kratší než maximálna podporovaná šírka. Viaceré univerzálne veľkosti Zásobník [x] Viacúčelový podávač Priraďuje jedinečný rozmer pre viaceré univerzálne veľkosti, ktoré sú vložené v každom zdroji papiera. Toto nastavenie sa zobrazí len vtedy, keď je aktivované v ponuke  Zariadenie . Na domovskej obrazovke sa dotknite položiek  Nastavenia Zariadenie Údržba Ponuka konfigurácie Konfigurácia zásobníkov Viaceré univerzálne veľkosti . ponuka Univerzálne nastavenie"},{"UUID":"a49f4f1d-87b1-4aa0-82c0-b17129ba2ad6","title":"Konfigurácia médií","link":"tray-configuration-topic.html","desc":"Vlastné veľkosti skenovania Položky ponuky","descFull":"Vlastné veľkosti skenovania Položky ponuky  Vlastné veľkosti skenovania  a ich popisy Položka ponuky Opis Vlastná veľkosť skenovania  [x] Názov veľkosti skenovania Šírka 1 – 8,5 palca (8,5*) 25,4 – 215,9 mm (215,9*) Výška 1 – 25 palcov (11*) 25,4 – 635 mm (279,4*) Orientácia Na výšku * Na šírku 2 skeny na stranu Vypnuté * Zapnuté Priradenie názvu veľkosti skenovania a konfigurácia nastavení skenovania. ponuka Vlastné veľkosti skenovania"},{"UUID":"2b1ec055-af1c-47f4-bc9f-c72126ccf9d2","title":"Konfigurácia médií","link":"tray-configuration-topic.html","desc":"typy médií Položka ponuky ","descFull":"typy médií Položka ponuky  Typy médií  a jej popis Položka ponuky Opis Obyčajný papier Kartón Recyklovaný papier Štítky Kancelársky papier Obálka Pevná obálka Hlavičkový papier Predtlačený papier Farebný papier Ľahký papier Ťažký papier Pevný/bavlnený Vlastný typ  [X] Určenie textúry, hmotnosti a orientácie papiera. ponuka typy médií"},{"UUID":"59cc3d7d-61ce-4795-8ca8-98067e0251c4","title":"Kopírovanie","link":"copy-defaults-topic.html","desc":"Predvolené hodnoty kopírovania Položky ponuky","descFull":"Predvolené hodnoty kopírovania Položky ponuky  Predvolené hodnoty kopírovania  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Typ obsahu Text Text/fotografia * Fotografia Grafika Zlepšenie výsledného výstupu na základe obsahu zdrojového dokumentu. Zdroj obsahu Čiernobiele laserové tlačiarne * Farebné laserové tlačiarne Atramentové tlačiarne Fotografia/film Časopis Noviny Tlač Iné Vylepšenie výsledného výstupu na základe zdroja zdrojového dokumentu. Strany Jednostranné na jednostranné * Jednostranné na obojstranné Obojstranné na jednostranné Obojstranné na obojstranné Určenie priebehu skenovania na základe zdrojového dokumentu. Oddeľovacie listy Žiadne * Medzi kópiami Medzi úlohami Medzi stranami Stanovenie, či vkladať prázdne oddeľovacie listy pri tlači. Zdroj oddeľovacích listov Zásobník  [x] (1*) Viacúčelový podávač Stanovenie zdroja papiera pre oddeľovacie listy. Farebne Vypnuté Zapnuté * Automatické Nastavenie tlačiarne na vytváranie farebného výstupu z úlohy skenovania. Počet stránok na stranu Vypnuté * 2 stránky na výšku 4 stránky na výšku 2 stránky na šírku 4 stránky na šírku Určenie počtu obrázkov strán, ktoré sa majú vytlačiť na jednu stranu listu papiera. Tlačiť orámovanie strán Vypnuté * Zapnuté Umiestnenie okraja okolo každého obrázka pri tlači viacerých obrázkov na jednu stranu. Zoradiť Vypnuté [1, 1, 1, 2, 2, 2] Zapnuté [1,2,1,2,1,2] * Tlač viacerých kópií v rade. Veľkosť „Kopírovať z“ [Zoznam veľkostí papiera] Nastavenie veľkosti papiera zdrojového dokumentu. Letter  je americké predvolené výrobné nastavenie. Veľkosť  A4  je medzinárodné predvolené výrobné nastavenie. Zdroj „Kopírovať do“ Zásobník  [x] (1*) Viacúčelový podávač Automatický výber veľkosti Stanovenie zdroja papiera pre úlohu kopírovania. Teplota –4 až 4 (0*) Nastavenie, či sa má vytvoriť chladnejší alebo teplejší výstup. Tmavosť 1 až 9 (5*) Úprava tmavosti naskenovaného obrázka. Počet kópií 1 – 9999 (1*) Stanovenie počtu kópií. Hlavička/päta Ľavá hlavička Stredná hlavička Pravá hlavička Ľavá päta Stredná päta Pravá päta Zadanie informácií v hlavičke alebo päte skenovaného obrázka. Prekrytie Dôverné Kopírovanie Koncept Naliehavé Vlastné Vypnuté * Určenie textu prekrytia, ktorý sa má vytlačiť na jednotlivých kópiách. Vlastné prekrytie Zadajte text v položke  Vlastné  ponuke  Prekrytie . Rozšírené spracovanie obrázkov Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Vyváženie farieb Azúrová – červená  (0*) Purpurová – zelená  (0*) Žltá – modrá  (0*) Nastavenie intenzity pre azúrovú, purpurovú a žltú farbu. Vynechanie farieb Vynechanie farieb  ( Žiadne *) Predvolený prah červenej  (128*) Predvolený prah zelenej  (128*) Predvolený prah modrej  (128*) Stanovenie farby, ktorá sa má pri skenovaní vynechať, a upravenie nastavenia vynechania danej farby. Automatická detekcia farieb Citlivosť farieb  (5*) Plošná citlivosť  (5*) Konfigurácia nastavenia automatickej detekcie farieb. Kontrast Najlepšie pre obsah * 0 – 5 Zadanie kontrastu skenovaného obrázka. Odstránenie pozadia Detekcia pozadia  ( Na základe obsahu  *) Hladina  (0*) Odstránenie farby pozadia alebo obrazového šumu z pôvodného dokumentu. Na základe obsahu  odstráni farbu pozadia z pôvodného dokumentu. Možnosť  Pevné  odstráni obrazový šum z fotografie. Automaticky zarovnať na stred Vypnuté * Zapnuté Zarovnanie obsahu na stred strany. Zrkadlový obraz Vypnuté * Zapnuté Vytvorenie zrkadlového obrazu zdrojového dokumentu. Negatív Vypnuté * Zapnuté Vytvorenie negatívu zdrojového dokumentu. Detaily tieňov –4 až 4 (0*) Úprava detailov tieňov v zdrojovom dokumente. Skenovať od okraja po okraj Vypnuté * Zapnuté Skenovanie pôvodného dokumentu od okraja po okraj. Ostrosť 1 – 5 (3*) Úprava ostrosti naskenovaného obrázka. Ovládacie prvky správcu Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Povoliť farebné kópie Vypnuté Zapnuté * Tlač kópií farebne. Povoliť prioritné kópie Vypnuté Zapnuté * Prerušenie tlačovej úlohy, aby bolo možné vytvoriť kópie. Vlastná úloha skenovania Vypnuté * Zapnuté Nastavenie tlačiarne na skenovanie prvého súboru originálnych dokumentov pomocou určených nastavení a potom skenovanie ďalšej skupiny s rovnakými alebo inými nastaveniami. Táto položka ponuky sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk s inteligentným ukladaním (ISD). Povoliť možnosť Uložiť ako skratku Vypnuté Zapnuté * Uloženie nastavení kopírovania ako skratky. Prispôsobiť zošikmenie z automatického podávača dokumentov Vypnuté Zapnuté * Nastavenie tlačiarne na úpravu zošikmených obrázkov z dokumentov, ktoré sú skenované z automatického podávača dokumentov. Vzorová kópia Vypnuté * Zapnuté Tlač vzorovej kópie na kontrolu kvality pred tlačou zostávajúcich kópií. Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk ISD. ponuka Predvolené hodnoty kopírovania"},{"UUID":"4f434f6c-1837-481d-9813-272793153c81","title":"Predvolené nastavenia faxu","link":"fax-defaults-subgroup.html","desc":"Režim faxu Položka ponuky ","descFull":"Režim faxu Položka ponuky  Režim faxu  a jej opis Položka ponuky Opis Režim faxu Fax * Faxový server Vypnuté Výber režimu faxu. ponuka Režim faxu"},{"UUID":"4354702d-c23c-40cf-9778-cac665787b88","title":"Predvolené nastavenia faxu","link":"fax-defaults-subgroup.html","desc":"nastavenie faxu Všeobecné nastavenia faxu","descFull":"nastavenie faxu Všeobecné nastavenia faxu Položky ponuky  Všeobecné nastavenia faxu  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Názov faxu Zadanie ID faxu. Faxové číslo Zadanie faxového čísla. ID faxu Názov faxu Faxové číslo * Nastavenie ID faxu, ktoré sa má použiť počas faxového vyjednávania. Zapnúť manuálne faxovanie Vypnuté * Zapnuté Zapnutie funkcie manuálneho faxovania v tlačiarni. Táto položka ponuky si vyžaduje rozdeľovač linky a telefónne slúchadlo. Používanie bežnej telefónnej linky na odpovedanie na prichádzajúcu faxovú úlohu a na voľbu faxového čísla. Na priamy prechod k funkcii manuálneho faxovania stlačte tlačidlá  #  a  0  na klávesnici. Využitie pamäte Všetko prijať Väčšinu prijať Vyrovnané * Väčšinu odoslať Všetko odoslať Nastavenie množstva vnútornej pamäte tlačiarne vyhradenej na faxovanie. Táto položka ponuky zabráni chybovým stavom vyrovnávacej pamäte a neúspešnému faxovaniu. Zrušiť faxy Povoliť * Nepovoliť Zrušenie odchádzajúcich alebo prichádzajúcich faxov. Maskovanie faxových čísel Vypnuté * Zľava Sprava Určenie formátu maskovania čísla, na ktoré sa fax odosiela. Číslice na maskovanie 0 – 58 (0*) Stanovenie počtu číslic na maskovanie v čísle, na ktoré sa fax odosiela. Povoliť detekciu pripojenej linky Vypnuté Zapnuté * Nastavenie detekcie pripojenia telefónnej linky k tlačiarni. Udalosti sa okamžite detegujú. Povoliť detekciu pripojenia linky k nesprávnemu konektoru Vypnuté Zapnuté * Nastavenie detekcie pripojenia telefónnej linky k správnemu portu tlačiarne. Udalosti sa okamžite detegujú. Povoliť podporu používania klapky Vypnuté Zapnuté * Zistite, či telefónnu linku nepoužíva aj iné zariadenie, napríklad iný telefón na tej istej linke. Udalosti sa okamžite detegujú. Optimalizovať kompatibilitu faxu Konfigurácia funkcie faxovania prostredníctvom tlačiarne na zaistenie optimálnej kompatibility s inými faxovými zariadeniami. Prenos faxu T.38 Analógový G.711 etherFAX Nastavenie spôsobu prenosu faxu. Táto položka ponuky sa zobrazí len v prípade, ak je v tlačiarni nainštalovaný licenčný balík etherFAX alebo Fax cez IP (FoIP). Táto položka ponuky sa zobrazí len v prípade, ak je v tlačiarni nainštalovaný licenčný balík Fax cez IP (FoIP). Nastavenia HTTPS faxu Táto ponuka sa zobrazí iba v prípade, ak je  Prenos faxu  nastavený na  etherFAX . Položky ponuky  Nastavenia HTTPS faxu  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Adresa URL služby HTTPS Zadajte adresu URL služby etherFAX. Server HTTPS proxy Zadajte adresu URL servera proxy. Používateľ servera HTTPS proxy Zadajte meno používateľa a heslo pre server proxy. Heslo servera HTTPS proxy Šifrovanie odosielania faxov Vypnuté Povolené * Požadované Povoliť šifrovanie odchádzajúcich faxových správ. Šifrovanie príjmu faxov Vypnuté Povolené * Požadované Povoliť šifrovanie prichádzajúcich faxových správ. Stav HTTPS faxu Zobraziť stav komunikácie so službou etherFAX. Nastavenia odosielania faxov Položky ponuky  Nastavenia odosielania faxov  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Rozlíšenie Štandardné * Jemné Veľmi jemné Ultra jemné Nastavenie rozlíšenia naskenovaného obrázka. Vyššie rozlíšenie zvyšuje čas odosielania faxu a vyžaduje viac pamäte. Veľkosť originálu [Zoznam formátov papiera] (Rôzne veľkosti*) Stanovenie veľkosti zdrojového dokumentu. Orientácia Na výšku * Na šírku Stanovenie orientácie zdrojového dokumentu. Strany Vypnuté * Krátky okraj Dlhý okraj Zadanie orientácie pôvodného dokumentu pri skenovaní na oboch stranách dokumentu. Typ obsahu Text * Text/fotografia Fotografia Grafika Zlepšenie výsledného výstupu na základe obsahu zdrojového dokumentu. Zdroj obsahu Čiernobiele laserové tlačiarne * Farebné laserové tlačiarne Atramentové tlačiarne Fotografia/film Časopis Noviny Tlač Iné Vylepšenie výsledného výstupu na základe zdroja zdrojového dokumentu. Tmavosť 1 – 9 (5*) Úprava tmavosti naskenovaného obrázka. Za PABX Zapnuté Vypnuté * Nastavenie tlačiarne na voľbu faxového čísla bez čakania na rozpoznanie oznamovacieho tónu. Telefónna sieť PABX umožňuje prostredníctvom jedného prístupového čísla využiť viacero liniek pre externých volajúcich. Režim vytáčania Tónové * Pulzné Určenie režimu vytáčania pre prichádzajúce a odchádzajúce faxy. Rozšírené spracovanie obrázkov Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Vyváženie farieb Azúrová – červená  (0*) Purpurová – zelená  (0*) Žltá – modrá  (0*) Nastavenie intenzity farieb počas skenovania. Vynechanie farieb Vynechanie farieb  ( Žiadne *) Predvolený prah červenej  (128*) Predvolený prah zelenej  (128*) Predvolený prah modrej  (128*) Stanovenie farby, ktorá sa má pri skenovaní vynechať, a upravenie nastavenia vynechania danej farby. Kontrast Najlepšie pre obsah * 0 1 2 3 4 5 Nastavenie kontrastu výstupu. Odstránenie pozadia Úroveň –4 až 4 (0*) Nastavenie množstva pozadia viditeľného na skenovanom obrázku. Zrkadlový obraz Vypnuté * Zapnuté Vytvorenie zrkadlového obrazu zdrojového dokumentu. Negatív Vypnuté * Zapnuté Vytvorenie negatívu zdrojového dokumentu. Detaily tieňov –4 až 4 (0*) Nastavenie detailu tieňov viditeľných na skenovanom obrázku. Skenovať od okraja po okraj Zapnuté Vypnuté * Umožnenie skenovania zdrojového dokumentu od okraja po okraj. Ostrosť 1 – 5 (3*) Úprava ostrosti naskenovaného obrázka. Teplota –4 až 4 (0*) Nastavenie, či sa má vytvoriť chladnejší alebo teplejší výstup. Ovládacie prvky správcu Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Automatické opätovné vytáčanie 0 – 9 (5*) Zadanie počtu pokusov o opätovné vytáčanie, ktoré tlačiareň zopakuje predtým, ako zruší odoslanie faxu na špecifikované miesto určenia. Frekvencia opätovného vytáčania 1 – 200 min (3*) Predĺženie doby medzi pokusmi o opätovné vytáčanie na zvýšenie šance úspešného odoslania faxu. Povoliť protokol ECM Zapnuté * Vypnuté Aktivácia funkcie ECM pre faxové úlohy. Funkcia ECM zistí a opraví chyby v procese prenosu faxu spôsobené šumom telefónnej linky a slabou silou signálu. Zapnúť skenovanie faxov Zapnuté * Vypnuté Vytváranie faxov pomocou skenera tlačiarne. Ovládač na faxovanie Zapnuté * Vypnuté Povolenie odosielania faxov ovládaču tlače. Povoliť možnosť Uložiť ako skratku Zapnuté * Vypnuté Ukladanie faxových čísel ako skratiek v tlačiarni. Maximálna rýchlosť 33600 * 14400 9600 4800 2400 Nastavenie maximálnej rýchlosti odosielania faxu. Vlastná úloha skenovania Vypnuté * Zapnuté Predvolené zapnutie skenovania vlastných úloh. Táto položka ponuky sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk s inteligentným ukladaním (ISD). Ukážka skenovania Vypnuté * Zapnuté Zobrazenie ukážky skenovania na displeji. Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk ISD. Prispôsobiť zošikmenie z automatického podávača dokumentov Vypnuté Zapnuté * Korekcia mierneho zošikmenia skenovaného obrázka. Zapnúť skenovanie farebných faxov Predvolene vypnuté * Predvolene zapnuté Nikdy nepoužiť Vždy použiť Povolenie skenovania faxov farebne. Automaticky konvertovať farebné faxy na čiernobiele Zapnuté * Vypnuté Konverzia všetkých odchádzajúcich farebných faxov na čiernobiele. Potvrdiť faxové číslo Vypnuté * Zapnuté Požiadanie používateľa o potvrdenie faxového čísla. Predvoľba vytáčania Nastavenie predvoľby vytáčania. Pravidlá pre predvoľbu vytáčania Vytvorenie pravidla pre predvoľbu vytáčania. Nastavenia príjmu faxov Položky ponuky  Nastavenia príjmu faxov  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Čakanie na úlohy faxovania Žiadne * Toner Toner a spotrebný materiál Odstránenie faxových úloh vyžadujúcich konkrétne nedostupné zdroje z frontu tlače. Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk. Počet zvonení pred odpoveďou 1 – 25 (3*) Nastavenie počtu zazvonení pred tým, než tlačiareň prijme prichádzajúce hovory. Automatické zmenšenie Zapnuté * Vypnuté Zmenšenie prichádzajúceho faxu tak, aby sa prispôsobil veľkosti strany. Zdroj papiera Zásobník  [X] Viacúčelový podávač Automatický * Nastavenie zdroja papiera na tlač prichádzajúceho faxu. Strany Zapnuté Vypnuté * Tlač na obidve strany papiera. Oddeľovacie listy Žiadne * Pred úlohou Po úlohe Stanovenie, či vkladať prázdne oddeľovacie listy pri tlači. Zdroj oddeľovacích listov Zásobník  [X] (1*) Viacúčelový podávač Stanovenie zdroja papiera pre oddeľovacie listy. Výstupná priehradka Štandardná priehradka Stanovenie výstupnej priehradky pre prijaté faxy. Päta faxu Zapnuté Vypnuté * Tlač informácií o prenose v spodnej časti každej strany prijatého faxu. Časová známka v päte faxu Príjem * Tlač Tlač časovej známky v spodnej časti každej strany prijatého faxu. Zadržiavanie faxov Režim zadržaných faxov Vypnuté * Vždy zapnuté Manuálne Plánované Zadržanie prijatých faxov pred tlačou do ich uvoľnenia. Zadržiavanie faxov Plán zadržiavania faxov Priraďte plán na zadržiavanie faxov. Táto položka ponuky sa zobrazí len v prípade, že je položka  Režim zadržaných faxov  nastavená na možnosť  Plánovaný . Ovládacie prvky správcu Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Zapnúť príjem faxov Zapnuté * Vypnuté Nastavenie tlačiarne na príjem faxov. Zapnúť príjem farebných faxov Zapnuté * Vypnuté Nastavenie tlačiarne na príjem farebných faxov. Povoliť identifikáciu volajúceho Zapnuté Vypnuté * Zobrazenie informácií o ID volajúceho z prichádzajúceho hovoru na displeji tlačiarne. Blokovať faxy bez názvu Zapnuté Vypnuté * Blokovanie prichádzajúcich faxov bez ID faxu. Zoznam zakázaných faxov Pridať zakázaný fax Stanovenie telefónnych čísel, ktoré chcete blokovať. Zapnutá odpoveď Všetky zvonenia * Len jedno zvonenie Len dve zvonenia Len tri zvonenia Len jedno alebo dve zvonenia Len jedno alebo tri zvonenia Len dve alebo tri zvonenia Nastavenie špecifického typu zvonenia pre prichádzajúci fax. Automatická odpoveď Zapnuté * Vypnuté Nastavenie tlačiarne na automatický príjem faxov. Kód manuálnej odpovede 0–9 (9*) Manuálne zadanie kódu na klávesnici na zadávanie telefónnych čísel, ktorým sa spustí príjem faxu. Táto položka ponuky sa zobrazí len v prípade, keď tlačiareň zdieľa linku s telefónom. Táto položka ponuky sa zobrazí len v prípade, keď nastavíte tlačiareň na manuálny príjem faxov. Posielanie faxov ďalej Tlačiť * Vytlačiť a poslať ďalej Poslať ďalej Stanovenie, či sa prijatý fax pošle ďalej. Poslať ďalej kontaktu Cieľové miesto 1 Cieľové miesto 2 Stanovenie miesta na preposlanie prijatého faxu. Táto položka ponuky sa zobrazuje len vtedy, keď je položka  Poslanie faxu ďalej  nastavená na možnosť  Vytlačiť a poslať ďalej  alebo  Poslať ďalej . Potvrdzujúci e-mail Zadajte e-mailovú adresu na prijímanie faxov cez FTP alebo sieťový priečinok. Táto položka ponuky sa zobrazuje len vtedy, keď je položka  Poslanie faxu ďalej  nastavená na možnosť  Vytlačiť a poslať ďalej  alebo  Poslať ďalej . Maximálna rýchlosť 33600* 14400 9600 4800 2400 Nastavenie maximálnej rýchlosti prenosu faxu. Úvodná strana faxu Položky ponuky  Úvodná strana faxu  a ich opis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Úvodná strana faxu Predvolene vypnuté * Predvolene zapnuté Nikdy nepoužiť Vždy použiť Konfigurácia nastavenia úvodnej strany faxu. Zahrnúť pole Komu Vypnuté * Zapnuté Zahrnúť pole Od Vypnuté * Zapnuté Od Zahrnúť pole Správa Vypnuté * Zapnuté Správa: Zahrnúť Logo Vypnuté * Zapnuté Zahrnúť pätu [x] Vypnuté * Zapnuté Päta [x] Nastavenia denníka faxov Položky ponuky  Nastavenia denníka faxov  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Frekvencia denníka prenosov Vždy * Nikdy Len v prípade chyby Nastavenie, ako často má tlačiareň vytvárať denník prenosov. Činnosť denníka prenosov Tlač Vypnuté Zapnuté * E‑mail Vypnuté * Zapnuté Vytlačte alebo odošlite e-mailom protokol o úspešnom prenose faxu alebo o chybe prenosu. Denník chýb príjmu Nikdy netlačiť * Tlačiť pri chybe Tlač denníka pri neúspešnom prijatí faxu. Automatická tlač denníkov Zapnuté * Vypnuté Tlačiť všetku aktivitu faxu. Zdroj papiera denníkov Zásobník  [x] (1*) Viacúčelový podávač Stanovenie zdroja papiera na tlač denníkov. Zobrazenie denníkov Názov vzdialeného faxu * Zadané číslo Identifikácia odosielateľa prostredníctvom názvu vzdialeného faxu alebo čísla faxu. Zapnúť denník úloh Zapnuté * Vypnuté Zobrazenie zhrnutia všetkých faxových úloh. Zapnúť denník hovorov Zapnuté * Vypnuté Zobrazenie zhrnutia histórie faxových hovorov. Výstupná priehradka denníkov Štandardná priehradka * Priehradka [x] Stanovenie výstupnej priehradky tlačených denníkov. Nastavenia reproduktora Položky ponuky  Nastavenia reproduktora  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Režim reproduktora Vždy vypnuté * Vždy zapnuté Zapnuté až do pripojenia Nastavenie režimu reproduktora faxu. Hlasitosť reproduktora Nízka * Vysoká Úprava predvolenej hlasitosti reproduktora. Hlasitosť zvonenia Vypnuté * Zapnuté Povolenie hlasitosti vyzváňania. Nastavenia služby VoIP Položky ponuky  Nastavenia služby VoIP  a ich opis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Protokol VoIP SIP * H.323 Nastavenie protokolu služby Voice over Internet Protocol (VoIP). Server STUN Zadanie servera STUN, ktorý má prejsť bránou firewall. Vynútiť režim faxu Vypnuté Zapnuté * Prepnutie bránu VoIP z analógového faxu na protokol T.38 na začiatku faxového hovoru. Vynútiť oneskorenie režimu faxu 0 – 15 (7*) Nastavenie časového oneskorenia v sekundách pri odosielaní ďalšieho pozvania  Vynútiť režim faxu . Nastavenia SIP Položky ponuky  Nastavenia SIP  a ich opis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Server proxy Zadanie IP adresy systému, ktorý konvertuje telefónne číslo na IP adresu, na ktorú sa fax odosiela. Registrátor Zadajte názov alebo IP adresu systému, ktorý vybavuje registráciu klientov protokolu Session Initiation Protocol (SIP). Používateľ Zadajte meno používateľa pre SIP. Heslo Zadajte heslo, ktoré sa používa pri registrácii v registrátorovi SIP. Overovacie ID Používateľské meno, ktoré sa používa pri registrácii. Ak nie je nastavené nastavenie Overovacie ID, nastavenie použije namiesto toho používateľské meno z položky  Používateľ . Prenos na registráciu UDP * TCP Nastavenie typu prenosu SIP na registráciu. Prenos prichádzajúcich hovorov UDP * TCP Protokoly UDP a TCP Nastavenie typu prenosu SIP pre prichádzajúce hovory. Prenos odchádzajúcich hovorov UDP * TCP Nastavenie typu prenosu SIP pre odchádzajúce hovory. Výstupný server proxy Zadanie výstupného servera proxy, aby ste mohli poslať ďalej celú komunikáciu SIP. Kontaktujte oddelenie Zadanie mena kontaktnej osoby pre SIP. Oblasť Zadanie názvu oblasti pre SIP. Ak názov oblasti nie je nastavená, nastavenie použije namiesto toho položku  Kontakt . Stav registrácie SIP Zobrazenie stavu registrácie SIP. Nastavenia protokolu H.323 Položky ponuky  Nastavenia H.323  a ich opis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Brána Zadanie IP adresy brány H.323. Server gatekeeper Zadanie servera gatekeeper pre bránu H.323. Používateľ Zadajte používateľské meno pre bránu H.323. Heslo Zadanie hesla pre bránu H.323. Povoliť rýchle spustenie Vypnuté * Zapnuté Povolenie rýchleho spustenia. Zakázať tunelovanie protokolu H.245 Vypnuté * Zapnuté Zakázanie tunelovania protokolu H.323. Zakázať zisťovanie servera gatekeeper Vypnuté Zapnuté * Zakázanie zisťovania servera gatekeeper pre protokol H.323. Nastavenia protokolu T.38 Položky ponuky  Nastavenia T.38  a ich opis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Redundancia indikátora 0 – 5 (3*) Nastavenie počtu opakovaní indikátora faxu v komunikácii s protokolom T.38. Redundancia dát prenášaných nízkou rýchlosťou 0 – 5 (3*) Nastavenie počtu opakovaní údajov pri nízkej rýchlosti v komunikácii s protokolom T.38. Redundancia dát prenášaných vysokou rýchlosťou 0 – 5 (1*) Nastavenie počtu opakovaní údajov pri vysokej rýchlosti v komunikácii s protokolom T.38. ponuka nastavenie faxu ponuka Všeobecné nastavenia faxu ponuka Nastavenia HTTPS faxu ponuka Nastavenia odosielania faxov ponuka Nastavenia príjmu faxov ponuka Úvodná strana faxu ponuka Nastavenia denníka faxov ponuka Nastavenia reproduktora ponuka Nastavenia služby VoIP ponuka Nastavenia SIP ponuka Nastavenia protokolu H.323 ponuka Nastavenia protokolu T.38"},{"UUID":"3889b03e-448d-4c27-8b42-f337d66d932e","title":"Predvolené nastavenia faxu","link":"fax-defaults-subgroup.html","desc":"nastavenie servera faxu Všeobecné nastavenia","descFull":"nastavenie servera faxu Všeobecné nastavenia faxu Položky ponuky  Všeobecné nastavenia faxu  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Cieľový formát Zadanie príjemcu faxu. Ak chcete použiť číslo faxu, pred číslo uveďte znak „#“. Adresa pre odpoveď Uvedenie adresy pre odpoveď na odoslanie faxu. Predmet Zadanie predmetu a správy faxu. Hlásenie Zapnúť analógový príjem Vypnuté * Zapnuté Nastavenie tlačiarne na príjem analógových faxov. Nastavenia e-mailu faxového servera Položky ponuky  Nastavenia e-mailu faxového servera  a ich opis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Použitie e-mailového servera SMTP Zapnuté Vypnuté * Pri prijímaní a odosielaní faxov použite nastavenia jednoduchého protokolu na prenos pošty (SMTP) pre e‑maily. Ak je nastavená možnosť  Zapnuté , všetky ostatné nastavenia ponuky  Nastavenia e-mailu faxového servera  sa nezobrazia. Primárna brána SMTP Zadajte adresu IP alebo názov hostiteľa primárneho servera SMTP. Port primárnej brány SMTP 1 – 65535 (25*) Zadajte číslo portu primárneho servera SMTP. Sekundárna brána SMTP Zadajte adresu IP alebo názov hostiteľa servera pre sekundárny alebo záložný server SMTP. Port sekundárnej brány SMTP 1 – 65535 (25*) Zadajte číslo portu servera pre sekundárny alebo záložný server SMTP. Časový limit SMTP 5 – 30 (30*) Nastavenie času do uplynutia platnosti v prípade, že server SMTP neodpovedá. Adresa pre odpoveď Uvedenie adresy pre odpoveď na odoslanie faxu. Použiť nástroj SSL/TLS Vypnuté * Dohodnúť Požadované Nastavenie možnosti odoslania faxu prostredníctvom šifrovaného spojenia. Je potrebný dôveryhodný certifikát Vypnuté Zapnuté * Stanovenie dôveryhodného certifikátu pre prístup k serveru SMTP. Overenie servera SMTP Nevyžaduje sa žiadne overenie * Prihlásenie/obyčajné NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Nastavenie typu overenia pre server SMTP. E-mail vytvorený na základe zariadenia Žiadne * Použiť poverenia SMTP zariadenia Zadajte, či sa vyžadujú poverenia pre e-maily iniciované zariadeniím. E-mail vytvorený na základe používateľa Žiadne * Použiť poverenia SMTP zariadenia Použiť ID používateľa a heslo relácie Použiť e-mailovú adresu a heslo relácie Vyzvať používateľa Zadajte, či sa vyžadujú poverenia pre e-maily iniciované používateľom. Použiť poverenia zariadenia služby Active Directory Vypnuté * Zapnuté Povolenie poverení používateľov a umiestnení skupín na pripojenie k serveru SMTP. ID používateľa zariadenia Určenie ID používateľa a hesla na pripojenie k serveru SMTP. Heslo zariadenia Kerberos 5 REALM Určenie oblasti protokolu overenia Kerberos 5. Doména NTLM Určenie názvu domény bezpečnostného protokolu NTLM. Vypnite chybu „Nie je nastavený server SMTP“ Vypnuté* Zapnuté Skrytie chybového hlásenia „Nie je nastavený server SMTP“. Nastavenia skenovania faxového servera Položky ponuky  Nastavenia skenovania faxového servera  a ich opis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Formát obrázkov TIFF (.tif) PDF (.pdf) * XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Nastavenie formátu súboru skenovaného obrázka. TXT (.txt) ,  RTF (.rtf) ,  DOCX (.docx) ,  XLSX (.xlsx) , and  CSV (.csv)  sa zobrazia len vtedy, ak ste si zakúpili a nainštalovali riešenie OCR. Typ obsahu Text * Text/fotografia Fotografia Grafika Zlepšenie výsledného výstupu na základe obsahu zdrojového dokumentu. Zdroj obsahu Čiernobiele laserové tlačiarne * Farebné laserové tlačiarne Atramentové tlačiarne Fotografia/film Časopis Noviny Tlač Iné Vylepšenie výsledného výstupu na základe zdroja zdrojového dokumentu. Rozlíšenie faxu Štandardné * Jemné Veľmi jemné Ultra jemné Nastavenie rozlíšenia faxu. Strany Vypnuté * Krátky okraj Dlhý okraj Zadanie orientácie pôvodného dokumentu pri skenovaní na oboch stranách dokumentu. Tmavosť 1 – 9 (5*) Nastavenie tmavosti výstupu. Orientácia Na výšku * Na šírku Stanovenie orientácie textu a grafických prvkov na strane. Veľkosť originálu [Zoznam veľkostí papiera] Nastavenie veľkosti papiera zdrojového dokumentu. Rôzne veľkosti  je americké predvolené výrobné nastavenie. Veľkosť A4 je medzinárodné predvolené výrobné nastavenie. Toto nastavenie sa môže líšiť v závislosti od modelu tlačiarne. Použiť viacstranový formát TIFF Vypnuté Zapnuté * Výber medzi jednostranovými a viacstranovými súbormi vo formáte TIFF. ponuka nastavenie servera faxu ponuka Všeobecné nastavenia faxu ponuka Nastavenia e-mailu faxového servera ponuka Nastavenia skenovania faxového servera"},{"UUID":"40821bd7-5109-4e86-8ae6-b9eaac184f30","title":"E-mail","link":"email-setup-topic.html","desc":"Nastavenie e-mailu Položky ponuky ","descFull":"Nastavenie e-mailu Položky ponuky  Nastavenie e-mailu  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Primárna brána SMTP Zadajte adresu IP alebo názov hostiteľa primárneho servera SMTP na odosielanie e-mailov. Port primárnej brány SMTP 1–65535 (25*) Zadajte číslo portu primárneho servera SMTP. Sekundárna brána SMTP Zadajte adresu IP alebo názov hostiteľa servera pre sekundárny alebo záložný server SMTP. Port sekundárnej brány SMTP 1–65535 (25*) Zadajte číslo portu servera pre sekundárny alebo záložný server SMTP. Časový limit SMTP 5 – 30 sekúnd (30*) Nastavenie času do uplynutia platnosti v prípade, že server SMTP neodpovedá. Adresa pre odpoveď Stanovenie e-mailovej adresy pre odpoveď. Vždy použiť predvolenú adresu servera SMTP na odpoveď Zapnuté Vypnuté * Vždy na serveri SMTP použiť predvolenú adresu na odpoveď. Použiť nástroj SSL/TLS Vypnuté * Dohodnúť Požadované Nastavenie možnosti odoslania e-mailu prostredníctvom šifrovaného spojenia. Je potrebný dôveryhodný certifikát Vypnuté Zapnuté * Pri prístupe k serveru SMTP sa vyžaduje dôveryhodný certifikát. Overenie servera SMTP Nevyžaduje sa žiadne overenie * Prihlásenie/obyčajné NTLM CRAM‑MD5 Digest‑MD5 Kerberos 5 Nastavenie typu overenia pre server SMTP. E-mail vytvorený na základe zariadenia Žiadne * Použiť poverenia SMTP zariadenia Stanovenie, či sú potrebné poverenia pre e-mail vytvorený na základe zariadenia. E-mail vytvorený na základe používateľa Žiadne * Použiť poverenia SMTP zariadenia Použiť ID používateľa a heslo relácie Použiť e-mailovú adresu a heslo relácie Vyzvať používateľa Stanovenie, či sú potrebné poverenia pre e-mail vytvorený na základe používateľa. Použiť poverenia zariadenia služby Active Directory Vypnuté * Zapnuté Stanovenie, či sú potrebné poverenia pre e-mail vytvorený na základe používateľa. ID používateľa zariadenia Určenie ID používateľa a hesla na pripojenie k serveru SMTP. Heslo zariadenia Kerberos 5 REALM Určenie oblasti protokolu overenia Kerberos 5. Doména NTLM Určenie názvu domény bezpečnostného protokolu NTLM. Vypnúť chybu „Nie je nastavený server SMTP“ Vypnuté * Zapnuté Skrytie chybového hlásenia „Nie je nastavený server SMTP“. ponuka Nastavenie e-mailu"},{"UUID":"c75aed91-77c5-4768-b848-ef1e5d2945e6","title":"E-mail","link":"email-setup-topic.html","desc":"Predvolené hodnoty e-mailu Položky ponuky","descFull":"Predvolené hodnoty e-mailu Položky ponuky  Predvolené hodnoty e-mailu  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Predmet: Zadanie predmetu a správy e-mailu. Správa: Názov súboru Zadanie názvu súboru skenovaného dokumentu. Formát JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Nastavenie formátu súboru skenovaného dokumentu. TXT (.txt) ,  RTF (.rtf) ,  DOCX (.docx) ,  XLSX (.xlsx) , a  CSV (.csv)  sa zobrazia len vtedy, ak ste si zakúpili a nainštalovali riešenie OCR. Globálne nastavenia funkcie OCR Rozpoznávané jazyky Automatické otočenie  (Vypnuté*) Odstránenie škvŕn  (Vypnuté*) Automatické zlepšenie kontrastu  (Vypnuté*) Zadanie nastavení optického rozpoznávania znakov (OCR). Táto položka ponuky sa zobrazuje, iba ak máte zakúpené a nainštalované riešenie na optické rozpoznávanie znakov. Nastavenia PDF Verzia PDF  (1.5*) Archívna verzia  (A‑1a*) Vysoká kompresia  ( Vypnuté  *) Zabezpečenie  ( Vypnuté *) S možnosťou vyhľadávania  ( Vypnuté *) Archívne (PDF/A)  ( Vypnuté  *) Konfigurovanie nastavenia PDF skenovaného dokumentu. Položky  Archívna verzia  a  Archívne (PDF/A)  sú podporované, len ak je pre položku  PDF verzia  nastavená možnosť 1.4. Vysoko komprimované  položky sa zobrazia len v prípade, že je nainštalovaný pevný disk alebo disk s inteligentným ukladaním (ISD). Možnosť vyhľadávania  sa zobrazuje, iba ak máte zakúpené a nainštalované OCR riešenie. Typ obsahu Text Text/fotografia * Fotografia Grafika Zlepšenie výsledného výstupu na základe typu obsahu zdrojového dokumentu. Zdroj obsahu Čiernobiele laserové tlačiarne * Farebné laserové tlačiarne Atramentové tlačiarne Fotografia/film Časopis Noviny Tlač Iné Zlepšenie výsledného výstupu na základe zdroja obsahu pôvodného dokumentu. Farebne Čiernobielo Sivá Farebne * Automatické Nastavenie tlačiarne na zachytenie obsahu súboru farebne alebo čiernobielo. Rozlíšenie 75 dpi 150 dpi * 200 dpi 300 dpi 400 dpi 600 dpi Nastavenie rozlíšenia naskenovaného obrázka. Tmavosť 1 – 9 (5*) Úprava tmavosti naskenovaného obrázka. Orientácia Na výšku * Na šírku Stanovenie orientácie zdrojového dokumentu. Veľkosť originálu Zmiešané veľkosti * Nastavenie veľkosti papiera zdrojového dokumentu. Strany Vypnuté * Krátky okraj Dlhý okraj Zadanie orientácie pôvodného dokumentu pri skenovaní na oboch stranách dokumentu. Rozšírené spracovanie obrázkov Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Vyváženie farieb Azúrová – červená  (0*) Purpurová – zelená  (0*) Žltá – modrá  (0*) Nastavenie intenzity pre azúrovú, purpurovú a žltú farbu. Vynechanie farieb Vynechanie farieb  ( Žiadne *) Predvolený prah červenej  (128*) Predvolený prah zelenej  (128*) Predvolený prah modrej  (128*) Stanovenie farby, ktorá sa má pri skenovaní vynechať, a upravenie nastavenia vynechania danej farby. Automatická detekcia farieb Citlivosť farieb  (5*) Plošná citlivosť  (5*) Bitová hĺbka pre e-mail  (1 bit*) Minimálne rozlíšenie skenovania  (300 dpi*) Konfigurácia nastavenia automatickej detekcie farieb. Kvalita JPEG Najlepšie pre obsah * 5 – 95 Nastavenie kvality JPEG skenovaného obrázka. Kontrast Najlepšie pre obsah * 0 – 5 Zadanie kontrastu skenovaného obrázka. Odstránenie pozadia Detekcia pozadia  ( Na základe obsahu  *) Hladina  (0*) Odstránenie farby pozadia alebo obrazového šumu z pôvodného dokumentu. Možnosť  Podľa obsahu  odstráni farbu pozadia z pôvodného dokumentu. Možnosť  Pevné  odstráni obrazový šum z fotografie. Zrkadlový obraz Vypnuté * Zapnuté Vytvorenie zrkadlového obrazu zdrojového dokumentu. Negatív Vypnuté * Zapnuté Vytvorenie negatívu zdrojového dokumentu. Detaily tieňov –4 až 4 (0*) Úprava detailov v tieňoch v skenovanom dokumente. Skenovať od okraja po okraj Vypnuté * Zapnuté Skenovanie pôvodného dokumentu od okraja po okraj. Ostrosť 1 – 5 (3*) Úprava ostrosti naskenovaného obrázka. Teplota –4 až 4 (0*) Generovanie modrejšieho a červenšieho výstupu pôvodného dokumentu. Prázdne strany Odstránenie prázdnych strán  ( Neodstraňovať *) Citlivosť na prázdne strany  (5*) Nastavenie citlivosti skenovania vo vzťahu k prázdnym stranám v pôvodnom dokumente. Ovládacie prvky správcu Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Max. veľkosť e-mailu 0 – 65535 (0*) Nastavenie povolenej veľkosti súboru pre každý e-mail. Chybová správa o veľkosti Stanovenie parametrov chybovej správy o veľkosti, ktorú tlačiareň odošle, keď e-mail prekročí povolenú veľkosť súboru. Môžete zadať len 1 024 znakov. Obmedziť ciele Obmedzenie odosielania e-mailov len na konkrétny zoznam názvov domén. Každú z domén oddeľte čiarkou. Odošli mi kópiu Nikdy sa nezobrazí * Predvolene zapnuté Predvolene vypnuté Vždy zapnuté Odoslanie kópie e-mailu sebe. Povoliť iba e-maily na svoju adresu Vypnuté * Zapnuté Nastavenie tlačiarne na odosielanie e-mailov len na svoju adresu. Použiť kópiu:/skrytú kópiu: Vypnuté * Zapnuté Povolenie kópie a skrytej kópie v rámci e-mailu. Použiť viacstranový formát TIFF Vypnuté Zapnuté * Umožňuje skenovanie viacerých TIFF obrázkov do súboru TIFF. Kompresia formátu TIFF JPEG LZW * Nastavenie typu pre súbory TIFF. Predvolený text 5 – 95 (75*) Nastavenie kvality textu obsahu, ktorý sa skenuje. Predvolený text/fotografia 5 – 95 (75*) Nastavenie kvality textu a fotografií obsahu, ktorý sa skenuje. Predvolená fotografia 5 – 95 (50*) Nastavenie kvality fotografie obsahu, ktorý sa skenuje. Prispôsobiť zošikmenie z automatického podávača dokumentov Vypnuté Zapnuté * Nastavenie tlačiarne na úpravu zošikmených obrázkov z dokumentov, ktoré sú skenované z automatického podávača dokumentov. Denník prenosov Tlačiť denník * Netlačiť denník Tlačiť iba pri chybe Tlač denníka prenosov skenov e-mailu. Zdroj papiera denníkov Zásobník  [x] (1*) Viacúčelový podávač Určenie zdroja papiera na tlač denníkov e-mailov. Vlastná úloha skenovania Vypnuté * Zapnuté Nastavenie tlačiarne na skenovanie prvého súboru originálnych dokumentov pomocou určených nastavení a potom skenovanie ďalšej skupiny s rovnakými alebo inými nastaveniami. Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk ISD. Ukážka skenovania Vypnuté * Zapnuté Zobrazenie ukážky skenovania zdrojového dokumentu. Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk ISD. Povoliť možnosť Uložiť ako skratku Vypnuté Zapnuté * Uloženie e-mailovej adresy ako odkazu. E-mailové obrázky odoslané ako Príloha * Webové pripojenie Určenie spôsobu odoslania obrázkov, ktoré sú uložené v e-maile. Po odoslaní obnoviť informácie v e-maile Vypnuté Zapnuté * Resetovanie polí Komu, Predmet, Správa a Názov súboru na predvolené hodnoty po odoslaní e-mailu. ponuka Predvolené hodnoty e-mailu"},{"UUID":"25f99244-6216-4a42-837f-71a35071c9ef","title":"E-mail","link":"email-setup-topic.html","desc":"Nastavenie webového pripojenia Položky ponuky","descFull":"Nastavenie webového pripojenia Položky ponuky  Nastavenie webového pripojenia  a ich popis Položka ponuky Opis Server Zadanie poverení servera, na ktorom sú uložené obrázky zahrnuté do e-mailu. Prihlásenie Heslo Cesta Názov súboru Webové pripojenie ponuka Nastavenie webového pripojenia"},{"UUID":"856752b7-158a-4a3c-b12d-0215ea9b9996","title":"FTP","link":"ftp-defaults-topic.html","desc":"Predvolené hodnoty FTP Položky ponuky","descFull":"Predvolené hodnoty FTP Položky ponuky  Predvolené hodnoty FTP  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Formát JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Nastavenie formátu súboru skenovaného obrázka. TXT (.txt) ,  RTF (.rtf) ,  DOCX (.docx) ,  XLSX (.xlsx) , a  CSV (.csv)  sa zobrazia len vtedy, ak ste si zakúpili a nainštalovali riešenie OCR. Globálne nastavenia funkcie OCR Rozpoznávané jazyky Automatické otočenie  ( Vypnuté *) Odstránenie škvŕn  ( Vypnuté *) Automatické zlepšenie kontrastu  ( Vypnuté *) Zadanie nastavení optického rozpoznávania znakov (OCR). Táto položka ponuky sa zobrazuje, iba ak máte zakúpené a nainštalované riešenie na optické rozpoznávanie znakov. Nastavenia PDF Verzia PDF  (1.5*) Archívna verzia  ( A‑1a *) Vysoká kompresia  ( Vypnuté  *) Zabezpečenie  ( Vypnuté *) S možnosťou vyhľadávania  ( Vypnuté *) Archívne (PDF/A)  ( Vypnuté  *) Konfigurácia nastavení PDF skenovaného obrázka. Položky  Archívna verzia  a  Archívne (PDF/A)  sú podporované, len ak je pre položku  PDF verzia  nastavená možnosť 1.4. Vysoko komprimované  položky sa zobrazia len v prípade, že je nainštalovaný pevný disk alebo disk s inteligentným ukladaním (ISD). Možnosť vyhľadávania  sa zobrazuje, iba ak máte zakúpené a nainštalované OCR riešenie. Typ obsahu Text Text/fotografia * Grafika Fotografia Zlepšenie výsledného výstupu na základe typu obsahu zdrojového dokumentu. Zdroj obsahu Čiernobiele laserové tlačiarne * Farebné laserové tlačiarne Atramentové tlačiarne Fotografia/film Časopis Noviny Tlač Iné Zlepšenie výsledného výstupu na základe zdroja obsahu pôvodného dokumentu. Farebne Čiernobielo Sivá Farebne * Automatické Nastavenie tlačiarne na zachytenie obsahu súboru farebne alebo čiernobielo. Rozlíšenie 75 dpi 150 dpi* 200 dpi 300 dpi 400 dpi 600 dpi Nastavenie rozlíšenia naskenovaného obrázka. Tmavosť 1 – 9 (5*) Úprava tmavosti naskenovaného obrázka. Orientácia Na výšku * Na šírku Stanovenie orientácie zdrojového dokumentu. Veľkosť originálu Zmiešané veľkosti * Nastavenie veľkosti papiera zdrojového dokumentu. Strany Vypnuté * Dlhý okraj Krátky okraj Stanovenie orientácie pri skenovaní na oboch stranách dokumentu. Názov súboru Stanovenie názvu skenovaného obrázka. Rozšírené spracovanie obrázkov Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Vyváženie farieb Azúrová – červená  (0*) Purpurová – zelená  (0*) Žltá – modrá  (0*) Nastavenie intenzity pre azúrovú, purpurovú a žltú farbu. Vynechanie farieb Vynechanie farieb  ( Žiadne *) Predvolený prah červenej  (128*) Predvolený prah zelenej  (128*) Predvolený prah modrej  (128*) Stanovenie farby, ktorá sa má pri skenovaní vynechať, a upravenie nastavenia vynechania danej farby. Automatická detekcia farieb Citlivosť farieb  (5*) Plošná citlivosť  (5*) Bitová hĺbka pre FTP  (1 bit*) Minimálne rozlíšenie skenovania  (300 dpi*) Konfigurácia nastavenia automatickej detekcie farieb. Kvalita JPEG Najlepšie pre obsah * 5 – 95 Nastavenie kvality JPEG skenovaného obrázka. Kontrast Najlepšie pre obsah * 0 1 2 3 4 5 Zadanie kontrastu skenovaného obrázka. Odstránenie pozadia Detekcia pozadia ( Podľa obsahu *) Hladina (0*) Odstránenie farby pozadia alebo obrazového šumu z pôvodného dokumentu. Možnosť  Podľa obsahu  odstráni farbu pozadia z pôvodného dokumentu. Možnosť  Pevné  odstráni obrazový šum z fotografie. Zrkadlový obraz Vypnuté * Zapnuté Vytvorenie zrkadlového obrazu zdrojového dokumentu. Negatív Vypnuté * Zapnuté Vytvorenie negatívu zdrojového dokumentu. Detaily tieňov –4 až 4 (0*) Úprava detailov v tieňoch v skenovanom dokumente. Skenovať od okraja po okraj Vypnuté * Zapnuté Umožnenie skenovania zdrojového dokumentu od okraja po okraj. Ostrosť 1 – 5 (3*) Úprava ostrosti naskenovaného obrázka. Teplota –4 až 4 (0*) Generovanie modrejšieho a červenšieho výstupu pôvodného dokumentu. Prázdne strany Odstránenie prázdnych strán  ( Neodstraňovať *) Citlivosť na prázdne strany  (5*) Nastavenie citlivosti skenovania vo vzťahu k prázdnym stranám v pôvodnom dokumente. Ovládacie prvky správcu Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Predvolený text 5 – 95 (75*) Nastavenie kvality textu na naskenovanom obrázku. Predvolený text/fotografia 5 – 95 (75*) Nastavenie kvality textu alebo fotografie na naskenovanom obrázku. Predvolená fotografia 5 – 95 (50*) Nastavenie kvality fotografie na naskenovanom obrázku. Použiť viacstranový formát TIFF Zapnuté * Vypnuté Umožňuje skenovanie viacerých TIFF obrázkov do súboru TIFF. Kompresia formátu TIFF LZW * JPEG Nastavenie typu pre súbory TIFF. Denník prenosov Tlačiť denník * Netlačiť denník Tlačiť iba pri chybe Tlač denníka prenosov FTP skenov. Zdroj papiera denníkov Zásobník  [x] (1*) Viacúčelový podávač Určite zdroj papiera pre tlač FTP denníkov. Vlastná úloha skenovania Vypnuté * Zapnuté Nastavenie tlačiarne na skenovanie prvého súboru originálnych dokumentov pomocou určených nastavení a potom skenovanie ďalšej skupiny s rovnakými alebo inými nastaveniami. Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk ISD. Ukážka skenovania Vypnuté * Zapnuté Zobrazenie ukážky zdrojového dokumentu. Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk ISD. Povoliť možnosť Uložiť ako skratku Vypnuté Zapnuté * Uloženie adresy FTP ako skratky. Prispôsobiť zošikmenie z automatického podávača dokumentov Vypnuté * Zapnuté Nastavenie tlačiarne na úpravu zošikmených obrázkov z dokumentov, ktoré sú skenované z automatického podávača dokumentov. Použite pasívne FTP Vypnuté * Zapnuté Ak je táto možnosť povolená, server FTP určí dátový port, ku ktorému sa tlačiareň pripojí. ponuka Predvolené hodnoty FTP"},{"UUID":"4ea60c3b-25d6-4849-b047-4bd3a50ac8a4","title":"Jednotka USB","link":"flash-drive-scan-topic.html","desc":"Skenovanie do pamäťovej jednotky flash","descFull":"Skenovanie do pamäťovej jednotky flash Položky ponuky  Skenovanie do pamäťovej jednotky flash  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Formát JPEG (.jpg) PDF (.pdf) * TIFF (.tif) XPS (.xps) TXT (.txt) RTF (.rtf) DOCX (.docx) XLSX (.xlsx) CSV (.csv) Nastavenie formátu súboru skenovaného obrázka. TXT (.txt) ,  RTF (.rtf) ,  DOCX (.docx) ,  XLSX (.xlsx) , a  CSV (.csv)  sa zobrazia len vtedy, ak ste si zakúpili a nainštalovali riešenie OCR. Globálne nastavenia funkcie OCR Rozpoznávané jazyky Automatické otočenie  ( Vypnuté *) Odstránenie škvŕn  ( Vypnuté *) Automatické zlepšenie kontrastu  ( Vypnuté *) Zadanie nastavení optického rozpoznávania znakov (OCR). Táto položka ponuky sa zobrazuje, iba ak máte zakúpené a nainštalované riešenie na optické rozpoznávanie znakov. Nastavenia PDF Verzia PDF  (1.5*) Archívna verzia  (A‑1a*) Vysoká kompresia  ( Vypnuté  *) Zabezpečenie  ( Vypnuté *) S možnosťou vyhľadávania  ( Vypnuté *) Archívne (PDF/A)  ( Vypnuté  *) Konfigurácia nastavení PDF skenovaného obrázka. Položky  Archívna verzia  a  Archívne (PDF/A)  sú podporované, len ak je pre položku  PDF verzia  nastavená možnosť 1.4. Vysoko komprimované  položky sa zobrazia len v prípade, že je nainštalovaný pevný disk alebo disk s inteligentným ukladaním (ISD). Možnosť vyhľadávania   sa zobrazuje, iba ak máte zakúpené a nainštalované OCR riešenie. Typ obsahu Text Text/fotografia * Grafika Fotografia Zlepšenie výsledného výstupu na základe typu obsahu zdrojového dokumentu. Zdroj obsahu Čiernobiele laserové tlačiarne * Farebné laserové tlačiarne Atramentové tlačiarne Fotografia/film Časopis Noviny Tlač Iné Zlepšenie výsledného výstupu na základe zdroja obsahu pôvodného dokumentu. Farebne Čiernobielo Sivá Farebne * Automatické Nastavenie tlačiarne na zachytenie obsahu súboru farebne alebo čiernobielo. Rozlíšenie 75 dpi 150 dpi* 200 dpi 300 dpi 400 dpi 600 dpi Nastavenie rozlíšenia naskenovaného obrázka. Tmavosť 1 – 9 (5*) Úprava tmavosti naskenovaného obrázka. Orientácia Na výšku * Na šírku Stanovenie orientácie zdrojového dokumentu. Veľkosť originálu Zmiešané veľkosti * Nastavenie veľkosti papiera zdrojového dokumentu. Strany Vypnuté * Dlhý okraj Krátky okraj Zadanie orientácie pôvodného dokumentu pri skenovaní na oboch stranách dokumentu. Názov súboru Stanovenie názvu skenovaného obrázka. Rozšírené spracovanie obrázkov Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Vyváženie farieb Azúrová – červená (0*) Purpurová – zelená (0*) Žltá – modrá (0*) Nastavenie intenzity pre azúrovú, purpurovú a žltú farbu. Vynechanie farieb Vynechanie farieb  ( Žiadne *) Predvolený prah červenej (128*) Predvolený prah zelenej (128*) Predvolený prah modrej (128*) Stanovenie farby, ktorá sa má pri skenovaní vynechať, a upravenie nastavenia vynechania danej farby. Automatická detekcia farieb Citlivosť farieb (5*) Plošná citlivosť  (5*) Bit. hĺbka pre skenovanie   (1 bit*) Minimálne rozlíšenie skenovania  (300 dpi*) Konfigurácia nastavenia automatickej detekcie farieb. Kvalita JPEG Najlepšie pre obsah * 5 – 95 Nastavenie kvality JPEG skenovaného obrázka. Kontrast Najlepšie pre obsah * 0 – 5 Zadanie kontrastu skenovaného obrázka. Odstránenie pozadia Detekcia pozadia ( Podľa obsahu *) Hladina (0*) Odstránenie farby pozadia alebo obrazového šumu z pôvodného dokumentu. Možnosť  Podľa obsahu  odstráni farbu pozadia z pôvodného dokumentu. Možnosť  Pevné  odstráni obrazový šum z fotografie. Zrkadlový obraz Vypnuté * Zapnuté Vytvorenie zrkadlového obrazu zdrojového dokumentu. Negatív Vypnuté * Zapnuté Vytvorenie negatívu zdrojového dokumentu. Detaily tieňov –4 až 4 (0*) Úprava detailov v tieňoch v skenovanom dokumente. Skenovať od okraja po okraj Vypnuté * Zapnuté Skenovanie pôvodného dokumentu od okraja po okraj. Ostrosť 1 – 5 (3*) Úprava ostrosti naskenovaného obrázka. Teplota –4 až 4 (0*) Generovanie modrejšieho a červenšieho výstupu pôvodného dokumentu. Prázdne strany Odstránenie prázdnych strán  ( Neodstraňovať *) Citlivosť na prázdne strany  (5*) Nastavenie citlivosti skenovania vo vzťahu k prázdnym stranám v pôvodnom dokumente. Ovládacie prvky správcu Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Predvolený text 5 – 95 (75*) Nastavenie kvality textu na naskenovanom obrázku. Predvolený text/fotografia 5 – 95 (75*) Nastavenie kvality textu alebo fotografie na naskenovanom obrázku. Predvolená fotografia 5 – 95 (50*) Nastavenie kvality fotografie na naskenovanom obrázku. Použiť viacstranový formát TIFF Vypnuté Zapnuté * Umožňuje skenovanie viacerých TIFF obrázkov do súboru TIFF. Kompresia formátu TIFF LZW * JPEG Nastavenie typu pre súbory TIFF. Vlastná úloha skenovania Vypnuté * Zapnuté Nastavenie tlačiarne na skenovanie prvého súboru originálnych dokumentov pomocou určených nastavení a potom skenovanie ďalšej skupiny s rovnakými alebo inými nastaveniami. Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk ISD. Ukážka skenovania Vypnuté * Zapnuté Zobrazenie ukážky skenovania zdrojového dokumentu. Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk ISD. Prispôsobiť zošikmenie z automatického podávača dokumentov Vypnuté * Zapnuté Nastavenie tlačiarne na úpravu zošikmených obrázkov z dokumentov, ktoré sú skenované z automatického podávača dokumentov. ponuka Skenovanie do pamäťovej jednotky flash"},{"UUID":"c12e8470-722d-4bfa-aa64-4dcbc52f8558","title":"Jednotka USB","link":"flash-drive-scan-topic.html","desc":"Tlač z pamäťovej jednotky flash Položky","descFull":"Tlač z pamäťovej jednotky flash Položky ponuky  Tlač z pamäťovej jednotky flash  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Počet kópií 1 – 9999 (1*) Nastavenie počtu kópií. Zdroj papiera Zásobník  [x] (1*) Viacúčelový podávač Manuálny podávač papiera Manuálny podávač obálok Nastavenie zdroja papiera pre tlačovú úlohu. Zoradiť Vypnuté [1, 1, 1, 2, 2, 2] Zapnuté [1, 2, 1, 2, 1, 2] * Stohovanie strán tlačovej úlohy v správnom poradí najmä pri tlači viacerých kópií tlačovej úlohy. Strany Jednostranne * Obojstranne Určenie, či sa má tlačiť na jednej alebo oboch stranách papiera. Štýl preklopenia Dlhý okraj * Krátky okraj Určenie toho, ktorá strana papiera sa zviaže pri obojstrannej tlači. Počet stránok na stranu Vypnuté * 2 stránky na stranu 3 stránky na stranu 4 stránky na stranu 6 stránok na stranu 9 stránok na stranu 12 stránok na stranu 16 stránok na stranu Tlač obrázkov na viacerých stránkach na jednu stranu jedného listu papiera. Zoradenie stránok na strane Vodorovne * Obrátene vodorovne Obrátene zvislo Zvislé Stanovenie polohy obrázkov na viacerých stránkach pri použití ponuky  Počet stránok na stranu . Orientácia stránok na strane Automatický * Na šírku Na výšku Stanovenie orientácie obrázkov na viacerých stránkach pri použití ponuky  Počet stránok na stranu . Okraje stránok na strane Žiadne * Plný Pri použití ponuky  Počet stránok na stranu  sa vytlačí okraj okolo obrázka každej strany. Oddeľovacie listy Vypnuté * Medzi kópiami Medzi úlohami Medzi stranami Vkladanie prázdnych oddeľovacích listov pri tlači. Zdroj oddeľovacích listov Zásobník  [x] (1*) Viacúčelový podávač Stanovenie zdroja papiera pre oddeľovacie listy. Prázdne strany Netlačiť * Tlač Tlač prázdnych strán v rámci tlačovej úlohy. ponuka Tlač z pamäťovej jednotky flash"},{"UUID":"dc0eed6e-2dd4-4da8-a882-57fecf21d436","title":"Sieť/porty","link":"network-overview-topic.html","desc":"Prehľad siete Položky ponuky ","descFull":"Prehľad siete Položky ponuky  Prehľad siete  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Aktívny adaptér Automaticky * Štandardná sieť Bezdrôtové Určenie typu sieťového pripojenia. Položka  Bezdrôtové  je k dispozícii len v tlačiarňach pripojených k bezdrôtovej sieti. Stav siete Zobrazenie stavu pripojenia siete tlačiarne. Zobraziť stav siete na tlačiarni Vypnuté Zapnuté * Zobrazenie stavu siete na displeji. Rýchlosť, Obojstranné Zobrazenie rýchlosti aktuálne aktívnej sieťovej karty. IPv4 Zobrazenie adries podľa protokolu IPv4. Všetky adresy podľa protokolu IPv6 Zobrazenie všetkých adries podľa protokolu IPv6. Obnoviť tlačový server Obnovenie všetkých aktívnych sieťových pripojení tlačiarne. Toto nastavenie odstráni všetky sieťové konfiguračné nastavenia. Časový limit sieťovej úlohy Vypnuté Zapnuté * (90  sekúnd ) Nastavenie doby, po ktorej uplynutí tlačiareň zruší sieťovú tlačovú úlohu. Stránka transparentu Vypnuté * Zapnuté Tlač stránky transparentu. Rozsah portov pre skenovanie do počítača Stanovenie platného rozsahu portov pre tlačiarne nachádzajúce sa za bránou firewall blokujúcou porty. Zapnúť sieťové pripojenie Vypnuté Zapnuté * Povolenie pripojenia tlačiarne k sieti. Povoliť protokol LLDP Vypnuté * Zapnuté Povolenie protokolu LLDP (Link Layer Discovery Protocol) v tlačiarni. ponuka Prehľad siete"},{"UUID":"e38bb7f9-0081-479f-8113-921e613fe7cb","title":"Sieť/porty","link":"network-overview-topic.html","desc":"Bezdrôtové Táto ponuka je k dispozícii","descFull":"Bezdrôtové Táto ponuka je k dispozícii iba pre tlačiarne, ktoré sú pripojené k sieti Wi-Fi alebo majú adaptér bezdrôtovej siete. Položky v ponuke  Bezdrôtové  a ich popisy Položka ponuky Opis Nastavenie prostredníctvom mobilnej aplikácie Konfigurácia pripojenia siete Wi-Fi pomocou mobilného asistenta spoločnosti Lexmark. Nastavenie na paneli tlačiarne Vybrať sieť Pridať sieť Wi-Fi Názov siete Režim siete Infraštruktúra Zabezpečený bezdrôtový režim Vypnuté * WPA2/WPA – osobné WPA2 – osobné WPA2/WPA3 – osobné WPA3 – osobné 802.1x – RADIUS Konfigurácia pripojenia siete Wi-Fi pomocou ovládacieho panela. Táto položka ponuky je k dispozícii na serveri Embedded Web Server ako  Nastavenie bezdrôtového pripojenia . Wi‑Fi Protected Setup (WPS – nastavenie zabezpečenia siete Wi-Fi) Spustenie stlačením tlačidla Spustenie kódom PIN Vytvorte sieť Wi-Fi a aktivujte zabezpečenie siete. Pomocou  metódy spustenia stlačením tlačidla  môžete pripojiť tlačiareň k sieti Wi-Fi po stlačení tlačidiel na tlačiarni a zároveň na prístupovom bode (bezdrôtovom smerovači) v rámci určeného času. Pomocou  metódy spustenia kódom PIN  môžete pripojiť tlačiareň k sieti Wi-Fi po zadaní kódu PIN tlačiarne do nastavení bezdrôtového pripojenia prístupového bodu. Kompatibilita 802.11b/g/n (2,4 GHz) * 802.11a/b/g/n/ac (2,4 GHz/5 GHz) 802.11a/n/ac (5 GHz) Nastavte štandard príslušnej siete Wi-Fi. Možnosti  802.11a/b/g/n/ac (2,4 GHz/5 GHz)  a  802.11a/n/ac (5 GHz)  sa zobrazia iba v prípade, že je nainštalovaná možnosť siete Wi-Fi. Zabezpečený bezdrôtový režim Vypnuté * WPA2/WPA – osobné WPA2 – osobné WPA2/WPA3 – osobné WPA3 – osobné 802.1x – RADIUS Nastavte režim zabezpečenia pre pripojenie tlačiarne k zariadeniam Wi-Fi. WPA2/WPA osobné AES * Povolenie zabezpečenia siete Wi-Fi cez WPA (Wi-Fi Protected Access). Táto položka ponuky sa zobrazí len v prípade, že je položka  Zabezpečený bezdrôtový režim  nastavená na možnosť  WPA2/WPA – osobné . Nastaviť PSK Nastavte heslo pre zabezpečené pripojenie siete Wi-Fi. WPA2 – osobné AES * Povolenie zabezpečenia siete Wi-Fi cez funkciu WPA2. Táto položka ponuky sa zobrazí len v prípade, že je položka  Zabezpečený bezdrôtový režim  nastavená na možnosť  WPA2 – osobné . Režim šifrovania 802.1x WPA+ WPA2 * WPA2 + PMF * Povoľte zabezpečenie siete Wi-Fi cez štandard 802.1x. Táto položka ponuky sa zobrazí len v prípade, že je položka  Zabezpečený bezdrôtový režim  nastavená na možnosť  802.1x – RADIUS . IPv4 Povoliť protokol DHCP Zapnuté * Vypnuté Nastaviť statickú adresu IP IP adresa Maska siete Brána Povolenie a konfigurácia nastavenia IPv4 v tlačiarni. IPv6 Povoliť protokol IPv6 Zapnuté * Vypnuté Povoliť protokol DHCPv6 Zapnuté Vypnuté * Bezstavová automatická konfigurácia adries Zapnuté * Vypnuté Adresa servera DNS Manuálne priradená adresa podľa protokolu IPv6 Manuálne priradený smerovač podľa protokolu IPv6 Predvoľba adresy Všetky adresy podľa protokolu IPv6 Všetky adresy smerovača podľa protokolu IPv6 Povolenie a konfigurácia nastavenia IPv6 v tlačiarni. Sieťová adresa UAA LAA Zobrazenie adries sietí. PCL SmartSwitch Zapnuté * Vypnuté Nastavenie tlačiarne na automatické prepnutie na emuláciu jazyka PCL, keď to vyžaduje tlačová úloha, bez ohľadu na predvolený jazyk tlačiarne. Ak je nastavenie  PCL SmartSwitch  vypnuté, tlačiareň neskúma prichádzajúce údaje a použije predvolený jazyk tlačiarne určený v ponuke  Nastavenie . PS SmartSwitch Zapnuté * Vypnuté Nastavenie tlačiarne na automatické prepnutie na emuláciu jazyka PS, keď to vyžaduje tlačová úloha bez ohľadu na predvolený jazyk tlačiarne. Ak je nastavenie  PS SmartSwitch  vypnuté, tlačiareň neskúma prichádzajúce údaje a použije predvolený jazyk tlačiarne určený v ponuke  Nastavenie . Ukladanie úloh do vyrovnávacej pamäte Zapnuté Vypnuté * Pred tlačou dočasne uložte tlačové úlohy na pevný disk alebo disk s inteligentným ukladaním (ISD). Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk ISD. Binárny jazyk PS pre Mac Automatický * Zapnuté Vypnuté Nastavenie tlačiarne na spracovanie tlačových úloh v binárnom jazyku PostScript pre Macintosh. Pri nastavení  Zapnuté  sa spracúvajú tlačové úlohy v neupravenom binárnom jazyku PostScript. Nastavenie  Vypnuté  filtruje tlačové úlohy prostredníctvom štandardného protokolu. ponuka Bezdrôtové"},{"UUID":"c02bc2c4-2c94-4253-8c24-72f0e52b91de","title":"Sieť/porty","link":"network-overview-topic.html","desc":"Wi‑Fi Direct Táto ponuka je","descFull":"Wi‑Fi Direct Táto ponuka je k dispozícii iba pre tlačiarne, ktoré sú pripojené k sieti Wi-Fi alebo majú adaptér bezdrôtovej siete. Položky ponuky  Wi-Fi Direct  a ich popisy Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Povoliť funkciu siete Wi-Fi Direct Zapnuté Vypnuté * Nastavenie tlačiarne, aby sa priamo pripájala k zariadeniam Wi-Fi. Názov siete Wi‑Fi Direct Nastavte názov siete Wi-Fi Direct. Heslo siete Wi‑Fi Direct Určite heslo na overenie totožnosti používateľov pri pripojení Wi‑Fi. Zobraziť heslo na stránke nastavenia Vypnutá Zapnuté * Zobrazte  Heslo siete Wi‑Fi Direct  na  stránke nastavenia siete . Číslo uprednostňovaného kanála 1-11 Automatický * Nastavenie uprednostňovaného kanála siete Wi-Fi. Adresa IP vlastníka skupiny Zadanie adresy IP vlastníka skupiny. Automaticky prijať požiadavky pre stlačenia tlačidla Vypnuté * Zapnuté Prijatie požiadaviek na automatické pripojenie do siete. Automatické prijímanie klientov nie je zabezpečené. ponuka Wi‑Fi Direct"},{"UUID":"53df6aaf-2bcb-46ae-9fbb-1620b8264389","title":"Sieť/porty","link":"network-overview-topic.html","desc":"AirPrint Táto ponuka je k dispozícii","descFull":"AirPrint Táto ponuka je k dispozícii iba na serveri Embedded Web Server. Položky ponuky  AirPrint  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Všetky funkcie AirPrint Zistenie stavu funkcie AirPrint tlačiarne. Zapnúť AirPrint Zapnuté * Vypnuté Zapnúť funkciu AirPrint. Táto položka ponuky sa zobrazí len v prípade, ak je vypnutý protokol IPP (Internet Printing Protocol) alebo mDNS. Zapnúť iBeacon Zapnuté Vypnuté * Zapnúť funkciu iBeacon. Názov Bonjour Identifikuje označenie a umiestnenie tlačiarne. Názov organizácie Organizačná jednotka Umiestnenie tlačiarne Zemepisná šírka tlačiarne Zemepisná dĺžka tlačiarne Nadmorská výška tlačiarne Ďalšie možnosti ponuka AirPrint"},{"UUID":"1c5deaac-1624-4137-bc31-b0fa005f1d23","title":"Sieť/porty","link":"network-overview-topic.html","desc":"Správa mobilných služieb Položky ponuky","descFull":"Správa mobilných služieb Položky ponuky  Správa mobilných služieb  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Zapnúť tlač IPP Zapnuté * Vypnuté Umožňuje tlač z mobilných zariadení pomocou protokolu IPP. Zapnúť fax IPP Zapnuté * Vypnuté Povolí odosielanie faxov pomocou protokolu IPP. Zapnúť IPP cez USB Zapnuté * Vypnuté Povolí úlohy tlače alebo skenovania cez pripojenie USB. Zapnúť skenovanie Zapnuté * Vypnuté Povolenie skenovania pomocou protokolu eSCL. Zapnúť rozpoznávanie Mopria Zapnuté * Vypnuté Umožňuje rozpoznanie tlačiarne pomocou zariadení s funkciou Mopria. ponuka Správa mobilných služieb"},{"UUID":"87f5d6a2-0565-4d9c-8484-9001914f937a","title":"Sieť/porty","link":"network-overview-topic.html","desc":"Ethernet Položky ponuky  Ethernet","descFull":"Ethernet Položky ponuky  Ethernet  a ich popisy Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Rýchlosť siete Zobrazenie rýchlosti aktívneho sieťového adaptéra. IPv4 Povoliť protokol DHCP  ( Zapnuté *) Nastaviť statickú adresu IP Konfigurácia nastavení protokolu IPv4. IPv6 Povoliť protokol IPv6  ( Zapnuté *) Povoliť protokol DHCPv6  ( Vypnuté *) Bezstavová automatická konfigurácia adries  ( Zapnuté *) Adresa servera DNS Manuálne priradená adresa podľa protokolu IPv6 Manuálne priradený smerovač podľa protokolu IPv6 Predvoľba adresy (64*) Všetky adresy podľa protokolu IPv6 Všetky adresy smerovača podľa protokolu IPv6 Konfigurácia nastavení protokolu IPv6. Sieťová adresa UAA LAA Zadanie sieťovej adresy. PCL SmartSwitch Vypnutá Zapnuté * Nastavenie tlačiarne na automatické prepnutie na emuláciu jazyka PCL, keď to vyžaduje tlačová úloha, bez ohľadu na predvolený jazyk tlačiarne. Keď je toto nastavenie vypnuté, tlačiareň neskúma prichádzajúce údaje a použije predvolený jazyk tlačiarne určený v ponuke  Nastavenie . PS SmartSwitch Vypnutá Zapnuté * Nastavenie tlačiarne na automatické prepnutie na emuláciu jazyka PostScript, keď to vyžaduje tlačová úloha, bez ohľadu na predvolený jazyk tlačiarne. Keď je toto nastavenie vypnuté, tlačiareň neskúma prichádzajúce údaje a použije predvolený jazyk tlačiarne určený v ponuke  Nastavenie . Ukladanie úloh do vyrovnávacej pamäte Vypnuté * Zapnuté Pred tlačou dočasne uložte tlačové úlohy na pevný disk alebo disk s inteligentným ukladaním (ISD). Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk ISD. Binárny jazyk PS pre Mac Automatický * Zapnuté Vypnutá Nastavenie tlačiarne na spracovanie tlačových úloh v binárnom jazyku PostScript pre Macintosh. Pri nastavení možnosti  Automaticky  sa spracovávajú tlačové úlohy z počítačov používajúcich operačný systém Windows alebo Macintosh. Nastavenie  Vypnuté  filtruje tlačové úlohy PostScript prostredníctvom štandardného protokolu. Úsporné ethernetové pripojenie Zapnuté Vypnutá Automatický * Zníženie spotreby energie, keď tlačiareň neprijíma žiadne údaje z ethernetovej siete. ponuka Ethernet"},{"UUID":"51438433-601a-45ae-b467-5dd0d4f91189","title":"Sieť/porty","link":"network-overview-topic.html","desc":"TCP/IP Táto ponuka sa zobrazí","descFull":"TCP/IP Táto ponuka sa zobrazí len na sieťových tlačiarňach alebo na tlačiarňach pripojených k tlačovým serverom. Položky ponuky  Protokol TCP/IP  a ich popisy Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Nastaviť hostiteľské meno Nastavenie aktuálneho hostiteľského mena TCP/IP. Názov domény Nastavenie názvu domény. Povoliť protokol DHCP/BOOTP na aktualizáciu servera NTP Zapnuté * Vypnuté Povolenie aktualizovať nastavenia NTP tlačiarne klientom využívajúcim protokoly DHCP a BOOTP. Názov nulovej konfigurácie Uveďte názov služby nulovej konfigurácie siete. Povoliť automatické pridelenie IP adresy Vypnuté Zapnuté * Automatické prideľovanie IP adresy. Adresa servera DNS Stanovenie aktuálnej adresy servera DNS. Zálohovať adresu servera DNS Stanovenie záložnej adresy servera DNS. Záložná adresa servera DNS 2 Záložná adresa servera DNS 3 Poradie vyhľadávania domén Stanovenie zoznamu názvov domén na vyhľadanie tlačiarne a jej prostriedkov, ktoré sa nachádzajú na iných doménach v rámci siete. Povoliť protokol DDNS Vypnuté * Zapnuté Aktualizácia nastavenia dynamického servera DNS. DDNS TTL Stanovenie aktuálneho nastavenia servera DDNS. Predvolené TTL Čas obnovenia DDNS Povoliť mDNS Vypnuté Zapnuté * Aktualizácia nastavenia multicast servera DNS. Adresa servera WINS Stanovenie adresy servera pre službu WINS. Povoliť protokol BOOTP Vypnuté * Zapnuté Povolenie prideľovania IP adresy tlačiarne protokolom BOOTP. Zoznam vyhradených serverov Zadanie IP adries, pre ktoré je povolená komunikácia s tlačiarňou cez protokol TCP/IP. Každú z IP adries oddeľte čiarkou. Môžete pridať až 50 IP adries. Možnosti zoznamu vyhradených serverov Blokovať všetky porty * Blokovať len tlač Blokovať len tlač a HTTP Zadanie možnosti prístupu pre IP adresy, ktoré nie sú v zozname. MTU 256 – 1500 Ethernet  (1500*) Stanovenie parametra jednotky MTU pre pripojenia TCP. Port neupravenej tlače 1 – 65535 (9100*) Stanovenie čísla portu na neupravenú tlač pre tlačiarne v sieti. Maximálna rýchlosť odchádzajúcich dátových prenosov Vypnuté * Zapnuté Nastavenie maximálnej prenosovej rýchlosti tlačiarne. Keď je táto funkcia aktivovaná, možnosť pre toto nastavenie je 100 – 1 000 000 kilobitov za sekundu. Podpora TLS Povoliť protokol TLSv1.0  ( Vypnuté ) Povoliť protokol TLSv1.1 ( vypnuté *) Povoliť protokol TLSv1.2  ( Zapnuté *) Zapnutie bezpečnostného protokolu Transport Layer Security. Zoznam šifier SSL Stanovenie kódovacích algoritmov slúžiacich na pripojenia SSL alebo TLS. Zoznam šifrovacích balíkov protokolu TLSv1.3 SSL ponuka TCP/IP"},{"UUID":"8b982d3a-f172-4ddb-a053-6812dcd5690f","title":"Sieť/porty","link":"network-overview-topic.html","desc":"SNMP Táto ponuka sa zobrazí","descFull":"SNMP Táto ponuka sa zobrazí len na sieťových tlačiarňach alebo na tlačiarňach pripojených k tlačovým serverom. Položky ponuky  SNMP  a ich popisy Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Protokol SNMP verzie 1 a 2c Zapnuté Vypnuté Zapnuté * Zapnúť protokol SNMP Vypnuté Zapnuté * Zapnúť PPM MIB Vypnuté Zapnuté * Komunita SNMP Konfigurácia protokolu SNMP verzie 1 a 2c na inštaláciu tlačových ovládačov a aplikácií. Protokol SNMP verzie 3 Zapnuté Vypnuté Zapnuté * Kontextové meno Nastaviť poverenia na čítanie/zápis Používateľské meno Heslo overenia Heslo na ochranu súkromia Nastaviť poverenia iba na čítanie Používateľské meno Heslo overenia Heslo na ochranu súkromia Tlačidlo mriežky na overenie MD5 SHA1 * Minimálna úroveň overenia Žiadne overenie, žiadne súkromie Overenie, žiadne súkromie Overenie, súkromie * Algoritmus súkromného režimu DES AES‑128 * Konfigurácia protokolu SNMP verzie 3 na inštaláciu a aktualizáciu zabezpečenia tlačiarne. ponuka SNMP"},{"UUID":"fcea21df-29d2-4685-aa1d-add4ab408e47","title":"Sieť/porty","link":"network-overview-topic.html","desc":"IPSec Táto ponuka sa zobrazí","descFull":"IPSec Táto ponuka sa zobrazí len na sieťových tlačiarňach alebo na tlačiarňach pripojených k tlačovým serverom. Položky ponuky  IPSec  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Povoliť protokol IPSec Vypnuté * Zapnuté Povoliť zabezpečenie protokolu IP (IPSec). Základná konfigurácia Predvolené * Kompatibilita Zabezpečené Nastavenie základnej konfigurácie protokolu IPSec. Táto položka ponuky sa zobrazí len v prípade, že je položka  Zapnúť protokol IPSec  nastavená na možnosť  Zapnuté . Skupinový návrh protokolu DH (Diffie‑Hellman) modp2048 (14) * modp3072 (15) modp4096 (16) modp6144 (17) Nastavenie základnej konfigurácie protokolu IPSec. Táto položka ponuky sa zobrazí len v prípade, že je položka  Základná konfigurácia  nastavená na možnosť  Kompatibilita . Navrhovaná metóda šifrovania 3DES AES * Nastavenie metódy šifrovania. Táto položka ponuky sa zobrazí len v prípade, že je položka  Základná konfigurácia  nastavená na možnosť  Kompatibilita . Navrhovaná metóda overenia SHA1 SHA256 * SHA512 Nastavenie metódy overenia. Táto položka ponuky sa zobrazí len v prípade, že je položka  Základná konfigurácia  nastavená na možnosť  Kompatibilita . Životnosť IKE SA (hod.) 1 2 4 8 24* Špecifikácia obdobia vypršania IKE SA. Táto položka ponuky sa zobrazí len v prípade, že je položka  Základná konfigurácia  nastavená na možnosť  Bezpečná . Životnosť IPSec SA (hod.) 1 2 4 8* 24 Špecifikácia obdobia vypršania IPSec SA. Táto položka ponuky sa zobrazí len v prípade, že je položka  Základná konfigurácia  nastavená na možnosť  Bezpečná . Certifikát zariadenia IPSec Stanovenie certifikátu protokolu IPSec. Táto položka ponuky sa zobrazí len v prípade, že je položka  Zapnúť protokol IPSec  nastavená na možnosť  Zapnuté . Spojenia overené vopred zdieľaným kľúčom Hostiteľ  [x] Konfigurácia overených spojení tlačiarne. Tieto položky ponuky sa zobrazia len v prípade, že je položka  Zapnúť protokol IPSec  nastavená na možnosť  Zapnuté . Certifikovať overené spojenia Hostiteľ  [x]  Adresa[/podsieť] ponuka IPSec"},{"UUID":"55d1a8c6-6e53-43c8-a1de-42a2001d0f25","title":"Sieť/porty","link":"network-overview-topic.html","desc":"802.1x Táto ponuka sa zobrazí","descFull":"802.1x Táto ponuka sa zobrazí len na sieťových tlačiarňach alebo na tlačiarňach pripojených k tlačovým serverom. Položky ponuky  802.1x  a ich opisy Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Aktívne Vypnuté * Zapnuté Nastavenie tlačiarne na pripojenie do sietí vyžadujúcich overenie pred umožnením prístupu. Overenie 802.1x Prihlasovacie meno zariadenia Prihlasovacie heslo zariadenia Overenie serverového certifikátu  ( Zapnuté *) Zapnúť záznam udalostí  ( Vypnuté . *) Certifikát zariadenia 802.1x Konfigurácia nastavení na overenie pripojenia 802.1x. Overovací mechanizmus EAP – MD5  ( Zapnuté *) EAP - MSCHAPv2  ( Zapnuté *) LEAP  ( Zapnuté *) PEAP  ( Zapnuté *) EAP -–TLS  ( Zapnuté *) EAP – TTLS  ( Zapnuté *) Spôsob overenia TTLS  ( MSCHAPv2 *) Konfigurácia povolených mechanizmov overenia pripojenia 802.1x. ponuka 802.1x"},{"UUID":"709cd2fc-592d-4c59-aabe-4b6bbc84a80b","title":"Sieť/porty","link":"network-overview-topic.html","desc":"Konfigurácia LPD Táto ponuka sa","descFull":"Konfigurácia LPD Táto ponuka sa zobrazí len na sieťových tlačiarňach alebo na tlačiarňach pripojených k tlačovým serverom. Položky ponuky  Konfigurácia LPD  a ich popisy Položka ponuky Popis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Časový limit LPD 0 – 65535 sekúnd (90*) Nastavenie hodnoty časového limitu na zastavenie servera LPD, ktorý neurčito dlho čaká na zadržané alebo neplatné tlačové úlohy. Stránka transparentu LPD Vypnuté * Zapnuté Tlač stránky transparentu pre všetky tlačové úlohy LPD. Stránka transparentu je prvá strana tlačovej úlohy, ktorá sa používa na oddelenie tlačových úloh a na určenie autora požiadavky na tlačovú úlohu. Záverečná stránka LPD Vypnuté * Zapnuté Tlač záverečnej stránky pre všetky tlačové úlohy LPD. Záverečná stránka je posledná stránka tlačovej úlohy. Konverzia návratu vozíka LPD Vypnuté * Zapnuté Povolenie konverzie návratu vozíka. Návrat vozíka predstavuje mechanizmus, ktorý tlačiarni prikazuje presunúť polohu kurzora na prvú polohu v rovnakom riadku. ponuka Konfigurácia LPD"},{"UUID":"f0a679f5-15d3-45fb-acc4-b87acaf6fdfa","title":"Sieť/porty","link":"network-overview-topic.html","desc":"Nastavenia HTTP/FTP Položky ponuky ","descFull":"Nastavenia HTTP/FTP Položky ponuky  Nastavenia HTTP/FTP  a ich popisy Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Server proxy IP adresa servera proxy HTPP Predvolený IP port servera HTTP IP adresa servera proxy FTP Predvolený IP port servera FTP Overenie Používateľské meno Heslo Miestne domény Konfigurácia nastavení servera HTTP a FTP. Ďalšie nastavenia Povoliť server HTTP  ( Zapnuté *) Prístup k serveru Embedded Web Server na monitorovanie a správu tlačiarne. Ďalšie nastavenia Zapnúť HTPPS  ( Zapnuté *) Povolenie protokolu HTTPS (Hypertext Transfer Protocol Secure) na šifrovanie prenosu údajov do a z tlačového servera. Ďalšie nastavenia Vynútiť pripojenia typu HTTPS  ( Vypnuté *) Vynútenie používania pripojení HTTPS tlačiarňou. Ďalšie nastavenia Povoliť protokol FTP/TFTP  ( Zapnuté *) Odosielanie súborov pomocou protokolu FTP/TFTP. Ďalšie nastavenia Certifikát zariadenia HTTPS  ( predvolené *) Zobrazenie certifikátu zariadenia HTTP používaného v tlačiarni. Ďalšie nastavenia Časový limit pre požiadavky HTTP/FTP  (30*) Stanovenie času, po uplynutí ktorého dôjde k prerušeniu spojenia so serverom. Ďalšie nastavenia Opakovania požiadaviek HTTP/FTP  (3*) Nastavenie počtu opakovaní požiadaviek na pripojenie k serveru HTTP/FTP. ponuka Nastavenia HTTP/FTP"},{"UUID":"ec392125-dcbe-41ee-9a09-a990f2af467f","title":"Sieť/porty","link":"network-overview-topic.html","desc":"ThinPrint Položky ponuky  ThinPrint","descFull":"ThinPrint Položky ponuky  ThinPrint  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Povoliť protokol ThinPrint Vypnuté * Zapnuté Tlačiť pomocou protokolu ThinPrint. Číslo portu 4000 – 4999 (4000*) Nastavenie čísla portu servera protokolu ThinPrint. Šírka pásma (bitov/s) 100 – 1000000 (0*) Nastavenie rýchlosti prenosu údajov v prostredí protokolu ThinPrint. Veľkosť paketu (kB) 0 – 64000 (0*) Nastavenie veľkosti paketu na prenos údajov. ponuka ThinPrint"},{"UUID":"a2de99be-c2a1-4bf6-8e58-d3934913ea8a","title":"Sieť/porty","link":"network-overview-topic.html","desc":"USB Položky ponuky  USB","descFull":"USB Položky ponuky  USB  a ich popisy Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. PCL SmartSwitch Vypnutá Zapnuté * Nastavenie tlačiarne na prepnutie na emuláciu jazyka PCL, keď to tlačová úloha prijatá prostredníctvom portu USB vyžaduje bez ohľadu na predvolený jazyk tlačiarne. Keď je toto nastavenie vypnuté, tlačiareň neskúma prichádzajúce údaje a použije predvolený jazyk tlačiarne určený v ponuke  Nastavenie . PS SmartSwitch Vypnutá Zapnuté * Nastavenie tlačiarne na prepnutie na emuláciu jazyka PostScript, keď to tlačová úloha prijatá prostredníctvom portu USB vyžaduje, bez ohľadu na predvolený jazyk tlačiarne. Keď je toto nastavenie vypnuté, tlačiareň neskúma prichádzajúce údaje a použije predvolený jazyk tlačiarne určený v ponuke  Nastavenie . Ukladanie úloh do vyrovnávacej pamäte Vypnuté * Zapnuté Pred tlačou dočasne uložte tlačové úlohy na pevný disk alebo disk s inteligentným ukladaním (ISD). Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk ISD. Binárny jazyk PS pre Mac Automatický * Zapnuté Vypnutá Nastavenie tlačiarne na spracovanie tlačových úloh v binárnom jazyku PostScript pre Macintosh. Pri nastavení možnosti  Automaticky  sa spracovávajú tlačové úlohy z počítačov používajúcich operačný systém Windows alebo Macintosh. Nastavenie  Vypnuté  filtruje tlačové úlohy PostScript prostredníctvom štandardného protokolu. Povoliť port USB Vypnutá Zapnuté * Povolenie predného portu USB. ponuka USB"},{"UUID":"33f1bac2-18dd-4794-83e9-88b791366aa2","title":"Sieť/porty","link":"network-overview-topic.html","desc":"Obmedzenie prístupu do externej siete","descFull":"Obmedzenie prístupu do externej siete Položky ponuky  Obmedzenie prístupu do externej siete  a ich popisy Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Obmedzenie prístupu do externej siete Vypnuté * Zapnuté Obmedzenie prístupu do siete. Adresa externej siete Špecifikácia sieťových adries s obmedzeným prístupom. E-mailová adresa na upozornenia Špecifikácia e-mailovej adresy, na ktorú sa má odoslať upozornenie na prihlásenie. Frekvencia cinknutí 1 – 300 (10*) Špecifikácia intervalu sieťových dotazov v sekundách. Predmet Zadajte predmet a správu v rámci oznámenia e-mailom. Správa ponuka Obmedzenie prístupu do externej siete"},{"UUID":"ddec198d-7f0b-4ff5-a08a-ce31e54ecfcf","title":"Spôsoby prihlásenia","link":"login-methods-subgroup.html","desc":"Správa povolení Položky ponuky ","descFull":"Správa povolení Položky ponuky  Spravovanie povolení  a ich opis Položka ponuky Opis Prístup k funkciám Prístup k adresáru cez aplikácie Upraviť Adresár Spravovať skratky Vytvárať profily Spravovať záložky Tlač z pamäťovej jednotky flash Skenovanie do pamäťovej jednotky flash Funkcia kopírovania Vynechanie farieb Funkcia e-mailu Funkcia faxu Funkcia FTP Uvoľniť zadržané faxy Prístup k zadržaným úlohám Používateľské profily Zrušiť úlohy v rámci zariadenia Zmeniť jazyk Protokol IPP Spustiť skenovanie na diaľku Čiernobiela tlač Sieťový priečinok – skenovanie Riadenie prístupu k funkciám tlačiarne. Ponuky správy Ponuka zabezpečenia Ponuka siete/portov Ponuka papiera Ponuka správ Ponuky konfigurácie funkcií Ponuka spotrebného materiálu Ponuka voliteľnej karty Ponuka SE Ponuka zariadenia Riadenie prístupu k ponuke nastavení tlačiarne. Správa zariadení Vzdialená správa Aktualizácie firmvéru Konfigurácia aplikácií Zámok ovládacieho panela Prístup k nástroju Embedded Web Server Importovať/exportovať všetky nastavenia vymazanie mimo prevádzky Registrácia do cloudových služieb Riadenie prístupu k možnostiam správy tlačiarne. Aplikácie Nové aplikácie Centrum skenovania Centrum skenovania – vlastné [x] Riadenie prístupu k aplikáciám tlačiarne. ponuka Správa povolení"},{"UUID":"44eba93b-2128-4536-8e80-56d6fd35e2d5","title":"Spôsoby prihlásenia","link":"login-methods-subgroup.html","desc":"miestne kontá Položky ponuky Miestne","descFull":"miestne kontá Položky ponuky Miestne kontá a ich popis Položka ponuky Opis Spravovať skupiny/povolenia Pridať skupinu Importovať riadenie prístupu Prístup k funkciám Ponuky správy Správa zariadení Všetci používatelia Importovať riadenie prístupu Prístup k funkciám Ponuky správy Správa zariadení Správca Kontrola skupiny používateľov, ktorí majú prístup k funkciám tlačiarne, aplikáciám a bezpečnostným nastaveniam. Pridať používateľa Používateľské meno/heslo Používateľské meno Heslo Kód PIN Vytváranie miestnych kont na správu prístupu k funkciám tlačiarne. Kontá s používateľským menom/heslom Pridať používateľa Kontá s používateľským menom Pridať používateľa Kontá s heslom Pridať používateľa Kontá s kódom PIN Pridať používateľa ponuka miestne kontá"},{"UUID":"fb22a23b-1b3b-4cab-a4c0-deaebe70d32b","title":"Zabezpečenie","link":"login-methods-subgroup.html","desc":"Plánovať zariadenia USB Položky ponuky","descFull":"Plánovať zariadenia USB Položky ponuky  Plánovať zariadenia USB  a ich popis Položka ponuky Opis Plány Pridať nový plán Plánovanie prístupu k prednému portu USB. ponuka Plánovať zariadenia USB"},{"UUID":"97fd4392-b987-429a-8688-52926ba6e749","title":"Zabezpečenie","link":"login-methods-subgroup.html","desc":"Denník auditu zabezpečenia Položky ponuky","descFull":"Denník auditu zabezpečenia Položky ponuky  Denník auditu zabezpečenia  a ich popisy Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Povoliť audit Vypnuté * Zapnuté Zaznamenávať udalosti v denníku auditu zabezpečenia a na vzdialený server Syslog. Zapnúť vzdialený server Syslog Vypnuté * Zapnuté Odosielanie denníkov auditu na vzdialený server. Vzdialený server Syslog Stanovenie vzdialeného servera Syslog. Port vzdialeného servera Syslog 1 – 65535 (514*) Určenie portu vzdialeného servera Syslog. Metóda vzdialeného servera Syslog Normálne UDP * Stunnel Stanovenie metódy posielania zaznamenaných udalostí denníkov na vzdialený server. Funkcia vzdialeného servera Syslog 0 – hlásenia jadra 1 – hlásenia na úrovni používateľa 2 – systém správ 3 – služby daemon systém 4 – hlásenia zabezpečenia/autorizácie * 5 – hlásenia interne generované serverom syslog 6 – podsystém riadkovej tlačiarne 7 – podsystém sieťových noviniek 8 – podsystém UUCP 9 – služba daemon hodiny 10 – hlásenia zabezpečenia/autorizácie 11 – služba daemon FTP 12 – podsystém NTP 13 – denník auditu 14 – denník výstrah 15 – služba daemon hodiny 16 – lokálne použitie 0 (local0) 17 – lokálne použitie 1 (local1) 18 – lokálne použitie 2 (local2) 19 – lokálne použitie 3 (local3) 20 – lokálne použitie 4 (local4) 21 – lokálne použitie 5 (local5) 22 – lokálne použitie 6 (local6) 23 – lokálne použitie 7 (local7) Stanovenie kódu funkcie, ktorú tlačiareň používa pri odosielaní udalosti denníka na vzdialený server. Závažnosť udalostí zapisovaných do denníka 0 – Núdzový stav 1 – Výstraha 2 – Kritické 3 – Chyba 4 – Upozornenie * 5 – Poznámka 6 – Informačné 7 – Ladenie Stanovenie úrovne priority ukončenia zaznamenávania hlásenia udalostí do denníka. Udalosti nezapisované do denníka vzdialeného servera Syslog Vypnuté * Zapnuté Na vzdialený server odosielať všetky udalosti bez ohľadu na stupeň závažnosti. E-mailová adresa správcu Odosielať e-mailové notifikácie udalostí zaznamenaných v denníkoch správcovi. E-mailová výstraha pri vymazaní denníka Vypnuté * Zapnuté Odoslať e‑mailovú notifikáciu správcovi v prípade odstránenia denníkového záznamu. E-mailová výstraha pri zaplnení denníka Vypnuté * Zapnuté Odoslať e‑mailovú notifikáciu správcovi v prípade zaplnenia denníka a začiatku prepisovania najstarších záznamov. Zapisovať do denníka úplné správanie Prepisovať najstaršie položky * Denník odoslať e-mailom, potom odstrániť všetky položky Riešiť problémy s ukladacím priestorom, keď denník zaplní vyhradenú pamäť. E-mailová výstraha pri % zaplnenia Vypnuté * Zapnuté Odoslať e‑mailovú notifikáciu správcovi v prípade, že denník zaplní vyhradenú pamäť. Úroveň pre výstrahu pri % zaplnenia 1 – 99 (90*) E-mailová výstraha pri exporte denníka Vypnuté * Zapnuté Odoslať e‑mailovú notifikáciu správcovi v prípade exportu denníka. E-mailová výstraha pri zmene nastavení denníka Vypnuté * Zapnuté Odoslať e‑mailovú notifikáciu správcovi v prípade nastavenia možnosti  Povoliť audit . Konce riadkov denníka LF (\\n) * CR (\\r) CRLF (\\r\\n) Stanovenie spôsobu, akým sa denník ukončí na konci každého riadka. Digitálne podpisovať exporty Vypnuté * Zapnuté Pridanie digitálneho podpisu do každého exportovaného denníkového súbora. Vymazať denník Odstránenie všetkých denníkov auditu. Denník exportovania Syslog (RFC 5424) Syslog (RFC 3164) CSV Export denníka zabezpečenia na jednotku flash. ponuka Denník auditu zabezpečenia"},{"UUID":"79f6325b-5d0a-47de-8cef-d61d46fec11d","title":"Zabezpečenie","link":"login-methods-subgroup.html","desc":"Obmedzenia prihlásenia Položky ponuky ","descFull":"Obmedzenia prihlásenia Položky ponuky  Obmedzenia prihlásenia  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Neúspešné prihlásenia 1 – 10 (3*) Stanovenie počtu neúspešných prihlásení, po ktorých dôjde k zablokovaniu používateľa. Časový rámec zlyhania 1 – 60 min (5*) Stanovenie časového rámca neúspešných prihlásení, po ktorého uplynutí dôjde k zablokovaniu používateľa. Doba zablokovania 1 – 60 min (5*) Stanovenie doby zablokovania. Časový limit webového prihlásenia 1 – 120 min (10*) Stanovenie oneskorenia pre vzdialené prihlásenie, po ktorého uplynutí dôjde k automatickému odhláseniu používateľa. ponuka Obmedzenia prihlásenia"},{"UUID":"18c29b6d-7473-4d4b-a6b8-da9250e5d8f0","title":"Zabezpečenie","link":"login-methods-subgroup.html","desc":"Nastavenie dôvernej tlače Položky ponuky","descFull":"Nastavenie dôvernej tlače Položky ponuky  Nastavenie dôvernej tlače  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Max. počet neplatných kódov PIN 2 – 10 Nastavte limit pre počet zadaní neplatného kódu PIN. Po dosiahnutí limitu sa odstránia tlačové úlohy pre dané meno používateľa. Koniec platnosti dôvernej úlohy Vypnuté * 1 hodina 4 hodiny 24 hodín 1 týždeň Nastavte individuálnu dobu uplynutia platnosti každej pozastavenej úlohy pred jej automatickým vymazaním z pevného disku alebo z disku s inteligentným ukladaním. Pozastavená úloha je  dôverná ,  opakovaná ,  rezervovaná  alebo  overovaná . Koniec platnosti opakovaných úloh Vypnuté * 1 hodina 4 hodiny 24 hodín 1 týždeň Nastavenie doby uplynutia platnosti tlačovej úlohy, ktorú chcete opakovať. Koniec platnosti overenia úlohy Vypnuté * 1 hodina 4 hodiny 24 hodín 1 týždeň Nastavte dobu uplynutia platnosti tlače kópie úlohy na kontrolu jej kvality pred vytlačením zostávajúcich kópií. Koniec platnosti rezervovanej úlohy Vypnuté * 1 hodina 4 hodiny 24 hodín 1 týždeň Nastavte dobu uplynutia platnosti úloh, ktoré chcete v tlačiarni uložiť na neskoršie vytlačenie. Je potrebné, aby sa zadržali všetky úlohy Vypnuté * Zapnuté Nastavenie tlačiarne, aby zadržala všetky tlačové úlohy. Zachovať duplicitné dokumenty Vypnuté * Zapnuté Nastavenie tlačiarne, aby zachovala všetky dokumenty s rovnakým názvom súboru. ponuka Nastavenie dôvernej tlače"},{"UUID":"a1253837-a888-477f-9a93-9343fad4df83","title":"Zabezpečenie","link":"login-methods-subgroup.html","desc":"Šifrovanie disku Táto položka ponuky","descFull":"Šifrovanie disku Táto položka ponuky sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk s inteligentným ukladaním. Položky ponuky  Šifrovanie disku  a ich popis Položka ponuky Opis Pevný disk Zobrazenie stavu šifrovania pevného disku alebo disku s inteligentným ukladaním. Disk s inteligentným ukladaním ponuka Šifrovanie disku"},{"UUID":"65861d7b-4f13-4454-8fdd-9b66ac63c289","title":"Zabezpečenie","link":"login-methods-subgroup.html","desc":"Vymazať dočasné údajové súbory Položky","descFull":"Vymazať dočasné údajové súbory Položky ponuky  Vymazať dočasné údajové súbory  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Uložené vo vstavanej pamäti Vypnuté * Zapnuté Odstránenie všetkých súborov uložených v pamäti tlačiarne. ponuka Vymazať dočasné údajové súbory"},{"UUID":"e629d8ce-29ff-4668-85fc-d72bc7d5ce51","title":"Zabezpečenie","link":"login-methods-subgroup.html","desc":"Nastavenia riešení LDAP Položky ponuky","descFull":"Nastavenia riešení LDAP Položky ponuky  Nastavenia riešení LDAP  a ich popisy Položka ponuky Opis Sledovanie odkazov LDAP Vypnuté * Zapnuté Vyhľadávanie účtov prihlásených používateľov na rôznych serveroch na doméne. Overenie certifikátu LDAP Áno Nie * Zapnutie overovania certifikátov LDAP. ponuka Nastavenia riešení LDAP"},{"UUID":"f1777eed-c910-4356-8c7e-cad5834494a9","title":"Zabezpečenie","link":"login-methods-subgroup.html","desc":"Rôzne Položky ponuky  Rôzne","descFull":"Rôzne Položky ponuky  Rôzne  a ich popis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Chránené funkcie Zobraziť * Skryť Zobrazuje všetky funkcie, ktoré ovládanie prístupu k funkciám (FAC) chráni bez ohľadu na bezpečnostné povolenia používateľa. Pomocou možnosti  Skryť  sa zobrazia v rámci ochrany FAC len tie funkcie, ku ktorým mám používateľ prístup. Povolenie tlače Vypnuté * Zapnuté Umožnenie prihlásenia používateľa pred tlačou. Predvolené prihlásenie s povolením tlače Kód PIN * Používateľské meno/heslo Používateľské meno Nastavenie predvoleného prihlásenia pre položku  Povolenie tlače . Prepínač obnovenia zabezpečenia Povoliť „hosťovský“ prístup * Žiadny účinok Zadanie prístupu používateľa k tlačiarni. Položka  Povoliť „hosťovský“ prístup  umožňuje obnovenie zariadenia, ak sa stratí heslo správcu. Ak sa vyskytne tento problém, kontaktujte podporu pre zákazníkov. Položka  Žiadny účinok  zabraňuje použitiu prepínača zabezpečenia na obnovenie zariadenia. Táto položka ponuky sa zobrazí len v prípade, ak je nainštalovaný skutočný hardvér prepínača zabezpečenia. Na používateľské údaje použite disk s inteligentným ukladaním Vypnuté Zapnuté * Zapnite disk s inteligentným ukladaním, aby ste uložili používateľské údaje. Táto položka ponuky sa zobrazí len v prípade, že je nainštalovaný disk s inteligentným ukladaním. Minimálna dĺžka hesla 0 – 32 (0*) Zadanie dĺžky hesla. Povoliť ukázanie hesla/čísla PIN Vypnuté * Zapnuté Zobrazenie hesla alebo osobného identifikačného čísla. ponuka Rôzne"},{"UUID":"9ca4eb76-797c-4488-9f44-ca0a988b2861","title":"Cloudové služby","link":"cloud-services-enrollment-topic.html","desc":"Záznam do cloudových služieb Položky","descFull":"Záznam do cloudových služieb Položky ponuky  Záznam do cloudových služieb  a ich opis Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Zobraziť viac informácií Zobrazenie ďalších informácií o používaní cloudových služieb Lexmark. Povoliť komunikáciu s cloudovými službami Lexmark Vypnuté * Zapnuté Povolenie komunikácie tlačiarne s cloudovými službami Lexmark. Zobraziť aktuálny stav Zobrazenie stavu pripojenia medzi tlačiarňou a cludovými službami Lexmark. ponuka Záznam do cloudových služieb"},{"UUID":"fecac562-7fa7-4132-a984-48cbd16df1fb","title":"Správy","link":"menu-settings-page-topic.html","desc":"Strana nastavení ponúk Položka ponuky","descFull":"Strana nastavení ponúk Položka ponuky  Strana nastavení ponúk  a jej popis Položka ponuky Popis Strana nastavení ponúk Tlač správy, ktorá obsahuje ponuky tlačiarne. ponuka Strana nastavení ponúk"},{"UUID":"81088194-f877-4ec7-8132-43b22a4f157c","title":"Správy","link":"menu-settings-page-topic.html","desc":"Zariadenie Zariadenie Položky ponuky ","descFull":"Zariadenie Zariadenie Položky ponuky  Zariadenie  a ich popisy Položka ponuky Opis Informácie o zariadení Tlač správy s informáciami o tlačiarni. Štatistiky zariadenia Tlač správy s údajmi o využívaní tlačiarne a o stave spotrebného materiálu. Zoznam profilov Tlač zoznamu profilov uložených v tlačiarni. Správa o zariadeniach Vytlačte diagnostický nástroj pre problémy s tlačou. Aby ste predišli orezávaniu obsahu, vytlačte správu na papier veľkosti Letter alebo A4. ponuka Zariadenie"},{"UUID":"f35b117b-fd81-460b-80aa-bc1fcdce46ee","title":"Správy","link":"menu-settings-page-topic.html","desc":"Tlač Položky ponuky  Tlač","descFull":"Tlač Položky ponuky  Tlač  a ich popisy Položka ponuky Opis Písma tlače Písma jazyka PCL Písma jazyka PS Tlač ukážok a informácií o písmach, ktoré sú k dispozícii pre jednotlivé jazyky tlačiarne. Tlačiť ukážku Stránka s ukážkou Vytlačí sa stránka, ktorá zobrazuje možnosti tlačiarne a podporované riešenia. Tlačiť adresár Vytlačte zdroje uložené na jednotke flash, pevnom disku alebo disku s inteligentným ukladaním (ISD). Táto položka ponuky sa zobrazí, len keď je nainštalovaná jednotka flash alebo disk ISD. ponuka Tlač"},{"UUID":"c5bb9e1e-7503-408c-9fa1-9ef0a7a1bce1","title":"Správy","link":"menu-settings-page-topic.html","desc":"Skratky Položky ponuky  Skratky","descFull":"Skratky Položky ponuky  Skratky  a ich popis Položka ponuky Popis Všetky skratky Tlač správy, ktorá obsahuje skratky uložené v tlačiarni. Skratky faxu Skratky pre kopírovanie Skratky e-mailu Skratky FTP Skratky sieťového priečinka ponuka Skratky"},{"UUID":"5d12de59-7b8f-4b58-91ed-ecce0d5a997a","title":"Správy","link":"menu-settings-page-topic.html","desc":"Fax Táto ponuka sa zobrazí","descFull":"Fax Táto ponuka sa zobrazí len v prípade, že je nakonfigurovaný fax a možnosť  Zapnúť denník úloh  a  Povoliť denník hovorov  je  zapnutá . Položky ponuky  Fax  a ich opisy Položka ponuky Opis Denník úloh faxovania Tlač správy o posledných 200 dokončených faxových úlohách. Denník faxových hovorov Tlač správy o posledných 100 pokusoch o hovory, prijatých a zablokovaných hovoroch. ponuka Fax"},{"UUID":"4caa5558-a7bf-447d-902b-5aa2551e7d31","title":"Správy","link":"menu-settings-page-topic.html","desc":"Sieť Položky ponuky  Sieť","descFull":"Sieť Položky ponuky  Sieť  a ich popis Položka ponuky Popis Stránka nastavenia siete Tlač strany, ktorá obsahuje informácie o nakonfigurovaných sieťových a bezdrôtových nastaveniach tlačiarne. Táto položka ponuky sa zobrazí len na sieťových tlačiarňach alebo na tlačiarňach pripojených k tlačovým serverom. Klienti pripojení k sieti Wi-Fi Direct Vytlačí sa stránka, ktorá zobrazuje zoznam zariadení pripojených k tlačiarni pomocou siete Wi-Fi Direct. Táto položka ponuky sa zobrazí len v prípade, že položka  Zapnúť Wi-Fi Direct  je nastavená na možnosť  Zapnuté . ponuka Sieť"},{"UUID":"5e28d0c7-e20c-46d5-bef1-8e1bb7f382bf","title":"Používanie ponúk tlačiarne","link":"troubleshooting-menu-topic.html","desc":"Riešenie problémov Položky ponuky Riešenie","descFull":"Riešenie problémov Položky ponuky Riešenie problémov a ich popis Položka ponuky Popis Strany testovania kvality tlače Tlač vzorových strán na identifikáciu a opravu chýb kvality tlače. Čistenie skenera Tlač pokynov na čistenie skenera. ponuka Riešenie problémov Strany testovania kvality tlače Čistenie skenera"},{"UUID":"d45c71cb-0d53-42cd-b030-e4481fb24233","title":"Používanie ponúk tlačiarne","link":"forms-merge-topic.html","desc":"Forms Merge Táto ponuka sa","descFull":"Forms Merge Táto ponuka sa zobrazí len v prípade, že je nainštalovaný pevný disk alebo disk s inteligentným ukladaním. Položky ponuky  Forms Merge  a ich popisy Položka ponuky Opis Hviezdička (*) vedľa hodnoty označuje predvolené výrobné nastavenie. Hromadný režim Tlačiť * Zachytenie údajov Vypnuté Zadanie režimu prevádzky pre funkciu Forms Merge. Cieľ zachytenia údajov Jednotka flash* Nastavenie cieľového miesta, kde sa majú zachytené údaje preposielať. Táto položka ponuky sa zobrazí len v prípade, že je položka Forms Merge nastavená na možnosť Zachytenie údajov. Nastavenia filtra a portu tlače Sieťový port Zapnuté * Vypnuté Povolenie funkcii Forms Merge spracovať všetky údaje, ktoré sa odosielajú do sieťového portu. Nastavenia filtra a portu tlače Sieťový filter Vypnuté * NEPLATNÉ OFIS OFIS+NEPLATNÉ OFIS+AS400 AS400 PCL ZPL ZPLF Zadanie sieťového filtra pre všetky údaje odosielané do tlačiarne. Nastavenia filtra a portu tlače Port USB Zapnuté * Vypnuté Povolenie funkcii Forms Merge spracovať všetky údaje, ktoré sa odosielajú USB portu. Nastavenia filtra a portu tlače Filter USB Vypnuté * NEPLATNÉ OFIS OFIS+NEPLATNÉ OFIS+AS400 AS400 PCL ZPL ZPLF Zadanie USB filtra pre všetky údaje odosielané do tlačiarne. Nastavenia filtra a portu tlače Časový limit lokálneho portu 1 – 100 (10*) Zadanie hodnoty časového limitu pre úlohy funkcie Forms Merge, ktoré sa odosielajú do lokálneho portu. Rôzne Tlač všetkých formulárov Tlač všetkých súborov formulárov uložených na inteligentnom pamäťovom disku alebo pevnom disku tlačiarne. Rôzne Tlač strany s chybami Zapnuté * Vypnuté Aktivácia tlače strany s chybami, keď sa vyskytne chyba v úlohe funkcie Forms Merge. ponuka Forms Merge"},{"UUID":"8518ad45-8669-47f1-881e-dceb632f3a84","title":"Používanie ponúk tlačiarne","link":"printing-menu-settings-page-topic.html","desc":"Tlač  strany nastavení ponúk","descFull":"Tlač  strany nastavení ponúk Na domovskej obrazovke sa dotknite položiek  Nastavenia Správy  Strana nastavení ponúk . tlač Strana nastavení ponúk Strana nastavení ponúk tlač ponuky tlačiarne"},{"UUID":"63f066c5-bf35-4667-89c9-e022adc9d4f0","title":"Údržba tlačiarne","link":"checking-status-of-parts-and-supplies-topic.html","desc":"Kontrola stavu súčastí a spotrebného materiálu","descFull":"Kontrola stavu súčastí a spotrebného materiálu Na domovskej obrazovke sa dotknite položky  Stav/spotrebný materiál . Vyberte súčasti alebo spotrebný materiál, ktorý chcete skontrolovať. K tomuto nastaveniu sa dostanete aj vtedy, keď sa dotknete hornej časti domovskej obrazovky. kontrola stavu súčastí a spotrebného materiálu stav spotrebného materiálu kontrola stav súčastí kontrola"},{"UUID":"05aa9d1e-c937-4f5a-b8ce-f65487c5212e","title":"Údržba tlačiarne","link":"configuring-supply-notifications-topic.html","desc":"Konfigurácia oznámení o spotrebnom materiáli Otvorte","descFull":"Konfigurácia oznámení o spotrebnom materiáli Otvorte webový prehliadač a do poľa adresy zadajte adresu IP tlačiarne. Pozrite si adresu IP tlačiarne na domovskej obrazovke tlačiarne. IP Adresa sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Ak používate server proxy, dočasne ho vypnite, aby sa správne načítala webová stránka. Kliknite na položky  Nastavenia Zariadenie Oznámenia . Z ponuky Spotrebný materiál kliknite na položku  Vlastné oznámenia o spotrebnom materiáli . Vyberte oznámenie pre každý spotrebný materiál. Uložte zmeny. oznámenia o spotrebnom materiáli konfigurácia konfigurácia oznámení o spotrebnom materiáli"},{"UUID":"8894785e-395d-4987-9a77-8cdddea3e8c3","title":"Údržba tlačiarne","link":"setting-up-e-mail-alert-topic.html","desc":"Nastavenie upozornení e-mailom Nakonfigurujte tlačiareň","descFull":"Nastavenie upozornení e-mailom Nakonfigurujte tlačiareň tak, aby odosielala upozornenia e-mailom, keď spotrebný materiál dosiahne nízku úroveň, keď je potrebné vymeniť alebo doplniť papier, prípadne keď dôjde k zaseknutiu papiera. Otvorte webový prehliadač a do poľa adresy zadajte adresu IP tlačiarne. Pozrite si adresu IP tlačiarne na domovskej obrazovke tlačiarne. IP Adresa sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Ak používate server proxy, dočasne ho vypnite, aby sa webová stránka správne načítala. Kliknite na položku  Nastavenia Zariadenie Oznámenia Nastavenie upozornení e-mailom a potom nakonfigurujte nastavenia. Ďalšie informácie o nastavení SMTP získate od svojho poskytovateľa e‑mailu. Použite zmeny. Kliknite na položku  Nastavenie zoznamu e-mailov a upozornení e-mailom  a potom nakonfigurujte nastavenia. Použite zmeny. upozornenia e-mailom nastavenie nastavenie upozornení e-mailom"},{"UUID":"e46ae001-3807-491e-b70f-9bf7d636219b","title":"Údržba tlačiarne","link":"viewing-reports-topic.html","desc":"Zobrazenie správ Na domovskej obrazovke","descFull":"Zobrazenie správ Na domovskej obrazovke sa dotknite položiek  Nastavenia Správy . Vyberte správu, ktorú chcete zobraziť. zobrazenie správ správy stav tlačiarne správy používanie tlačiarne"},{"UUID":"7fce1cb8-c6c1-4764-b02a-8efaf9945dd2","title":"Objednávanie súčastí a spotrebného materiálu","link":"ordering-supplies-group.html","desc":"Ak objednávate spotrebný materiál v USA,","descFull":"Ak objednávate spotrebný materiál v USA, obráťte sa na spoločnosť Lexmark na čísle 1 800 539 6275, kde získate informácie o autorizovaných predajcoch spotrebného materiálu spoločnosti Lexmark vo vašom okolí. V iných krajinách alebo regiónoch navštívte adresu  www.lexmark.com  alebo sa obráťte na predajcu, od ktorého ste kúpili tlačiareň. Ak chcete objednať spotrebný materiál, obráťte sa na predajňu, v ktorej ste tlačiareň kúpili. Všetky odhady životnosti spotrebného materiálu tlačiarne sú založené na predpoklade tlače na obyčajný papier veľkosti Letter alebo A4. Ak nebudete udržiavať optimálny výkon tlačiarne alebo vymieňať súčasti a spotrebný materiál, môže dôjsť k jej poškodeniu. originálne súčasti a spotrebný materiál"},{"UUID":"a527bcbb-e678-4a88-a3a0-dbbd99477f83","title":"Objednávanie súčastí a spotrebného materiálu","link":"ordering-supplies-group.html","desc":"Používanie originálnych súčastí a spotrebného materiálu","descFull":"Používanie originálnych súčastí a spotrebného materiálu Lexmark Tlačiareň Lexmark funguje najlepšie s originálnymi súčasťami a spotrebným materiálom Lexmark. Používanie spotrebného materiálu alebo súčastí tretích strán môže ovplyvniť výkonnosť, spoľahlivosť alebo životnosť tlačiarne a jej tlačových súčastí. Môže mať vplyv aj na pokrytie záruky. Záruka nepokrýva poškodenie spôsobené používaním súčastí a spotrebného materiálu tretích strán. Všetky indikátory životnosti sú určené na fungovanie so súčasťami a spotrebným materiálom Lexmark a ak sa používajú súčasti a spotrebný materiál tretích strán, môžu sa správať nepredvídateľne. Používanie tlačových súčastí po určenej životnosti môže poškodiť tlačiareň Lexmark alebo jej priradené súčasti. Spotrebný materiál a súčasti bez zmluvy o programe vrátenia môžu byť obnovené a repasované. Záruka výrobcu sa však nevzťahuje na škody spôsobené neoriginálnymi spotrebnými materiálmi alebo súčasťami. Obnovenie nastavenia počítadiel pre spotrebný materiál alebo súčiastky bez správneho repasovania môže poškodiť tlačiareň. Po obnovení nastavení počítadla spotrebného materiálu alebo súčiastok môže tlačiareň zobrazovať chybové hlásenie, ktoré označuje prítomnosť obnovenej položky. používanie originálnych súčastí a spotrebného materiálu Lexmark originálne súčasti a spotrebný materiál Lexmark"},{"UUID":"3dc4b4d1-06fe-4b38-aaa4-06b92a491b4b","title":"Objednávanie súčastí a spotrebného materiálu","link":"ordering-supplies-group.html","desc":"Objednávanie tonerovej kazety Odhadovaná výťažnosť","descFull":"Objednávanie tonerovej kazety Odhadovaná výťažnosť kazety je založená na norme ISO/IEC 19752. Dlhé obdobia s mimoriadne malým objemom tlače môžu negatívne ovplyvniť skutočnú výťažnosť. Ak chcete objednať tonerovú kazetu, obráťte sa na miesto, kde ste zakúpili tlačiareň. Tonerové kazety Lexmark MX532 pre program vrátenia Položka USA a Kanada Európsky hospodársky priestor, Island, Lichtenštajnsko a Nórsko Zvyšok Ázie a Tichomoria Latinská Amerika Zvyšok Európy, Blízky východ a Afrika Tonerová kazeta pre program vrátenia 66S1000 66S2000 66S3000 66S4000 66S5000 Tonerová kazeta s vysokou kapacitou pre program vrátenia 66S1H00 66S2H00 66S3H00 66S4H00 66S5H00 Bežné tonerové kazety Lexmark MX532 Položka Celý svet Bežná tonerová kazeta s vysokou kapacitou 66S0HA0 Tonerové kazety Lexmark MX632 pre program vrátenia Položka USA a Kanada Európsky hospodársky priestor, Island, Lichtenštajnsko a Nórsko Zvyšok Ázie a Tichomoria Latinská Amerika Zvyšok Európy, Blízky východ a Afrika Tonerová kazeta pre program vrátenia 66S1000 66S2000 66S3000 66S4000 66S5000 Tonerové kazety s mimoriadne vysokou kapacitou pre program vrátenia 66S1X00 66S2X00 66S3X00 66S4X00 66S5X00 Bežné tonerové kazety Lexmark MX632 Položka Celý svet Bežná tonerová kazeta s mimoriadne vysokou kapacitou 66S0XA0 Tonerové kazety Lexmark XM3350 pre program vrátenia Položka USA a Kanada Európsky hospodársky priestor, Island, Lichtenštajnsko a Nórsko Zvyšok sveta Tonerové kazety s mimoriadne vysokou kapacitou pre program vrátenia 24B7541 24B7542 24B7543 objednanie spotrebného materiálu tonerová kazeta tonerová kazeta objednávanie"},{"UUID":"fac4a8c0-f672-40ba-beb1-ecb694172896","title":"Objednávanie súčastí a spotrebného materiálu","link":"ordering-supplies-group.html","desc":"Objednanie tlačovej jednotky Dlhé obdobia","descFull":"Objednanie tlačovej jednotky Dlhé obdobia s mimoriadne malým objemom tlače môžu spôsobiť zlyhanie súčastí tlačovej jednotky ešte pred spotrebovaním tonera. Ak chcete objednať tlačovú jednotku, obráťte sa na miesto, kde ste zakúpili tlačiareň. Čísla položiek spotrebného materiálu a dielov tlačiarní Položka Číslo súčasti Bežná tlačová jednotka 66S0ZA0 tlačová jednotka objednávanie objednanie spotrebného materiálu tlačová jednotka"},{"UUID":"ea90adef-dd2d-42c6-9d44-108cd7a4abe1","title":"Výmena súčastí a spotrebného materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výmena tonerovej kazety Otvorte dvierka","descFull":"Výmena tonerovej kazety Otvorte dvierka A. Vyberte prázdnu tonerovú kazetu. Vybaľte novú tonerovú kazetu. Potraste novou tonerovou kazetou, aby sa toner rovnomerne rozložil. Vložte novú tonerovú kazetu. Zatvorte dvierka A. tonerová kazeta výmena výmena spotrebného materiálu tonerová kazeta"},{"UUID":"c1c34db6-8caf-469f-b5ee-ecaa9549d184","title":"Výmena súčastí a spotrebného materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výmena tlačovej jednotky Otvorte dvierka","descFull":"Výmena tlačovej jednotky Otvorte dvierka A. Vyberte tonerovú kazetu. Vyberte prázdnu tlačovú jednotku. Vybaľte novú tlačovú jednotku. Potraste tlačovou jednotkou, aby sa toner rovnomerne rozložil. Tlačovú jednotku nevystavujte priamemu svetlu na dlhšie ako 10 minút. Dlhšie vystavenie svetlu môže spôsobiť problémy s kvalitou tlače. Nedotýkajte sa fotovalca. Mohli by ste tým ovplyvniť kvalitu tlače budúcich tlačových úloh. Vložte novú tlačovú jednotku. Vložte tonerovú kazetu. Zatvorte dvierka A. tlačová jednotka výmena výmena spotrebného materiálu tlačová jednotka"},{"UUID":"7c9ed4af-9cbd-4d11-9961-a3c86501576c","title":"Výmena súčastí a spotrebného materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výmena kazety so spinkami Otvorte","descFull":"Výmena kazety so spinkami Otvorte prístupové dvierka zošívačky. Vyberte kazetu so spinkami. Odstráňte prázdnu náplň so spinkami. Vložte a zatlačte novú kazetu so spinkami, kým nezapadne na správne miesto. Vložte novú kazetu so spinkami a potom zatvorte prístupové dvierka zošívačky. Skontrolujte stav LED indikátora. Pohodlná zošívačka je pripravená na použitie, keď sa rozsvieti modré svetlo. doplnenie spiniek výmena výmena náplne so spinkami"},{"UUID":"117d6940-d1e6-4063-99d5-0706566f0679","title":"Výmena súčastí a spotrebného materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výmena zdroja napájania pohodlnej zošívačky","descFull":"Výmena zdroja napájania pohodlnej zošívačky Vypnite tlačiareň. Vytiahnite napájací kábel zo sieťovej zásuvky a potom z tlačiarne. Odpojte zdroj napájania z elektrickej zásuvky. Odstráňte kryt stĺpika a kábel zdroja napájania. Odstráňte pohodlnú zošívačku. Odstráňte použitý zdroj napájania. Vybaľte nový zdroj napájania. Vložte nový zdroj napájania cez tlačiareň a potom ho pripojte k pohodlnej zošívačke. Nainštalujte pohodlnú zošívačku. Správne umiestnite zdroj napájania. Pripojte kryt stĺpika. Správne zaistite zdroj napájania. Pripojte jeden koniec napájacieho kábla zošívačky do zdroja napájania a druhý do elektrickej zásuvky. Pripojte jeden koniec napájacieho kábla tlačiarne do tlačiarne a druhý do elektrickej zásuvky. Riziku požiaru alebo zásahu elektrickým prúdom sa vyhnete tak, že zapojíte napájací kábel do riadne označenej a správne uzemnenej elektrickej zásuvky, ktorá sa nachádza blízko produktu a je ľahko dostupná. Zapnite tlačiareň. zdroj napájania výmena výmena zdroja napájania"},{"UUID":"3b2cc205-e089-4784-9ec2-81327757f368","title":"Výmena súčastí a spotrebného materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výmena bezdrôtového tlačového servera ","descFull":"Výmena bezdrôtového tlačového servera  MarkNet  N8450 Ak pristupujete k riadiacej jednotke alebo inštalujete voliteľný hardvérový prvok či pamäťové zariadenie po inštalácii tlačiarne, tlačiareň vypnite a odpojte napájací kábel z elektrickej zásuvky, aby ste sa vyhli riziku zasiahnutia elektrickým prúdom. Ak sú k tlačiarni pripojené iné zariadenia, tiež ich vypnite a odpojte všetky káble, ktoré smerujú do tlačiarne. Táto úloha vyžaduje použitie plochého skrutkovača. Vypnite tlačiareň. Vytiahnite napájací kábel zo sieťovej zásuvky a potom z tlačiarne. Otvorte prístupový kryt riadiacej dosky. Elektronické súčasti riadiacej jednotky sa môžu ľahko poškodiť statickou elektrinou. Skôr ako sa dotknete akejkoľvek súčasti alebo konektora riadiacej dosky, dotknite sa kovového povrchu tlačiarne. Odstráňte kryt bezdrôtového tlačového servera. Vyberte faxovú kartu. Odstráňte použitý bezdrôtový tlačový server. Vybaľte nový bezdrôtový tlačový server. Vložte nový bezdrôtový tlačový server tak, aby s  kliknutím  zapadol na miesto. Vložte faxovú kartu a potom nasaďte skrutky. Pripojte kryt bezdrôtového tlačového servera a potom nasaďte skrutku. Zatvorte prístupový kryt riadiacej jednotky a potom nasaďte skrutku. Napájací kábel pripojte k tlačiarni a potom do elektrickej zásuvky. Riziku požiaru alebo zásahu elektrickým prúdom sa vyhnete tak, že zapojíte napájací kábel do riadne označenej a správne uzemnenej elektrickej zásuvky, ktorá sa nachádza blízko produktu a je ľahko dostupná. Zapnite tlačiareň. bezdrôtový tlačový server výmena výmena bezdrôtového tlačového servera Bezdrôtový tlačový server MarkNet N8450"},{"UUID":"e66b343e-a9fb-4551-9078-d03e14b48d32","title":"Výmena súčastí a spotrebného materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výmena vyzdvihovacích koliesok Vypnite tlačiareň.","descFull":"Výmena vyzdvihovacích koliesok Vypnite tlačiareň. Vytiahnite napájací kábel zo sieťovej zásuvky a potom z tlačiarne. Vyberte zásobník. Demontujte použité vyzdvihovacie kolieska. Vybaľte nové vyzdvihovacie kolieska. Vložte nové vyzdvihovacie kolieska. Vložte zásobník. Napájací kábel pripojte k tlačiarni a potom do elektrickej zásuvky. Riziku požiaru alebo elektrického šoku sa vyhnete tak, že zapojíte napájací kábel do riadne označenej a správne uzemnenej elektrickej zásuvky, ktorá sa nachádza blízko produktu a je ľahko dostupná. Zapnite tlačiareň. vyzdvihovacie kolieska výmena výmena súčastí vyzdvihovacie kolieska"},{"UUID":"d34aab8c-c5d4-4100-9f43-04c1d33e5a18","title":"Výmena súčastí a spotrebného materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výmena bloku skenovacieho skla Otvorte","descFull":"Výmena bloku skenovacieho skla Otvorte kryt skenera. Odstráňte použitý blok skenovacieho skla. Vybaľte nový blok skenovacieho skla. Zarovnajte nový blok skenovacieho skla so skenovacím sklom. Zatvorte kryt skenera, aby sa nový blok skenovacieho skla prilepil ku krytu. Otvorte kryt skenera. Zatlačením na blok skenovacieho skla ho upevnite. Zatvorte kryt skenera. blok skenovacieho skla výmena výmena súčastí blok skenovacieho skla"},{"UUID":"8372ca62-9038-4507-afaa-dea81317e6c6","title":"Výmena súčastí a spotrebného materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Výmena valcov automatického podávača dokumentov","descFull":"Výmena valcov automatického podávača dokumentov Otvorte dvierka C. Vyberte použitý podávací valec automatického podávača dokumentov. Odstráňte použitý oddeľovací valec automatického podávača dokumentov. Rozbaľte nový podávací a oddeľovací valec automatického podávača dokumentov. Vložte nový oddeľovací valec automatického podávača dokumentov tak, aby  s kliknutím  zapadol na miesto. Vložte nový podávací valec automatického podávača dokumentov tak, aby  s kliknutím  zapadol na miesto. Zatvorte dvierka C. výmena súčastí valce automatického podávača dokumentov valce automatického podávača dokumentov výmena výmena súčastí podávací valec automatického podávača dokumentov podávací valec automatického podávača dokumentov výmena výmena súčastí oddeľovací valec automatického podávača dokumentov oddeľovací valec automatického podávača dokumentov výmena"},{"UUID":"77294194-c8e4-4bea-a1e5-2c6ef7d49640","title":"Výmena súčastí a spotrebného materiálu","link":"replacing-toner-cartridge-topic.html","desc":"Obnovenie počítadiel používania spotrebného materiálu","descFull":"Obnovenie počítadiel používania spotrebného materiálu Na domovskej obrazovke sa dotknite položiek  Nastavenia Zariadenie Údržba Ponuka konfigurácie Počítadlá používania spotrebného materiálu . Vyberte počítadlo, ktoré chcete obnoviť. Spotrebný materiál a súčasti bez zmluvy o programe vrátenia môžu byť obnovené a repasované. Záruka výrobcu sa však nevzťahuje na škody spôsobené neoriginálnymi spotrebnými materiálmi alebo súčasťami. Obnovenie nastavenia počítadiel pre spotrebný materiál alebo súčasti bez správneho repasovania môže poškodiť tlačiareň. Po obnovení nastavení počítadla spotrebného materiálu alebo súčastí môže tlačiareň zobrazovať chybové hlásenie, ktoré označuje prítomnosť obnovenej položky. Spotrebný materiál a súčasti bez zmluvy o programe používania a vrátenia môžu byť obnovené a repasované. Záruka výrobcu sa však nevzťahuje na škody spôsobené neoriginálnymi spotrebnými materiálmi alebo súčasťami. Obnovenie nastavenia počítadiel pre spotrebný materiál alebo súčasti bez správneho repasovania môže poškodiť tlačiareň. Po obnovení nastavení počítadla spotrebného materiálu alebo súčastí môže tlačiareň zobrazovať chybové hlásenie, ktoré označuje prítomnosť obnovenej položky. počítadlá používania spotrebného materiálu obnovenie obnovenie počítadiel používania spotrebného materiálu"},{"UUID":"3188beb1-831b-436d-82cd-ec170268b17f","title":"Čistenie súčastí tlačiarne","link":"cleaning-printer-topic.html","desc":"Čistenie tlačiarne Skôr než budete","descFull":"Čistenie tlačiarne Skôr než budete pokračovať, odpojte napájací kábel zo zásuvky a z tlačiarne odpojte všetky káble, aby ste sa pri čistení vonkajších častí tlačiarne vyhli zasiahnutiu elektrickým prúdom. Tento postup vykonajte každých pár mesiacov. Záruka tlačiarne nekryje poškodenie tlačiarne spôsobené nesprávnym zaobchádzaním. Vypnite tlačiareň a potom z elektrickej zásuvky odpojte napájací kábel. Vyberte papier zo štandardnej priehradky a z viacúčelového podávača. Pomocou jemnej kefky alebo vysávača odstráňte prach, smietky a kúsky papiera okolo tlačiarne. Utrite povrch tlačiarne navlhčenou mäkkou tkaninou, ktorá nepúšťa vlákna. Nepoužívajte čistiace prostriedky ani saponáty, pretože by mohli poškodiť povrch tlačiarne. Uistite sa, že po vyčistení sú všetky časti tlačiarne suché. Zapojte napájací kábel do elektrickej zásuvky a zapnite tlačiareň. Riziku požiaru alebo elektrického šoku sa vyhnete tak, že zapojíte napájací kábel do riadne označenej a správne uzemnenej elektrickej zásuvky, ktorá sa nachádza blízko produktu a je ľahko dostupná. čistenie tlačiarne čistenie vnútorné časti tlačiarne čistenie vonkajšie časti tlačiarne"},{"UUID":"ca0b60a1-bc87-44df-8c25-f6caeba2fc8e","title":"Čistenie súčastí tlačiarne","link":"cleaning-printer-topic.html","desc":"Čistenie dotykovej obrazovky Skôr než","descFull":"Čistenie dotykovej obrazovky Skôr než budete pokračovať, odpojte napájací kábel zo zásuvky a z tlačiarne odpojte všetky káble, aby ste sa pri čistení vonkajších častí tlačiarne vyhli zasiahnutiu elektrickým prúdom. Vypnite tlačiareň a potom z elektrickej zásuvky odpojte napájací kábel. Navlhčenou mäkkou handričkou, z ktorej sa neuvoľňujú vlákna, utrite dotykovú obrazovku. Nepoužívajte čistiace prostriedky ani saponáty, pretože by mohli poškodiť dotykovú obrazovku. Po čistení sa uistite, že je dotyková obrazovka suchá. Zapojte napájací kábel do elektrickej zásuvky a zapnite tlačiareň. Riziku požiaru alebo elektrického šoku sa vyhnete tak, že zapojíte napájací kábel do riadne označenej a správne uzemnenej elektrickej zásuvky, ktorá sa nachádza blízko produktu a je ľahko dostupná. dotyková obrazovka čistenie čistenie dotykovej obrazovky"},{"UUID":"1415bfa3-3992-4e85-aa2e-f67c624ddf36","title":"Čistenie súčastí tlačiarne","link":"cleaning-printer-topic.html","desc":"Čistenie skenera Otvorte kryt skenera.","descFull":"Čistenie skenera Otvorte kryt skenera. Navlhčenou mäkkou handričkou, z ktorej sa neuvoľňujú vlákna, utrite nasledujúce časti: Skenovací blok skla automatického podávača dokumentov Blok skenovacieho skla Sklo automatického podávača dokumentov Skenovacie sklo Zatvorte kryt skenera. Otvorte dvierka C. Navlhčenou mäkkou handričkou, z ktorej sa neuvoľňujú vlákna, utrite nasledujúce časti: Skenovací blok skla automatického podávača dokumentov v dvierkach C Sklo automatického podávača dokumentov v dvierkach C Zatvorte dvierka C. skener čistenie čistenie skenera"},{"UUID":"4e404310-87d4-459a-b75a-5f5119172580","title":"Čistenie súčastí tlačiarne","link":"cleaning-printer-topic.html","desc":"Čistenie valcov automatického podávača dokumentov","descFull":"Čistenie valcov automatického podávača dokumentov Otvorte dvierka C. Odstráňte podávací valec automatického podávača dokumentov. Odstráňte oddeľovací valec automatického podávača dokumentov. Naneste izopropylalkohol na mäkkú handričku, z ktorej sa neuvoľňujú vlákna, a utrite ňou podávací a oddeľovací valec automatického podávača dokumentov. Vložte nový oddeľovací valec automatického podávača dokumentov tak, aby  s kliknutím  zapadol na miesto. Vložte podávací valec automatického podávača dokumentov tak, aby  s kliknutím  zapadol na miesto. Zatvorte dvierka C. čistenie podávacieho valca automatického podávača dokumentov podávací valec automatického podávača dokumentov čistenie čistenie oddeľovacieho valca automatického podávača dokumentov oddeľovací valec automatického podávača dokumentov čistenie čistenie valcov automatického podávača dokumentov valce automatického podávača dokumentov čistenie"},{"UUID":"35a1cd73-eb10-4d25-9042-0a862a7c903f","title":"Úspora energie a papiera","link":"configuring-power-save-mode-settings-topic.html","desc":"Konfigurácia nastavení režimu úspory energie","descFull":"Konfigurácia nastavení režimu úspory energie režim spánku Na domovskej obrazovke sa dotknite položky  Nastavenia Zariadenie Správa napájania Časové limity Režim spánku . Zadajte dĺžku nečinnosti pred prepnutím tlačiarne do  režimu spánku . režim dlhodobého spánku Na domovskej obrazovke sa dotknite položky  Nastavenia Zariadenie Správa napájania Časové limity Časový limit dlhodobého spánku Vyberte dĺžku nečinnosti pred prepnutím tlačiarne do režimu dlhodobého spánku. Aby funkcia  Časový limit dlhodobého spánku  fungovala, nastavte položku  Časový limit dlhodobého spánku pri pripojení  na možnosť  Prejsť do režimu dlhodobého spánku . Funkcia Embedded Web Server je počas režimu  Dlhodobý spánok  vypnutá. režim spánku konfigurácia režim dlhodobého spánku konfigurácia ekologické nastavenia režimy úspory energie konfigurácia"},{"UUID":"2641615b-1281-4820-93cb-bee8996d8de1","title":"Úspora energie a papiera","link":"configuring-power-save-mode-settings-topic.html","desc":"Úprava jasu displeja Na domovskej","descFull":"Úprava jasu displeja Na domovskej obrazovke sa dotknite položky  Nastavenia Zariadenie Predvoľby . V ponuke  Jas displeja  upravte toto nastavenie. jas displeja nastavenie nastavenie jasu displeja"},{"UUID":"d2f6fd2b-7afe-4743-b18f-c910679f6994","title":"Úspora energie a papiera","link":"configuring-power-save-mode-settings-topic.html","desc":"Úspora spotrebného materiálu Tlačte na","descFull":"Úspora spotrebného materiálu Tlačte na obe strany papiera. Obojstranná tlač je v ovládači tlačiarne nastavená predvolene. Tlačte viacero stránok na jeden hárok papiera. Používajte funkciu náhľadu, aby ste ešte pred tlačou videli, ako bude dokument vyzerať. Vytlačte jednu kópiu dokumentu, aby ste mohli skontrolovať presnosť jej obsahu a formátu. úspora spotrebného materiálu spotrebný materiál úspora"},{"UUID":"24e3f224-1616-4caa-a6b6-82cc3cf72209","title":"Údržba tlačiarne","link":"moving-printer-topic.html","desc":"Premiestnenie tlačiarne na iné miesto","descFull":"Premiestnenie tlačiarne na iné miesto Premiestnenie tlačiarne na iné miesto Ak je hmotnosť tlačiarne väčšia ako 20 kg (44 libier), na jej bezpečné zdvihnutie môžu byť potrebné dve alebo viaceré osoby. Riziku požiaru a zásahu elektrickým prúdom sa vyhnete tak, že budete používať len napájací kábel dodaný s týmto produktom alebo náhradu schválenú výrobcom. Keď premiestňujete tlačiareň, dodržte nasledujúce pokyny, aby ste zabránili úrazu a poškodeniu tlačiarne: Skontrolujte, či sú zavreté všetky dvierka a zásobníky. Vypnite tlačiareň a potom z elektrickej zásuvky odpojte napájací kábel. Z tlačiarne odpojte všetky káble. Ak sú k tlačiarni pripojené samostatne stojace voliteľné zásobníky alebo výstupné voliteľné prvky, pred presunom tlačiarne ich odpojte. Ak má tlačiareň základňu na kolieskach, opatrne ju posuňte na nové miesto. Dávajte pozor pri prechode cez prahy dverí a nerovnosti na podlahe. Ak tlačiareň nemá základňu na kolieskach, ale používa voliteľné zásobníky alebo výstupné voliteľné prvky, odoberte výstupné voliteľné prvky a tlačiareň zdvihnite bez zásobníkov. Nedvíhajte tlačiareň zároveň s voliteľnými prvkami. Na zdvihnutie tlačiarne vždy použite držadlá na tlačiarni. Ak na premiestnenie tlačiarne používate vozík, musí mať povrch, ktorý bude podopierať celú tlačiareň. Ak na prenos hardvérových voliteľných prvkov používate vozík, musí mať povrch, ktorý bude podopierať celé hardvérové voliteľné prvky. Tlačiareň prenášajte v zvislej polohe. Nerobte s ňou prudké a náhle pohyby. Pri ukladaní tlačiarne dávajte pozor, aby ste pod ňou nemali prsty. Skontrolujte, či je okolo tlačiarne dostatok voľného miesta. Záruka tlačiarne sa nevzťahuje na poškodenie tlačiarne spôsobené nesprávnym zaobchádzaním pri premiestňovaní. premiestnenie tlačiarne"},{"UUID":"46c1c8d8-14a3-4b80-96c5-80f1ac5f659a","title":"Údržba tlačiarne","link":"shipping-printer-topic.html","desc":"Doprava tlačiarne Pokyny o doprave","descFull":"Doprava tlačiarne Pokyny o doprave získate na adrese  https://support.lexmark.com  alebo kontaktovaním podpory pre zákazníkov. Pri preprave tlačiarne použite pôvodné balenie alebo sa obráťte na predajcu vašej tlačiarne. tlačiareň preprava preprava tlačiarne"},{"UUID":"c602703e-978a-40c5-a41d-1ca21f151170","title":"Riešenie problémov","link":"print-quality-problems-picker-topic.html","desc":"Problémy s kvalitou tlače Nájdite","descFull":"Problémy s kvalitou tlače Nájdite obrázok, ktorý pripomína váš problém s kvalitou tlače, kliknite na odkaz nižšie a prečítajte si kroky na vyriešenie problému. problémy s kvalitou tlače riešenie problémov problémy s kvalitou tlače riešenie problémov s tlačou problémy s kvalitou tlače"},{"UUID":"3b357009-2885-4f05-a25c-57b2a6f3f40f","title":"Riešenie problémov","link":"printer-error-codes-topic.html","desc":"Chybové kódy tlačiarne Chybové kódy","descFull":"Chybové kódy tlačiarne Chybové kódy a ako ich vyriešiť Chybové kódy Chybové hlásenie Riešenie 8,01 Zatvorte predné dvierka A. Všetky dvierka nechajte zatvorené, pokiaľ nevykonávate údržbu. 9.00 Tlačiareň sa musela reštartovať. Posledná úloha sa nemusela dokončiť. Dotknite sa tlačidla  Pokračovať , čím správu vymažete a tlač bude pokračovať. 11,11, 11,21, 11,31, 11,41 Vložte <source/> s <type/> <size/>. Otvorte označený zásobník a potom vložte papier. Ďalšie informácie nájdete v časti  . 11,12, 11,22, 11,32, 11,42 Vložte <source/> s <type/> <size/> <orientation/>. 11.91 Do viacúčelového podávača vložte <type/> <size/>. Otvorte viacúčelový podávač a potom vložte papier. Ďalšie informácie nájdete v časti  . 11.92 Do viacúčelového podávača vložte <type/> <size/> <orientation/>. 12,11, 12,21, 12,31, 12,41 Zmeňte <source/> na <type/> <size/>. Otvorte označený zásobník, vyberte papier a potom vložte správny typ a veľkosť papiera. Ďalšie informácie nájdete v časti  . 12,12, 12,22, 12,32, 12,42 Zmeňte <source/> na <type/> <size/> <orientation/>. 12.91 Zmeňte viacúčelový podávač na <type/> <size/>. Odstráňte papier a potom vložte správny typ a veľkosť papiera. Ďalšie informácie nájdete v časti  . 12.92 Zmeňte viacúčelový podávač na <type/> <size/> <orientation/>. 29.08 Odstráňte obalový materiál. Otvorte dvierka A. Vyberte tonerovú kazetu. Vyberte tlačovú jednotku. Odstráňte baliaci materiál. Jednotku fotovalca nevystavujte priamemu svetlu na dlhšie ako 10 minút. Dlhšie vystavenie svetlu môže spôsobiť problémy s kvalitou tlače. Nedotýkajte sa lesklého fotovalca pod tlačovou jednotkou. Mohli by ste tým ovplyvniť kvalitu tlače budúcich tlačových úloh. Vložte tlačovú jednotku. Vložte tonerovú kazetu. Zatvorte dvierka A. Vyberte všetky zásobníky a potom odstráňte všetok obalový materiál. Vložte všetky zásobníky. 31.40z Znova nainštalujte chýbajúcu alebo nereagujúcu kazetu. Otvorte dvierka A. Vyberte tonerovú kazetu. Vložte tonerovú kazetu. Zatvorte dvierka A. 31.60z Znova nainštalujte chýbajúcu alebo nereagujúcu tlačovú jednotku. Otvorte dvierka A. Vyberte tonerovú kazetu. Vyberte tlačovú jednotku. Jednotku fotovalca nevystavujte priamemu svetlu na dlhšie ako 10 minút. Dlhšie vystavenie svetlu môže spôsobiť problémy s kvalitou tlače. Nedotýkajte sa lesklého fotovalca pod tlačovou jednotkou. Mohli by ste tým ovplyvniť kvalitu tlače budúcich tlačových úloh. Vložte tlačovú jednotku. Vložte tonerovú kazetu. Zatvorte dvierka A. 32.40z Vymeňte nepodporovanú kazetu. Pozrite si časť  . 32.60z Vymeňte nepodporovanú tlačovú jednotku. Pozrite si časť  . 33,40 Kazeta od iného výrobcu ako spoločnosť Lexmark, pozrite si používateľskú príručku. Pozrite si časť  . 33.60 Tlačová jednotka od iného výrobcu ako spoločnosť Lexmark, pozrite si používateľskú príručku. 37.1 Nedostatok pamäte na zoradenie úlohy. Vyskúšajte jedno alebo viaceré z nasledujúcich riešení: Ak chcete vytlačiť časť úlohy, ktorá je uložená, a začať zoraďovať zvyšok tlačovej úlohy, dotknite sa položky  Pokračovať . Zrušte aktuálnu tlačovú úlohu. 37.3 Nedostatok pamäte, niektoré pozastavené úlohy boli odstránené. Dotknite sa tlačidla  Pokračovať , čím správu vymažete a tlač bude pokračovať. 38,1 Pamäť je plná. Vyskúšajte jedno alebo viaceré z nasledujúcich riešení: Dotknite sa položky  Zrušiť úlohu , čím sa hlásenie odstráni. Dokument vytlačte po častiach alebo ho odošlite do inej tlačiarne. Nainštalujte ďalšiu pamäť tlačiarne. 39.1 Zložitá stránka, niektoré údaje sa nemuseli vytlačiť. Vyskúšajte jedno alebo viaceré z nasledujúcich riešení: Dotknite sa tlačidla  Pokračovať , čím správu vymažete a tlač bude pokračovať. Zrušte aktuálnu tlačovú úlohu. Nainštalujte ďalšiu pamäť tlačiarne. Pred opätovným odoslaním tlačovej úlohy na tlač znížte jej zložitosť a veľkosť. Znížte počet stránok v tlačovej úlohe. Znížte počet a veľkosť prevzatých písiem. Z tlačovej úlohy odstráňte všetky nepotrebné písma alebo makrá. Znížte počet grafických prvkov v tlačovej úlohe. 42.yy Vymeňte kazetu, región tlačiarne sa nezhoduje. Pozrite si časť  . 43.40z Znova vložte kazetu. Pozrite si časť  . 44.40 Vymeňte kazetu, tlačiareň sa nezhoduje. Pozrite si časť  . 55.1 Chyba pri čítaní jednotky USB. Odstráňte jednotku USB. Ak chcete pokračovať, odstráňte jednotku flash. 55.2 Chyba pri čítaní z rozbočovača USB. Odstráňte rozbočovač. Ak chcete pokračovať, odstráňte rozbočovač USB. 58 Je pripojených príliš veľa zásobníkov. Podporovať sa môže len <x/> zásobník/zásobníkov. Vypnite tlačiareň a potom z elektrickej zásuvky odpojte napájací kábel. Odstráňte jeden alebo viac zásobníkov. Zapojte napájací kábel do elektrickej zásuvky a zapnite tlačiareň. Riziku požiaru alebo zásahu elektrickým prúdom sa vyhnete tak, že zapojíte napájací kábel do riadne označenej a správne uzemnenej elektrickej zásuvky, ktorá sa nachádza blízko produktu a je ľahko dostupná. 59 Nekompatibilný zásobník [x] Vypnite tlačiareň a potom z elektrickej zásuvky odpojte napájací kábel. Vyberte označený zásobník. Zapojte napájací kábel do elektrickej zásuvky a zapnite tlačiareň. Riziku požiaru alebo zásahu elektrickým prúdom sa vyhnete tak, že zapojíte napájací kábel do riadne označenej a správne uzemnenej elektrickej zásuvky, ktorá sa nachádza blízko produktu a je ľahko dostupná. 61 Odpojte chybný disk. Vymeňte poškodený úložný disk. 62 Disk je plný. Vyskúšajte jedno alebo viaceré z nasledujúcich riešení: Dotknite sa položky  Pokračovať , čím sa hlásenie odstráni. Vymažte údaje o písmach, makrách a ďalšie údaje uložené na disku s inteligentným ukladaním. Nainštalujte disk s inteligentným ukladaním. 63 Formátovať disk. Formátovaním sa teraz vymažú všetky informácie z pamäťového disku. Ak chcete disk formátovať, postupujte takto: Na domovskej obrazovke sa dotknite položiek  Nastavenia Zariadenie Údržba Vymazanie mimo prevádzky. Dotknite sa položky  Ošetriť všetky informácie na pevnom disku  alebo  Vymazať disk s inteligentným ukladaním  potom sa dotknite položky  VYMAZAŤ . 71.01 Nie je nastavený názov faxového zariadenia. Obráťte sa na správcu systému. Pozrite si časť  . 71.02 Nie je nastavené číslo faxového zariadenia. Obráťte sa na správcu systému. 71.03 K modemu nie je pripojená žiadna analógová telefónna linka, fax je vypnutý. Skontrolujte linku, či je pripojená a má signál. Ďalšie informácie nájdete v časti  . 71.06 So serverom faxu HTTPS sa nedá spojiť Pripojenie k faxovému serveru HTTPS sa prerušilo. Skontrolujte internetové pripojenie tlačiarne. 71.12 Pamäť je plná, nemožno tlačiť faxy. Dotknite sa položky  Vytlačiť všetko  vytlačte maximum uložených faxov. 71.13 Pamäť je plná. Faxy sa nedajú odosielať. Vyskúšajte jedno alebo viaceré z nasledujúcich riešení: Pokračujte a skúste fax odoslať znovu. Naskenujte originál dokumentu po jednotlivých stranách, vytočte faxové číslo a potom naskenujte dokument. 71,4 Nesprávny čas tlačiarne. Ak chcete nastaviť správny čas tlačiarne, postupujte takto: Dotknite sa položiek  Nastavenia Zariadenie Predvoľby Dotknite sa položky  Dátum a čas  a potom nastavte správny čas. 72.01 E-mailový server SMTP nie je nastavený. Obráťte sa na správcu systému. Vyskúšajte jednu z týchto možností: Nastavte si funkciu e-mailu. Ďalšie informácie nájdete v časti  . Vypnite chybové hlásenie. Ďalšie informácie nájdete v časti  . 80,01, 80,03, 80,09 Súprava na údržbu je takmer prázdna. Dotknite sa položky  Pokračovať , čím sa hlásenie odstráni. 80,11, 80,13, 80,19 Úroveň súpravy na údržbu je nízka. 80,21, 80,23, 80,29 Úroveň súpravy na údržbu je veľmi nízka. 84,00, 84,01, 84,02, 84,03, 84,09 Úroveň naplnenia tlačovej jednotky je takmer nízka. Dotknite sa položky  Pokračovať , čím sa hlásenie odstráni. 84.11, 84.12, 84.13, 84.19 Úroveň naplnenia tlačovej jednotky je nízka. 84.21, 84.22, 84.23, 84.29 Úroveň naplnenia tlačovej jednotky je veľmi nízka. 84.31, 84.32, 84.33 Vymeňte tlačovú jednotku, odporúčaná doba životnosti uplynula. Pozrite si časť  . 84.41, 84.42, 84.43 Ak chcete pokračovať v tlači, vymeňte tlačovú jednotku. 88.00, 88.08, 88.09 Úroveň naplnenia kazety je takmer nízka. Dotknite sa položky  Pokračovať , čím sa hlásenie odstráni. 88.10, 88.18, 88.19 Úroveň naplnenia kazety je nízka. 88.20, 88.28, 88.29 Úroveň naplnenia kazety je veľmi nízka. 88,30, 88,38 Vymeňte kazetu, odhadovaný počet zostávajúcich strán je <num/>. Pozrite si časť  . 88,30, 88,38 Vymeňte kazetu. 88.40, 88.48 Vymeňte kazetu, zostáva 0 strán. 200,03 Zaseknutie papiera, [hlavička zaseknutia]. [xxx.yy] Pozrite si časť  . 200.04, 200.05, 200.14, 200.24, 200.25, 200.34, 200.35, 200.44, 200.45, 202.05, 202.15, 202.25, 202.35, 202.45, 230.03, 230.13, 230.23, 230.33, 230.43 Zaseknutie papiera, [hlavička zaseknutia]. [xxx.yy] Pozrite si časť  . 200.12, 200.15, 200.22, 200.32, 200.33, 200.42, 200.91, 202.03, 200.13, 202.33, 202.43, 202.93 Zaseknutie papiera, [hlavička zaseknutia]. [xxx.yy] Pozrite si časť  . 200,13, 200,23, 200,33, 200,43, 241,86 Zaseknutie papiera, [hlavička zaseknutia]. [xxx.yy] Pozrite si časť  . 230,15, 230,25, 230,33, 230,45, 232,13, 232,23, 232,33, 232,43, 232,53, 232,93 Zaseknutie papiera, [hlavička zaseknutia]. [xxx.yy] Pozrite si časť  . 24x.x6, 24x.8y, 602.x9 66x.x3, 66x.8y Chyba pri vkladaní papiera, [hlavička zaseknutia]. [xxx.yy] Pozrite si časť  . 280.11, 280.13, 280.15, 280.91, 280.93, 280.95, 284.11, 284.13, 284.15, 284.91, 284.93, 284.95, 295.01, 680.10, 680.20, 680.40 Zaseknutie skenera. [xxx.yy] Pozrite si časť  . chybové kódy tlačiarne chybové kódy chybové hlásenia tlačiarne chybové hlásenia"},{"UUID":"e617547e-84dc-4991-8ff6-f3c10bb515d8","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Prázdne alebo biele strany Skôr","descFull":"Prázdne alebo biele strany Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov  Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta od spoločnosti Lexmark. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta. Ak kazeta nie je podporovaná, nainštalujte podporovanú kazetu. Vytlačte dokument. Tlačí tlačiareň prázdne alebo biele strany? Problém je vyriešený. Odstráňte zvyšky baliaceho materiálu na tlačovej jednotke. Vyberte z tlačiarne tonerovú kazetu a potom tlačovú jednotku. Tlačovú jednotku nevystavujte priamemu svetlu na dlhšie ako 10 minút. Dlhšie vystavenie svetlu môže spôsobiť problémy s kvalitou tlače. Nedotýkajte sa fotovalca pod tlačovou jednotkou. Mohli by ste tým ovplyvniť kvalitu tlače budúcich tlačových úloh. Skontrolujte, či tlačová jednotka nie je poškodená a v prípade potreby ju vymeňte. Skontrolujte, či kontakt fotovalca nie je ohnutý alebo mimo svoje miesto. Poriadne zatraste tlačovou jednotkou, aby sa toner rovnomerne rozložil. Vložte tlačovú jednotku a potom vložte tonerovú kazetu. Vytlačte dokument. Tlačí tlačiareň prázdne alebo biele strany? Problém je vyriešený. Skontrolujte stav tonerovej kazety a v prípade potreby ju vymeňte. Na domovskej obrazovke sa dotknite položky  Stav/spotrebný materiál Spotrebný materiál . Vytlačte dokument. Tlačí tlačiareň prázdne alebo biele strany? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s kvalitou tlače prázdne strany problém s kvalitou tlače biele strany biele strany prázdne strany"},{"UUID":"c85a336c-d548-4c28-aa3d-11189d25ba66","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Tmavá tlač Skôr než sa","descFull":"Tmavá tlač Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta od spoločnosti Lexmark. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta. Ak kazeta nie je podporovaná, nainštalujte podporovanú kazetu. Vytlačte dokument. Je výtlačok tmavý? Problém je vyriešený. Tlačiareň vypnite, počkajte 10 sekúnd a potom ju znova zapnite. Znížte tmavosť tonera. Na domovskej obrazovke sa dotknite položiek  Nastavenia Tlač Kvalita Tmavosť tonera . Vytlačte dokument. Je výtlačok tmavý? Problém je vyriešený. Špecifikujte typ papiera v dialógovom okne Predvoľby tlače alebo Tlač v závislosti od používaného operačného systému. Uistite sa, že nastavenie zodpovedá vloženému papieru. Nastavenie môžete zmeniť aj prostredníctvom ovládacieho panela tlačiarne. Na domovskej obrazovke sa dotknite položiek  Nastavenia Papier Konfigurácia zásobníkov Veľkosť/typ papiera . Vytlačte dokument. Je výtlačok tmavý? Problém je vyriešený. Skontrolujte, či papier nemá textúrovaný alebo drsný povrch. Tlačíte na textúrovaný alebo drsný papier? Prejdite na krok 6. Textúrovaný papier nahraďte obyčajným papierom. Vytlačte dokument. Je výtlačok tmavý? Problém je vyriešený. Vložte papier z nového balíka. Pri vysokej vlhkosti papier absorbuje vlhko. Papier vyberte z pôvodného balenia, až keď ho budete chcieť použiť. Vytlačte dokument. Je výtlačok tmavý? Problém je vyriešený. Vyberte a znova vložte tlačovú jednotku. Tlačovú jednotku nevystavujte priamemu svetlu na dlhšie ako 10 minút. Dlhšie vystavenie svetlu môže spôsobiť problémy s kvalitou tlače. Nedotýkajte sa fotovalca pod tlačovou jednotkou. Mohli by ste tým ovplyvniť kvalitu tlače budúcich tlačových úloh. Vytlačte dokument. Je výtlačok tmavý? Problém je vyriešený. Vymeňte tlačovú jednotku. Vytlačte dokument. Je výtlačok tmavý? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s kvalitou tlače tmavá tlač tmavá tlač"},{"UUID":"6ce90373-267d-42d3-a080-c20670a692e4","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Jemné čiary nie sú vytlačené","descFull":"Jemné čiary nie sú vytlačené správne Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta od spoločnosti Lexmark. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta. Ak kazeta nie je podporovaná, nainštalujte podporovanú kazetu. Vytlačte dokument. Sú jemné čiary vytlačené správne? Problém je vyriešený. Upravte nastavenia kvality tlače. Na domovskej obrazovke sa dotknite položiek  Nastavenia Tlač Kvalita Zvýšenie počtu pixelov Písma . Nastavte tmavosť tonera na hodnotu 7. Na domovskej obrazovke sa dotknite položiek  Nastavenia Tlač Kvalita Tmavosť tonera . Vytlačte dokument. Sú jemné čiary vytlačené správne? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . problém s kvalitou tlače jemné čiary nie sú vytlačené správne jemné čiary nie sú vytlačené správne"},{"UUID":"9a383209-5b34-427a-8662-8a1ac9f4e614","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Ohnutý alebo zdeformovaný papier Skôr","descFull":"Ohnutý alebo zdeformovaný papier Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta od spoločnosti Lexmark. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta. Ak kazeta nie je podporovaná, nainštalujte podporovanú kazetu. Vytlačte dokument. Je papier ohnutý alebo zdeformovaný? Problém je vyriešený. Vložte papier z nového balíka. Pri vysokej vlhkosti papier absorbuje vlhko. Papier vyberte z pôvodného balenia, až keď ho budete chcieť použiť. Vytlačte dokument. Je papier ohnutý alebo zdeformovaný? Problém je vyriešený. Špecifikujte typ papiera v dialógovom okne Predvoľby tlače alebo Tlač v závislosti od používaného operačného systému. Uistite sa, že nastavenie zodpovedá vloženému papieru. Nastavenie môžete zmeniť aj prostredníctvom ovládacieho panela tlačiarne. Na domovskej obrazovke sa dotknite položiek  Nastavenia Papier Konfigurácia zásobníkov Veľkosť/typ papiera . Vytlačte dokument. Je papier ohnutý alebo zdeformovaný? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s kvalitou tlače ohnutý papier problém s kvalitou tlače zdeformovaný papier ohnutý papier zdeformovaný papier"},{"UUID":"01446abd-fd26-40cd-bca2-73cbcca8e5ca","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Sivé pozadie Skôr než sa","descFull":"Sivé pozadie Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Tlačiareň vypnite, počkajte 10 sekúnd a potom ju znova zapnite. Znížte tmavosť tonera. Na domovskej obrazovke sa dotknite položiek  Nastavenia Tlač Kvalita Tmavosť tonera . Vytlačte dokument. Objavuje sa na výtlačkoch sivé pozadie? Problém je vyriešený. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta od spoločnosti Lexmark. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta. Ak kazeta nie je podporovaná, nainštalujte podporovanú kazetu. Vytlačte dokument. Objavuje sa na výtlačkoch sivé pozadie? Problém je vyriešený. Špecifikujte typ papiera v dialógovom okne Predvoľby tlače alebo Tlač v závislosti od používaného operačného systému. Uistite sa, že nastavenie zodpovedá vloženému papieru. Nastavenie môžete zmeniť aj prostredníctvom ovládacieho panela tlačiarne. Na domovskej obrazovke sa dotknite položiek  Nastavenia Papier Konfigurácia zásobníkov Veľkosť/typ papiera . Vytlačte dokument. Objavuje sa na výtlačkoch sivé pozadie? Problém je vyriešený. Vyberte a znova vložte tlačovú jednotku. Nevystavujte tlačovú jednotku priamemu svetlu. Dlhšie vystavenie svetlu môže spôsobiť problémy s kvalitou tlače. Nedotýkajte sa fotovalca. Mohli by ste tým ovplyvniť kvalitu tlače budúcich tlačových úloh. Vytlačte dokument. Objavuje sa na výtlačkoch sivé pozadie? Problém je vyriešený. Aktualizujte firmvér tlačiarne. Ďalšie informácie nájdete v časti  . Vytlačte dokument. Objavuje sa na výtlačkoch sivé pozadie? Problém je vyriešený. Vymeňte tlačovú jednotku. Vytlačte dokument. Objavuje sa na výtlačkoch sivé pozadie? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s kvalitou tlače sivé pozadie na výtlačkoch sivé pozadie na výtlačkoch"},{"UUID":"13189a7d-21a8-4ea7-8486-668a59386366","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Nesprávne okraje Nesprávne okraje Skôr","descFull":"Nesprávne okraje Nesprávne okraje Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Upravte vodiace lišty papiera v zásobníku do správnej polohy pre vložený papier. Vytlačte dokument. Sú okraje správne? Problém je vyriešený. Špecifikujte veľkosť papiera v dialógovom okne Predvoľby tlače alebo Tlač v závislosti od používaného operačného systému. Uistite sa, že nastavenie zodpovedá vloženému papieru. Nastavenie môžete zmeniť aj prostredníctvom ovládacieho panela tlačiarne. Na domovskej obrazovke sa dotknite položiek  Nastavenia Papier Konfigurácia zásobníkov Veľkosť/typ papiera . Vytlačte dokument. Sú okraje správne? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . nesprávne okraje problém s kvalitou tlače nesprávne okraje"},{"UUID":"4d5c4951-e73f-4a8a-bbed-33af82f28288","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Svetlá tlač Skôr než sa","descFull":"Svetlá tlač Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta od spoločnosti Lexmark. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta. Ak kazeta nie je podporovaná, nainštalujte podporovanú kazetu. Vytlačte dokument. Je tlač svetlá? Problém je vyriešený. Tlačiareň vypnite, počkajte 10 sekúnd a potom ju znova zapnite. Zvýšte tmavosť tonera. Na domovskej obrazovke sa dotknite položiek  Nastavenia Tlač Kvalita Tmavosť tonera . Vytlačte dokument. Je tlač svetlá? Problém je vyriešený. Špecifikujte typ papiera v dialógovom okne Predvoľby tlače alebo Tlač v závislosti od používaného operačného systému. Uistite sa, že nastavenie zodpovedá vloženému papieru. Nastavenie môžete zmeniť aj prostredníctvom ovládacieho panela tlačiarne. Na domovskej obrazovke sa dotknite položiek  Nastavenia Papier Konfigurácia zásobníkov Veľkosť/typ papiera . Vytlačte dokument. Je tlač svetlá? Problém je vyriešený. Špecifikujte rozlíšenie tlače v dialógovom okne Predvoľby tlače alebo Tlač v závislosti od používaného operačného systému. Nastavte rozlíšenie na  600 dpi . Vytlačte dokument. Je tlač svetlá? Problém je vyriešený. Vyberte tlačovú jednotku. Nevystavujte tlačovú jednotku priamemu svetlu. Dlhšie vystavenie svetlu môže spôsobiť problémy s kvalitou tlače. Nedotýkajte sa fotovalca. Mohli by ste tým ovplyvniť kvalitu tlače budúcich tlačových úloh. Poriadne zatraste tlačovou jednotkou, aby sa toner rovnomerne rozložil. Vložte tlačovú jednotku. Tlačiareň vypnite, počkajte 10 sekúnd a potom ju znova zapnite. Vytlačte dokument. Je tlač svetlá? Problém je vyriešený. Skontrolujte stav tonerovej kazety. Na domovskej obrazovke sa dotknite položiek  Nastavenia Správy Zariadenie Štatistiky zariadenia . V časti Informácie o spotrebnom materiáli na vytlačených stranách skontrolujte stav tonerovej kazety. Blíži sa koniec životnosti tonerovej kazety? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Vymeňte tonerovú kazetu. Vytlačte dokument. Je tlač svetlá? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s kvalitou tlače svetlá tlač svetlá tlač"},{"UUID":"78257c8a-72af-47a3-bf97-d38abe724dec","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Roztečená tlač a bodky Skôr než","descFull":"Roztečená tlač a bodky Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta od spoločnosti Lexmark. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta. Ak kazeta nie je podporovaná, nainštalujte podporovanú kazetu. Vytlačte dokument. Je tlač roztečená? Problém je vyriešený. Skontrolujte, či sa v tlačiarni nenachádza vytečený toner. Je tlačiareň čistá a nenachádza sa v nej žiadny vytečený toner? Prejdite na krok 4. Vymeňte tonerovú kazetu. Vytlačte dokument. Je tlač roztečená? Problém je vyriešený. Skontrolujte stav tlačovej jednotky. Na domovskej obrazovke sa dotknite položky  Stav/spotrebný materiál Spotrebný materiál . Blíži sa koniec životnosti tlačovej jednotky? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Vymeňte tlačovú jednotku. Vytlačte dokument. Je tlač roztečená? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s kvalitou tlače roztečená tlač problém s kvalitou tlače bodky na výtlačku roztečená tlač bodky na výtlačku"},{"UUID":"c86eede3-6514-47fd-96d2-5bd11e856204","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Zvlnenie papiera Postup riešenia problému","descFull":"Zvlnenie papiera Postup riešenia problému Akcia Áno Nie Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta od spoločnosti Lexmark. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta. Ak kazeta nie je podporovaná, nainštalujte podporovanú kazetu. Vytlačte dokument. Je papier zvlnený? Problém je vyriešený. Upravte vodiace lišty v zásobníku do správnej polohy pre vložený papier. Vytlačte dokument. Je papier zvlnený? Problém je vyriešený. Špecifikujte veľkosť a typ papiera v dialógovom okne Predvoľby tlače alebo Tlač v závislosti od používaného operačného systému. Uistite sa, že nastavenia zodpovedajú vloženému papieru. Nastavenia môžete zmeniť aj prostredníctvom ovládacieho panela tlačiarne. Vytlačte dokument. Je papier zvlnený? Problém je vyriešený. Vyberte papier zo zásobníka a obráťte ho. Vytlačte dokument. Je papier zvlnený? Problém je vyriešený. Vložte papier z nového balíka. Pri vysokej vlhkosti papier absorbuje vlhko. Papier vyberte z pôvodného balenia, až keď ho budete chcieť použiť. Vytlačte dokument. Je papier zvlnený? Problém je vyriešený. Overte, či je vložený papier podporovaný. Ak papier nie je podporovaný, vložte papier s podporovanou hmotnosťou. Vytlačte dokument. Je papier zvlnený? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s kvalitou tlače zvlnenie papiera zvlnenie papiera"},{"UUID":"d13f9ed4-9c25-4be2-b69d-8b7c6ffc1c46","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Krivá alebo šikmá tlač Skôr","descFull":"Krivá alebo šikmá tlač Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Vytiahnite zásobník. Vyberte papier a potom vložte papier z nového balíka. Pri vysokej vlhkosti papier absorbuje vlhko. Papier vyberte z pôvodného balenia, až keď ho budete chcieť použiť. Stlačte a potiahnite vodiace lišty papiera do správnej polohy pre veľkosť papiera, ktorý vkladáte. Vložte zásobník. Vytlačte dokument. Je tlač krivá alebo šikmá? Problém je vyriešený. Skontrolujte, či tlačíte na podporovaný papier. Vytlačte dokument. Je tlač krivá alebo šikmá? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. tlač nakrivo tlač našikmo problém s kvalitou tlače tlač nakrivo problém s kvalitou tlače tlač našikmo tlač nakrivo tlač našikmo"},{"UUID":"68ccb43b-60ff-457a-8495-d0f29be97d54","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Čierne strany Skôr než sa","descFull":"Čierne strany Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta od spoločnosti Lexmark. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta. Ak kazeta nie je podporovaná, nainštalujte podporovanú kazetu. Vytlačte dokument. Tlačí tlačiareň čierne strany? Problém je vyriešený. Vyberte tlačovú jednotku. Tlačovú jednotku nevystavujte priamemu svetlu na dlhšie ako 10 minút. Dlhšie vystavenie svetlu môže spôsobiť problémy s kvalitou tlače. Nedotýkajte sa fotovalca pod tlačovou jednotkou. Mohli by ste tým ovplyvniť kvalitu tlače budúcich tlačových úloh. Odstráňte zvyšky baliaceho materiálu na tlačovej jednotke. Dbajte na to, aby ste odstránili všetky prekážky medzi nabíjacím valcom a fotovalcom. Vložte tlačovú jednotku. Vytlačte dokument. Tlačí tlačiareň čierne strany? Problém je vyriešený. Skontrolujte, či tlačová jednotka nie je poškodená. Je tlačová jednotka nepoškodená? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Vymeňte tlačovú jednotku. Vytlačte dokument. Tlačí tlačiareň čierne strany? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s kvalitou tlače čierne strany čierne strany čierne strany"},{"UUID":"4991d0f0-ea5d-40b2-9f99-44c48bd59180","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Odrezaný text alebo obrázky Skôr","descFull":"Odrezaný text alebo obrázky Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta od spoločnosti Lexmark. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta. Ak kazeta nie je podporovaná, nainštalujte podporovanú kazetu. Vytlačte dokument. Je odrezaný text alebo obrázky? Problém je vyriešený. Vyberte tlačovú jednotku. Tlačovú jednotku nevystavujte priamemu svetlu na dlhšie ako 10 minút. Dlhšie vystavenie svetlu môže spôsobiť problémy s kvalitou tlače. Nedotýkajte sa fotovalca pod tlačovou jednotkou. Mohli by ste tým ovplyvniť kvalitu tlače budúcich tlačových úloh. Odstráňte zvyšky baliaceho materiálu na tlačovej jednotke. Dbajte na to, aby ste odstránili všetky prekážky medzi nabíjacím valcom a fotovalcom. Vložte tlačovú jednotku. Vytlačte dokument. Je odrezaný text alebo obrázky? Problém je vyriešený. Vymeňte tlačovú jednotku. Vytlačte dokument. Je odrezaný text alebo obrázky? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s kvalitou tlače odrezaný text alebo obrázky odrezaný text na výtlačku odrezané obrázky na výtlačku"},{"UUID":"6aeed5b7-1d51-4dee-9d40-aacc448541ec","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Toner sa dá ľahko zotrieť","descFull":"Toner sa dá ľahko zotrieť Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta od spoločnosti Lexmark. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta. Ak kazeta nie je podporovaná, nainštalujte podporovanú kazetu. Vytlačte dokument. Dá sa toner ľahko zotrieť? Problém je vyriešený. Špecifikujte typ papiera v dialógovom okne Predvoľby tlače alebo Tlač v závislosti od používaného operačného systému. Uistite sa, že nastavenie zodpovedá vloženému papieru. Nastavenie môžete zmeniť aj prostredníctvom ovládacieho panela tlačiarne. Na domovskej obrazovke sa dotknite položiek  Nastavenia Papier Konfigurácia zásobníkov Veľkosť/typ papiera . Vytlačte dokument. Dá sa toner ľahko zotrieť? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s kvalitou tlače toner sa dá ľahko zotrieť toner sa dá ľahko zotrieť"},{"UUID":"11c38275-d438-474a-9355-d58029046483","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Vodorovné svetlé pásy Skôr než","descFull":"Vodorovné svetlé pásy Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta od spoločnosti Lexmark. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta. Ak kazeta nie je podporovaná, nainštalujte podporovanú kazetu. Vytlačte dokument. Objavujú sa na výtlačkoch vodorovné svetlé pásy? Problém je vyriešený. Vyberte a znova vložte tlačovú jednotku. Nevystavujte tlačovú jednotku priamemu svetlu. Dlhšie vystavenie svetlu môže spôsobiť problémy s kvalitou tlače. Nedotýkajte sa fotovalca. Mohli by ste tým ovplyvniť kvalitu tlače budúcich tlačových úloh. Vytlačte dokument. Objavujú sa na výtlačkoch vodorovné svetlé pásy? Problém je vyriešený. Vymeňte tlačovú jednotku. Vytlačte dokument. Objavujú sa na výtlačkoch vodorovné svetlé pásy? Problém je vyriešený. Tlačiareň vypnite, počkajte 10 sekúnd a potom ju znova zapnite. Vytlačte dokument. Objavujú sa na výtlačkoch vodorovné svetlé pásy? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s kvalitou tlače vodorovné svetlé pruhy vodorovné svetlé pruhy"},{"UUID":"003c7484-3ade-4a7b-b6a8-fccb1bdf1929","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Zvislé svetlé pásy Skôr než","descFull":"Zvislé svetlé pásy Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta od spoločnosti Lexmark. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta. Ak kazeta nie je podporovaná, nainštalujte podporovanú kazetu. Vytlačte dokument. Objavujú sa na výtlačkoch zvislé svetlé pásy? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s kvalitou tlače zvislé svetlé pruhy zvislé svetlé pruhy"},{"UUID":"bf4e2f04-0bf2-4a39-87ca-764c426f039f","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Zvislé biele čiary Skôr než","descFull":"Zvislé biele čiary Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta od spoločnosti Lexmark. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta. Ak kazeta nie je podporovaná, nainštalujte podporovanú kazetu. Vytlačte dokument. Objavujú sa na výtlačkoch zvislé biele čiary? Problém je vyriešený. Špecifikujte typ papiera v dialógovom okne Predvoľby tlače alebo Tlač v závislosti od používaného operačného systému. Uistite sa, že nastavenie zodpovedá vloženému papieru. Nastavenie môžete zmeniť aj prostredníctvom ovládacieho panela tlačiarne. Na domovskej obrazovke sa dotknite položiek  Nastavenia Papier Konfigurácia zásobníkov Veľkosť/typ papiera . Vytlačte dokument. Objavujú sa na výtlačkoch zvislé biele čiary? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s kvalitou tlače zvislé biele čiary zvislé biele čiary"},{"UUID":"da60f5ef-6fc3-4f39-a5ce-0d446508ea75","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Zvislé tmavé pruhy Skôr než","descFull":"Zvislé tmavé pruhy Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta od spoločnosti Lexmark. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta. Ak kazeta nie je podporovaná, nainštalujte podporovanú kazetu. Vytlačte dokument. Objavujú sa na výtlačkoch zvislé tmavé pruhy? Problém je vyriešený. Vyberte z tlačiarne tonerovú kazetu a potom tlačovú jednotku. Tlačovú jednotku nevystavujte priamemu svetlu na dlhšie ako 10 minút. Dlhšie vystavenie svetlu môže spôsobiť problémy s kvalitou tlače. Nedotýkajte sa fotovalca pod tlačovou jednotkou. Mohli by ste tým ovplyvniť kvalitu tlače budúcich tlačových úloh. Vložte tlačovú jednotku a potom vložte kazetu. Vytlačte dokument. Objavujú sa na výtlačkoch zvislé tmavé pruhy? Problém je vyriešený. Vyberte tlačovú jednotku. Tlačovú jednotku nevystavujte priamemu svetlu na dlhšie ako 10 minút. Dlhšie vystavenie svetlu môže spôsobiť problémy s kvalitou tlače. Nedotýkajte sa fotovalca pod tlačovou jednotkou. Mohli by ste tým ovplyvniť kvalitu tlače budúcich tlačových úloh. Odstráňte zvyšky baliaceho materiálu na tlačovej jednotke. Dbajte na to, aby ste odstránili všetky prekážky medzi nabíjacím valcom a fotovalcom. Vložte tlačovú jednotku. Vytlačte dokument. Objavujú sa na výtlačkoch zvislé tmavé pruhy? Problém je vyriešený. Skontrolujte, či na pravú stranu tlačiarne nesvieti jasné svetlo a v prípade potreby tlačiareň premiestnite. Vytlačte dokument. Objavujú sa na výtlačkoch zvislé tmavé pruhy? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s kvalitou tlače zvislé tmavé pruhy zvislé tmavé pruhy na výtlačkoch"},{"UUID":"b42dffb2-d862-4aab-8b39-8ce3734adb92","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Zvislé tmavé čiary alebo pásy","descFull":"Zvislé tmavé čiary alebo pásy Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Na domovskej obrazovke stlačte položku  Nastavenia Riešenie problémov Čistenie skenera Vytlačte dokument. Objavujú sa na výtlačkoch zvislé tmavé čiary alebo pruhy? Prejdite na krok 3. Skener utrite navlhčenou mäkkou tkaninou, z ktorej sa neuvoľňujú vlákna. Ďalšie informácie nájdete v časti  . Skopírujte dokument pomocou automatického podávača dokumentov. Objavujú sa na výtlačkoch zvislé tmavé čiary alebo pruhy? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta od spoločnosti Lexmark. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta. Ak kazeta nie je podporovaná, nainštalujte podporovanú kazetu. Vytlačte dokument. Objavujú sa na výtlačkoch zvislé tmavé čiary alebo pruhy? Problém je vyriešený. Vyberte a znova vložte tlačovú jednotku. Tlačovú jednotku nevystavujte priamemu svetlu na dlhšie ako 10 minút. Dlhšie vystavenie svetlu môže spôsobiť problémy s kvalitou tlače. Nedotýkajte sa fotovalca pod tlačovou jednotkou. Mohli by ste tým ovplyvniť kvalitu tlače budúcich tlačových úloh. Vytlačte dokument. Objavujú sa na výtlačkoch zvislé tmavé čiary alebo pruhy? Problém je vyriešený. Vymeňte tlačovú jednotku. Vytlačte dokument. Objavujú sa na výtlačkoch zvislé tmavé čiary alebo pruhy? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problémy s kvalitou tlače zvislé tmavé čiary alebo pásy zvislé tmavé čiary na výtlačkoch zvislé pásy na výtlačkoch"},{"UUID":"50cd441f-bd15-4565-b1c6-358fdd35a779","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Zvislé tmavé pásy a chýbajúci obsah","descFull":"Zvislé tmavé pásy a chýbajúci obsah Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta od spoločnosti Lexmark. Skontrolujte, či sa v tlačiarni nachádza originálna a podporovaná tonerová kazeta. Ak kazeta nie je podporovaná, nainštalujte podporovanú kazetu. Vytlačte dokument. Objavujú sa na výtlačkoch zvislé tmavé pruhy a chýbajú tam obrázky? Problém je vyriešený. Vyberte tlačovú jednotku. Tlačovú jednotku nevystavujte priamemu svetlu na dlhšie ako 10 minút. Dlhšie vystavenie svetlu môže spôsobiť problémy s kvalitou tlače. Nedotýkajte sa fotovalca pod tlačovou jednotkou. Mohli by ste tým ovplyvniť kvalitu tlače budúcich tlačových úloh. Odstráňte zvyšky baliaceho materiálu na tlačovej jednotke. Dbajte na to, aby ste odstránili všetky prekážky medzi nabíjacím valcom a fotovalcom. Vložte tlačovú jednotku. Vytlačte dokument. Objavujú sa na výtlačkoch zvislé tmavé pruhy a chýbajú tam obrázky? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. zvislé tmavé pásy chýbajúci obsah problém s kvalitou tlače zvislé tmavé pásy a chýbajúci obsah"},{"UUID":"2fd4279a-9766-4486-ae80-f8b109cbbade","title":"Nízka kvalita tlače","link":"solving-printing-problems.html","desc":"Opakujúce sa chyby Skôr než","descFull":"Opakujúce sa chyby Skôr než sa pustíte do riešenia tohto problému, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Postup riešenia problému Akcia Áno Nie Pomocou tlače strán testu kvality skontrolujte, či sa vzdialenosť medzi opakujúcimi sa chybami rovná niektorej z nasledujúcich hodnôt: 97 mm (3,82 palca) 47 mm (1,85 palca) 38 mm (1,5 palca) Zhoduje sa vzdialenosť medzi opakujúcimi sa chybami s niektorou z týchto hodnôt? Zaznamenajte si vzdialenosť a kontaktujte oddelenie  Podpora pre zákazníkov . Zaznamenajte si vzdialenosť a kontaktujte oddelenie  Technická podpora . Poznačte si vzdialenosť a kontaktujte svojho  predajcu . Vymeňte tlačovú jednotku. Vytlačte dokument. Objavujú sa opakujúce sa chyby? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s kvalitou tlače opakujúce sa chyby opakujúce sa chyby na výtlačkoch"},{"UUID":"3020f629-f554-4b64-a0a2-915b74f5277b","title":"Problémy s tlačou","link":"solving-printing-problems.html","desc":"Tlačové úlohy sa netlačia Postup","descFull":"Tlačové úlohy sa netlačia Postup riešenia problému Akcia Áno Nie V dokumente, ktorý sa snažíte vytlačiť, otvorte okno Tlač a skontrolujte, či ste vybrali správnu tlačiareň. Vytlačte dokument. Vytlačil sa dokument? Problém je vyriešený. Skontrolujte, či je tlačiareň zapnutá. Vyriešte všetky chybové hlásenia, ktoré sa zobrazia na displeji. Vytlačte dokument. Vytlačil sa dokument? Problém je vyriešený. Skontrolujte, či porty fungujú a káble sú poriadne pripojené k počítaču a tlačiarni. Ďalšie informácie nájdete v dokumentácii k inštalácii dodanej s tlačiarňou. Vytlačte dokument. Vytlačil sa dokument? Problém je vyriešený. Tlačiareň vypnite, počkajte 10 sekúnd a potom ju znova zapnite. Vytlačte dokument. Vytlačil sa dokument? Problém je vyriešený. Odstráňte a potom znova nainštalujte ovládač tlačiarne. Vytlačte dokument. Vytlačil sa dokument? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . problém s tlačou tlačové úlohy sa netlačia nevytlačené tlačové úlohy"},{"UUID":"496aca68-5e53-49c3-8349-7bd8513b1681","title":"Problémy s tlačou","link":"solving-printing-problems.html","desc":"Dôverné a iné pozastavené dokumenty sa","descFull":"Dôverné a iné pozastavené dokumenty sa nevytlačia Postup riešenia problému Akcia Áno Nie Na ovládacom paneli si overte, či sa dokumenty zobrazujú v zozname  Pozastavené úlohy . Ak sa tam dokumenty neuvádzajú, vytlačte ich pomocou možností Tlačiť a zadržať. Vytlačte dokumenty. Vytlačili sa dokumenty? Problém je vyriešený. Tlačová úloha môže obsahovať chybu formátovania alebo neplatné údaje. Odstráňte tlačovú úlohu a znova ju odošlite. V prípade súborov PDF vytvorte nový súbor a potom dokumenty vytlačte. Vytlačili sa dokumenty? Problém je vyriešený. Ak tlačíte z internetu, možno tlačiareň číta viaceré názvy úloh ako duplikáty. Používatelia systému Windows Otvorte dialógové okno Predvoľby tlače. Na karte Tlačiť a zadržať kliknite na položku  Tlačiť a zadržať  a potom kliknite na možnosť  Ponechať duplicitné dokumenty . Zadajte kód PIN a uložte zmeny. Odošlite tlačovú úlohu. Používatelia systému Macintosh Uložte a pomenujte každú úlohu osobitne. Úlohy odošlite jednotlivo. Vytlačili sa dokumenty? Problém je vyriešený. Odstráňte niektoré zadržané úlohy, aby ste uvoľnili pamäť tlačiarne. Vytlačte dokumenty. Vytlačili sa dokumenty? Problém je vyriešený. Zväčšite pamäť tlačiarne. Vytlačte dokumenty. Vytlačili sa dokumenty? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . riešenie problémov, tlač dôverné a iné pozastavené dokumenty sa nevytlačia riešenie problémov s tlačou dôverné a iné pozastavené dokumenty sa nevytlačia dôverné dokumenty sa nevytlačia pozastavené dokumenty sa netlačia"},{"UUID":"587f793a-6b1a-4d7d-b4b6-2325c3b658ff","title":"Problémy s tlačou","link":"solving-printing-problems.html","desc":"Úloha sa tlačí z nesprávneho zásobníka","descFull":"Úloha sa tlačí z nesprávneho zásobníka alebo na nesprávny papier Postup riešenia problému Akcia Áno Nie Skontrolujte, či tlačíte na správny papier. Vytlačte dokument. Vytlačil sa dokument na správny papier? Vložte papier správnej veľkosti a typu. Špecifikujte veľkosť a typ papiera v dialógovom okne Predvoľby tlače alebo Tlač v závislosti od používaného operačného systému. Nastavenia môžete zmeniť aj prostredníctvom ovládacieho panela tlačiarne. Na domovskej obrazovke sa dotknite položiek  Nastavenia Papier Konfigurácia zásobníkov Veľkosť/typ papiera . Uistite sa, že nastavenia zodpovedajú vloženému papieru. Vytlačte dokument. Vytlačil sa dokument na správny papier? Problém je vyriešený. Skontrolujte, či sú zásobníky prepojené. Ďalšie informácie nájdete v časti  . Vytlačte dokument. Tlačí sa dokument zo správneho zásobníka? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . riešenie problémov s tlačou úloha sa tlačí z nesprávneho zásobníka riešenie problémov s tlačou úloha sa tlačí na nesprávny papier riešenie problémov, tlač úloha sa tlačí z nesprávneho zásobníka riešenie problémov, tlač úloha sa tlačí na nesprávny papier úloha sa tlačí z nesprávneho zásobníka úloha sa tlačí na nesprávny papier"},{"UUID":"51243cc1-b350-4839-8d6f-0379dab896ab","title":"Problémy s tlačou","link":"solving-printing-problems.html","desc":"Pomalá tlač Postup riešenia problému","descFull":"Pomalá tlač Postup riešenia problému Akcia Áno Nie Uistite sa, že je kábel tlačiarne riadne pripojený k tlačiarni a k počítaču, tlačovému serveru, voliteľnému prvku alebo k inému sieťovému zariadeniu. Tlačí tlačiareň pomaly? Problém je vyriešený. Uistite sa, že tlačiareň nie je v režime Tichý režim. Na domovskej obrazovke sa dotknite položiek  Nastavenia Zariadenie Údržba Ponuka konfigurácie Prevádzka zariadenia Tichý režim . Vytlačte dokument. Tlačí tlačiareň pomaly? Problém je vyriešený. Špecifikujte rozlíšenie tlače v dialógovom okne Predvoľby tlače alebo Tlač v závislosti od používaného operačného systému. Nastavte rozlíšenie na  600 dpi . Vytlačte dokument. Tlačí tlačiareň pomaly? Problém je vyriešený. Na domovskej obrazovke sa dotknite položiek  Nastavenia Tlač Kvalita Rozlíšenie tlače . Nastavte rozlíšenie na  600 dpi . Vytlačte dokument. Tlačí tlačiareň pomaly? Problém je vyriešený. Špecifikujte typ papiera v dialógovom okne Predvoľby tlače alebo Tlač v závislosti od používaného operačného systému. Uistite sa, že nastavenie zodpovedá vloženému papieru. Nastavenie môžete zmeniť aj prostredníctvom ovládacieho panela tlačiarne. Ťažší papier sa tlačí pomalšie. Papier užší ako formáty list, A4 a legal sa môže tlačiť pomalšie. Vytlačte dokument. Tlačí tlačiareň pomaly? Problém je vyriešený. Uistite sa, že nastavenia tlačiarne pre položky Štruktúra a Hmotnosť zodpovedajú vkladanému papieru. Na domovskej obrazovke sa dotknite položiek  Nastavenia Papier Konfigurácia médií Typy médií . Papier s drsnou štruktúrou povrchu a papier s vysokou hmotnosťou sa môžu tlačiť pomalšie. Vytlačte dokument. Tlačí tlačiareň pomaly? Problém je vyriešený. Odstráňte zadržané úlohy. Tlačí tlačiareň pomaly? Problém je vyriešený. Uistite sa, že sa tlačiareň neprehrieva. Po dlhej tlačovej úlohe nechajte tlačiareň vychladnúť. Dodržujte odporúčané teploty okolia pre tlačiareň. Ďalšie informácie nájdete v časti  . Vytlačte dokument. Tlačí tlačiareň pomaly? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s tlačou pomalá tlač pomalá tlač"},{"UUID":"a4674838-06fc-45fe-bf09-f4066f1435bc","title":"Riešenie problémov","link":"trb-printer-not-responding-topic.html","desc":"Tlačiareň nereaguje Postup riešenia problému","descFull":"Tlačiareň nereaguje Postup riešenia problému Akcia Áno Nie Skontrolujte, či je napájací kábel zapojený do elektrickej zásuvky. Riziku požiaru alebo zásahu elektrickým prúdom sa vyhnete tak, že zapojíte napájací kábel do riadne označenej a správne uzemnenej elektrickej zásuvky, ktorá sa nachádza blízko produktu a je ľahko dostupná. Reaguje tlačiareň? Problém je vyriešený. Skontrolujte, či elektrická zásuvka nie je vypnutá vypínačom alebo poistkou. Je elektrická zásuvka vypnutá vypínačom alebo poistkou? Zapnite vypínač alebo poistku. Skontrolujte, či je tlačiareň zapnutá. Je tlačiareň zapnutá? Zapnite tlačiareň. Skontrolujte, či tlačiareň nie je v režime spánku alebo dlhodobého spánku. Je tlačiareň v režime spánku alebo dlhodobého spánku? Tlačiareň zobuďte stlačením tlačidla napájania. Skontrolujte, či sú káble spájajúce tlačiareň a počítač zapojené do správnych portov. Sú káble zapojené do správnych portov? Zapojte káble do správnych portov. Tlačiareň vypnite, nainštalujte hardvérové voliteľné prvky a následne tlačiareň zapnite. Ďalšie informácie nájdete v dokumentácii dodanej s voliteľným prvkom. Reaguje tlačiareň? Problém je vyriešený. Nainštalujte správny ovládač tlačiarne. Reaguje tlačiareň? Problém je vyriešený. Tlačiareň vypnite, počkajte 10 sekúnd a potom ju znova zapnite. Reaguje tlačiareň? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . riešenie problémov tlačiareň nereaguje tlačiareň nereaguje"},{"UUID":"576c35c7-147f-493a-8726-b430f0584610","title":"Riešenie problémov","link":"trb-unable-to-read-flash-drive-topic.html","desc":"Nemožno čítať pamäťovú jednotku flash","descFull":"Nemožno čítať pamäťovú jednotku flash Nemožno čítať pamäťovú jednotku flash Postup riešenia problému Akcia Áno Nie Skontrolujte, či tlačiareň nespracováva inú úlohu tlače, skenovania alebo faxovania. Je tlačiareň pripravená? Prejdite na krok 3. Počkajte, kým tlačiareň ukončí spracovanie inej pracovnej úlohy. Pamäťovú jednotku flash vyberte a znova vložte. Rozpoznala tlačiareň pamäťovú jednotku flash? Problém je vyriešený. Skontrolujte, či je pamäťová jednotka flash vložená do predného portu USB. Pamäťová jednotka flash nefunguje, keď sa vloží do zadného portu USB. Je pamäťová jednotka flash vložená do správneho portu? Prejdite na krok 5. Vložte pamäťovú jednotku flash do správneho portu. Rozpoznala tlačiareň pamäťovú jednotku flash? Problém je vyriešený. Overte, či je jednotka flash podporovaná. Ďalšie informácie nájdete v časti  . Je jednotka flash podporovaná? Prejdite na krok 7. Vložte podporovanú pamäťovú jednotku flash. Rozpoznala tlačiareň pamäťovú jednotku flash? Problém je vyriešený. Pamäťovú jednotku flash vyberte a znova vložte. Rozpoznala tlačiareň pamäťovú jednotku flash? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . nemožno čítať pamäťovú jednotku flash riešenie problémov, tlač riešenie problémov s tlačou nemožno čítať pamäťovú jednotku flash"},{"UUID":"b61bd1e5-83a4-4ab4-9e74-daaed7173af7","title":"Riešenie problémov","link":"enabling-usb-port-topic.html","desc":"Zapnutie portu USB Na domovskej","descFull":"Zapnutie portu USB Na domovskej obrazovke sa dotknite položiek  Nastavenia Sieť/porty USB Povoliť port USB . port USB povolenie zapnutie portu USB"},{"UUID":"9181d3dd-5f92-4c74-ab6e-73d2fe79c9b8","title":"Odstránenie zaseknutého papiera","link":"clearing-jams.html","desc":"Predchádzanie zaseknutiu papiera Papier vložte","descFull":"Predchádzanie zaseknutiu papiera Papier vložte správne Uistite sa, že papier je v zásobníku vyrovnaný. Správne a nesprávne vkladanie papiera Správne vkladanie papiera Nesprávne vkladanie papiera Zásobníky nevyberajte ani nenapĺňajte, keď tlačiareň pracuje. Nevkladajte priveľa papiera. Uistite sa, že výška stohu nepresahuje označenie maximálnej kapacity papiera. Papier do zásobníka nezasúvajte. Papier vkladajte tak, ako je zobrazené na ilustrácii. Uistite sa, že vodiace lišty papiera sú v správnej polohe a netlačia silno na papier alebo obálky. Po vložení papiera zásobník dobre zasuňte do tlačiarne. Používajte odporúčaný papier Používajte iba odporúčaný papier alebo špeciálne médiá. Nevkladajte zvlnený, pokrčený, vlhký, ohnutý ani stočený papier. Pred vložením papiera ohnite, rozdeľte a zarovnajte jeho okraje. Nepoužívajte papier, ktorý bol ručne odstrihnutý alebo orezaný. V jednom zásobníku nemiešajte papier rôznych veľkostí, hmotností a typov. Uistite sa, že veľkosť a typ papiera sú v počítači alebo na ovládacom paneli tlačiarne správne nastavené. Papier skladujte podľa odporúčaní výrobcu. zaseknutia papiera predchádzanie zaseknutia, papier predchádzanie predchádzanie zaseknutiu papiera"},{"UUID":"1e329f42-9a40-49c7-b5bc-f3a4e5532bbf","title":"Odstránenie zaseknutého papiera","link":"clearing-jams.html","desc":"Identifikácia miest zaseknutia Keď je","descFull":"Identifikácia miest zaseknutia Keď je  Asistent zaseknutia  nastavený na možnosť  Zapnuté , po odstránení zaseknutej strany z tlačiarne vyjdú prázdne alebo čiastočne vytlačené strany. Skontrolujte, či sú vo výstupe tlačiarne prázdne strany. Keď je funkcia  Obnova po zaseknutí  nastavená na možnosť  Zapnuté  alebo  Automaticky , tlačiareň znova vytlačí zaseknuté strany. Miesta zaseknutia Miesta zaseknutia 1 Automatický podávač dokumentov 2 Viacúčelový podávač 3 Zásobníky 4 Dvierka A 5 Jednotka obojstrannej tlače 6 Dvierka B miesta zaseknutia identifikácia zaseknutia papiera umiestnenie lokalizácia zaseknutí papiera"},{"UUID":"a82863d7-861c-4fef-b063-22fb8564915f","title":"Odstránenie zaseknutého papiera","link":"clearing-jams.html","desc":"Zaseknutie papiera v dvierkach A Otvorte","descFull":"Zaseknutie papiera v dvierkach A Otvorte dvierka A. Vyberte tonerovú kazetu. Vyberte tlačovú jednotku. Tlačovú jednotku nevystavujte priamemu svetlu na dlhšie ako 10 minút. Dlhšie vystavenie svetlu môže spôsobiť problémy s kvalitou tlače. Nedotýkajte sa fotovalca. Mohli by ste tým ovplyvniť kvalitu tlače budúcich tlačových úloh. Vyberte zaseknutý papier. Vnútro tlačiarne môže byť horúce. Skôr ako sa dotknete ktorejkoľvek časti, nechajte povrch vychladnúť, aby ste predišli riziku popálenia. Uistite sa, že ste vybrali všetok papier. Vložte tlačovú jednotku. Orientujte sa podľa šípok v tlačiarni. Vložte tonerovú kazetu. Orientujte sa podľa šípok v tlačiarni. Zatvorte dvierka A. odstránenie zaseknutého papiera v dvierkach A odstránenie zaseknutého papiera v dvierkach A zaseknutie papiera v dvierkach A"},{"UUID":"1f8b638d-d500-445d-a487-159332fac1e4","title":"Odstránenie zaseknutého papiera","link":"clearing-jams.html","desc":"Zaseknutie papiera v dvierkach B Otvorte","descFull":"Zaseknutie papiera v dvierkach B Otvorte dvierka B. Vnútro tlačiarne môže byť horúce. Skôr ako sa dotknete ktorejkoľvek časti, nechajte povrch vychladnúť, aby ste predišli riziku popálenia. Vyberte zaseknutý papier. Uistite sa, že ste vybrali všetok papier. Zatvorte dvierka B. odstránenie zaseknutého papiera v dvierkach B odstránenie zaseknutého papiera v dvierkach B zaseknutie papiera v dvierkach B"},{"UUID":"a153a64b-a4fc-4d7c-84dd-576802a6ba60","title":"Odstránenie zaseknutého papiera","link":"clearing-jams.html","desc":"Zaseknutý papier v jednotke obojstrannej tlače","descFull":"Zaseknutý papier v jednotke obojstrannej tlače Vyberte zásobník. Potlačením západky jednotky obojstrannej tlače otvorte jednotku obojstrannej tlače. Vyberte zaseknutý papier. Uistite sa, že ste vybrali všetok papier. Vložte zásobník. odstránenie zaseknutého papiera v jednotke obojstrannej tlače odstránenie zaseknutého papiera v jednotke obojstrannej tlače zaseknutý papier v jednotke obojstrannej tlače"},{"UUID":"5f693b29-3c6b-4cf4-8c81-22da08f76ba3","title":"Odstránenie zaseknutého papiera","link":"clearing-jams.html","desc":"Zaseknutie papiera v zásobníkoch Vyberte zásobník.","descFull":"Zaseknutie papiera v zásobníkoch Vyberte zásobník. Aby sa zabránilo poškodeniu v dôsledku elektrostatického výboja, pred prístupom do vnútorných priestorov tlačiarne alebo ich dotykom sa dotknite akéhokoľvek odhaleného kovového rámu tlačiarne. Vyberte zaseknutý papier. Uistite sa, že ste vybrali všetok papier. Vložte zásobník. odstránenie zaseknutého papiera v zásobníkoch odstránenie zaseknutého papiera v zásobníkoch zaseknutie papiera v zásobníkoch"},{"UUID":"ebc4aead-1a1f-4914-bf51-2f51ab19692f","title":"Odstránenie zaseknutého papiera","link":"clearing-jams.html","desc":"Zaseknutie papiera vo viacúčelovom podávači","descFull":"Zaseknutie papiera vo viacúčelovom podávači Vyberte papier z viacúčelového podávača. Vyberte zaseknutý papier. Uistite sa, že ste vybrali všetok papier. Znova vložte papier a potom nastavte vodiacu lištu. odstránenie zaseknutého papiera vo viacúčelovom podávači odstránenie zaseknutého papiera vo viacúčelovom podávači zaseknutie papiera vo viacúčelovom podávači"},{"UUID":"1bd41b5f-7450-4a86-a735-7b164b69dd8c","title":"Odstránenie zaseknutého papiera","link":"clearing-jams.html","desc":"Zaseknutý papier v automatickom podávači dokumentov","descFull":"Zaseknutý papier v automatickom podávači dokumentov Zaseknutý papier pod vrchným krytom automatického podávača dokumentov Odstráňte všetky pôvodné dokumenty zo zásobníka automatického podávača dokumentov. Otvorte dvierka C. Vyberte zaseknutý papier. Uistite sa, že ste vybrali všetok papier. Zatvorte dvierka C. Zaseknutý papier pod výstupnou priehradkou automatického podávača dokumentov Odstráňte všetky pôvodné dokumenty zo zásobníka automatického podávača dokumentov. Nadvihnite zásobník automatického podávača dokumentov a vyberte zaseknutý papier. Uistite sa, že ste vybrali všetok papier. Zásobník automatického podávača dokumentov zasuňte späť na miesto. odstránenie zaseknutého papiera v automatickom podávači dokumentov odstránenie zaseknutého papiera v automatickom podávači dokumentov zaseknutie papiera v automatickom podávači dokumentov"},{"UUID":"8d166ad3-c9a4-42c6-ba06-b371a7da846a","title":"Problémy so sieťovým pripojením","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Nemožno otvoriť Embedded Web Server","descFull":"Nemožno otvoriť Embedded Web Server Postup riešenia problému Akcia Áno Nie Skontrolujte, či je tlačiareň zapnutá. Otvorte servera Embedded Web Server (EWS) tlačiarne. Ide vám otvoriť server EWS? Problém je vyriešený. Uistite sa, že adresa IP tlačiarne je správna. Pozrite si adresu IP na domovskej obrazovke. Adresa IP sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Otvorte server EWS. Ide vám otvoriť server EWS? Problém je vyriešený. Uistite sa, že ste nainštalovali podporovaný prehliadač: Internet Explorer verzia 11 alebo novší Microsoft Edge Safari verzia 6 alebo novší Google Chrome  verzia 32 alebo novší Mozilla Firefox verzia 24 alebo novší Otvorte server EWS. Ide vám otvoriť server EWS? Problém je vyriešený. Skontrolujte, či funguje pripojenie k sieti. Ak pripojenie nefunguje, obráťte sa na správcu. Otvorte server EWS. Ide vám otvoriť server EWS? Problém je vyriešený. Uistite sa, že káble medzi tlačiarňou a tlačovým serverom sú poriadne zapojené. Ďalšie informácie nájdete v dokumentácii dodanej s tlačovým serverom. Otvorte server EWS. Ide vám otvoriť server EWS? Problém je vyriešený. Skontrolujte, či sú webové servery proxy vypnuté. Ak sú servery vypnuté, obráťte sa na správcu. Otvorte server EWS. Ide vám otvoriť server EWS? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . nemožno otvoriť Embedded Web Server riešenie problémov nemožno otvoriť Embedded Web Server"},{"UUID":"aff427dc-30c5-4c1a-b3ee-8ba95d7dccbc","title":"Problémy so sieťovým pripojením","link":"trb-cannot-open-embedded-web-server-topic.html","desc":"Tlačiareň sa nepodarilo pripojiť k","descFull":"Tlačiareň sa nepodarilo pripojiť k sieti Wi‑Fi Postup riešenia problému Akcia Áno Nie Skontrolujte, či je položka  Aktívny adaptér  nastavená na možnosť  Automaticky . Na domovskej obrazovke sa dotknite položiek  Nastavenie Sieť/porty Prehľad siete Aktívny adaptér Automaticky . Môže sa tlačiareň pripojiť k sieti Wi-Fi? Problém je vyriešený. Skontrolujte, či je vybratá správna sieť Wi‑Fi. Niektoré smerovače môžu zdieľať predvolený identifikátor SSID. Pokúšate sa pripojiť k správnej sieti Wi‑Fi? Prejdite na krok 4. Pripojte sa k správnej sieti Wi‑Fi. Ďalšie informácie nájdete v časti  . Môže sa tlačiareň pripojiť k sieti Wi-Fi? Problém je vyriešený. Skontrolujte zabezpečený bezdrôtový režim. Na domovskej obrazovke sa dotknite položiek  Nastavenia Sieť/porty Bezdrôtové Zabezpečený bezdrôtový režim . Je zvolený správny zabezpečený bezdrôtový režim? Prejdite na krok 6. Zvoľte správny zabezpečený bezdrôtový režim. Môže sa tlačiareň pripojiť k sieti Wi-Fi? Problém je vyriešený. Skontrolujte, či ste zadali správne heslo siete. Berte do úvahy medzery, čísla a veľké písmená v hesle. Môže sa tlačiareň pripojiť k sieti Wi-Fi? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . tlačiareň sa nedá pripojiť k sieti Wi‑Fi riešenie problémov tlačiareň sa nedá pripojiť k sieti Wi‑Fi"},{"UUID":"e488d433-e4cc-4b95-8938-49edda6f0118","title":"Problémy s hardvérovými voliteľnými prvkami","link":"trb-cannot-detect-internal-option-topic.html","desc":"Interný voliteľný prvok nemožno zistiť","descFull":"Interný voliteľný prvok nemožno zistiť Postup riešenia problému Akcia Áno Nie Tlačiareň vypnite, počkajte 10 sekúnd a potom ju znova zapnite. Zistí tlačiareň interný voliteľný prvok? Problém je vyriešený. Vytlačte stranu nastavení ponúk a overte, či sa na zozname Nainštalované funkcie uvádza interný voliteľný prvok. Je interný voliteľný prvok uvedený? Prejdite na krok 4. Skontrolujte, či je interný voliteľný prvok správne nainštalovaný v riadiacej jednotke. Vypnite tlačiareň a potom z elektrickej zásuvky odpojte napájací kábel. Uistite sa, že interný voliteľný prvok je nainštalovaný v správnom konektore riadiacej dosky. Zapojte napájací kábel do elektrickej zásuvky a zapnite tlačiareň. Riziku požiaru alebo elektrického šoku sa vyhnete tak, že zapojíte napájací kábel do riadne označenej a správne uzemnenej elektrickej zásuvky, ktorá sa nachádza blízko produktu a je ľahko dostupná. Zistí tlačiareň interný voliteľný prvok? Problém je vyriešený. Skontrolujte, či je interný voliteľný prvok dostupný v ovládači tlačiarne. V prípade potreby manuálne pridajte interný voliteľný prvok do ovládača tlačiarne, aby bol k dispozícii pre tlačové úlohy. Ďalšie informácie nájdete v časti  . Vytlačte dokument. Zistí tlačiareň interný voliteľný prvok? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . riešenie problémov, možnosti tlačiarne interný voliteľný prvok nemožno zistiť riešenie problémov s voliteľnými prvkami tlačiarne interný voliteľný prvok nemožno zistiť interný voliteľný prvok nemožno zistiť"},{"UUID":"072ed521-47cd-49cc-84ea-6843891128d6","title":"Problémy s hardvérovými voliteľnými prvkami","link":"trb-cannot-detect-internal-option-topic.html","desc":"Zistila sa chybná pamäť flash","descFull":"Zistila sa chybná pamäť flash Vyskúšajte jedno alebo viaceré z nasledujúcich riešení: Vymeňte chybný disk s inteligentným ukladaním. Ak chcete hlásenie ignorovať a pokračovať v tlači, na domovskej obrazovke sa dotknite položky  Pokračovať . Zrušte aktuálnu tlačovú úlohu. Kontaktujte svojho  predajcu . hlásenia tlačiarne Zistila sa chybná pamäť flash chybný disk s inteligentným ukladaním"},{"UUID":"fc4a2f8f-5f16-4b42-bb89-ce5988c962ec","title":"Problémy s hardvérovými voliteľnými prvkami","link":"trb-cannot-detect-internal-option-topic.html","desc":"Nedostatok voľného miesta v pamäti flash","descFull":"Nedostatok voľného miesta v pamäti flash pre zdroje Vyskúšajte jedno alebo viaceré z nasledujúcich riešení: Dotknite sa tlačidla  Pokračovať , čím správu vymažete a tlač bude pokračovať. Vymažte údaje o písmach, makrách a ďalšie údaje uložené v pamäti flash. Nainštalujte pevný disk. Stiahnuté písma a makrá, ktoré neboli uložené v pamäti flash, sa odstránia. Kontaktujte svojho  predajcu . hlásenia tlačiarne Nedostatok voľného miesta v pamäti flash pre zdroje Nedostatok voľného miesta v pamäti flash pre zdroje"},{"UUID":"90d111d0-0f23-42e6-a84c-d0a83667f1fa","title":"Problémy s hardvérovými voliteľnými prvkami","link":"trb-cannot-detect-internal-option-topic.html","desc":"Červené svetlo na pohodlnej zošívačke","descFull":"Červené svetlo na pohodlnej zošívačke Vyskúšajte jedno alebo viaceré z nasledujúcich riešení: Zatvorte prístupové dvierka k spinkám. Vyberte uvoľnené spinky. Po odstránení uvoľnených spiniek sú pred zošívaním potrebné dva cykly plnenia. Do zošívačky trikrát vložte stoh papiera. Zošívanie začne pri treťom vložení. Výmena kazety so spinkami červený indikátor na pohodlnej zošívačke pohodlná zošívačka červený indikátor"},{"UUID":"71eb87bc-59cc-48e9-8636-f41eeab67966","title":"Problémy so spotrebným materiálom","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"výmena kazety, región tlačiarne sa","descFull":"výmena kazety, región tlačiarne sa nezhoduje Ak chcete opraviť tento problém, zakúpte si kazetu so správnym regiónom zhodujúcim sa s regiónom tlačiarne alebo kazetu určenú na použitie kdekoľvek na svete. Prvé číslo v správe po čísle 42 označuje región tlačiarne. Druhé číslo v správe po čísle 42 označuje región kazety. Nainštalujte správnu tonerovú kazetu. Regióny tlačiarne a tonerovej kazety Región Číselný kód Celosvetové použitie alebo nedefinovaný región 0 Severná Amerika (Spojené štáty, Kanada), Austrália, Nový Zéland 1 Európsky hospodársky priestor, Island, Lichtenštajnsko a Nórsko 2 Ázijsko-pacifická oblasť 3 Latinská Amerika 4 Zvyšok Európy, Blízky východ a Afrika 5 Neplatný región 9 Ak chcete zistiť nastavenia regiónu tlačiarne a tonerovej kazety, vytlačte strany testu kvality. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . hlásenia tlačiarne výmena kazety, región tlačiarne sa nezhoduje výmena kazety, región tlačiarne sa nezhoduje"},{"UUID":"f262b82c-1f0d-4db1-aa32-21e50367140c","title":"Problémy so spotrebným materiálom","link":"message-replace-cartridge-printer-region-mismatch-topic.html","desc":"Spotrebný materiál, ktorého výrobcom nie","descFull":"Spotrebný materiál, ktorého výrobcom nie je spoločnosť Lexmark Spotrebný materiál, ktorého výrobcom nie je spoločnosť Dell Spotrebný materiál, ktorého výrobcom nie je výrobca tlačiarne Tlačiareň zistila, že je v nej vložený spotrebný materiál alebo súčasť, ktorých výrobcom nie je spoločnosť Lexmark. Tlačiareň zistila, že je v nej vložený spotrebný materiál alebo súčasť, ktorých výrobcom nie je spoločnosť Dell. Tlačiareň zistila, že je v nej vložený neznámy spotrebný materiál alebo súčasť. Tlačiareň Lexmark funguje najlepšie s originálnymi súčasťami a spotrebným materiálom značky Lexmark. Používanie spotrebného materiálu alebo súčastí tretích strán môže ovplyvniť výkonnosť, spoľahlivosť alebo životnosť tlačiarne a jej tlačových súčastí. Tlačiareň Dell funguje najlepšie s originálnymi súčasťami a spotrebným materiálom značky Dell. Používanie spotrebného materiálu alebo súčastí tretích strán môže ovplyvniť výkonnosť, spoľahlivosť alebo životnosť tlačiarne a jej tlačových súčastí. Tlačiareň funguje najlepšie s originálnym spotrebným materiálom a súčasťami od príslušného výrobcu. Používanie spotrebného materiálu alebo súčastí tretích strán môže ovplyvniť výkonnosť, spoľahlivosť alebo životnosť tlačiarne a jej tlačových súčastí. Všetky indikátory životnosti sú určené na fungovanie so súčasťami a spotrebným materiálom Lexmark a pri používaní spotrebného materiálu alebo súčastí tretích strán sa môžu správať nepredvídateľne. Používaním tlačových súčastí po určenej životnosti sa môže poškodiť tlačiareň Lexmark alebo priradené súčasti. Všetky indikátory životnosti sú určené na fungovanie so súčasťami a spotrebným materiálom Dell a pri používaní spotrebného materiálu alebo súčastí tretích strán sa môžu správať nepredvídateľne. Používaním tlačových súčastí po určenej životnosti sa môže poškodiť tlačiareň Dell alebo priradené súčasti. Všetky indikátory životnosti sú určené na fungovanie so súčasťami a spotrebným materiálom od výrobcu tlačiarne a pri používaní spotrebného materiálu alebo súčastí tretích strán sa môžu správať nepredvídateľne. Používaním tlačových súčastí po určenej životnosti sa môže poškodiť tlačiareň alebo priradené súčasti. Používanie spotrebného materiálu alebo súčastí tretích strán môže mať vplyv na záručné krytie. Záruka sa nevzťahuje na poškodenie spôsobené používaním spotrebného materiálu alebo súčastí tretích strán. Ak chcete prijať všetky tieto riziká a pokračovať v používaní neoriginálneho spotrebného materiálu alebo súčastí tlačiarne, dvoma prstami stlačte a 15 sekúnd podržte chybové hlásenie. Keď sa zobrazí dialógové okno s potvrdením, dotknite sa položky  Pokračovať . Ak tieto riziká nechcete prijať, vyberte spotrebný materiál alebo súčasti tretích strán a vložte originálny spotrebný materiál alebo súčasť od spoločnosti Lexmark. Ďalšie informácie nájdete v časti  . Ak tieto riziká nechcete prijať, vyberte spotrebný materiál alebo súčasti tretích strán a vložte originálny spotrebný materiál alebo súčasť od spoločnosti Dell. Ak tieto riziká nechcete prijať, vyberte spotrebný materiál alebo súčasti tretích strán a vložte originálny spotrebný materiál alebo súčasť od výrobcu tlačiarne. Ak tlačiareň nezačne tlačiť ani po odstránení chybového hlásenia, vynulujte počítadlo používania spotrebného materiálu. Na domovskej obrazovke sa dotknite položiek  Nastavenia Zariadenie Údržba Ponuka konfigurácie Počítadlá používania spotrebného materiálu . Vyberte súčasť alebo spotrebný materiál, ktoré chcete vynulovať, a dotknite sa položky  Spustiť . Prečítajte si správu s upozornením a dotknite sa položky  Pokračovať . Pomocou dvoch prstov sa dotknite displeja na 15 sekúnd, aby ste správu vymazali. Ak sa vám nepodarí vynulovať počítadlá používania spotrebného materiálu, vráťte príslušný spotrebný materiál na predajné miesto. hlásenia tlačiarne spotrebný materiál od iného výrobcu ako spoločnosti Lexmark spotrebný materiál od iného výrobcu ako spoločnosti Lexmark hlásenia tlačiarne spotrebný materiál od iného výrobcu ako spoločnosti Dell spotrebný materiál od iného výrobcu ako spoločnosti Dell hlásenia tlačiarne spotrebný materiál od iného výrobcu ako je výrobca tlačiarne spotrebný materiál od iného výrobcu ako je výrobca tlačiarne obnovenie počítadlá používania spotrebného materiálu počítadlá používania spotrebného materiálu obnovenie obnovenie počítadiel používania spotrebného materiálu"},{"UUID":"b92ec72b-043d-44e5-af08-9f56d073c779","title":"Problémy s podávaním papiera","link":"trb-envelope-seals-when-printing-topic.html","desc":"Obálka sa zalepí počas tlače","descFull":"Obálka sa zalepí počas tlače Postup riešenia problému Akcia Áno Nie Používajte obálky, ktoré boli skladované v suchom prostredí. Tlač na veľmi vlhké obálky môže spôsobiť ich zalepenie. Odošlite tlačovú úlohu. Zalepí sa obálka pri tlači? Problém je vyriešený. Uistite sa, či je typ papiera nastavený na možnosť Obálka. Na domovskej obrazovke sa dotknite položiek  Nastavenia Papier Konfigurácia zásobníkov Veľkosť/typ papiera . Odošlite tlačovú úlohu. Zalepí sa obálka pri tlači? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. riešenie problémov, tlač obálka sa zalepí počas tlače riešenie problémov s tlačou obálka sa zalepí počas tlače obálka sa zalepí počas tlače"},{"UUID":"3c0454e5-6d71-4ee9-a112-24257e39b292","title":"Problémy s podávaním papiera","link":"trb-envelope-seals-when-printing-topic.html","desc":"Zoradená tlač nefunguje Postup riešenia","descFull":"Zoradená tlač nefunguje Postup riešenia problému Akcia Áno Nie Na domovskej obrazovke sa dotknite položiek  Nastavenia Tlač Rozloženie Zoradiť. Dotknite sa položky  Zap. [1,2,1,2,1,2] . Vytlačte dokument. Je dokument správne zoradený? Problém je vyriešený. V dokumente, ktorý chcete tlačiť, otvorte dialógové okno Tlač a vyberte možnosť  Zoradiť . Vytlačte dokument. Je dokument správne zoradený? Problém je vyriešený. Znížte počet stránok určených na tlač. Vytlačte dokument. Sú stránky správne zoradené? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . riešenie problémov s tlačou zoradená tlač nefunguje riešenie problémov, tlač zoradená tlač nefunguje zoradená tlač nefunguje"},{"UUID":"79f0b52b-115f-4515-993e-6d73e20e6c71","title":"Problémy s podávaním papiera","link":"trb-envelope-seals-when-printing-topic.html","desc":"Prepojenie zásobníkov nefunguje Postup riešenia","descFull":"Prepojenie zásobníkov nefunguje Postup riešenia problému Akcia Áno Nie Skontrolujte, či zásobníky obsahujú papier rovnakej veľkosti a rovnakého typu. Skontrolujte, či sú vodiace lišty papiera správne umiestnené. Vytlačte dokument. Sú zásobníky správne prepojené? Problém je vyriešený. Na domovskej obrazovke sa dotknite položiek  Nastavenia Papier Konfigurácia zásobníkov Veľkosť/typ papiera . Nastavte veľkosť a typ papiera tak, aby zodpovedali papieru vloženému v prepojených zásobníkoch. Vytlačte dokument. Sú zásobníky správne prepojené? Problém je vyriešený. Skontrolujte, či je možnosť  Prepojenie na zásobník  nastavená na možnosť  Automatické . Ďalšie informácie nájdete v časti  . Vytlačte dokument. Sú zásobníky správne prepojené? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . riešenie problémov, tlač prepojenie zásobníkov nefunguje riešenie problémov s tlačou prepojenie zásobníkov nefunguje"},{"UUID":"b0433a2e-5d4d-4de9-bcf5-9a74fee14c30","title":"Problémy s podávaním papiera","link":"trb-envelope-seals-when-printing-topic.html","desc":"Papier sa často zasekáva Postup","descFull":"Papier sa často zasekáva Postup riešenia problému Akcia Áno Nie Vyberte zásobník. Skontrolujte, či je papier vložený správne. Uistite sa, že sú všetky vodiace lišty papiera správne umiestnené. Uistite sa, že výška stohu nepresahuje označenie maximálneho množstva papiera. Uistite sa, že tlačíte na odporúčaný typ a veľkosť papiera. Vložte zásobník. Vytlačte dokument. Často sa zasekáva papier? Problém je vyriešený. Na domovskej obrazovke sa dotknite položiek  Nastavenia Papier Konfigurácia zásobníkov Veľkosť/typ papiera . Nastavte správnu veľkosť a typ papiera. Vytlačte dokument. Často sa zasekáva papier? Problém je vyriešený. Vložte papier z nového balíka. Pri vysokej vlhkosti papier absorbuje vlhko. Papier vyberte z pôvodného balenia, až keď ho budete chcieť použiť. Vytlačte dokument. Často sa zasekáva papier? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. riešenie problémov, tlač papier sa často zasekáva riešenie problémov s tlačou papier sa často zasekáva papier sa často zasekáva"},{"UUID":"a0cc5cce-cbff-4b34-be98-ddecdc9cd150","title":"Problémy s podávaním papiera","link":"trb-envelope-seals-when-printing-topic.html","desc":"Zaseknuté strany sa nevytlačia znova","descFull":"Zaseknuté strany sa nevytlačia znova Postup riešenia problému Akcia Áno Nie Na domovskej obrazovke ťuknite na položky  Nastavenia Zariadenie Upozornenia Obnovenie zaseknutého obsahu. V ponuke Obnova po zaseknutí sa dotknite položky  Zap.  alebo  Automaticky . Vytlačte dokument. Vytlačili sa zaseknuté strany? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . riešenie problémov, tlač zaseknuté strany sa nevytlačia znova zaseknuté strany sa nevytlačia znova"},{"UUID":"151f88b4-00c3-454b-9d06-db853c7bcf29","title":"Problémy s e-mailami","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Vypnutie chybového hlásenia „Nie je","descFull":"Vypnutie chybového hlásenia „Nie je nastavený server SMTP“ Na domovskej obrazovke sa dotknite položiek  Nastavenia E‑mail Nastavenie e‑mailu Vypnúť chybu „Nie je nastavený server SMTP“ Zap. . Aby ste zabránili opätovnému výskytu chyby, vykonajte jeden alebo viacero z nasledujúcich krokov: Aktualizujte firmvér tlačiarne. Ďalšie informácie nájdete v časti  . Nakonfigurujte nastavenia protokolu e‑mail SMTP. Ďalšie informácie nájdete v časti  . chyba: nie je nastavený server SMTP zakázanie riešenie problémov chyba: nie je nastavený server SMTP zakázanie chyby Nie je nastavený server SMTP"},{"UUID":"a2b52206-c893-42ea-99a4-528b9209c871","title":"Problémy s e-mailami","link":"disabling-smtp-server-not-setup-error-topic.html","desc":"Nemožno odosielať e-maily Postup riešenia","descFull":"Nemožno odosielať e-maily Postup riešenia problému Akcia Áno Nie Skontrolujte, či sú správne nakonfigurované nastavenia e-mailového protokolu SMTP. Ďalšie informácie nájdete v časti  . Môžete odoslať e‑mail? Problém je vyriešený. Skontrolujte, či používate správne heslo. V závislosti od poskytovateľa e‑mailových služieb použite heslo účtu, heslo aplikácie alebo heslo na overenie totožnosti. Ďalšie informácie nájdete v časti  . Môžete odoslať e‑mail? Problém je vyriešený. Skontrolujte, či je tlačiareň pripojená k sieti a sieť je pripojená k internetu. Môžete odoslať e‑mail? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . riešenie problémov s e‑mailom nie je možné odosielať e-maily riešenie problémov, e‑mail nie je možné odosielať e-maily nie je možné odosielať e-maily"},{"UUID":"caefcab5-7bf6-4a14-89de-af2f092e586c","title":"Problémy s faxovaním","link":"trb-caller-id-not-shown-topic.html","desc":"ID volajúceho sa nezobrazuje Tieto","descFull":"ID volajúceho sa nezobrazuje Tieto pokyny sa vzťahujú len na tlačiarne s podporou analógového faxu. Ďalšie informácie nájdete v časti   Nastavenie tlačiarne na fax . Postup riešenia problému Akcia Áno Nie Povoliť ID volajúceho. Na domovskej obrazovke sa dotknite položiek  Nastavenia Fax Nastavenie faxu Nastavenia príjmu faxov Ovládacie prvky správcu Povoliť ID volajúceho. Zobrazuje sa ID volajúceho? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . riešenie problémov, fax ID volajúceho sa nezobrazuje riešenie problémov s faxom ID volajúceho sa nezobrazuje ID volajúceho sa nezobrazuje"},{"UUID":"c7e22e7e-fc45-444b-924a-de0cc9aca3ba","title":"Problémy s faxovaním","link":"trb-caller-id-not-shown-topic.html","desc":"Nie je možné odosielať ani","descFull":"Nie je možné odosielať ani prijímať faxy pomocou analógového faxu Postup riešenia problému Akcia Áno Nie Vyriešte všetky chybové hlásenia, ktoré sa zobrazia na displeji. Funguje prijímanie alebo odosielanie faxov? Problém je vyriešený. Uistite sa, že káblové pripojenie nasledujúcich zariadení je zabezpečené: Telefón Slúchadlo Telefónny záznamník Funguje prijímanie alebo odosielanie faxov? Problém je vyriešený. Počúvajte, či sa ozve oznamovací tón. Zavolajte na faxové číslo, aby ste zistili, či funguje správne. Ak používate funkciu vytáčania so zloženým slúchadlom, zvýšte hlasitosť a počúvajte, či sa ozve oznamovací tón. Ozval sa oznamovací tón? Prejdite na krok 5. Skontrolujte telefónnu sieťovú zásuvku. Zapojte analógový telefón priamo do sieťovej zásuvky. Počúvajte, či sa ozve oznamovací tón. Ak sa oznamovací tón neozýva, použite iný telefónny kábel. Ak sa oznamovací tón stále neozýva, zapojte analógový telefón do inej sieťovej zásuvky. Ak sa oznamovací tón ozve, zapojte do tejto sieťovej zásuvky tlačiareň. Funguje prijímanie alebo odosielanie faxov? Problém je vyriešený. Skontrolujte, či je tlačiareň pripojená k analógovej telefónnej službe alebo do správnej digitálnej prípojky. Ak využívate telefónnu službu ISDN (Integrated Services for Digital Network), tlačiareň pripojte k analógovému telefónnemu portu terminálového adaptéra ISDN. Ďalšie informácie získate od poskytovateľa služieb ISDN. Ak využívate služby DSL, pripojte sa k filtru DSL alebo smerovaču, ktorý podporuje analógové použitie. Ďalšie informácie získate od poskytovateľa služieb DSL. Ak využívate telefónnu službu pobočkovej ústredne (PBX), uistite sa, že tlačiareň pripájate k analógovému pripojeniu PBX. Ak žiadne pripojenie neexistuje, porozmýšľajte nad zavedením analógovej telefónnej linky pre fax. Funguje prijímanie alebo odosielanie faxov? Problém je vyriešený. Dočasne odpojte ďalšie zariadenia a vypnite ďalšie telefónne služby. Odpojte ďalšie zariadenia (ako sú napr. telefónne záznamníky, počítače, modemy či rozbočovače telefónnej linky) umiestnené medzi tlačiarňou a telefónnou linkou. Vypnite funkcie čakania hovoru a hlasovej schránky. Ďalšie informácie získate od telefónnej spoločnosti. Funguje prijímanie alebo odosielanie faxov? Problém je vyriešený. Naskenujte pôvodný dokument po jednotlivých stranách. Vytočte faxové číslo. Naskenujte dokument. Funguje prijímanie alebo odosielanie faxov? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . riešenie problémov s faxom nie je možné odosielať ani prijímať faxy pomocou analógového faxu riešenie problémov, fax nie je možné odosielať ani prijímať faxy pomocou analógového faxu nie je možné odosielať ani prijímať faxy pomocou analógového faxu"},{"UUID":"9738e4fc-ee77-41d4-a1ee-e227e3261c78","title":"Problémy s faxovaním","link":"trb-caller-id-not-shown-topic.html","desc":"Analógové faxy sa dajú prijímať,","descFull":"Analógové faxy sa dajú prijímať, ale nie odosielať Postup riešenia problému Akcia Áno Nie Zdrojový dokument správne vložte do zásobníka automatického podávača dokumentov alebo ho položte na skenovacie sklo. Dajú sa faxy odosielať? Problém je vyriešený. Správne nastavte číslo skratky. Skontrolujte, či číslo skratky platí pre telefónne číslo, ktoré chcete zadať. Telefónne číslo zadajte manuálne. Dajú sa faxy odosielať? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . riešenie problémov s faxom nie je možné odosielať faxy pomocou analógového faxu riešenie problémov, fax nie je možné odosielať faxy pomocou analógového faxu"},{"UUID":"4ab76573-62b9-48a3-a67c-3d1f407d30ce","title":"Problémy s faxovaním","link":"trb-caller-id-not-shown-topic.html","desc":"Analógové faxy sa dajú odosielať,","descFull":"Analógové faxy sa dajú odosielať, ale nie prijímať Postup riešenia problému Akcia Áno Nie Uistite sa, že zdroj papiera nie je prázdny. Dajú sa faxy prijímať? Problém je vyriešený. Skontrolujte nastavenia oneskorenia počtu zvonení. Na domovskej obrazovke sa dotknite položiek  Nastavenia Fax Nastavenie faxu Nastavenia príjmu faxov Počet zvonení pred odpoveďou . Dajú sa faxy prijímať? Problém je vyriešený. Ak tlačiareň tlačí prázdne strany, pozrite si časť  . Dajú sa faxy prijímať? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . riešenie problémov s faxom analógové faxy sa dajú odosielať, ale nie prijímať riešenie problémov, fax analógové faxy sa dajú odosielať, ale nie prijímať nie je možné prijímať faxy pomocou analógového faxu"},{"UUID":"fd3d650c-a817-4ecc-8bb0-42418d94c4bf","title":"Problémy s faxovaním","link":"trb-caller-id-not-shown-topic.html","desc":"Nie je možné nastaviť etherFAX","descFull":"Nie je možné nastaviť etherFAX Postup riešenia problému Akcia Áno Nie Skontrolujte pripojenie tlačiarne. Vytlačte  stránku nastavenia siete . Na domovskej obrazovke sa dotknite položiek  Nastavenia Správy Sieť Stránka nastavenia siete . Skontrolujte stav tlačiarne. Je tlačiareň pripojená k sieti? Prejdite na krok 3. Skontrolujte, či je tlačiareň pripojená k sieti a sieť je pripojená k internetu. Môžete nastaviť etherFAX? Problém je vyriešený. Uistite sa, že je služba etherFAX správne nastavená. Ďalšie informácie nájdete v časti  . Môžete nastaviť etherFAX? Problém je vyriešený. Prejdite na adresu  https://www.etherfax.net/lexmark . riešenie problémov s faxom nie je možné nastaviť etherFAX riešenie problémov, fax nie je možné nastaviť etherFAX"},{"UUID":"b5232b3a-ab19-4568-9e44-63503e2586d6","title":"Problémy s faxovaním","link":"trb-caller-id-not-shown-topic.html","desc":"Nemožno prijímať alebo odosielať faxy","descFull":"Nemožno prijímať alebo odosielať faxy cez etherFAX Postup riešenia problému Akcia Áno Nie Skontrolujte, či je tlačiareň pripojená k sieti a sieť je pripojená k internetu. Môžete odosielať a prijímať faxy pomocou služby etherFAX? Problém je vyriešený. Uistite sa, že je služba etherFAX správne nastavená. Na domovskej obrazovke sa dotknite položiek  Nastavenia Fax Nastavenie faxu Všeobecné nastavenia faxu. Skontrolujte, či je zadané správne faxové číslo. Skontrolujte, či je možnosť  Prenos faxu  nastavená na  etherFAX . Táto ponuka sa zobrazí len vtedy, keď je k dispozícii viac ako jeden prenos faxu. Ak má tlačiareň nainštalovanú len službu etherFAX, automaticky sa nakonfiguruje. Môžete odosielať a prijímať faxy pomocou služby etherFAX? Problém je vyriešený. Veľké dokumenty rozdeľte na súbory s menšou veľkosťou. Môžete odosielať a prijímať faxy pomocou služby etherFAX? Problém je vyriešený. Prejdite na adresu  https://www.etherfax.net/lexmark . riešenie problémov s faxom nemožno prijímať alebo odosielať faxy cez etherFAX riešenie problémov, fax nemožno prijímať alebo odosielať faxy cez etherFAX nemožno prijímať alebo odosielať faxy cez etherFAX"},{"UUID":"475147f6-e52d-49b5-a142-7d16dda6a177","title":"Problémy s faxovaním","link":"trb-caller-id-not-shown-topic.html","desc":"Nízka kvalita tlače faxu Postup","descFull":"Nízka kvalita tlače faxu Postup riešenia problému Akcia Áno Nie Uistite sa, či nedošlo k chybám z hľadiska kvality tlače. Na domovskej obrazovke sa dotknite položiek  Nastavenia Riešenie problémov Tlačiť strany testu kvality . Opravte všetky chyby kvality tlače. Ďalšie informácie nájdete v časti  . Je kvalita tlače faxu dostatočná? Problém je vyriešený. Ak používate analógový fax, znížte rýchlosť prenosu prichádzajúceho faxu. Na domovskej obrazovke sa dotknite položiek  Nastavenia Fax Nastavenie faxu Nastavenia príjmu faxov Ovládacie prvky správcu . V ponuke Maximálna rýchlosť vyberte nižšiu prenosovú rýchlosť. Je kvalita tlače faxu dostatočná? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . riešenie problémov s faxom znížená kvalita tlače nízka kvalita tlače faxu riešenie problémov, fax znížená kvalita tlače"},{"UUID":"fdd5703f-ddc1-4a9a-aace-fa85b519e616","title":"Problémy s faxovaním","link":"trb-caller-id-not-shown-topic.html","desc":"Chýbajúce informácie na úvodnej strane","descFull":"Chýbajúce informácie na úvodnej strane faxu Postup riešenia problému Akcia Nie Áno Tlačiareň vypnite, počkajte 10 sekúnd a potom ju znova zapnite. Odoslanie alebo prijatie faxu. Chýbajú na úvodnej strane faxu informácie? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . riešenie problémov s faxom chýbajúce informácie na úvodnej strane faxu riešenie problémov, fax chýbajúce informácie na úvodnej strane faxu chýbajúce informácie na úvodnej strane faxu"},{"UUID":"2833e42f-2590-40a0-b262-0142a37ca076","title":"Problémy s faxovaním","link":"trb-caller-id-not-shown-topic.html","desc":"Nie je možné z počítača odoslať","descFull":"Nie je možné z počítača odoslať úvodnú stranu faxu Postup riešenia problému Akcia Áno Nie Uistite sa, že je ovládač tlače aktualizovaný. Ďalšie informácie nájdete v časti  . Odošlite fax. Môžete odoslať úvodnú stranu faxu? Problém je vyriešený. V dokumente, ktorý chcete odoslať faxom, otvorte dialógové okno  Tlač . Vyberte tlačiareň a kliknite na položky  Vlastnosti ,  Predvoľby ,  Možnosti  alebo  Nastavenie . Kliknite na  Fax  a zrušte nastavenie  Pred faxovaním vždy zobraziť nastavenia . Odošlite fax. Môžete odoslať úvodnú stranu faxu? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . riešenie problémov s faxom nie je možné z počítača odoslať úvodnú stranu faxu riešenie problémov, fax nie je možné z počítača odoslať úvodnú stranu faxu nie je možné z počítača odoslať úvodnú stranu faxu"},{"UUID":"1be02a55-e25c-47c7-ab6e-a74442966abe","title":"Problémy so skenovaním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nemožno skenovať do počítača Postup","descFull":"Nemožno skenovať do počítača Postup riešenia problému Akcia Áno Nie Vykonajte kopírovaciu úlohu. Je kopírovacia úloha úspešná? Prejdite na krok 3. Tlačiareň vypnite, počkajte 10 sekúnd a potom ju znova zapnite. Naskenujte dokument. Môžete naskenovať dokument do počítača? Problém je vyriešený. Skontrolujte pripojenie tlačiarne. Vytlačte  stránku nastavenia siete . Na domovskej obrazovke sa dotknite položiek  Nastavenia Správy Sieť Stránka nastavenia siete. Skontrolujte stav tlačiarne. Je tlačiareň pripojená k sieti? Prejdite na krok 5. Pripojte tlačiareň k sieti. Naskenujte dokument. Môžete naskenovať dokument do počítača? Problém je vyriešený. Skontrolujte, či sú tlačiareň a počítač pripojené k rovnakej sieti. Naskenujte dokument. Môžete naskenovať dokument do počítača? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . riešenie problémov skenovania nie je možné skenovať do počítača riešenie problémov, skenovanie nie je možné skenovať do počítača nie je možné skenovať do počítača"},{"UUID":"b9d8fac7-3db2-42c8-8157-faf1717ee8db","title":"Problémy so skenovaním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nemožno skenovať do sieťového priečinka","descFull":"Nemožno skenovať do sieťového priečinka Postup riešenia problému Akcia Áno Nie Vytvorte odkaz na sieťový priečinok. Naskenujte dokument pomocou odkazu. Ďalšie informácie nájdete v časti  . Môžete naskenovať dokument a uložiť ho do sieťového priečinka? Problém je vyriešený. Uistite sa, že cesta k sieťovému priečinku a jeho formát sú správne. Napríklad  // server_hostname /foldername/path , pričom  server_hostname  predstavuje plne kvalifikovanú doménu (FQDN) alebo adresu IP. Sú cesta k sieťovému priečinku a jej formát správne? Prejdite na krok 4. Skontrolujte, či máte povolenie na prístup a zápis do sieťového priečinka. Môžete naskenovať dokument a uložiť ho do sieťového priečinka? Problém je vyriešený. Aktualizujte odkaz na sieťový priečinok. Otvorte webový prehliadač a do poľa adresy zadajte adresu IP tlačiarne. Pozrite si adresu IP tlačiarne na domovskej obrazovke. IP Adresa sa zobrazuje ako štyri skupiny čísel, ktoré sú oddelené bodkami, napríklad 123.123.123.123. Ak používate server proxy, dočasne ho vypnite, aby sa webová stránka správne načítala. Kliknite na možnosť  Odkazy  a potom vyberte odkaz. Ak máte viacero typov odkazov, vyberte položku  Sieťový priečinok . Do poľa  Zdieľaná cesta  zadajte cestu k sieťovému priečinku. Ak je zdieľaná cesta  \\\\server_hostname\\foldername\\path , zadajte text  //server_hostname/foldername/path . Pri zadávaní zdieľanej cesty používajte predné lomky. V ponuke  Overenie  vyberte svoj spôsob overenia. Ak je položka  Overenie  nastavená na možnosť  Použiť pridelené používateľské meno a heslo , do polí  Používateľské meno  a  Heslo  zadajte svoje prihlasovacie údaje. Kliknite na možnosť  Uložiť . Môžete naskenovať dokument a uložiť ho do sieťového priečinka? Problém je vyriešený. Skontrolujte, či sú tlačiareň a sieťový priečinok pripojené k rovnakej sieti. Môžete naskenovať dokument a uložiť ho do sieťového priečinka? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . nie je možné skenovať do sieťového priečinka riešenie problémov, skenovanie nie je možné skenovať do sieťového priečinka riešenie problémov skenovania nemožno skenovať do sieťového priečinka"},{"UUID":"1c604c36-f82f-4d38-aa04-5c209ccd6ba7","title":"Problémy so skenovaním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Čiastočné kópie dokumentu alebo fotografie","descFull":"Čiastočné kópie dokumentu alebo fotografie Postup riešenia problému Akcia Áno Nie Uistite sa, že dokument alebo fotografia sú vložené tvárou nadol v ľavom hornom roku skenovacieho skla. Skopírujte dokument alebo fotografiu. Skopíroval sa dokument alebo fotografia správne? Problém je vyriešený. Nastavenia veľkosti papiera a papier vložený v zásobníku by sa mali zhodovať. Skopírujte dokument alebo fotografiu. Skopíroval sa dokument alebo fotografia správne? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . problém s kvalitou skenovania čiastočné kópie dokumentov problém s kvalitou skenovania čiastočné kópie fotografií problém s kvalitou skenovania čiastočné kópie dokumentov problém s kvalitou skenovania čiastočné kópie fotografií čiastočné kópie dokumentov čiastočné kópie fotografií"},{"UUID":"3fb2d826-2f52-486d-b2b5-185a1d3bd458","title":"Problémy so skenovaním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Nízka kvalita kopírovania Postup riešenia","descFull":"Nízka kvalita kopírovania Postup riešenia problému Akcia Áno Nie Skenovacie sklo a sklo automatického podávača dokumentov vyčistite navlhčenou mäkkou tkaninou, ktorá nepúšťa vlákna. Ak sa vnútri vašej tlačiarne nachádza druhé sklo automatického podávača dokumentov, vyčistite aj to. Ďalšie informácie nájdete v časti  . Uistite sa, že dokument alebo fotografia sú vložené tvárou nadol v ľavom hornom roku skenovacieho skla. Skopírujte dokument alebo fotografiu. Je kvalita kópie dostatočná? Problém je vyriešený. Skontrolujte kvalitu zdrojového dokumentu alebo fotografie. Upravte nastavenia kvality skenovania. Skopírujte dokument alebo fotografiu. Je kvalita kópie dostatočná? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . problém s kvalitou skenovania nízka kvalita kópií problém s kvalitou skenovania nízka kvalita kópií nízka kvalita kópií"},{"UUID":"00e5bf31-d410-4a4a-8ff3-cecdafe80b7f","title":"Problémy so skenovaním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Zvislé tmavé čiary na výtlačku","descFull":"Zvislé tmavé čiary na výtlačku pri skenovaní z automatického podávača dokumentov Postup riešenia problému Akcia Áno Nie Otvorte kryt skenera. Navlhčenou mäkkou tkaninou, z ktorej sa neuvoľňujú vlákna, utrite sklo automatického podávača dokumentov a skenovací blok skla automatického podávača dokumentov. Zatvorte kryt skenera. Naskenujte dokument. Objavujú sa na skenovaných dokumentoch zvislé čiary? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s kvalitou skenovania zvislé tmavé pásy problém s kvalitou skenovania zvislé tmavé pásy zvislé tmavé pásy skenovanie z automatického podávača dokumentov skenovanie z PDF zvislé tmavé pásy"},{"UUID":"5adc99f4-aec9-44c9-be36-389d12d2b4fb","title":"Problémy so skenovaním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Zubatý obrázok alebo text pri","descFull":"Zubatý obrázok alebo text pri skenovaní z automatického podávača dokumentov Postup riešenia problému Akcia Áno Nie Vložte do automatického podávača dokumentov 50 hárkov čistého obyčajného papiera. Obyčajný papier pomáha s čistením a odstránením prachu a ďalších nánosov z podávacích valcov automatického podávača dokumentov. Na domovskej stránke sa dotknite položky  . Vložte do automatického podávača dokumentov zdrojový dokument. Naskenujte dokument. Obsahuje výstup zubatý obrázok alebo text? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problém s kvalitou skenovania zubatý obrázok problém s kvalitou skenovania zubatý text zubatý obrázok skenovanie z automatického podávača dokumentov zubatý text skenovanie z automatického podávača dokumentov"},{"UUID":"28b8a5cf-15ff-49a5-8710-a362c8e93ecb","title":"Problémy so skenovaním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Úloha skenovania nebola úspešná Postup","descFull":"Úloha skenovania nebola úspešná Postup riešenia problému Akcia Áno Nie Skontrolujte káblové pripojenie. Uistite sa, že kábel USB alebo siete Ethernet je riadne pripojený k počítaču a tlačiarni. Naskenujte dokument. Je úloha skenovania úspešná? Problém je vyriešený. Skontrolujte súbor, ktorý chcete naskenovať. Uistite sa, že názov súboru sa ešte v cieľovom priečinku nepoužíva. Uistite sa, že dokument alebo fotografia určené na skenovanie, nie sú otvorené v inej aplikácii. Naskenujte dokument. Je úloha skenovania úspešná? Problém je vyriešený. Uistite sa, že v nastaveniach cieľovej konfigurácie je začiarknutá položka Pridať časovú známku alebo Prepísať existujúci súbor. Naskenujte dokument. Je úloha skenovania úspešná? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . úloha skenovania nebola úspešná problémy so skenovaním úloha skenovania nebola úspešná"},{"UUID":"2c8214b6-2e49-46e4-b1b1-6772497fe6ce","title":"Problémy so skenovaním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skener sa nezatvára Postup riešenia","descFull":"Skener sa nezatvára Postup riešenia problému Akcia Áno Nie Odstráňte prekážky, ktoré bránia zatvoreniu krytu skenera. Zatvorila sa kryt skenera správne? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . problémy s kopírovaním skener sa nezatvára problémy so skenovaním skener sa nezatvára skener sa nezatvára"},{"UUID":"92ac4013-cbef-49e4-9318-a5c4ae0320af","title":"Problémy so skenovaním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skenovanie trvá príliš dlho alebo","descFull":"Skenovanie trvá príliš dlho alebo spôsobí zamrznutie počítača Postup riešenia problému Akcia Áno Nie Zatvorte všetky aplikácie, ktoré zasahujú do skenovania. Trvá skenovanie príliš dlho alebo spôsobí zamrznutie počítača? Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . Problém je vyriešený. problémy so skenovaním skenovanie trvá príliš dlho problémy so skenovaním počítač zamrzne počas skenovania"},{"UUID":"63364a8e-737f-47fd-a0d4-2463a2885cfd","title":"Problémy so skenovaním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Skener nereaguje Postup riešenia problému","descFull":"Skener nereaguje Postup riešenia problému Akcia Áno Nie Skontrolujte, či je napájací kábel správne pripojený k tlačiarni a elektrickej zásuvke. Riziku požiaru alebo zásahu elektrickým prúdom sa vyhnete tak, že zapojíte napájací kábel do riadne označenej a správne uzemnenej elektrickej zásuvky, ktorá sa nachádza blízko produktu a je ľahko dostupná. Skopírujte alebo naskenujte dokument. Skener reaguje? Problém je vyriešený. Skontrolujte, či je tlačiareň zapnutá. Vyriešte všetky chybové hlásenia, ktoré sa zobrazia na displeji. Skopírujte alebo naskenujte dokument. Skener reaguje? Problém je vyriešený. Tlačiareň vypnite, počkajte približne 10 sekúnd a potom tlačiareň zapnite. Skopírujte alebo naskenujte dokument. Skener reaguje? Problém je vyriešený. Kontaktujte  podporu pre zákazníkov . Kontaktujte  technickú podporu . Kontaktujte svojho  predajcu . problémy s kopírovaním skener nereaguje problémy so skenovaním skener nereaguje skener nereaguje"},{"UUID":"4dbb0ea3-61c9-4647-a371-1781c6e4c6ec","title":"Problémy so skenovaním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Úprava registrácie skenera Na domovskej","descFull":"Úprava registrácie skenera Na domovskej obrazovke sa dotknite položky  Nastavenia Zariadenie Údržba Ponuka konfigurácie Konfigurácia skenera Manuálna registrácia skenera . V ponuke Rýchly test tlače sa dotknite položky  Spustenie . Položte stránku rýchleho testu tlače na skenovacie sklo a dotknite sa položky  Registrácia plochého skenera . V ponuke Rýchly test kopírovania sa dotknite položky  Spustenie . Porovnajte stránku rýchleho testu kopírovania so zdrojovým dokumentom. Ak sa okraje testovacej stránky líšia od zdrojového dokumentu, upravte položky Ľavý okraj a Horný okraj. Kroky   a   opakujte dovtedy, kým okraje stránky rýchleho testu kopírovania nebudú zodpovedať zdrojovému dokumentu. nastavenie registrácia skenera"},{"UUID":"5e11a3e6-6e9c-4098-ba78-c06280fc5330","title":"Problémy so skenovaním","link":"trb-cannot-scan-to-computer-topic.html","desc":"Úprava registrácie automatického podávača dokumentov","descFull":"Úprava registrácie automatického podávača dokumentov Na domovskej obrazovke sa dotknite položky  Nastavenia Zariadenie Údržba Ponuka konfigurácie Konfigurácia skenera Manuálna registrácia skenera . V ponuke Rýchly test tlače sa dotknite položky  Spustenie . Umiestnite stánku rýchleho testu tlače do zásobníka automatického podávača dokumentov. Dotknite sa položky  Registrácia predného automatického podávača dokumentov  alebo položky  Registrácia zadného automatického podávača dokumentov . Ak chcete zarovnať registráciu predného automatického podávača dokumentov, položte testovaciu stránku lícom nahor, krátkym okrajom napred do zásobníka automatického podávača dokumentov. Ak chcete zarovnať registráciu zadného automatického podávača dokumentov, položte testovaciu stránku lícom nadol, krátkym okrajom napred do zásobníka automatického podávača dokumentov. V ponuke Rýchly test kopírovania sa dotknite položky  Spustenie . Porovnajte stránku rýchleho testu kopírovania so zdrojovým dokumentom. Ak sa okraje testovacej stránky líšia od zdrojového dokumentu, upravte položky Horizontálna úprava a Horný okraj. Kroky   a   opakujte dovtedy, kým okraje stránky rýchleho testu kopírovania nebudú zodpovedať zdrojovému dokumentu. Registrácia automatického podávača dokumentov nastavenie úprava registrácie automatického podávača dokumentov"},{"UUID":"36e5280c-4462-4ff0-ab27-58202337a11a","title":"Riešenie problémov","link":"trb-contacting-customer-support-topic.html","desc":"Kontaktovanie podpory pre zákazníkov Pred","descFull":"Kontaktovanie podpory pre zákazníkov Pred kontaktovaním podpory pre zákazníkov sa uistite, že máte k dispozícii nasledujúce informácie: Problém s tlačiarňou Chybové hlásenie Typ modelu a sériové číslo tlačiarne Prejdite na adresu  http://support.lexmark.com , ak chcete dostávať maily alebo podporu cez chat, prezerať knižnicu návodov na používanie, podpornú dokumentáciu, ovládače a iné súbory na prevzatie. K dispozícii je aj telefonická technická podpora. V USA a Kanade volajte na číslo 1-800-539-6275. V prípade iných krajín alebo regiónov prejdite na  zoznam kontaktov medzinárodnej podpory . Navštívte miesto, kde ste si tlačiareň zakúpili. kontaktovanie podpory pre zákazníkov podpora pre zákazníkov kontaktovanie"},{"UUID":"facd0ff2-4c0b-46b9-9996-4bf737f565a8","title":"Riešenie problémov","link":"troubleshooting-chapter.html","desc":"Kontaktovanie technickej podpory Keď zavoláte","descFull":"Kontaktovanie technickej podpory Keď zavoláte na oddelenie technickej podpory, opíšte daný problém, zobrazovanú správu na displeji tlačiarne a postup riešenia problému, ktorý ste už podnikli. Pozrite si štítok na vnútornej strane horného predného krytu alebo na zadnej strane tlačiarne a zaznamenajte si tieto informácie: model tlačiarne, číslo servisného štítku alebo kód expresného servisu. Ďalšie informácie nájdete na adrese  www.dell.com/support . riešenie problémov kontaktovanie technickej podpory kontaktovanie technickej podpory"},{"UUID":"01c86288-ec36-40c6-8ec6-555a7c759e7f","title":"Riešenie problémov","link":"troubleshooting-chapter.html","desc":"Kontaktovanie predajcu Pred kontaktovaním predajcu","descFull":"Kontaktovanie predajcu Pred kontaktovaním predajcu sa uistite, že máte k dispozícii nasledujúce informácie: Problém s tlačiarňou Chybové hlásenie Typ modelu a sériové číslo tlačiarne kontaktovanie predajcu predajca tlačiarne"},{"UUID":"8d719beb-a53e-4806-87b2-7eff8c987419","title":"Recyklácia a likvidácia","link":"recycling-lexmark-products-topic.html","desc":"Recyklácia produktov Lexmark Vrátenie produktov","descFull":"Recyklácia produktov Lexmark Vrátenie produktov Lexmark na recykláciu: Prejdite na stránku  www.lexmark.com/recycle . Vyberte svoju krajinu alebo región. Vyberte program recyklácie. Postupujte podľa pokynov na obrazovke. recyklácia produktov Lexmark"},{"UUID":"9913d211-8787-4b9c-b51d-4104a25a7fda","title":"Recyklácia a likvidácia","link":"recycling-lexmark-packaging-topic.html","desc":"Recyklácia obalov Lexmark Spoločnosť Lexmark","descFull":"Recyklácia obalov Lexmark Spoločnosť Lexmark sa neustále snaží minimalizovať obalové materiály. Menej obalových materiálov zaručuje, že tlačiarne Lexmark sa prenášajú čo najefektívnejšie a environmentálne najšetrnejšie a že pre vás bude jednoduchšie zbaviť sa obalov. Zabezpečíme tak aj vznik menšieho množstva emisií skleníkových plynov, úsporu energie a prírodných zdrojov. Spoločnosť Lexmark navyše v niektorých krajinách alebo regiónoch ponúka recykláciu obalových materiálov. Pre ďalšie informácie prejdite na stránku  www.lexmark.com/recycle  a vyberte svoju krajinu alebo región. Informácie o dostupných programoch recyklácie obalových materiálov nájdete pri informáciách o recyklácii produktu. Kartóny Lexmark sú 100 % recyklovateľné v zariadeniach na recykláciu lepenky. Vo vašej oblasti takéto zariadenia nemusia existovať. Pena, ktorú spoločnosť Lexmark používa pri balení, je recyklovateľná v zariadeniach na recykláciu peny. Vo vašej oblasti takéto zariadenia nemusia existovať.  Keď vrátite kazetu spoločnosti Lexmark, môžete znovu použiť krabičku, v ktorej ste kazetu dostali. Spoločnosť Lexmark krabičku zrecykluje. recyklácia obalové materiály Lexmark"}]

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
WHAT: SublimeText-like Fuzzy Search

USAGE:
  fuzzysort.single('fs', 'Fuzzy Search') // {score: -16}
  fuzzysort.single('test', 'test') // {score: 0}
  fuzzysort.single('doesnt exist', 'target') // null

  fuzzysort.go('mr', ['Monitor.cpp', 'MeshRenderer.cpp'])
  // [{score: -18, target: "MeshRenderer.cpp"}, {score: -6009, target: "Monitor.cpp"}]

  fuzzysort.highlight(fuzzysort.single('fs', 'Fuzzy Search'), '<b>', '</b>')
  // <b>F</b>uzzy <b>S</b>earch
*/

// UMD (Universal Module Definition) for fuzzysort
;(function(root, UMD) {
  if(true) !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (UMD),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  else if(typeof module === 'object' && module.exports) module.exports = UMD()
  else root.fuzzysort = UMD()
})(this, function UMD() { function fuzzysortNew(instanceOptions) {

  var fuzzysort = {

    single: function(search, target, options) {
      if(!search) return null
      if(!isObj(search)) search = fuzzysort.getPreparedSearch(search)

      if(!target) return null
      if(!isObj(target)) target = fuzzysort.getPrepared(target)

      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      return algorithm(search, target, search[0])
      // var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      // var result = algorithm(search, target, search[0])
      // if(result === null) return null
      // if(result.score < threshold) return null
      // return result
    },

    go: function(search, targets, options) {
      if(!search) return noResults
      search = fuzzysort.prepareSearch(search)
      var searchLowerCode = search[0]

      var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
      var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
      var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
        : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
        : true
      var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
      var resultsLen = 0; var limitedCount = 0
      var targetsLen = targets.length

      // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

      // options.keys
      if(options && options.keys) {
        var scoreFn = options.scoreFn || defaultScoreFn
        var keys = options.keys
        var keysLen = keys.length
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var objResults = new Array(keysLen)
          for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
            var key = keys[keyI]
            var target = getValue(obj, key)
            if(!target) { objResults[keyI] = null; continue }
            if(!isObj(target)) target = fuzzysort.getPrepared(target)

            objResults[keyI] = algorithm(search, target, searchLowerCode)
          }
          objResults.obj = obj // before scoreFn so scoreFn can use it
          var score = scoreFn(objResults)
          if(score === null) continue
          if(score < threshold) continue
          objResults.score = score
          if(resultsLen < limit) { q.add(objResults); ++resultsLen }
          else {
            ++limitedCount
            if(score > q.peek().score) q.replaceTop(objResults)
          }
        }

      // options.key
      } else if(options && options.key) {
        var key = options.key
        for(var i = targetsLen - 1; i >= 0; --i) { var obj = targets[i]
          var target = getValue(obj, key)
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue

          // have to clone result so duplicate targets from different obj can each reference the correct obj
          result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }

      // no keys
      } else {
        for(var i = targetsLen - 1; i >= 0; --i) { var target = targets[i]
          if(!target) continue
          if(!isObj(target)) target = fuzzysort.getPrepared(target)

          var result = algorithm(search, target, searchLowerCode)
          if(result === null) continue
          if(result.score < threshold) continue
          if(resultsLen < limit) { q.add(result); ++resultsLen }
          else {
            ++limitedCount
            if(result.score > q.peek().score) q.replaceTop(result)
          }
        }
      }

      if(resultsLen === 0) return noResults
      var results = new Array(resultsLen)
      for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
      results.total = resultsLen + limitedCount
      return results
    },

    goAsync: function(search, targets, options) {
      var canceled = false
      var p = new Promise(function(resolve, reject) {
        if(!search) return resolve(noResults)
        search = fuzzysort.prepareSearch(search)
        var searchLowerCode = search[0]

        var q = fastpriorityqueue()
        var iCurrent = targets.length - 1
        var threshold = options && options.threshold || instanceOptions && instanceOptions.threshold || -9007199254740991
        var limit = options && options.limit || instanceOptions && instanceOptions.limit || 9007199254740991
        var allowTypo = options && options.allowTypo!==undefined ? options.allowTypo
          : instanceOptions && instanceOptions.allowTypo!==undefined ? instanceOptions.allowTypo
          : true
        var algorithm = allowTypo ? fuzzysort.algorithm : fuzzysort.algorithmNoTypo
        var resultsLen = 0; var limitedCount = 0
        function step() {
          if(canceled) return reject('canceled')

          var startMs = Date.now()

          // This code is copy/pasted 3 times for performance reasons [options.keys, options.key, no keys]

          // options.keys
          if(options && options.keys) {
            var scoreFn = options.scoreFn || defaultScoreFn
            var keys = options.keys
            var keysLen = keys.length
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var objResults = new Array(keysLen)
              for (var keyI = keysLen - 1; keyI >= 0; --keyI) {
                var key = keys[keyI]
                var target = getValue(obj, key)
                if(!target) { objResults[keyI] = null; continue }
                if(!isObj(target)) target = fuzzysort.getPrepared(target)

                objResults[keyI] = algorithm(search, target, searchLowerCode)
              }
              objResults.obj = obj // before scoreFn so scoreFn can use it
              var score = scoreFn(objResults)
              if(score === null) continue
              if(score < threshold) continue
              objResults.score = score
              if(resultsLen < limit) { q.add(objResults); ++resultsLen }
              else {
                ++limitedCount
                if(score > q.peek().score) q.replaceTop(objResults)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // options.key
          } else if(options && options.key) {
            var key = options.key
            for(; iCurrent >= 0; --iCurrent) { var obj = targets[iCurrent]
              var target = getValue(obj, key)
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue

              // have to clone result so duplicate targets from different obj can each reference the correct obj
              result = {target:result.target, _targetLowerCodes:null, _nextBeginningIndexes:null, score:result.score, indexes:result.indexes, obj:obj} // hidden

              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }

          // no keys
          } else {
            for(; iCurrent >= 0; --iCurrent) { var target = targets[iCurrent]
              if(!target) continue
              if(!isObj(target)) target = fuzzysort.getPrepared(target)

              var result = algorithm(search, target, searchLowerCode)
              if(result === null) continue
              if(result.score < threshold) continue
              if(resultsLen < limit) { q.add(result); ++resultsLen }
              else {
                ++limitedCount
                if(result.score > q.peek().score) q.replaceTop(result)
              }

              if(iCurrent%1000/*itemsPerCheck*/ === 0) {
                if(Date.now() - startMs >= 10/*asyncInterval*/) {
                  isNode?setImmediate(step):setTimeout(step)
                  return
                }
              }
            }
          }

          if(resultsLen === 0) return resolve(noResults)
          var results = new Array(resultsLen)
          for(var i = resultsLen - 1; i >= 0; --i) results[i] = q.poll()
          results.total = resultsLen + limitedCount
          resolve(results)
        }

        isNode?setImmediate(step):step()
      })
      p.cancel = function() { canceled = true }
      return p
    },

    highlight: function(result, hOpen, hClose) {
      if(result === null) return null
      if(hOpen === undefined) hOpen = '<b>'
      if(hClose === undefined) hClose = '</b>'
      var highlighted = ''
      var matchesIndex = 0
      var opened = false
      var target = result.target
      var targetLen = target.length
      var matchesBest = result.indexes
      for(var i = 0; i < targetLen; ++i) { var char = target[i]
        if(matchesBest[matchesIndex] === i) {
          ++matchesIndex
          if(!opened) { opened = true
            highlighted += hOpen
          }

          if(matchesIndex === matchesBest.length) {
            highlighted += char + hClose + target.substr(i+1)
            break
          }
        } else {
          if(opened) { opened = false
            highlighted += hClose
          }
        }
        highlighted += char
      }

      return highlighted
    },

    prepare: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:null, score:null, indexes:null, obj:null} // hidden
    },
    prepareSlow: function(target) {
      if(!target) return
      return {target:target, _targetLowerCodes:fuzzysort.prepareLowerCodes(target), _nextBeginningIndexes:fuzzysort.prepareNextBeginningIndexes(target), score:null, indexes:null, obj:null} // hidden
    },
    prepareSearch: function(search) {
      if(!search) return
      return fuzzysort.prepareLowerCodes(search)
    },



    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code
    // Below this point is only internal code



    getPrepared: function(target) {
      if(target.length > 999) return fuzzysort.prepare(target) // don't cache huge targets
      var targetPrepared = preparedCache.get(target)
      if(targetPrepared !== undefined) return targetPrepared
      targetPrepared = fuzzysort.prepare(target)
      preparedCache.set(target, targetPrepared)
      return targetPrepared
    },
    getPreparedSearch: function(search) {
      if(search.length > 999) return fuzzysort.prepareSearch(search) // don't cache huge searches
      var searchPrepared = preparedSearchCache.get(search)
      if(searchPrepared !== undefined) return searchPrepared
      searchPrepared = fuzzysort.prepareSearch(search)
      preparedSearchCache.set(search, searchPrepared)
      return searchPrepared
    },

    algorithm: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var typoSimpleI = 0
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[typoSimpleI===0?searchI : (typoSimpleI===searchI?searchI+1 : (typoSimpleI===searchI-1?searchI-1 : searchI))]
        }

        ++targetI; if(targetI >= targetLen) { // Failed to find searchI
          // Check for typo or exit
          // we go as far as possible before trying to transpose
          // then we transpose backwards until we reach the beginning
          for(;;) {
            if(searchI <= 1) return null // not allowed to transpose first char
            if(typoSimpleI === 0) { // we haven't tried to transpose yet
              --searchI
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
              typoSimpleI = searchI
            } else {
              if(typoSimpleI === 1) return null // reached the end of the line for transposing
              --typoSimpleI
              searchI = typoSimpleI
              searchLowerCode = searchLowerCodes[searchI + 1]
              var searchLowerCodeNew = searchLowerCodes[searchI]
              if(searchLowerCode === searchLowerCodeNew) continue // doesn't make sense to transpose a repeat char
            }
            matchesSimpleLen = searchI
            targetI = matchesSimple[matchesSimpleLen - 1] + 1
            break
          }
        }
      }

      var searchI = 0
      var typoStrictI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) { // We failed to push chars forward for a better match
            // transpose, starting from the beginning
            ++typoStrictI; if(typoStrictI > searchLen-2) break
            if(searchLowerCodes[typoStrictI] === searchLowerCodes[typoStrictI+1]) continue // doesn't make sense to transpose a repeat char
            targetI = firstPossibleI
            continue
          }

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[typoStrictI===0?searchI : (typoStrictI===searchI?searchI+1 : (typoStrictI===searchI-1?searchI-1 : searchI))] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) {
          score *= 1000
          if(typoSimpleI !== 0) score += -20/*typoPenalty*/
        } else {
          if(typoStrictI !== 0) score += -20/*typoPenalty*/
        }
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    algorithmNoTypo: function(searchLowerCodes, prepared, searchLowerCode) {
      var targetLowerCodes = prepared._targetLowerCodes
      var searchLen = searchLowerCodes.length
      var targetLen = targetLowerCodes.length
      var searchI = 0 // where we at
      var targetI = 0 // where you at
      var matchesSimpleLen = 0

      // very basic fuzzy match; to remove non-matching targets ASAP!
      // walk through target. find sequential matches.
      // if all chars aren't found then exit
      for(;;) {
        var isMatch = searchLowerCode === targetLowerCodes[targetI]
        if(isMatch) {
          matchesSimple[matchesSimpleLen++] = targetI
          ++searchI; if(searchI === searchLen) break
          searchLowerCode = searchLowerCodes[searchI]
        }
        ++targetI; if(targetI >= targetLen) return null // Failed to find searchI
      }

      var searchI = 0
      var successStrict = false
      var matchesStrictLen = 0

      var nextBeginningIndexes = prepared._nextBeginningIndexes
      if(nextBeginningIndexes === null) nextBeginningIndexes = prepared._nextBeginningIndexes = fuzzysort.prepareNextBeginningIndexes(prepared.target)
      var firstPossibleI = targetI = matchesSimple[0]===0 ? 0 : nextBeginningIndexes[matchesSimple[0]-1]

      // Our target string successfully matched all characters in sequence!
      // Let's try a more advanced and strict test to improve the score
      // only count it as a match if it's consecutive or a beginning character!
      if(targetI !== targetLen) for(;;) {
        if(targetI >= targetLen) {
          // We failed to find a good spot for this search char, go back to the previous search char and force it forward
          if(searchI <= 0) break // We failed to push chars forward for a better match

          --searchI
          var lastMatch = matchesStrict[--matchesStrictLen]
          targetI = nextBeginningIndexes[lastMatch]

        } else {
          var isMatch = searchLowerCodes[searchI] === targetLowerCodes[targetI]
          if(isMatch) {
            matchesStrict[matchesStrictLen++] = targetI
            ++searchI; if(searchI === searchLen) { successStrict = true; break }
            ++targetI
          } else {
            targetI = nextBeginningIndexes[targetI]
          }
        }
      }

      { // tally up the score & keep track of matches for highlighting later
        if(successStrict) { var matchesBest = matchesStrict; var matchesBestLen = matchesStrictLen }
        else { var matchesBest = matchesSimple; var matchesBestLen = matchesSimpleLen }
        var score = 0
        var lastTargetI = -1
        for(var i = 0; i < searchLen; ++i) { var targetI = matchesBest[i]
          // score only goes down if they're not consecutive
          if(lastTargetI !== targetI - 1) score -= targetI
          lastTargetI = targetI
        }
        if(!successStrict) score *= 1000
        score -= targetLen - searchLen
        prepared.score = score
        prepared.indexes = new Array(matchesBestLen); for(var i = matchesBestLen - 1; i >= 0; --i) prepared.indexes[i] = matchesBest[i]

        return prepared
      }
    },

    prepareLowerCodes: function(str) {
      var strLen = str.length
      var lowerCodes = [] // new Array(strLen)    sparse array is too slow
      var lower = str.toLowerCase()
      for(var i = 0; i < strLen; ++i) lowerCodes[i] = lower.charCodeAt(i)
      return lowerCodes
    },
    prepareBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = []; var beginningIndexesLen = 0
      var wasUpper = false
      var wasAlphanum = false
      for(var i = 0; i < targetLen; ++i) {
        var targetCode = target.charCodeAt(i)
        var isUpper = targetCode>=65&&targetCode<=90
        var isAlphanum = isUpper || targetCode>=97&&targetCode<=122 || targetCode>=48&&targetCode<=57
        var isBeginning = isUpper && !wasUpper || !wasAlphanum || !isAlphanum
        wasUpper = isUpper
        wasAlphanum = isAlphanum
        if(isBeginning) beginningIndexes[beginningIndexesLen++] = i
      }
      return beginningIndexes
    },
    prepareNextBeginningIndexes: function(target) {
      var targetLen = target.length
      var beginningIndexes = fuzzysort.prepareBeginningIndexes(target)
      var nextBeginningIndexes = [] // new Array(targetLen)     sparse array is too slow
      var lastIsBeginning = beginningIndexes[0]
      var lastIsBeginningI = 0
      for(var i = 0; i < targetLen; ++i) {
        if(lastIsBeginning > i) {
          nextBeginningIndexes[i] = lastIsBeginning
        } else {
          lastIsBeginning = beginningIndexes[++lastIsBeginningI]
          nextBeginningIndexes[i] = lastIsBeginning===undefined ? targetLen : lastIsBeginning
        }
      }
      return nextBeginningIndexes
    },

    cleanup: cleanup,
    new: fuzzysortNew,
  }
  return fuzzysort
} // fuzzysortNew

// This stuff is outside fuzzysortNew, because it's shared with instances of fuzzysort.new()
var isNode = "function" !== 'undefined' && typeof window === 'undefined'
// var MAX_INT = Number.MAX_SAFE_INTEGER
// var MIN_INT = Number.MIN_VALUE
var preparedCache = new Map()
var preparedSearchCache = new Map()
var noResults = []; noResults.total = 0
var matchesSimple = []; var matchesStrict = []
function cleanup() { preparedCache.clear(); preparedSearchCache.clear(); matchesSimple = []; matchesStrict = [] }
function defaultScoreFn(a) {
  var max = -9007199254740991
  for (var i = a.length - 1; i >= 0; --i) {
    var result = a[i]; if(result === null) continue
    var score = result.score
    if(score > max) max = score
  }
  if(max === -9007199254740991) return null
  return max
}

// prop = 'key'              2.5ms optimized for this case, seems to be about as fast as direct obj[prop]
// prop = 'key1.key2'        10ms
// prop = ['key1', 'key2']   27ms
function getValue(obj, prop) {
  var tmp = obj[prop]; if(tmp !== undefined) return tmp
  var segs = prop
  if(!Array.isArray(prop)) segs = prop.split('.')
  var len = segs.length
  var i = -1
  while (obj && (++i < len)) obj = obj[segs[i]]
  return obj
}

function isObj(x) { return typeof x === 'object' } // faster as a function

// Hacked version of https://github.com/lemire/FastPriorityQueue.js
var fastpriorityqueue=function(){var r=[],o=0,e={};function n(){for(var e=0,n=r[e],c=1;c<o;){var f=c+1;e=c,f<o&&r[f].score<r[c].score&&(e=f),r[e-1>>1]=r[e],c=1+(e<<1)}for(var a=e-1>>1;e>0&&n.score<r[a].score;a=(e=a)-1>>1)r[e]=r[a];r[e]=n}return e.add=function(e){var n=o;r[o++]=e;for(var c=n-1>>1;n>0&&e.score<r[c].score;c=(n=c)-1>>1)r[n]=r[c];r[n]=e},e.poll=function(){if(0!==o){var e=r[0];return r[0]=r[--o],n(),e}},e.peek=function(e){if(0!==o)return r[0]},e.replaceTop=function(o){r[0]=o,n()},e};
var q = fastpriorityqueue() // reuse this, except for async, it needs to make its own

return fuzzysortNew()
}) // UMD

// TODO: (performance) wasm version!?

// TODO: (performance) layout memory in an optimal way to go fast by avoiding cache misses

// TODO: (performance) preparedCache is a memory leak

// TODO: (like sublime) backslash === forwardslash

// TODO: (performance) i have no idea how well optizmied the allowing typos algorithm is

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.8
 * Copyright (C) 2019 Oliver Nightingale
 * @license MIT
 */

;(function(){

/**
 * A convenience function for configuring and constructing
 * a new lunr Index.
 *
 * A lunr.Builder instance is created and the pipeline setup
 * with a trimmer, stop word filter and stemmer.
 *
 * This builder object is yielded to the configuration function
 * that is passed as a parameter, allowing the list of fields
 * and other builder parameters to be customised.
 *
 * All documents _must_ be added within the passed config function.
 *
 * @example
 * var idx = lunr(function () {
 *   this.field('title')
 *   this.field('body')
 *   this.ref('id')
 *
 *   documents.forEach(function (doc) {
 *     this.add(doc)
 *   }, this)
 * })
 *
 * @see {@link lunr.Builder}
 * @see {@link lunr.Pipeline}
 * @see {@link lunr.trimmer}
 * @see {@link lunr.stopWordFilter}
 * @see {@link lunr.stemmer}
 * @namespace {function} lunr
 */
var lunr = function (config) {
  var builder = new lunr.Builder

  builder.pipeline.add(
    lunr.trimmer,
    lunr.stopWordFilter,
    lunr.stemmer
  )

  builder.searchPipeline.add(
    lunr.stemmer
  )

  config.call(builder, builder)
  return builder.build()
}

lunr.version = "2.3.8"
/*!
 * lunr.utils
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A namespace containing utils for the rest of the lunr library
 * @namespace lunr.utils
 */
lunr.utils = {}

/**
 * Print a warning message to the console.
 *
 * @param {String} message The message to be printed.
 * @memberOf lunr.utils
 * @function
 */
lunr.utils.warn = (function (global) {
  /* eslint-disable no-console */
  return function (message) {
    if (global.console && console.warn) {
      console.warn(message)
    }
  }
  /* eslint-enable no-console */
})(this)

/**
 * Convert an object to a string.
 *
 * In the case of `null` and `undefined` the function returns
 * the empty string, in all other cases the result of calling
 * `toString` on the passed object is returned.
 *
 * @param {Any} obj The object to convert to a string.
 * @return {String} string representation of the passed object.
 * @memberOf lunr.utils
 */
lunr.utils.asString = function (obj) {
  if (obj === void 0 || obj === null) {
    return ""
  } else {
    return obj.toString()
  }
}

/**
 * Clones an object.
 *
 * Will create a copy of an existing object such that any mutations
 * on the copy cannot affect the original.
 *
 * Only shallow objects are supported, passing a nested object to this
 * function will cause a TypeError.
 *
 * Objects with primitives, and arrays of primitives are supported.
 *
 * @param {Object} obj The object to clone.
 * @return {Object} a clone of the passed object.
 * @throws {TypeError} when a nested object is passed.
 * @memberOf Utils
 */
lunr.utils.clone = function (obj) {
  if (obj === null || obj === undefined) {
    return obj
  }

  var clone = Object.create(null),
      keys = Object.keys(obj)

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i],
        val = obj[key]

    if (Array.isArray(val)) {
      clone[key] = val.slice()
      continue
    }

    if (typeof val === 'string' ||
        typeof val === 'number' ||
        typeof val === 'boolean') {
      clone[key] = val
      continue
    }

    throw new TypeError("clone is not deep and does not support nested objects")
  }

  return clone
}
lunr.FieldRef = function (docRef, fieldName, stringValue) {
  this.docRef = docRef
  this.fieldName = fieldName
  this._stringValue = stringValue
}

lunr.FieldRef.joiner = "/"

lunr.FieldRef.fromString = function (s) {
  var n = s.indexOf(lunr.FieldRef.joiner)

  if (n === -1) {
    throw "malformed field ref string"
  }

  var fieldRef = s.slice(0, n),
      docRef = s.slice(n + 1)

  return new lunr.FieldRef (docRef, fieldRef, s)
}

lunr.FieldRef.prototype.toString = function () {
  if (this._stringValue == undefined) {
    this._stringValue = this.fieldName + lunr.FieldRef.joiner + this.docRef
  }

  return this._stringValue
}
/*!
 * lunr.Set
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A lunr set.
 *
 * @constructor
 */
lunr.Set = function (elements) {
  this.elements = Object.create(null)

  if (elements) {
    this.length = elements.length

    for (var i = 0; i < this.length; i++) {
      this.elements[elements[i]] = true
    }
  } else {
    this.length = 0
  }
}

/**
 * A complete set that contains all elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.complete = {
  intersect: function (other) {
    return other
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return true
  }
}

/**
 * An empty set that contains no elements.
 *
 * @static
 * @readonly
 * @type {lunr.Set}
 */
lunr.Set.empty = {
  intersect: function () {
    return this
  },

  union: function (other) {
    return other
  },

  contains: function () {
    return false
  }
}

/**
 * Returns true if this set contains the specified object.
 *
 * @param {object} object - Object whose presence in this set is to be tested.
 * @returns {boolean} - True if this set contains the specified object.
 */
lunr.Set.prototype.contains = function (object) {
  return !!this.elements[object]
}

/**
 * Returns a new set containing only the elements that are present in both
 * this set and the specified set.
 *
 * @param {lunr.Set} other - set to intersect with this set.
 * @returns {lunr.Set} a new set that is the intersection of this and the specified set.
 */

lunr.Set.prototype.intersect = function (other) {
  var a, b, elements, intersection = []

  if (other === lunr.Set.complete) {
    return this
  }

  if (other === lunr.Set.empty) {
    return other
  }

  if (this.length < other.length) {
    a = this
    b = other
  } else {
    a = other
    b = this
  }

  elements = Object.keys(a.elements)

  for (var i = 0; i < elements.length; i++) {
    var element = elements[i]
    if (element in b.elements) {
      intersection.push(element)
    }
  }

  return new lunr.Set (intersection)
}

/**
 * Returns a new set combining the elements of this and the specified set.
 *
 * @param {lunr.Set} other - set to union with this set.
 * @return {lunr.Set} a new set that is the union of this and the specified set.
 */

lunr.Set.prototype.union = function (other) {
  if (other === lunr.Set.complete) {
    return lunr.Set.complete
  }

  if (other === lunr.Set.empty) {
    return this
  }

  return new lunr.Set(Object.keys(this.elements).concat(Object.keys(other.elements)))
}
/**
 * A function to calculate the inverse document frequency for
 * a posting. This is shared between the builder and the index
 *
 * @private
 * @param {object} posting - The posting for a given term
 * @param {number} documentCount - The total number of documents.
 */
lunr.idf = function (posting, documentCount) {
  var documentsWithTerm = 0

  for (var fieldName in posting) {
    if (fieldName == '_index') continue // Ignore the term index, its not a field
    documentsWithTerm += Object.keys(posting[fieldName]).length
  }

  var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5)

  return Math.log(1 + Math.abs(x))
}

/**
 * A token wraps a string representation of a token
 * as it is passed through the text processing pipeline.
 *
 * @constructor
 * @param {string} [str=''] - The string token being wrapped.
 * @param {object} [metadata={}] - Metadata associated with this token.
 */
lunr.Token = function (str, metadata) {
  this.str = str || ""
  this.metadata = metadata || {}
}

/**
 * Returns the token string that is being wrapped by this object.
 *
 * @returns {string}
 */
lunr.Token.prototype.toString = function () {
  return this.str
}

/**
 * A token update function is used when updating or optionally
 * when cloning a token.
 *
 * @callback lunr.Token~updateFunction
 * @param {string} str - The string representation of the token.
 * @param {Object} metadata - All metadata associated with this token.
 */

/**
 * Applies the given function to the wrapped string token.
 *
 * @example
 * token.update(function (str, metadata) {
 *   return str.toUpperCase()
 * })
 *
 * @param {lunr.Token~updateFunction} fn - A function to apply to the token string.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.update = function (fn) {
  this.str = fn(this.str, this.metadata)
  return this
}

/**
 * Creates a clone of this token. Optionally a function can be
 * applied to the cloned token.
 *
 * @param {lunr.Token~updateFunction} [fn] - An optional function to apply to the cloned token.
 * @returns {lunr.Token}
 */
lunr.Token.prototype.clone = function (fn) {
  fn = fn || function (s) { return s }
  return new lunr.Token (fn(this.str, this.metadata), this.metadata)
}
/*!
 * lunr.tokenizer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A function for splitting a string into tokens ready to be inserted into
 * the search index. Uses `lunr.tokenizer.separator` to split strings, change
 * the value of this property to change how strings are split into tokens.
 *
 * This tokenizer will convert its parameter to a string by calling `toString` and
 * then will split this string on the character in `lunr.tokenizer.separator`.
 * Arrays will have their elements converted to strings and wrapped in a lunr.Token.
 *
 * Optional metadata can be passed to the tokenizer, this metadata will be cloned and
 * added as metadata to every token that is created from the object to be tokenized.
 *
 * @static
 * @param {?(string|object|object[])} obj - The object to convert into tokens
 * @param {?object} metadata - Optional metadata to associate with every token
 * @returns {lunr.Token[]}
 * @see {@link lunr.Pipeline}
 */
lunr.tokenizer = function (obj, metadata) {
  if (obj == null || obj == undefined) {
    return []
  }

  if (Array.isArray(obj)) {
    return obj.map(function (t) {
      return new lunr.Token(
        lunr.utils.asString(t).toLowerCase(),
        lunr.utils.clone(metadata)
      )
    })
  }

  var str = obj.toString().toLowerCase(),
      len = str.length,
      tokens = []

  for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
    var char = str.charAt(sliceEnd),
        sliceLength = sliceEnd - sliceStart

    if ((char.match(lunr.tokenizer.separator) || sliceEnd == len)) {

      if (sliceLength > 0) {
        var tokenMetadata = lunr.utils.clone(metadata) || {}
        tokenMetadata["position"] = [sliceStart, sliceLength]
        tokenMetadata["index"] = tokens.length

        tokens.push(
          new lunr.Token (
            str.slice(sliceStart, sliceEnd),
            tokenMetadata
          )
        )
      }

      sliceStart = sliceEnd + 1
    }

  }

  return tokens
}

/**
 * The separator used to split a string into tokens. Override this property to change the behaviour of
 * `lunr.tokenizer` behaviour when tokenizing strings. By default this splits on whitespace and hyphens.
 *
 * @static
 * @see lunr.tokenizer
 */
lunr.tokenizer.separator = /[\s\-]+/
/*!
 * lunr.Pipeline
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Pipelines maintain an ordered list of functions to be applied to all
 * tokens in documents entering the search index and queries being ran against
 * the index.
 *
 * An instance of lunr.Index created with the lunr shortcut will contain a
 * pipeline with a stop word filter and an English language stemmer. Extra
 * functions can be added before or after either of these functions or these
 * default functions can be removed.
 *
 * When run the pipeline will call each function in turn, passing a token, the
 * index of that token in the original list of all tokens and finally a list of
 * all the original tokens.
 *
 * The output of functions in the pipeline will be passed to the next function
 * in the pipeline. To exclude a token from entering the index the function
 * should return undefined, the rest of the pipeline will not be called with
 * this token.
 *
 * For serialisation of pipelines to work, all functions used in an instance of
 * a pipeline should be registered with lunr.Pipeline. Registered functions can
 * then be loaded. If trying to load a serialised pipeline that uses functions
 * that are not registered an error will be thrown.
 *
 * If not planning on serialising the pipeline then registering pipeline functions
 * is not necessary.
 *
 * @constructor
 */
lunr.Pipeline = function () {
  this._stack = []
}

lunr.Pipeline.registeredFunctions = Object.create(null)

/**
 * A pipeline function maps lunr.Token to lunr.Token. A lunr.Token contains the token
 * string as well as all known metadata. A pipeline function can mutate the token string
 * or mutate (or add) metadata for a given token.
 *
 * A pipeline function can indicate that the passed token should be discarded by returning
 * null, undefined or an empty string. This token will not be passed to any downstream pipeline
 * functions and will not be added to the index.
 *
 * Multiple tokens can be returned by returning an array of tokens. Each token will be passed
 * to any downstream pipeline functions and all will returned tokens will be added to the index.
 *
 * Any number of pipeline functions may be chained together using a lunr.Pipeline.
 *
 * @interface lunr.PipelineFunction
 * @param {lunr.Token} token - A token from the document being processed.
 * @param {number} i - The index of this token in the complete list of tokens for this document/field.
 * @param {lunr.Token[]} tokens - All tokens for this document/field.
 * @returns {(?lunr.Token|lunr.Token[])}
 */

/**
 * Register a function with the pipeline.
 *
 * Functions that are used in the pipeline should be registered if the pipeline
 * needs to be serialised, or a serialised pipeline needs to be loaded.
 *
 * Registering a function does not add it to a pipeline, functions must still be
 * added to instances of the pipeline for them to be used when running a pipeline.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @param {String} label - The label to register this function with
 */
lunr.Pipeline.registerFunction = function (fn, label) {
  if (label in this.registeredFunctions) {
    lunr.utils.warn('Overwriting existing registered function: ' + label)
  }

  fn.label = label
  lunr.Pipeline.registeredFunctions[fn.label] = fn
}

/**
 * Warns if the function is not registered as a Pipeline function.
 *
 * @param {lunr.PipelineFunction} fn - The function to check for.
 * @private
 */
lunr.Pipeline.warnIfFunctionNotRegistered = function (fn) {
  var isRegistered = fn.label && (fn.label in this.registeredFunctions)

  if (!isRegistered) {
    lunr.utils.warn('Function is not registered with pipeline. This may cause problems when serialising the index.\n', fn)
  }
}

/**
 * Loads a previously serialised pipeline.
 *
 * All functions to be loaded must already be registered with lunr.Pipeline.
 * If any function from the serialised data has not been registered then an
 * error will be thrown.
 *
 * @param {Object} serialised - The serialised pipeline to load.
 * @returns {lunr.Pipeline}
 */
lunr.Pipeline.load = function (serialised) {
  var pipeline = new lunr.Pipeline

  serialised.forEach(function (fnName) {
    var fn = lunr.Pipeline.registeredFunctions[fnName]

    if (fn) {
      pipeline.add(fn)
    } else {
      throw new Error('Cannot load unregistered function: ' + fnName)
    }
  })

  return pipeline
}

/**
 * Adds new functions to the end of the pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction[]} functions - Any number of functions to add to the pipeline.
 */
lunr.Pipeline.prototype.add = function () {
  var fns = Array.prototype.slice.call(arguments)

  fns.forEach(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)
    this._stack.push(fn)
  }, this)
}

/**
 * Adds a single function after a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.after = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  pos = pos + 1
  this._stack.splice(pos, 0, newFn)
}

/**
 * Adds a single function before a function that already exists in the
 * pipeline.
 *
 * Logs a warning if the function has not been registered.
 *
 * @param {lunr.PipelineFunction} existingFn - A function that already exists in the pipeline.
 * @param {lunr.PipelineFunction} newFn - The new function to add to the pipeline.
 */
lunr.Pipeline.prototype.before = function (existingFn, newFn) {
  lunr.Pipeline.warnIfFunctionNotRegistered(newFn)

  var pos = this._stack.indexOf(existingFn)
  if (pos == -1) {
    throw new Error('Cannot find existingFn')
  }

  this._stack.splice(pos, 0, newFn)
}

/**
 * Removes a function from the pipeline.
 *
 * @param {lunr.PipelineFunction} fn The function to remove from the pipeline.
 */
lunr.Pipeline.prototype.remove = function (fn) {
  var pos = this._stack.indexOf(fn)
  if (pos == -1) {
    return
  }

  this._stack.splice(pos, 1)
}

/**
 * Runs the current list of functions that make up the pipeline against the
 * passed tokens.
 *
 * @param {Array} tokens The tokens to run through the pipeline.
 * @returns {Array}
 */
lunr.Pipeline.prototype.run = function (tokens) {
  var stackLength = this._stack.length

  for (var i = 0; i < stackLength; i++) {
    var fn = this._stack[i]
    var memo = []

    for (var j = 0; j < tokens.length; j++) {
      var result = fn(tokens[j], j, tokens)

      if (result === null || result === void 0 || result === '') continue

      if (Array.isArray(result)) {
        for (var k = 0; k < result.length; k++) {
          memo.push(result[k])
        }
      } else {
        memo.push(result)
      }
    }

    tokens = memo
  }

  return tokens
}

/**
 * Convenience method for passing a string through a pipeline and getting
 * strings out. This method takes care of wrapping the passed string in a
 * token and mapping the resulting tokens back to strings.
 *
 * @param {string} str - The string to pass through the pipeline.
 * @param {?object} metadata - Optional metadata to associate with the token
 * passed to the pipeline.
 * @returns {string[]}
 */
lunr.Pipeline.prototype.runString = function (str, metadata) {
  var token = new lunr.Token (str, metadata)

  return this.run([token]).map(function (t) {
    return t.toString()
  })
}

/**
 * Resets the pipeline by removing any existing processors.
 *
 */
lunr.Pipeline.prototype.reset = function () {
  this._stack = []
}

/**
 * Returns a representation of the pipeline ready for serialisation.
 *
 * Logs a warning if the function has not been registered.
 *
 * @returns {Array}
 */
lunr.Pipeline.prototype.toJSON = function () {
  return this._stack.map(function (fn) {
    lunr.Pipeline.warnIfFunctionNotRegistered(fn)

    return fn.label
  })
}
/*!
 * lunr.Vector
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A vector is used to construct the vector space of documents and queries. These
 * vectors support operations to determine the similarity between two documents or
 * a document and a query.
 *
 * Normally no parameters are required for initializing a vector, but in the case of
 * loading a previously dumped vector the raw elements can be provided to the constructor.
 *
 * For performance reasons vectors are implemented with a flat array, where an elements
 * index is immediately followed by its value. E.g. [index, value, index, value]. This
 * allows the underlying array to be as sparse as possible and still offer decent
 * performance when being used for vector calculations.
 *
 * @constructor
 * @param {Number[]} [elements] - The flat list of element index and element value pairs.
 */
lunr.Vector = function (elements) {
  this._magnitude = 0
  this.elements = elements || []
}


/**
 * Calculates the position within the vector to insert a given index.
 *
 * This is used internally by insert and upsert. If there are duplicate indexes then
 * the position is returned as if the value for that index were to be updated, but it
 * is the callers responsibility to check whether there is a duplicate at that index
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @returns {Number}
 */
lunr.Vector.prototype.positionForIndex = function (index) {
  // For an empty vector the tuple can be inserted at the beginning
  if (this.elements.length == 0) {
    return 0
  }

  var start = 0,
      end = this.elements.length / 2,
      sliceLength = end - start,
      pivotPoint = Math.floor(sliceLength / 2),
      pivotIndex = this.elements[pivotPoint * 2]

  while (sliceLength > 1) {
    if (pivotIndex < index) {
      start = pivotPoint
    }

    if (pivotIndex > index) {
      end = pivotPoint
    }

    if (pivotIndex == index) {
      break
    }

    sliceLength = end - start
    pivotPoint = start + Math.floor(sliceLength / 2)
    pivotIndex = this.elements[pivotPoint * 2]
  }

  if (pivotIndex == index) {
    return pivotPoint * 2
  }

  if (pivotIndex > index) {
    return pivotPoint * 2
  }

  if (pivotIndex < index) {
    return (pivotPoint + 1) * 2
  }
}

/**
 * Inserts an element at an index within the vector.
 *
 * Does not allow duplicates, will throw an error if there is already an entry
 * for this index.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 */
lunr.Vector.prototype.insert = function (insertIdx, val) {
  this.upsert(insertIdx, val, function () {
    throw "duplicate index"
  })
}

/**
 * Inserts or updates an existing index within the vector.
 *
 * @param {Number} insertIdx - The index at which the element should be inserted.
 * @param {Number} val - The value to be inserted into the vector.
 * @param {function} fn - A function that is called for updates, the existing value and the
 * requested value are passed as arguments
 */
lunr.Vector.prototype.upsert = function (insertIdx, val, fn) {
  this._magnitude = 0
  var position = this.positionForIndex(insertIdx)

  if (this.elements[position] == insertIdx) {
    this.elements[position + 1] = fn(this.elements[position + 1], val)
  } else {
    this.elements.splice(position, 0, insertIdx, val)
  }
}

/**
 * Calculates the magnitude of this vector.
 *
 * @returns {Number}
 */
lunr.Vector.prototype.magnitude = function () {
  if (this._magnitude) return this._magnitude

  var sumOfSquares = 0,
      elementsLength = this.elements.length

  for (var i = 1; i < elementsLength; i += 2) {
    var val = this.elements[i]
    sumOfSquares += val * val
  }

  return this._magnitude = Math.sqrt(sumOfSquares)
}

/**
 * Calculates the dot product of this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The vector to compute the dot product with.
 * @returns {Number}
 */
lunr.Vector.prototype.dot = function (otherVector) {
  var dotProduct = 0,
      a = this.elements, b = otherVector.elements,
      aLen = a.length, bLen = b.length,
      aVal = 0, bVal = 0,
      i = 0, j = 0

  while (i < aLen && j < bLen) {
    aVal = a[i], bVal = b[j]
    if (aVal < bVal) {
      i += 2
    } else if (aVal > bVal) {
      j += 2
    } else if (aVal == bVal) {
      dotProduct += a[i + 1] * b[j + 1]
      i += 2
      j += 2
    }
  }

  return dotProduct
}

/**
 * Calculates the similarity between this vector and another vector.
 *
 * @param {lunr.Vector} otherVector - The other vector to calculate the
 * similarity with.
 * @returns {Number}
 */
lunr.Vector.prototype.similarity = function (otherVector) {
  return this.dot(otherVector) / this.magnitude() || 0
}

/**
 * Converts the vector to an array of the elements within the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toArray = function () {
  var output = new Array (this.elements.length / 2)

  for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
    output[j] = this.elements[i]
  }

  return output
}

/**
 * A JSON serializable representation of the vector.
 *
 * @returns {Number[]}
 */
lunr.Vector.prototype.toJSON = function () {
  return this.elements
}
/* eslint-disable */
/*!
 * lunr.stemmer
 * Copyright (C) 2019 Oliver Nightingale
 * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
 */

/**
 * lunr.stemmer is an english language stemmer, this is a JavaScript
 * implementation of the PorterStemmer taken from http://tartarus.org/~martin
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token - The string to stem
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 * @function
 */
lunr.stemmer = (function(){
  var step2list = {
      "ational" : "ate",
      "tional" : "tion",
      "enci" : "ence",
      "anci" : "ance",
      "izer" : "ize",
      "bli" : "ble",
      "alli" : "al",
      "entli" : "ent",
      "eli" : "e",
      "ousli" : "ous",
      "ization" : "ize",
      "ation" : "ate",
      "ator" : "ate",
      "alism" : "al",
      "iveness" : "ive",
      "fulness" : "ful",
      "ousness" : "ous",
      "aliti" : "al",
      "iviti" : "ive",
      "biliti" : "ble",
      "logi" : "log"
    },

    step3list = {
      "icate" : "ic",
      "ative" : "",
      "alize" : "al",
      "iciti" : "ic",
      "ical" : "ic",
      "ful" : "",
      "ness" : ""
    },

    c = "[^aeiou]",          // consonant
    v = "[aeiouy]",          // vowel
    C = c + "[^aeiouy]*",    // consonant sequence
    V = v + "[aeiou]*",      // vowel sequence

    mgr0 = "^(" + C + ")?" + V + C,               // [C]VC... is m>0
    meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$",  // [C]VC[V] is m=1
    mgr1 = "^(" + C + ")?" + V + C + V + C,       // [C]VCVC... is m>1
    s_v = "^(" + C + ")?" + v;                   // vowel in stem

  var re_mgr0 = new RegExp(mgr0);
  var re_mgr1 = new RegExp(mgr1);
  var re_meq1 = new RegExp(meq1);
  var re_s_v = new RegExp(s_v);

  var re_1a = /^(.+?)(ss|i)es$/;
  var re2_1a = /^(.+?)([^s])s$/;
  var re_1b = /^(.+?)eed$/;
  var re2_1b = /^(.+?)(ed|ing)$/;
  var re_1b_2 = /.$/;
  var re2_1b_2 = /(at|bl|iz)$/;
  var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
  var re4_1b_2 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var re_1c = /^(.+?[^aeiou])y$/;
  var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;

  var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;

  var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
  var re2_4 = /^(.+?)(s|t)(ion)$/;

  var re_5 = /^(.+?)e$/;
  var re_5_1 = /ll$/;
  var re3_5 = new RegExp("^" + C + v + "[^aeiouwxy]$");

  var porterStemmer = function porterStemmer(w) {
    var stem,
      suffix,
      firstch,
      re,
      re2,
      re3,
      re4;

    if (w.length < 3) { return w; }

    firstch = w.substr(0,1);
    if (firstch == "y") {
      w = firstch.toUpperCase() + w.substr(1);
    }

    // Step 1a
    re = re_1a
    re2 = re2_1a;

    if (re.test(w)) { w = w.replace(re,"$1$2"); }
    else if (re2.test(w)) { w = w.replace(re2,"$1$2"); }

    // Step 1b
    re = re_1b;
    re2 = re2_1b;
    if (re.test(w)) {
      var fp = re.exec(w);
      re = re_mgr0;
      if (re.test(fp[1])) {
        re = re_1b_2;
        w = w.replace(re,"");
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1];
      re2 = re_s_v;
      if (re2.test(stem)) {
        w = stem;
        re2 = re2_1b_2;
        re3 = re3_1b_2;
        re4 = re4_1b_2;
        if (re2.test(w)) { w = w + "e"; }
        else if (re3.test(w)) { re = re_1b_2; w = w.replace(re,""); }
        else if (re4.test(w)) { w = w + "e"; }
      }
    }

    // Step 1c - replace suffix y or Y by i if preceded by a non-vowel which is not the first letter of the word (so cry -> cri, by -> by, say -> say)
    re = re_1c;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      w = stem + "i";
    }

    // Step 2
    re = re_2;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step2list[suffix];
      }
    }

    // Step 3
    re = re_3;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      suffix = fp[2];
      re = re_mgr0;
      if (re.test(stem)) {
        w = stem + step3list[suffix];
      }
    }

    // Step 4
    re = re_4;
    re2 = re2_4;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      if (re.test(stem)) {
        w = stem;
      }
    } else if (re2.test(w)) {
      var fp = re2.exec(w);
      stem = fp[1] + fp[2];
      re2 = re_mgr1;
      if (re2.test(stem)) {
        w = stem;
      }
    }

    // Step 5
    re = re_5;
    if (re.test(w)) {
      var fp = re.exec(w);
      stem = fp[1];
      re = re_mgr1;
      re2 = re_meq1;
      re3 = re3_5;
      if (re.test(stem) || (re2.test(stem) && !(re3.test(stem)))) {
        w = stem;
      }
    }

    re = re_5_1;
    re2 = re_mgr1;
    if (re.test(w) && re2.test(w)) {
      re = re_1b_2;
      w = w.replace(re,"");
    }

    // and turn initial Y back to y

    if (firstch == "y") {
      w = firstch.toLowerCase() + w.substr(1);
    }

    return w;
  };

  return function (token) {
    return token.update(porterStemmer);
  }
})();

lunr.Pipeline.registerFunction(lunr.stemmer, 'stemmer')
/*!
 * lunr.stopWordFilter
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.generateStopWordFilter builds a stopWordFilter function from the provided
 * list of stop words.
 *
 * The built in lunr.stopWordFilter is built using this generator and can be used
 * to generate custom stopWordFilters for applications or non English languages.
 *
 * @function
 * @param {Array} token The token to pass through the filter
 * @returns {lunr.PipelineFunction}
 * @see lunr.Pipeline
 * @see lunr.stopWordFilter
 */
lunr.generateStopWordFilter = function (stopWords) {
  var words = stopWords.reduce(function (memo, stopWord) {
    memo[stopWord] = stopWord
    return memo
  }, {})

  return function (token) {
    if (token && words[token.toString()] !== token.toString()) return token
  }
}

/**
 * lunr.stopWordFilter is an English language stop word list filter, any words
 * contained in the list will not be passed through the filter.
 *
 * This is intended to be used in the Pipeline. If the token does not pass the
 * filter then undefined will be returned.
 *
 * @function
 * @implements {lunr.PipelineFunction}
 * @params {lunr.Token} token - A token to check for being a stop word.
 * @returns {lunr.Token}
 * @see {@link lunr.Pipeline}
 */
lunr.stopWordFilter = lunr.generateStopWordFilter([
  'a',
  'able',
  'about',
  'across',
  'after',
  'all',
  'almost',
  'also',
  'am',
  'among',
  'an',
  'and',
  'any',
  'are',
  'as',
  'at',
  'be',
  'because',
  'been',
  'but',
  'by',
  'can',
  'cannot',
  'could',
  'dear',
  'did',
  'do',
  'does',
  'either',
  'else',
  'ever',
  'every',
  'for',
  'from',
  'get',
  'got',
  'had',
  'has',
  'have',
  'he',
  'her',
  'hers',
  'him',
  'his',
  'how',
  'however',
  'i',
  'if',
  'in',
  'into',
  'is',
  'it',
  'its',
  'just',
  'least',
  'let',
  'like',
  'likely',
  'may',
  'me',
  'might',
  'most',
  'must',
  'my',
  'neither',
  'no',
  'nor',
  'not',
  'of',
  'off',
  'often',
  'on',
  'only',
  'or',
  'other',
  'our',
  'own',
  'rather',
  'said',
  'say',
  'says',
  'she',
  'should',
  'since',
  'so',
  'some',
  'than',
  'that',
  'the',
  'their',
  'them',
  'then',
  'there',
  'these',
  'they',
  'this',
  'tis',
  'to',
  'too',
  'twas',
  'us',
  'wants',
  'was',
  'we',
  'were',
  'what',
  'when',
  'where',
  'which',
  'while',
  'who',
  'whom',
  'why',
  'will',
  'with',
  'would',
  'yet',
  'you',
  'your'
])

lunr.Pipeline.registerFunction(lunr.stopWordFilter, 'stopWordFilter')
/*!
 * lunr.trimmer
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.trimmer is a pipeline function for trimming non word
 * characters from the beginning and end of tokens before they
 * enter the index.
 *
 * This implementation may not work correctly for non latin
 * characters and should either be removed or adapted for use
 * with languages with non-latin characters.
 *
 * @static
 * @implements {lunr.PipelineFunction}
 * @param {lunr.Token} token The token to pass through the filter
 * @returns {lunr.Token}
 * @see lunr.Pipeline
 */
lunr.trimmer = function (token) {
  return token.update(function (s) {
    return s.replace(/^\W+/, '').replace(/\W+$/, '')
  })
}

lunr.Pipeline.registerFunction(lunr.trimmer, 'trimmer')
/*!
 * lunr.TokenSet
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * A token set is used to store the unique list of all tokens
 * within an index. Token sets are also used to represent an
 * incoming query to the index, this query token set and index
 * token set are then intersected to find which tokens to look
 * up in the inverted index.
 *
 * A token set can hold multiple tokens, as in the case of the
 * index token set, or it can hold a single token as in the
 * case of a simple query token set.
 *
 * Additionally token sets are used to perform wildcard matching.
 * Leading, contained and trailing wildcards are supported, and
 * from this edit distance matching can also be provided.
 *
 * Token sets are implemented as a minimal finite state automata,
 * where both common prefixes and suffixes are shared between tokens.
 * This helps to reduce the space used for storing the token set.
 *
 * @constructor
 */
lunr.TokenSet = function () {
  this.final = false
  this.edges = {}
  this.id = lunr.TokenSet._nextId
  lunr.TokenSet._nextId += 1
}

/**
 * Keeps track of the next, auto increment, identifier to assign
 * to a new tokenSet.
 *
 * TokenSets require a unique identifier to be correctly minimised.
 *
 * @private
 */
lunr.TokenSet._nextId = 1

/**
 * Creates a TokenSet instance from the given sorted array of words.
 *
 * @param {String[]} arr - A sorted array of strings to create the set from.
 * @returns {lunr.TokenSet}
 * @throws Will throw an error if the input array is not sorted.
 */
lunr.TokenSet.fromArray = function (arr) {
  var builder = new lunr.TokenSet.Builder

  for (var i = 0, len = arr.length; i < len; i++) {
    builder.insert(arr[i])
  }

  builder.finish()
  return builder.root
}

/**
 * Creates a token set from a query clause.
 *
 * @private
 * @param {Object} clause - A single clause from lunr.Query.
 * @param {string} clause.term - The query clause term.
 * @param {number} [clause.editDistance] - The optional edit distance for the term.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromClause = function (clause) {
  if ('editDistance' in clause) {
    return lunr.TokenSet.fromFuzzyString(clause.term, clause.editDistance)
  } else {
    return lunr.TokenSet.fromString(clause.term)
  }
}

/**
 * Creates a token set representing a single string with a specified
 * edit distance.
 *
 * Insertions, deletions, substitutions and transpositions are each
 * treated as an edit distance of 1.
 *
 * Increasing the allowed edit distance will have a dramatic impact
 * on the performance of both creating and intersecting these TokenSets.
 * It is advised to keep the edit distance less than 3.
 *
 * @param {string} str - The string to create the token set from.
 * @param {number} editDistance - The allowed edit distance to match.
 * @returns {lunr.Vector}
 */
lunr.TokenSet.fromFuzzyString = function (str, editDistance) {
  var root = new lunr.TokenSet

  var stack = [{
    node: root,
    editsRemaining: editDistance,
    str: str
  }]

  while (stack.length) {
    var frame = stack.pop()

    // no edit
    if (frame.str.length > 0) {
      var char = frame.str.charAt(0),
          noEditNode

      if (char in frame.node.edges) {
        noEditNode = frame.node.edges[char]
      } else {
        noEditNode = new lunr.TokenSet
        frame.node.edges[char] = noEditNode
      }

      if (frame.str.length == 1) {
        noEditNode.final = true
      }

      stack.push({
        node: noEditNode,
        editsRemaining: frame.editsRemaining,
        str: frame.str.slice(1)
      })
    }

    if (frame.editsRemaining == 0) {
      continue
    }

    // insertion
    if ("*" in frame.node.edges) {
      var insertionNode = frame.node.edges["*"]
    } else {
      var insertionNode = new lunr.TokenSet
      frame.node.edges["*"] = insertionNode
    }

    if (frame.str.length == 0) {
      insertionNode.final = true
    }

    stack.push({
      node: insertionNode,
      editsRemaining: frame.editsRemaining - 1,
      str: frame.str
    })

    // deletion
    // can only do a deletion if we have enough edits remaining
    // and if there are characters left to delete in the string
    if (frame.str.length > 1) {
      stack.push({
        node: frame.node,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // deletion
    // just removing the last character from the str
    if (frame.str.length == 1) {
      frame.node.final = true
    }

    // substitution
    // can only do a substitution if we have enough edits remaining
    // and if there are characters left to substitute
    if (frame.str.length >= 1) {
      if ("*" in frame.node.edges) {
        var substitutionNode = frame.node.edges["*"]
      } else {
        var substitutionNode = new lunr.TokenSet
        frame.node.edges["*"] = substitutionNode
      }

      if (frame.str.length == 1) {
        substitutionNode.final = true
      }

      stack.push({
        node: substitutionNode,
        editsRemaining: frame.editsRemaining - 1,
        str: frame.str.slice(1)
      })
    }

    // transposition
    // can only do a transposition if there are edits remaining
    // and there are enough characters to transpose
    if (frame.str.length > 1) {
      var charA = frame.str.charAt(0),
          charB = frame.str.charAt(1),
          transposeNode

      if (charB in frame.node.edges) {
        transposeNode = frame.node.edges[charB]
      } else {
        transposeNode = new lunr.TokenSet
        frame.node.edges[charB] = transposeNode
      }

      if (frame.str.length == 1) {
        transposeNode.final = true
      }

      stack.push({
        node: transposeNode,
        editsRemaining: frame.editsRemaining - 1,
        str: charA + frame.str.slice(2)
      })
    }
  }

  return root
}

/**
 * Creates a TokenSet from a string.
 *
 * The string may contain one or more wildcard characters (*)
 * that will allow wildcard matching when intersecting with
 * another TokenSet.
 *
 * @param {string} str - The string to create a TokenSet from.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.fromString = function (str) {
  var node = new lunr.TokenSet,
      root = node

  /*
   * Iterates through all characters within the passed string
   * appending a node for each character.
   *
   * When a wildcard character is found then a self
   * referencing edge is introduced to continually match
   * any number of any characters.
   */
  for (var i = 0, len = str.length; i < len; i++) {
    var char = str[i],
        final = (i == len - 1)

    if (char == "*") {
      node.edges[char] = node
      node.final = final

    } else {
      var next = new lunr.TokenSet
      next.final = final

      node.edges[char] = next
      node = next
    }
  }

  return root
}

/**
 * Converts this TokenSet into an array of strings
 * contained within the TokenSet.
 *
 * This is not intended to be used on a TokenSet that
 * contains wildcards, in these cases the results are
 * undefined and are likely to cause an infinite loop.
 *
 * @returns {string[]}
 */
lunr.TokenSet.prototype.toArray = function () {
  var words = []

  var stack = [{
    prefix: "",
    node: this
  }]

  while (stack.length) {
    var frame = stack.pop(),
        edges = Object.keys(frame.node.edges),
        len = edges.length

    if (frame.node.final) {
      /* In Safari, at this point the prefix is sometimes corrupted, see:
       * https://github.com/olivernn/lunr.js/issues/279 Calling any
       * String.prototype method forces Safari to "cast" this string to what
       * it's supposed to be, fixing the bug. */
      frame.prefix.charAt(0)
      words.push(frame.prefix)
    }

    for (var i = 0; i < len; i++) {
      var edge = edges[i]

      stack.push({
        prefix: frame.prefix.concat(edge),
        node: frame.node.edges[edge]
      })
    }
  }

  return words
}

/**
 * Generates a string representation of a TokenSet.
 *
 * This is intended to allow TokenSets to be used as keys
 * in objects, largely to aid the construction and minimisation
 * of a TokenSet. As such it is not designed to be a human
 * friendly representation of the TokenSet.
 *
 * @returns {string}
 */
lunr.TokenSet.prototype.toString = function () {
  // NOTE: Using Object.keys here as this.edges is very likely
  // to enter 'hash-mode' with many keys being added
  //
  // avoiding a for-in loop here as it leads to the function
  // being de-optimised (at least in V8). From some simple
  // benchmarks the performance is comparable, but allowing
  // V8 to optimize may mean easy performance wins in the future.

  if (this._str) {
    return this._str
  }

  var str = this.final ? '1' : '0',
      labels = Object.keys(this.edges).sort(),
      len = labels.length

  for (var i = 0; i < len; i++) {
    var label = labels[i],
        node = this.edges[label]

    str = str + label + node.id
  }

  return str
}

/**
 * Returns a new TokenSet that is the intersection of
 * this TokenSet and the passed TokenSet.
 *
 * This intersection will take into account any wildcards
 * contained within the TokenSet.
 *
 * @param {lunr.TokenSet} b - An other TokenSet to intersect with.
 * @returns {lunr.TokenSet}
 */
lunr.TokenSet.prototype.intersect = function (b) {
  var output = new lunr.TokenSet,
      frame = undefined

  var stack = [{
    qNode: b,
    output: output,
    node: this
  }]

  while (stack.length) {
    frame = stack.pop()

    // NOTE: As with the #toString method, we are using
    // Object.keys and a for loop instead of a for-in loop
    // as both of these objects enter 'hash' mode, causing
    // the function to be de-optimised in V8
    var qEdges = Object.keys(frame.qNode.edges),
        qLen = qEdges.length,
        nEdges = Object.keys(frame.node.edges),
        nLen = nEdges.length

    for (var q = 0; q < qLen; q++) {
      var qEdge = qEdges[q]

      for (var n = 0; n < nLen; n++) {
        var nEdge = nEdges[n]

        if (nEdge == qEdge || qEdge == '*') {
          var node = frame.node.edges[nEdge],
              qNode = frame.qNode.edges[qEdge],
              final = node.final && qNode.final,
              next = undefined

          if (nEdge in frame.output.edges) {
            // an edge already exists for this character
            // no need to create a new node, just set the finality
            // bit unless this node is already final
            next = frame.output.edges[nEdge]
            next.final = next.final || final

          } else {
            // no edge exists yet, must create one
            // set the finality bit and insert it
            // into the output
            next = new lunr.TokenSet
            next.final = final
            frame.output.edges[nEdge] = next
          }

          stack.push({
            qNode: qNode,
            output: next,
            node: node
          })
        }
      }
    }
  }

  return output
}
lunr.TokenSet.Builder = function () {
  this.previousWord = ""
  this.root = new lunr.TokenSet
  this.uncheckedNodes = []
  this.minimizedNodes = {}
}

lunr.TokenSet.Builder.prototype.insert = function (word) {
  var node,
      commonPrefix = 0

  if (word < this.previousWord) {
    throw new Error ("Out of order word insertion")
  }

  for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
    if (word[i] != this.previousWord[i]) break
    commonPrefix++
  }

  this.minimize(commonPrefix)

  if (this.uncheckedNodes.length == 0) {
    node = this.root
  } else {
    node = this.uncheckedNodes[this.uncheckedNodes.length - 1].child
  }

  for (var i = commonPrefix; i < word.length; i++) {
    var nextNode = new lunr.TokenSet,
        char = word[i]

    node.edges[char] = nextNode

    this.uncheckedNodes.push({
      parent: node,
      char: char,
      child: nextNode
    })

    node = nextNode
  }

  node.final = true
  this.previousWord = word
}

lunr.TokenSet.Builder.prototype.finish = function () {
  this.minimize(0)
}

lunr.TokenSet.Builder.prototype.minimize = function (downTo) {
  for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
    var node = this.uncheckedNodes[i],
        childKey = node.child.toString()

    if (childKey in this.minimizedNodes) {
      node.parent.edges[node.char] = this.minimizedNodes[childKey]
    } else {
      // Cache the key for this node since
      // we know it can't change anymore
      node.child._str = childKey

      this.minimizedNodes[childKey] = node.child
    }

    this.uncheckedNodes.pop()
  }
}
/*!
 * lunr.Index
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * An index contains the built index of all documents and provides a query interface
 * to the index.
 *
 * Usually instances of lunr.Index will not be created using this constructor, instead
 * lunr.Builder should be used to construct new indexes, or lunr.Index.load should be
 * used to load previously built and serialized indexes.
 *
 * @constructor
 * @param {Object} attrs - The attributes of the built search index.
 * @param {Object} attrs.invertedIndex - An index of term/field to document reference.
 * @param {Object<string, lunr.Vector>} attrs.fieldVectors - Field vectors
 * @param {lunr.TokenSet} attrs.tokenSet - An set of all corpus tokens.
 * @param {string[]} attrs.fields - The names of indexed document fields.
 * @param {lunr.Pipeline} attrs.pipeline - The pipeline to use for search terms.
 */
lunr.Index = function (attrs) {
  this.invertedIndex = attrs.invertedIndex
  this.fieldVectors = attrs.fieldVectors
  this.tokenSet = attrs.tokenSet
  this.fields = attrs.fields
  this.pipeline = attrs.pipeline
}

/**
 * A result contains details of a document matching a search query.
 * @typedef {Object} lunr.Index~Result
 * @property {string} ref - The reference of the document this result represents.
 * @property {number} score - A number between 0 and 1 representing how similar this document is to the query.
 * @property {lunr.MatchData} matchData - Contains metadata about this match including which term(s) caused the match.
 */

/**
 * Although lunr provides the ability to create queries using lunr.Query, it also provides a simple
 * query language which itself is parsed into an instance of lunr.Query.
 *
 * For programmatically building queries it is advised to directly use lunr.Query, the query language
 * is best used for human entered text rather than program generated text.
 *
 * At its simplest queries can just be a single term, e.g. `hello`, multiple terms are also supported
 * and will be combined with OR, e.g `hello world` will match documents that contain either 'hello'
 * or 'world', though those that contain both will rank higher in the results.
 *
 * Wildcards can be included in terms to match one or more unspecified characters, these wildcards can
 * be inserted anywhere within the term, and more than one wildcard can exist in a single term. Adding
 * wildcards will increase the number of documents that will be found but can also have a negative
 * impact on query performance, especially with wildcards at the beginning of a term.
 *
 * Terms can be restricted to specific fields, e.g. `title:hello`, only documents with the term
 * hello in the title field will match this query. Using a field not present in the index will lead
 * to an error being thrown.
 *
 * Modifiers can also be added to terms, lunr supports edit distance and boost modifiers on terms. A term
 * boost will make documents matching that term score higher, e.g. `foo^5`. Edit distance is also supported
 * to provide fuzzy matching, e.g. 'hello~2' will match documents with hello with an edit distance of 2.
 * Avoid large values for edit distance to improve query performance.
 *
 * Each term also supports a presence modifier. By default a term's presence in document is optional, however
 * this can be changed to either required or prohibited. For a term's presence to be required in a document the
 * term should be prefixed with a '+', e.g. `+foo bar` is a search for documents that must contain 'foo' and
 * optionally contain 'bar'. Conversely a leading '-' sets the terms presence to prohibited, i.e. it must not
 * appear in a document, e.g. `-foo bar` is a search for documents that do not contain 'foo' but may contain 'bar'.
 *
 * To escape special characters the backslash character '\' can be used, this allows searches to include
 * characters that would normally be considered modifiers, e.g. `foo\~2` will search for a term "foo~2" instead
 * of attempting to apply a boost of 2 to the search term "foo".
 *
 * @typedef {string} lunr.Index~QueryString
 * @example <caption>Simple single term query</caption>
 * hello
 * @example <caption>Multiple term query</caption>
 * hello world
 * @example <caption>term scoped to a field</caption>
 * title:hello
 * @example <caption>term with a boost of 10</caption>
 * hello^10
 * @example <caption>term with an edit distance of 2</caption>
 * hello~2
 * @example <caption>terms with presence modifiers</caption>
 * -foo +bar baz
 */

/**
 * Performs a search against the index using lunr query syntax.
 *
 * Results will be returned sorted by their score, the most relevant results
 * will be returned first.  For details on how the score is calculated, please see
 * the {@link https://lunrjs.com/guides/searching.html#scoring|guide}.
 *
 * For more programmatic querying use lunr.Index#query.
 *
 * @param {lunr.Index~QueryString} queryString - A string containing a lunr query.
 * @throws {lunr.QueryParseError} If the passed query string cannot be parsed.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.search = function (queryString) {
  return this.query(function (query) {
    var parser = new lunr.QueryParser(queryString, query)
    parser.parse()
  })
}

/**
 * A query builder callback provides a query object to be used to express
 * the query to perform on the index.
 *
 * @callback lunr.Index~queryBuilder
 * @param {lunr.Query} query - The query object to build up.
 * @this lunr.Query
 */

/**
 * Performs a query against the index using the yielded lunr.Query object.
 *
 * If performing programmatic queries against the index, this method is preferred
 * over lunr.Index#search so as to avoid the additional query parsing overhead.
 *
 * A query object is yielded to the supplied function which should be used to
 * express the query to be run against the index.
 *
 * Note that although this function takes a callback parameter it is _not_ an
 * asynchronous operation, the callback is just yielded a query object to be
 * customized.
 *
 * @param {lunr.Index~queryBuilder} fn - A function that is used to build the query.
 * @returns {lunr.Index~Result[]}
 */
lunr.Index.prototype.query = function (fn) {
  // for each query clause
  // * process terms
  // * expand terms from token set
  // * find matching documents and metadata
  // * get document vectors
  // * score documents

  var query = new lunr.Query(this.fields),
      matchingFields = Object.create(null),
      queryVectors = Object.create(null),
      termFieldCache = Object.create(null),
      requiredMatches = Object.create(null),
      prohibitedMatches = Object.create(null)

  /*
   * To support field level boosts a query vector is created per
   * field. An empty vector is eagerly created to support negated
   * queries.
   */
  for (var i = 0; i < this.fields.length; i++) {
    queryVectors[this.fields[i]] = new lunr.Vector
  }

  fn.call(query, query)

  for (var i = 0; i < query.clauses.length; i++) {
    /*
     * Unless the pipeline has been disabled for this term, which is
     * the case for terms with wildcards, we need to pass the clause
     * term through the search pipeline. A pipeline returns an array
     * of processed terms. Pipeline functions may expand the passed
     * term, which means we may end up performing multiple index lookups
     * for a single query term.
     */
    var clause = query.clauses[i],
        terms = null,
        clauseMatches = lunr.Set.complete

    if (clause.usePipeline) {
      terms = this.pipeline.runString(clause.term, {
        fields: clause.fields
      })
    } else {
      terms = [clause.term]
    }

    for (var m = 0; m < terms.length; m++) {
      var term = terms[m]

      /*
       * Each term returned from the pipeline needs to use the same query
       * clause object, e.g. the same boost and or edit distance. The
       * simplest way to do this is to re-use the clause object but mutate
       * its term property.
       */
      clause.term = term

      /*
       * From the term in the clause we create a token set which will then
       * be used to intersect the indexes token set to get a list of terms
       * to lookup in the inverted index
       */
      var termTokenSet = lunr.TokenSet.fromClause(clause),
          expandedTerms = this.tokenSet.intersect(termTokenSet).toArray()

      /*
       * If a term marked as required does not exist in the tokenSet it is
       * impossible for the search to return any matches. We set all the field
       * scoped required matches set to empty and stop examining any further
       * clauses.
       */
      if (expandedTerms.length === 0 && clause.presence === lunr.Query.presence.REQUIRED) {
        for (var k = 0; k < clause.fields.length; k++) {
          var field = clause.fields[k]
          requiredMatches[field] = lunr.Set.empty
        }

        break
      }

      for (var j = 0; j < expandedTerms.length; j++) {
        /*
         * For each term get the posting and termIndex, this is required for
         * building the query vector.
         */
        var expandedTerm = expandedTerms[j],
            posting = this.invertedIndex[expandedTerm],
            termIndex = posting._index

        for (var k = 0; k < clause.fields.length; k++) {
          /*
           * For each field that this query term is scoped by (by default
           * all fields are in scope) we need to get all the document refs
           * that have this term in that field.
           *
           * The posting is the entry in the invertedIndex for the matching
           * term from above.
           */
          var field = clause.fields[k],
              fieldPosting = posting[field],
              matchingDocumentRefs = Object.keys(fieldPosting),
              termField = expandedTerm + "/" + field,
              matchingDocumentsSet = new lunr.Set(matchingDocumentRefs)

          /*
           * if the presence of this term is required ensure that the matching
           * documents are added to the set of required matches for this clause.
           *
           */
          if (clause.presence == lunr.Query.presence.REQUIRED) {
            clauseMatches = clauseMatches.union(matchingDocumentsSet)

            if (requiredMatches[field] === undefined) {
              requiredMatches[field] = lunr.Set.complete
            }
          }

          /*
           * if the presence of this term is prohibited ensure that the matching
           * documents are added to the set of prohibited matches for this field,
           * creating that set if it does not yet exist.
           */
          if (clause.presence == lunr.Query.presence.PROHIBITED) {
            if (prohibitedMatches[field] === undefined) {
              prohibitedMatches[field] = lunr.Set.empty
            }

            prohibitedMatches[field] = prohibitedMatches[field].union(matchingDocumentsSet)

            /*
             * Prohibited matches should not be part of the query vector used for
             * similarity scoring and no metadata should be extracted so we continue
             * to the next field
             */
            continue
          }

          /*
           * The query field vector is populated using the termIndex found for
           * the term and a unit value with the appropriate boost applied.
           * Using upsert because there could already be an entry in the vector
           * for the term we are working with. In that case we just add the scores
           * together.
           */
          queryVectors[field].upsert(termIndex, clause.boost, function (a, b) { return a + b })

          /**
           * If we've already seen this term, field combo then we've already collected
           * the matching documents and metadata, no need to go through all that again
           */
          if (termFieldCache[termField]) {
            continue
          }

          for (var l = 0; l < matchingDocumentRefs.length; l++) {
            /*
             * All metadata for this term/field/document triple
             * are then extracted and collected into an instance
             * of lunr.MatchData ready to be returned in the query
             * results
             */
            var matchingDocumentRef = matchingDocumentRefs[l],
                matchingFieldRef = new lunr.FieldRef (matchingDocumentRef, field),
                metadata = fieldPosting[matchingDocumentRef],
                fieldMatch

            if ((fieldMatch = matchingFields[matchingFieldRef]) === undefined) {
              matchingFields[matchingFieldRef] = new lunr.MatchData (expandedTerm, field, metadata)
            } else {
              fieldMatch.add(expandedTerm, field, metadata)
            }

          }

          termFieldCache[termField] = true
        }
      }
    }

    /**
     * If the presence was required we need to update the requiredMatches field sets.
     * We do this after all fields for the term have collected their matches because
     * the clause terms presence is required in _any_ of the fields not _all_ of the
     * fields.
     */
    if (clause.presence === lunr.Query.presence.REQUIRED) {
      for (var k = 0; k < clause.fields.length; k++) {
        var field = clause.fields[k]
        requiredMatches[field] = requiredMatches[field].intersect(clauseMatches)
      }
    }
  }

  /**
   * Need to combine the field scoped required and prohibited
   * matching documents into a global set of required and prohibited
   * matches
   */
  var allRequiredMatches = lunr.Set.complete,
      allProhibitedMatches = lunr.Set.empty

  for (var i = 0; i < this.fields.length; i++) {
    var field = this.fields[i]

    if (requiredMatches[field]) {
      allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field])
    }

    if (prohibitedMatches[field]) {
      allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field])
    }
  }

  var matchingFieldRefs = Object.keys(matchingFields),
      results = [],
      matches = Object.create(null)

  /*
   * If the query is negated (contains only prohibited terms)
   * we need to get _all_ fieldRefs currently existing in the
   * index. This is only done when we know that the query is
   * entirely prohibited terms to avoid any cost of getting all
   * fieldRefs unnecessarily.
   *
   * Additionally, blank MatchData must be created to correctly
   * populate the results.
   */
  if (query.isNegated()) {
    matchingFieldRefs = Object.keys(this.fieldVectors)

    for (var i = 0; i < matchingFieldRefs.length; i++) {
      var matchingFieldRef = matchingFieldRefs[i]
      var fieldRef = lunr.FieldRef.fromString(matchingFieldRef)
      matchingFields[matchingFieldRef] = new lunr.MatchData
    }
  }

  for (var i = 0; i < matchingFieldRefs.length; i++) {
    /*
     * Currently we have document fields that match the query, but we
     * need to return documents. The matchData and scores are combined
     * from multiple fields belonging to the same document.
     *
     * Scores are calculated by field, using the query vectors created
     * above, and combined into a final document score using addition.
     */
    var fieldRef = lunr.FieldRef.fromString(matchingFieldRefs[i]),
        docRef = fieldRef.docRef

    if (!allRequiredMatches.contains(docRef)) {
      continue
    }

    if (allProhibitedMatches.contains(docRef)) {
      continue
    }

    var fieldVector = this.fieldVectors[fieldRef],
        score = queryVectors[fieldRef.fieldName].similarity(fieldVector),
        docMatch

    if ((docMatch = matches[docRef]) !== undefined) {
      docMatch.score += score
      docMatch.matchData.combine(matchingFields[fieldRef])
    } else {
      var match = {
        ref: docRef,
        score: score,
        matchData: matchingFields[fieldRef]
      }
      matches[docRef] = match
      results.push(match)
    }
  }

  /*
   * Sort the results objects by score, highest first.
   */
  return results.sort(function (a, b) {
    return b.score - a.score
  })
}

/**
 * Prepares the index for JSON serialization.
 *
 * The schema for this JSON blob will be described in a
 * separate JSON schema file.
 *
 * @returns {Object}
 */
lunr.Index.prototype.toJSON = function () {
  var invertedIndex = Object.keys(this.invertedIndex)
    .sort()
    .map(function (term) {
      return [term, this.invertedIndex[term]]
    }, this)

  var fieldVectors = Object.keys(this.fieldVectors)
    .map(function (ref) {
      return [ref, this.fieldVectors[ref].toJSON()]
    }, this)

  return {
    version: lunr.version,
    fields: this.fields,
    fieldVectors: fieldVectors,
    invertedIndex: invertedIndex,
    pipeline: this.pipeline.toJSON()
  }
}

/**
 * Loads a previously serialized lunr.Index
 *
 * @param {Object} serializedIndex - A previously serialized lunr.Index
 * @returns {lunr.Index}
 */
lunr.Index.load = function (serializedIndex) {
  var attrs = {},
      fieldVectors = {},
      serializedVectors = serializedIndex.fieldVectors,
      invertedIndex = Object.create(null),
      serializedInvertedIndex = serializedIndex.invertedIndex,
      tokenSetBuilder = new lunr.TokenSet.Builder,
      pipeline = lunr.Pipeline.load(serializedIndex.pipeline)

  if (serializedIndex.version != lunr.version) {
    lunr.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr.version + "' does not match serialized index '" + serializedIndex.version + "'")
  }

  for (var i = 0; i < serializedVectors.length; i++) {
    var tuple = serializedVectors[i],
        ref = tuple[0],
        elements = tuple[1]

    fieldVectors[ref] = new lunr.Vector(elements)
  }

  for (var i = 0; i < serializedInvertedIndex.length; i++) {
    var tuple = serializedInvertedIndex[i],
        term = tuple[0],
        posting = tuple[1]

    tokenSetBuilder.insert(term)
    invertedIndex[term] = posting
  }

  tokenSetBuilder.finish()

  attrs.fields = serializedIndex.fields

  attrs.fieldVectors = fieldVectors
  attrs.invertedIndex = invertedIndex
  attrs.tokenSet = tokenSetBuilder.root
  attrs.pipeline = pipeline

  return new lunr.Index(attrs)
}
/*!
 * lunr.Builder
 * Copyright (C) 2019 Oliver Nightingale
 */

/**
 * lunr.Builder performs indexing on a set of documents and
 * returns instances of lunr.Index ready for querying.
 *
 * All configuration of the index is done via the builder, the
 * fields to index, the document reference, the text processing
 * pipeline and document scoring parameters are all set on the
 * builder before indexing.
 *
 * @constructor
 * @property {string} _ref - Internal reference to the document reference field.
 * @property {string[]} _fields - Internal reference to the document fields to index.
 * @property {object} invertedIndex - The inverted index maps terms to document fields.
 * @property {object} documentTermFrequencies - Keeps track of document term frequencies.
 * @property {object} documentLengths - Keeps track of the length of documents added to the index.
 * @property {lunr.tokenizer} tokenizer - Function for splitting strings into tokens for indexing.
 * @property {lunr.Pipeline} pipeline - The pipeline performs text processing on tokens before indexing.
 * @property {lunr.Pipeline} searchPipeline - A pipeline for processing search terms before querying the index.
 * @property {number} documentCount - Keeps track of the total number of documents indexed.
 * @property {number} _b - A parameter to control field length normalization, setting this to 0 disabled normalization, 1 fully normalizes field lengths, the default value is 0.75.
 * @property {number} _k1 - A parameter to control how quickly an increase in term frequency results in term frequency saturation, the default value is 1.2.
 * @property {number} termIndex - A counter incremented for each unique term, used to identify a terms position in the vector space.
 * @property {array} metadataWhitelist - A list of metadata keys that have been whitelisted for entry in the index.
 */
lunr.Builder = function () {
  this._ref = "id"
  this._fields = Object.create(null)
  this._documents = Object.create(null)
  this.invertedIndex = Object.create(null)
  this.fieldTermFrequencies = {}
  this.fieldLengths = {}
  this.tokenizer = lunr.tokenizer
  this.pipeline = new lunr.Pipeline
  this.searchPipeline = new lunr.Pipeline
  this.documentCount = 0
  this._b = 0.75
  this._k1 = 1.2
  this.termIndex = 0
  this.metadataWhitelist = []
}

/**
 * Sets the document field used as the document reference. Every document must have this field.
 * The type of this field in the document should be a string, if it is not a string it will be
 * coerced into a string by calling toString.
 *
 * The default ref is 'id'.
 *
 * The ref should _not_ be changed during indexing, it should be set before any documents are
 * added to the index. Changing it during indexing can lead to inconsistent results.
 *
 * @param {string} ref - The name of the reference field in the document.
 */
lunr.Builder.prototype.ref = function (ref) {
  this._ref = ref
}

/**
 * A function that is used to extract a field from a document.
 *
 * Lunr expects a field to be at the top level of a document, if however the field
 * is deeply nested within a document an extractor function can be used to extract
 * the right field for indexing.
 *
 * @callback fieldExtractor
 * @param {object} doc - The document being added to the index.
 * @returns {?(string|object|object[])} obj - The object that will be indexed for this field.
 * @example <caption>Extracting a nested field</caption>
 * function (doc) { return doc.nested.field }
 */

/**
 * Adds a field to the list of document fields that will be indexed. Every document being
 * indexed should have this field. Null values for this field in indexed documents will
 * not cause errors but will limit the chance of that document being retrieved by searches.
 *
 * All fields should be added before adding documents to the index. Adding fields after
 * a document has been indexed will have no effect on already indexed documents.
 *
 * Fields can be boosted at build time. This allows terms within that field to have more
 * importance when ranking search results. Use a field boost to specify that matches within
 * one field are more important than other fields.
 *
 * @param {string} fieldName - The name of a field to index in all documents.
 * @param {object} attributes - Optional attributes associated with this field.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this field.
 * @param {fieldExtractor} [attributes.extractor] - Function to extract a field from a document.
 * @throws {RangeError} fieldName cannot contain unsupported characters '/'
 */
lunr.Builder.prototype.field = function (fieldName, attributes) {
  if (/\//.test(fieldName)) {
    throw new RangeError ("Field '" + fieldName + "' contains illegal character '/'")
  }

  this._fields[fieldName] = attributes || {}
}

/**
 * A parameter to tune the amount of field length normalisation that is applied when
 * calculating relevance scores. A value of 0 will completely disable any normalisation
 * and a value of 1 will fully normalise field lengths. The default is 0.75. Values of b
 * will be clamped to the range 0 - 1.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.b = function (number) {
  if (number < 0) {
    this._b = 0
  } else if (number > 1) {
    this._b = 1
  } else {
    this._b = number
  }
}

/**
 * A parameter that controls the speed at which a rise in term frequency results in term
 * frequency saturation. The default value is 1.2. Setting this to a higher value will give
 * slower saturation levels, a lower value will result in quicker saturation.
 *
 * @param {number} number - The value to set for this tuning parameter.
 */
lunr.Builder.prototype.k1 = function (number) {
  this._k1 = number
}

/**
 * Adds a document to the index.
 *
 * Before adding fields to the index the index should have been fully setup, with the document
 * ref and all fields to index already having been specified.
 *
 * The document must have a field name as specified by the ref (by default this is 'id') and
 * it should have all fields defined for indexing, though null or undefined values will not
 * cause errors.
 *
 * Entire documents can be boosted at build time. Applying a boost to a document indicates that
 * this document should rank higher in search results than other documents.
 *
 * @param {object} doc - The document to add to the index.
 * @param {object} attributes - Optional attributes associated with this document.
 * @param {number} [attributes.boost=1] - Boost applied to all terms within this document.
 */
lunr.Builder.prototype.add = function (doc, attributes) {
  var docRef = doc[this._ref],
      fields = Object.keys(this._fields)

  this._documents[docRef] = attributes || {}
  this.documentCount += 1

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i],
        extractor = this._fields[fieldName].extractor,
        field = extractor ? extractor(doc) : doc[fieldName],
        tokens = this.tokenizer(field, {
          fields: [fieldName]
        }),
        terms = this.pipeline.run(tokens),
        fieldRef = new lunr.FieldRef (docRef, fieldName),
        fieldTerms = Object.create(null)

    this.fieldTermFrequencies[fieldRef] = fieldTerms
    this.fieldLengths[fieldRef] = 0

    // store the length of this field for this document
    this.fieldLengths[fieldRef] += terms.length

    // calculate term frequencies for this field
    for (var j = 0; j < terms.length; j++) {
      var term = terms[j]

      if (fieldTerms[term] == undefined) {
        fieldTerms[term] = 0
      }

      fieldTerms[term] += 1

      // add to inverted index
      // create an initial posting if one doesn't exist
      if (this.invertedIndex[term] == undefined) {
        var posting = Object.create(null)
        posting["_index"] = this.termIndex
        this.termIndex += 1

        for (var k = 0; k < fields.length; k++) {
          posting[fields[k]] = Object.create(null)
        }

        this.invertedIndex[term] = posting
      }

      // add an entry for this term/fieldName/docRef to the invertedIndex
      if (this.invertedIndex[term][fieldName][docRef] == undefined) {
        this.invertedIndex[term][fieldName][docRef] = Object.create(null)
      }

      // store all whitelisted metadata about this token in the
      // inverted index
      for (var l = 0; l < this.metadataWhitelist.length; l++) {
        var metadataKey = this.metadataWhitelist[l],
            metadata = term.metadata[metadataKey]

        if (this.invertedIndex[term][fieldName][docRef][metadataKey] == undefined) {
          this.invertedIndex[term][fieldName][docRef][metadataKey] = []
        }

        this.invertedIndex[term][fieldName][docRef][metadataKey].push(metadata)
      }
    }

  }
}

/**
 * Calculates the average document length for this index
 *
 * @private
 */
lunr.Builder.prototype.calculateAverageFieldLengths = function () {

  var fieldRefs = Object.keys(this.fieldLengths),
      numberOfFields = fieldRefs.length,
      accumulator = {},
      documentsWithField = {}

  for (var i = 0; i < numberOfFields; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        field = fieldRef.fieldName

    documentsWithField[field] || (documentsWithField[field] = 0)
    documentsWithField[field] += 1

    accumulator[field] || (accumulator[field] = 0)
    accumulator[field] += this.fieldLengths[fieldRef]
  }

  var fields = Object.keys(this._fields)

  for (var i = 0; i < fields.length; i++) {
    var fieldName = fields[i]
    accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName]
  }

  this.averageFieldLength = accumulator
}

/**
 * Builds a vector space model of every document using lunr.Vector
 *
 * @private
 */
lunr.Builder.prototype.createFieldVectors = function () {
  var fieldVectors = {},
      fieldRefs = Object.keys(this.fieldTermFrequencies),
      fieldRefsLength = fieldRefs.length,
      termIdfCache = Object.create(null)

  for (var i = 0; i < fieldRefsLength; i++) {
    var fieldRef = lunr.FieldRef.fromString(fieldRefs[i]),
        fieldName = fieldRef.fieldName,
        fieldLength = this.fieldLengths[fieldRef],
        fieldVector = new lunr.Vector,
        termFrequencies = this.fieldTermFrequencies[fieldRef],
        terms = Object.keys(termFrequencies),
        termsLength = terms.length


    var fieldBoost = this._fields[fieldName].boost || 1,
        docBoost = this._documents[fieldRef.docRef].boost || 1

    for (var j = 0; j < termsLength; j++) {
      var term = terms[j],
          tf = termFrequencies[term],
          termIndex = this.invertedIndex[term]._index,
          idf, score, scoreWithPrecision

      if (termIdfCache[term] === undefined) {
        idf = lunr.idf(this.invertedIndex[term], this.documentCount)
        termIdfCache[term] = idf
      } else {
        idf = termIdfCache[term]
      }

      score = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf)
      score *= fieldBoost
      score *= docBoost
      scoreWithPrecision = Math.round(score * 1000) / 1000
      // Converts 1.23456789 to 1.234.
      // Reducing the precision so that the vectors take up less
      // space when serialised. Doing it now so that they behave
      // the same before and after serialisation. Also, this is
      // the fastest approach to reducing a number's precision in
      // JavaScript.

      fieldVector.insert(termIndex, scoreWithPrecision)
    }

    fieldVectors[fieldRef] = fieldVector
  }

  this.fieldVectors = fieldVectors
}

/**
 * Creates a token set of all tokens in the index using lunr.TokenSet
 *
 * @private
 */
lunr.Builder.prototype.createTokenSet = function () {
  this.tokenSet = lunr.TokenSet.fromArray(
    Object.keys(this.invertedIndex).sort()
  )
}

/**
 * Builds the index, creating an instance of lunr.Index.
 *
 * This completes the indexing process and should only be called
 * once all documents have been added to the index.
 *
 * @returns {lunr.Index}
 */
lunr.Builder.prototype.build = function () {
  this.calculateAverageFieldLengths()
  this.createFieldVectors()
  this.createTokenSet()

  return new lunr.Index({
    invertedIndex: this.invertedIndex,
    fieldVectors: this.fieldVectors,
    tokenSet: this.tokenSet,
    fields: Object.keys(this._fields),
    pipeline: this.searchPipeline
  })
}

/**
 * Applies a plugin to the index builder.
 *
 * A plugin is a function that is called with the index builder as its context.
 * Plugins can be used to customise or extend the behaviour of the index
 * in some way. A plugin is just a function, that encapsulated the custom
 * behaviour that should be applied when building the index.
 *
 * The plugin function will be called with the index builder as its argument, additional
 * arguments can also be passed when calling use. The function will be called
 * with the index builder as its context.
 *
 * @param {Function} plugin The plugin to apply.
 */
lunr.Builder.prototype.use = function (fn) {
  var args = Array.prototype.slice.call(arguments, 1)
  args.unshift(this)
  fn.apply(this, args)
}
/**
 * Contains and collects metadata about a matching document.
 * A single instance of lunr.MatchData is returned as part of every
 * lunr.Index~Result.
 *
 * @constructor
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 * @property {object} metadata - A cloned collection of metadata associated with this document.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData = function (term, field, metadata) {
  var clonedMetadata = Object.create(null),
      metadataKeys = Object.keys(metadata || {})

  // Cloning the metadata to prevent the original
  // being mutated during match data combination.
  // Metadata is kept in an array within the inverted
  // index so cloning the data can be done with
  // Array#slice
  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]
    clonedMetadata[key] = metadata[key].slice()
  }

  this.metadata = Object.create(null)

  if (term !== undefined) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = clonedMetadata
  }
}

/**
 * An instance of lunr.MatchData will be created for every term that matches a
 * document. However only one instance is required in a lunr.Index~Result. This
 * method combines metadata from another instance of lunr.MatchData with this
 * objects metadata.
 *
 * @param {lunr.MatchData} otherMatchData - Another instance of match data to merge with this one.
 * @see {@link lunr.Index~Result}
 */
lunr.MatchData.prototype.combine = function (otherMatchData) {
  var terms = Object.keys(otherMatchData.metadata)

  for (var i = 0; i < terms.length; i++) {
    var term = terms[i],
        fields = Object.keys(otherMatchData.metadata[term])

    if (this.metadata[term] == undefined) {
      this.metadata[term] = Object.create(null)
    }

    for (var j = 0; j < fields.length; j++) {
      var field = fields[j],
          keys = Object.keys(otherMatchData.metadata[term][field])

      if (this.metadata[term][field] == undefined) {
        this.metadata[term][field] = Object.create(null)
      }

      for (var k = 0; k < keys.length; k++) {
        var key = keys[k]

        if (this.metadata[term][field][key] == undefined) {
          this.metadata[term][field][key] = otherMatchData.metadata[term][field][key]
        } else {
          this.metadata[term][field][key] = this.metadata[term][field][key].concat(otherMatchData.metadata[term][field][key])
        }

      }
    }
  }
}

/**
 * Add metadata for a term/field pair to this instance of match data.
 *
 * @param {string} term - The term this match data is associated with
 * @param {string} field - The field in which the term was found
 * @param {object} metadata - The metadata recorded about this term in this field
 */
lunr.MatchData.prototype.add = function (term, field, metadata) {
  if (!(term in this.metadata)) {
    this.metadata[term] = Object.create(null)
    this.metadata[term][field] = metadata
    return
  }

  if (!(field in this.metadata[term])) {
    this.metadata[term][field] = metadata
    return
  }

  var metadataKeys = Object.keys(metadata)

  for (var i = 0; i < metadataKeys.length; i++) {
    var key = metadataKeys[i]

    if (key in this.metadata[term][field]) {
      this.metadata[term][field][key] = this.metadata[term][field][key].concat(metadata[key])
    } else {
      this.metadata[term][field][key] = metadata[key]
    }
  }
}
/**
 * A lunr.Query provides a programmatic way of defining queries to be performed
 * against a {@link lunr.Index}.
 *
 * Prefer constructing a lunr.Query using the {@link lunr.Index#query} method
 * so the query object is pre-initialized with the right index fields.
 *
 * @constructor
 * @property {lunr.Query~Clause[]} clauses - An array of query clauses.
 * @property {string[]} allFields - An array of all available fields in a lunr.Index.
 */
lunr.Query = function (allFields) {
  this.clauses = []
  this.allFields = allFields
}

/**
 * Constants for indicating what kind of automatic wildcard insertion will be used when constructing a query clause.
 *
 * This allows wildcards to be added to the beginning and end of a term without having to manually do any string
 * concatenation.
 *
 * The wildcard constants can be bitwise combined to select both leading and trailing wildcards.
 *
 * @constant
 * @default
 * @property {number} wildcard.NONE - The term will have no wildcards inserted, this is the default behaviour
 * @property {number} wildcard.LEADING - Prepend the term with a wildcard, unless a leading wildcard already exists
 * @property {number} wildcard.TRAILING - Append a wildcard to the term, unless a trailing wildcard already exists
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with trailing wildcard</caption>
 * query.term('foo', { wildcard: lunr.Query.wildcard.TRAILING })
 * @example <caption>query term with leading and trailing wildcard</caption>
 * query.term('foo', {
 *   wildcard: lunr.Query.wildcard.LEADING | lunr.Query.wildcard.TRAILING
 * })
 */

lunr.Query.wildcard = new String ("*")
lunr.Query.wildcard.NONE = 0
lunr.Query.wildcard.LEADING = 1
lunr.Query.wildcard.TRAILING = 2

/**
 * Constants for indicating what kind of presence a term must have in matching documents.
 *
 * @constant
 * @enum {number}
 * @see lunr.Query~Clause
 * @see lunr.Query#clause
 * @see lunr.Query#term
 * @example <caption>query term with required presence</caption>
 * query.term('foo', { presence: lunr.Query.presence.REQUIRED })
 */
lunr.Query.presence = {
  /**
   * Term's presence in a document is optional, this is the default value.
   */
  OPTIONAL: 1,

  /**
   * Term's presence in a document is required, documents that do not contain
   * this term will not be returned.
   */
  REQUIRED: 2,

  /**
   * Term's presence in a document is prohibited, documents that do contain
   * this term will not be returned.
   */
  PROHIBITED: 3
}

/**
 * A single clause in a {@link lunr.Query} contains a term and details on how to
 * match that term against a {@link lunr.Index}.
 *
 * @typedef {Object} lunr.Query~Clause
 * @property {string[]} fields - The fields in an index this clause should be matched against.
 * @property {number} [boost=1] - Any boost that should be applied when matching this clause.
 * @property {number} [editDistance] - Whether the term should have fuzzy matching applied, and how fuzzy the match should be.
 * @property {boolean} [usePipeline] - Whether the term should be passed through the search pipeline.
 * @property {number} [wildcard=lunr.Query.wildcard.NONE] - Whether the term should have wildcards appended or prepended.
 * @property {number} [presence=lunr.Query.presence.OPTIONAL] - The terms presence in any matching documents.
 */

/**
 * Adds a {@link lunr.Query~Clause} to this query.
 *
 * Unless the clause contains the fields to be matched all fields will be matched. In addition
 * a default boost of 1 is applied to the clause.
 *
 * @param {lunr.Query~Clause} clause - The clause to add to this query.
 * @see lunr.Query~Clause
 * @returns {lunr.Query}
 */
lunr.Query.prototype.clause = function (clause) {
  if (!('fields' in clause)) {
    clause.fields = this.allFields
  }

  if (!('boost' in clause)) {
    clause.boost = 1
  }

  if (!('usePipeline' in clause)) {
    clause.usePipeline = true
  }

  if (!('wildcard' in clause)) {
    clause.wildcard = lunr.Query.wildcard.NONE
  }

  if ((clause.wildcard & lunr.Query.wildcard.LEADING) && (clause.term.charAt(0) != lunr.Query.wildcard)) {
    clause.term = "*" + clause.term
  }

  if ((clause.wildcard & lunr.Query.wildcard.TRAILING) && (clause.term.slice(-1) != lunr.Query.wildcard)) {
    clause.term = "" + clause.term + "*"
  }

  if (!('presence' in clause)) {
    clause.presence = lunr.Query.presence.OPTIONAL
  }

  this.clauses.push(clause)

  return this
}

/**
 * A negated query is one in which every clause has a presence of
 * prohibited. These queries require some special processing to return
 * the expected results.
 *
 * @returns boolean
 */
lunr.Query.prototype.isNegated = function () {
  for (var i = 0; i < this.clauses.length; i++) {
    if (this.clauses[i].presence != lunr.Query.presence.PROHIBITED) {
      return false
    }
  }

  return true
}

/**
 * Adds a term to the current query, under the covers this will create a {@link lunr.Query~Clause}
 * to the list of clauses that make up this query.
 *
 * The term is used as is, i.e. no tokenization will be performed by this method. Instead conversion
 * to a token or token-like string should be done before calling this method.
 *
 * The term will be converted to a string by calling `toString`. Multiple terms can be passed as an
 * array, each term in the array will share the same options.
 *
 * @param {object|object[]} term - The term(s) to add to the query.
 * @param {object} [options] - Any additional properties to add to the query clause.
 * @returns {lunr.Query}
 * @see lunr.Query#clause
 * @see lunr.Query~Clause
 * @example <caption>adding a single term to a query</caption>
 * query.term("foo")
 * @example <caption>adding a single term to a query and specifying search fields, term boost and automatic trailing wildcard</caption>
 * query.term("foo", {
 *   fields: ["title"],
 *   boost: 10,
 *   wildcard: lunr.Query.wildcard.TRAILING
 * })
 * @example <caption>using lunr.tokenizer to convert a string to tokens before using them as terms</caption>
 * query.term(lunr.tokenizer("foo bar"))
 */
lunr.Query.prototype.term = function (term, options) {
  if (Array.isArray(term)) {
    term.forEach(function (t) { this.term(t, lunr.utils.clone(options)) }, this)
    return this
  }

  var clause = options || {}
  clause.term = term.toString()

  this.clause(clause)

  return this
}
lunr.QueryParseError = function (message, start, end) {
  this.name = "QueryParseError"
  this.message = message
  this.start = start
  this.end = end
}

lunr.QueryParseError.prototype = new Error
lunr.QueryLexer = function (str) {
  this.lexemes = []
  this.str = str
  this.length = str.length
  this.pos = 0
  this.start = 0
  this.escapeCharPositions = []
}

lunr.QueryLexer.prototype.run = function () {
  var state = lunr.QueryLexer.lexText

  while (state) {
    state = state(this)
  }
}

lunr.QueryLexer.prototype.sliceString = function () {
  var subSlices = [],
      sliceStart = this.start,
      sliceEnd = this.pos

  for (var i = 0; i < this.escapeCharPositions.length; i++) {
    sliceEnd = this.escapeCharPositions[i]
    subSlices.push(this.str.slice(sliceStart, sliceEnd))
    sliceStart = sliceEnd + 1
  }

  subSlices.push(this.str.slice(sliceStart, this.pos))
  this.escapeCharPositions.length = 0

  return subSlices.join('')
}

lunr.QueryLexer.prototype.emit = function (type) {
  this.lexemes.push({
    type: type,
    str: this.sliceString(),
    start: this.start,
    end: this.pos
  })

  this.start = this.pos
}

lunr.QueryLexer.prototype.escapeCharacter = function () {
  this.escapeCharPositions.push(this.pos - 1)
  this.pos += 1
}

lunr.QueryLexer.prototype.next = function () {
  if (this.pos >= this.length) {
    return lunr.QueryLexer.EOS
  }

  var char = this.str.charAt(this.pos)
  this.pos += 1
  return char
}

lunr.QueryLexer.prototype.width = function () {
  return this.pos - this.start
}

lunr.QueryLexer.prototype.ignore = function () {
  if (this.start == this.pos) {
    this.pos += 1
  }

  this.start = this.pos
}

lunr.QueryLexer.prototype.backup = function () {
  this.pos -= 1
}

lunr.QueryLexer.prototype.acceptDigitRun = function () {
  var char, charCode

  do {
    char = this.next()
    charCode = char.charCodeAt(0)
  } while (charCode > 47 && charCode < 58)

  if (char != lunr.QueryLexer.EOS) {
    this.backup()
  }
}

lunr.QueryLexer.prototype.more = function () {
  return this.pos < this.length
}

lunr.QueryLexer.EOS = 'EOS'
lunr.QueryLexer.FIELD = 'FIELD'
lunr.QueryLexer.TERM = 'TERM'
lunr.QueryLexer.EDIT_DISTANCE = 'EDIT_DISTANCE'
lunr.QueryLexer.BOOST = 'BOOST'
lunr.QueryLexer.PRESENCE = 'PRESENCE'

lunr.QueryLexer.lexField = function (lexer) {
  lexer.backup()
  lexer.emit(lunr.QueryLexer.FIELD)
  lexer.ignore()
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexTerm = function (lexer) {
  if (lexer.width() > 1) {
    lexer.backup()
    lexer.emit(lunr.QueryLexer.TERM)
  }

  lexer.ignore()

  if (lexer.more()) {
    return lunr.QueryLexer.lexText
  }
}

lunr.QueryLexer.lexEditDistance = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.EDIT_DISTANCE)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexBoost = function (lexer) {
  lexer.ignore()
  lexer.acceptDigitRun()
  lexer.emit(lunr.QueryLexer.BOOST)
  return lunr.QueryLexer.lexText
}

lunr.QueryLexer.lexEOS = function (lexer) {
  if (lexer.width() > 0) {
    lexer.emit(lunr.QueryLexer.TERM)
  }
}

// This matches the separator used when tokenising fields
// within a document. These should match otherwise it is
// not possible to search for some tokens within a document.
//
// It is possible for the user to change the separator on the
// tokenizer so it _might_ clash with any other of the special
// characters already used within the search string, e.g. :.
//
// This means that it is possible to change the separator in
// such a way that makes some words unsearchable using a search
// string.
lunr.QueryLexer.termSeparator = lunr.tokenizer.separator

lunr.QueryLexer.lexText = function (lexer) {
  while (true) {
    var char = lexer.next()

    if (char == lunr.QueryLexer.EOS) {
      return lunr.QueryLexer.lexEOS
    }

    // Escape character is '\'
    if (char.charCodeAt(0) == 92) {
      lexer.escapeCharacter()
      continue
    }

    if (char == ":") {
      return lunr.QueryLexer.lexField
    }

    if (char == "~") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexEditDistance
    }

    if (char == "^") {
      lexer.backup()
      if (lexer.width() > 0) {
        lexer.emit(lunr.QueryLexer.TERM)
      }
      return lunr.QueryLexer.lexBoost
    }

    // "+" indicates term presence is required
    // checking for length to ensure that only
    // leading "+" are considered
    if (char == "+" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    // "-" indicates term presence is prohibited
    // checking for length to ensure that only
    // leading "-" are considered
    if (char == "-" && lexer.width() === 1) {
      lexer.emit(lunr.QueryLexer.PRESENCE)
      return lunr.QueryLexer.lexText
    }

    if (char.match(lunr.QueryLexer.termSeparator)) {
      return lunr.QueryLexer.lexTerm
    }
  }
}

lunr.QueryParser = function (str, query) {
  this.lexer = new lunr.QueryLexer (str)
  this.query = query
  this.currentClause = {}
  this.lexemeIdx = 0
}

lunr.QueryParser.prototype.parse = function () {
  this.lexer.run()
  this.lexemes = this.lexer.lexemes

  var state = lunr.QueryParser.parseClause

  while (state) {
    state = state(this)
  }

  return this.query
}

lunr.QueryParser.prototype.peekLexeme = function () {
  return this.lexemes[this.lexemeIdx]
}

lunr.QueryParser.prototype.consumeLexeme = function () {
  var lexeme = this.peekLexeme()
  this.lexemeIdx += 1
  return lexeme
}

lunr.QueryParser.prototype.nextClause = function () {
  var completedClause = this.currentClause
  this.query.clause(completedClause)
  this.currentClause = {}
}

lunr.QueryParser.parseClause = function (parser) {
  var lexeme = parser.peekLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.type) {
    case lunr.QueryLexer.PRESENCE:
      return lunr.QueryParser.parsePresence
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expected either a field or a term, found " + lexeme.type

      if (lexeme.str.length >= 1) {
        errorMessage += " with value '" + lexeme.str + "'"
      }

      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }
}

lunr.QueryParser.parsePresence = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  switch (lexeme.str) {
    case "-":
      parser.currentClause.presence = lunr.Query.presence.PROHIBITED
      break
    case "+":
      parser.currentClause.presence = lunr.Query.presence.REQUIRED
      break
    default:
      var errorMessage = "unrecognised presence operator'" + lexeme.str + "'"
      throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term or field, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.FIELD:
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseField = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  if (parser.query.allFields.indexOf(lexeme.str) == -1) {
    var possibleFields = parser.query.allFields.map(function (f) { return "'" + f + "'" }).join(', '),
        errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields

    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.fields = [lexeme.str]

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    var errorMessage = "expecting term, found nothing"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      return lunr.QueryParser.parseTerm
    default:
      var errorMessage = "expecting term, found '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseTerm = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  parser.currentClause.term = lexeme.str.toLowerCase()

  if (lexeme.str.indexOf("*") != -1) {
    parser.currentClause.usePipeline = false
  }

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseEditDistance = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var editDistance = parseInt(lexeme.str, 10)

  if (isNaN(editDistance)) {
    var errorMessage = "edit distance must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.editDistance = editDistance

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

lunr.QueryParser.parseBoost = function (parser) {
  var lexeme = parser.consumeLexeme()

  if (lexeme == undefined) {
    return
  }

  var boost = parseInt(lexeme.str, 10)

  if (isNaN(boost)) {
    var errorMessage = "boost must be numeric"
    throw new lunr.QueryParseError (errorMessage, lexeme.start, lexeme.end)
  }

  parser.currentClause.boost = boost

  var nextLexeme = parser.peekLexeme()

  if (nextLexeme == undefined) {
    parser.nextClause()
    return
  }

  switch (nextLexeme.type) {
    case lunr.QueryLexer.TERM:
      parser.nextClause()
      return lunr.QueryParser.parseTerm
    case lunr.QueryLexer.FIELD:
      parser.nextClause()
      return lunr.QueryParser.parseField
    case lunr.QueryLexer.EDIT_DISTANCE:
      return lunr.QueryParser.parseEditDistance
    case lunr.QueryLexer.BOOST:
      return lunr.QueryParser.parseBoost
    case lunr.QueryLexer.PRESENCE:
      parser.nextClause()
      return lunr.QueryParser.parsePresence
    default:
      var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'"
      throw new lunr.QueryParseError (errorMessage, nextLexeme.start, nextLexeme.end)
  }
}

  /**
   * export the module via AMD, CommonJS or as a browser global
   * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
   */
  ;(function (root, factory) {
    if (true) {
      // AMD. Register as an anonymous module.
      !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
      /**
       * Node. Does not work with strict CommonJS, but
       * only CommonJS-like enviroments that support module.exports,
       * like Node.
       */
      module.exports = factory()
    } else {
      // Browser globals (root is window)
      root.lunr = factory()
    }
  }(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return lunr
  }))
})();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* provides utilities for the included stemmers */
        lunr.stemmerSupport = {
            Among: function(s, substring_i, result, method) {
                this.toCharArray = function(s) {
                    var sLength = s.length, charArr = new Array(sLength);
                    for (var i = 0; i < sLength; i++)
                        charArr[i] = s.charCodeAt(i);
                    return charArr;
                };

                if ((!s && s != "") || (!substring_i && (substring_i != 0)) || !result)
                    throw ("Bad Among initialisation: s:" + s + ", substring_i: "
                        + substring_i + ", result: " + result);
                this.s_size = s.length;
                this.s = this.toCharArray(s);
                this.substring_i = substring_i;
                this.result = result;
                this.method = method;
            },
            SnowballProgram: function() {
                var current;
                return {
                    bra : 0,
                    ket : 0,
                    limit : 0,
                    cursor : 0,
                    limit_backward : 0,
                    setCurrent : function(word) {
                        current = word;
                        this.cursor = 0;
                        this.limit = word.length;
                        this.limit_backward = 0;
                        this.bra = this.cursor;
                        this.ket = this.limit;
                    },
                    getCurrent : function() {
                        var result = current;
                        current = null;
                        return result;
                    },
                    in_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor++;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    in_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch <= max && ch >= min) {
                                ch -= min;
                                if (s[ch >> 3] & (0X1 << (ch & 0X7))) {
                                    this.cursor--;
                                    return true;
                                }
                            }
                        }
                        return false;
                    },
                    out_grouping : function(s, min, max) {
                        if (this.cursor < this.limit) {
                            var ch = current.charCodeAt(this.cursor);
                            if (ch > max || ch < min) {
                                this.cursor++;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor++;
                                return true;
                            }
                        }
                        return false;
                    },
                    out_grouping_b : function(s, min, max) {
                        if (this.cursor > this.limit_backward) {
                            var ch = current.charCodeAt(this.cursor - 1);
                            if (ch > max || ch < min) {
                                this.cursor--;
                                return true;
                            }
                            ch -= min;
                            if (!(s[ch >> 3] & (0X1 << (ch & 0X7)))) {
                                this.cursor--;
                                return true;
                            }
                        }
                        return false;
                    },
                    eq_s : function(s_size, s) {
                        if (this.limit - this.cursor < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor + i) != s.charCodeAt(i))
                                return false;
                        this.cursor += s_size;
                        return true;
                    },
                    eq_s_b : function(s_size, s) {
                        if (this.cursor - this.limit_backward < s_size)
                            return false;
                        for (var i = 0; i < s_size; i++)
                            if (current.charCodeAt(this.cursor - s_size + i) != s
                                .charCodeAt(i))
                                return false;
                        this.cursor -= s_size;
                        return true;
                    },
                    find_among : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, l = this.limit, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = common; i2 < w.s_size; i2++) {
                                if (c + common == l) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c + common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c + w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c + w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    find_among_b : function(v, v_size) {
                        var i = 0, j = v_size, c = this.cursor, lb = this.limit_backward, common_i = 0, common_j = 0, first_key_inspected = false;
                        while (true) {
                            var k = i + ((j - i) >> 1), diff = 0, common = common_i < common_j
                                ? common_i
                                : common_j, w = v[k];
                            for (var i2 = w.s_size - 1 - common; i2 >= 0; i2--) {
                                if (c - common == lb) {
                                    diff = -1;
                                    break;
                                }
                                diff = current.charCodeAt(c - 1 - common) - w.s[i2];
                                if (diff)
                                    break;
                                common++;
                            }
                            if (diff < 0) {
                                j = k;
                                common_j = common;
                            } else {
                                i = k;
                                common_i = common;
                            }
                            if (j - i <= 1) {
                                if (i > 0 || j == i || first_key_inspected)
                                    break;
                                first_key_inspected = true;
                            }
                        }
                        while (true) {
                            var w = v[i];
                            if (common_i >= w.s_size) {
                                this.cursor = c - w.s_size;
                                if (!w.method)
                                    return w.result;
                                var res = w.method();
                                this.cursor = c - w.s_size;
                                if (res)
                                    return w.result;
                            }
                            i = w.substring_i;
                            if (i < 0)
                                return 0;
                        }
                    },
                    replace_s : function(c_bra, c_ket, s) {
                        var adjustment = s.length - (c_ket - c_bra), left = current
                            .substring(0, c_bra), right = current.substring(c_ket);
                        current = left + s + right;
                        this.limit += adjustment;
                        if (this.cursor >= c_ket)
                            this.cursor += adjustment;
                        else if (this.cursor > c_bra)
                            this.cursor = c_bra;
                        return adjustment;
                    },
                    slice_check : function() {
                        if (this.bra < 0 || this.bra > this.ket || this.ket > this.limit
                            || this.limit > current.length)
                            throw ("faulty slice operation");
                    },
                    slice_from : function(s) {
                        this.slice_check();
                        this.replace_s(this.bra, this.ket, s);
                    },
                    slice_del : function() {
                        this.slice_from("");
                    },
                    insert : function(c_bra, c_ket, s) {
                        var adjustment = this.replace_s(c_bra, c_ket, s);
                        if (c_bra <= this.bra)
                            this.bra += adjustment;
                        if (c_bra <= this.ket)
                            this.ket += adjustment;
                    },
                    slice_to : function() {
                        this.slice_check();
                        return current.substring(this.bra, this.ket);
                    },
                    eq_v_b : function(s) {
                        return this.eq_s_b(s.length, s);
                    }
                };
            }
        };

        lunr.trimmerSupport = {
            generateTrimmer: function(wordCharacters) {
                var startRegex = new RegExp("^[^" + wordCharacters + "]+")
                var endRegex = new RegExp("[^" + wordCharacters + "]+$")

                return function(token) {
                    // for lunr version 2
                    if (typeof token.update === "function") {
                        return token.update(function (s) {
                            return s
                                .replace(startRegex, '')
                                .replace(endRegex, '');
                        })
                    } else { // for lunr version 1
                        return token
                            .replace(startRegex, '')
                            .replace(endRegex, '');
                    }
                };
            }
        }
    }
}));


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */
    return function(lunr) {
        /* Set up the pipeline for indexing content in multiple languages. The
           corresponding lunr.{lang} files must be loaded before calling this
           function; English ('en') is built in.

           Returns: a lunr plugin for use in your indexer.

           Known drawback: every word will be stemmed with stemmers for every
           language. This could mean that sometimes words that have the same
           stemming root will not be stemmed as such.
           */
        lunr.multiLanguage = function(/* lang1, lang2, ... */) {
            var languages = Array.prototype.slice.call(arguments);
            var nameSuffix = languages.join('-');
            var wordCharacters = "";
            var pipeline = [];
            var searchPipeline = [];
            for (var i = 0; i < languages.length; ++i) {
                if (languages[i] == 'en') {
                    wordCharacters += '\\w';
                    pipeline.unshift(lunr.stopWordFilter);
                    pipeline.push(lunr.stemmer);
                    searchPipeline.push(lunr.stemmer);
                } else {
                    wordCharacters += lunr[languages[i]].wordCharacters;
                    if (lunr[languages[i]].stopWordFilter) {
                        pipeline.unshift(lunr[languages[i]].stopWordFilter);
                    }
                    if (lunr[languages[i]].stemmer) {
                        pipeline.push(lunr[languages[i]].stemmer);
                        searchPipeline.push(lunr[languages[i]].stemmer);
                    }
                }
            };
            var multiTrimmer = lunr.trimmerSupport.generateTrimmer(wordCharacters);
            lunr.Pipeline.registerFunction(multiTrimmer, 'lunr-multi-trimmer-' + nameSuffix);
            pipeline.unshift(multiTrimmer);

            return function() {
                this.pipeline.reset();

                this.pipeline.add.apply(this.pipeline, pipeline);

                // for lunr version 2
                // this is necessary so that every searched word is also stemmed before
                // in lunr <= 1 this is not needed, as it is done using the normal pipeline
                if (this.searchPipeline) {
                    this.searchPipeline.reset();
                    this.searchPipeline.add.apply(this.searchPipeline, searchPipeline);
                }
            };
        }
    }
}));


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
    } else if (typeof exports === 'object') {
        /**
         * Node. Does not work with strict CommonJS, but
         * only CommonJS-like environments that support module.exports,
         * like Node.
         */
        module.exports = factory()
    } else {
        // Browser globals (root is window)
        factory()(root.lunr);
    }
}(this, function () {
    /**
     * Just return a value to define the module export.
     * This example returns an object, but the module
     * can return a function as the exported value.
     */

    return function(lunr) {
        // TinySegmenter 0.1 -- Super compact Japanese tokenizer in Javascript
        // (c) 2008 Taku Kudo <taku@chasen.org>
        // TinySegmenter is freely distributable under the terms of a new BSD licence.
        // For details, see http://chasen.org/~taku/software/TinySegmenter/LICENCE.txt

        function TinySegmenter() {
          var patterns = {
            "[一二三四五六七八九十百千万億兆]":"M",
            "[一-龠々〆ヵヶ]":"H",
            "[ぁ-ん]":"I",
            "[ァ-ヴーｱ-ﾝﾞｰ]":"K",
            "[a-zA-Zａ-ｚＡ-Ｚ]":"A",
            "[0-9０-９]":"N"
          }
          this.chartype_ = [];
          for (var i in patterns) {
            var regexp = new RegExp(i);
            this.chartype_.push([regexp, patterns[i]]);
          }

          this.BIAS__ = -332
          this.BC1__ = {"HH":6,"II":2461,"KH":406,"OH":-1378};
          this.BC2__ = {"AA":-3267,"AI":2744,"AN":-878,"HH":-4070,"HM":-1711,"HN":4012,"HO":3761,"IA":1327,"IH":-1184,"II":-1332,"IK":1721,"IO":5492,"KI":3831,"KK":-8741,"MH":-3132,"MK":3334,"OO":-2920};
          this.BC3__ = {"HH":996,"HI":626,"HK":-721,"HN":-1307,"HO":-836,"IH":-301,"KK":2762,"MK":1079,"MM":4034,"OA":-1652,"OH":266};
          this.BP1__ = {"BB":295,"OB":304,"OO":-125,"UB":352};
          this.BP2__ = {"BO":60,"OO":-1762};
          this.BQ1__ = {"BHH":1150,"BHM":1521,"BII":-1158,"BIM":886,"BMH":1208,"BNH":449,"BOH":-91,"BOO":-2597,"OHI":451,"OIH":-296,"OKA":1851,"OKH":-1020,"OKK":904,"OOO":2965};
          this.BQ2__ = {"BHH":118,"BHI":-1159,"BHM":466,"BIH":-919,"BKK":-1720,"BKO":864,"OHH":-1139,"OHM":-181,"OIH":153,"UHI":-1146};
          this.BQ3__ = {"BHH":-792,"BHI":2664,"BII":-299,"BKI":419,"BMH":937,"BMM":8335,"BNN":998,"BOH":775,"OHH":2174,"OHM":439,"OII":280,"OKH":1798,"OKI":-793,"OKO":-2242,"OMH":-2402,"OOO":11699};
          this.BQ4__ = {"BHH":-3895,"BIH":3761,"BII":-4654,"BIK":1348,"BKK":-1806,"BMI":-3385,"BOO":-12396,"OAH":926,"OHH":266,"OHK":-2036,"ONN":-973};
          this.BW1__ = {",と":660,",同":727,"B1あ":1404,"B1同":542,"、と":660,"、同":727,"」と":1682,"あっ":1505,"いう":1743,"いっ":-2055,"いる":672,"うし":-4817,"うん":665,"から":3472,"がら":600,"こう":-790,"こと":2083,"こん":-1262,"さら":-4143,"さん":4573,"した":2641,"して":1104,"すで":-3399,"そこ":1977,"それ":-871,"たち":1122,"ため":601,"った":3463,"つい":-802,"てい":805,"てき":1249,"でき":1127,"です":3445,"では":844,"とい":-4915,"とみ":1922,"どこ":3887,"ない":5713,"なっ":3015,"など":7379,"なん":-1113,"にし":2468,"には":1498,"にも":1671,"に対":-912,"の一":-501,"の中":741,"ませ":2448,"まで":1711,"まま":2600,"まる":-2155,"やむ":-1947,"よっ":-2565,"れた":2369,"れで":-913,"をし":1860,"を見":731,"亡く":-1886,"京都":2558,"取り":-2784,"大き":-2604,"大阪":1497,"平方":-2314,"引き":-1336,"日本":-195,"本当":-2423,"毎日":-2113,"目指":-724,"Ｂ１あ":1404,"Ｂ１同":542,"｣と":1682};
          this.BW2__ = {"..":-11822,"11":-669,"――":-5730,"−−":-13175,"いう":-1609,"うか":2490,"かし":-1350,"かも":-602,"から":-7194,"かれ":4612,"がい":853,"がら":-3198,"きた":1941,"くな":-1597,"こと":-8392,"この":-4193,"させ":4533,"され":13168,"さん":-3977,"しい":-1819,"しか":-545,"した":5078,"して":972,"しな":939,"その":-3744,"たい":-1253,"たた":-662,"ただ":-3857,"たち":-786,"たと":1224,"たは":-939,"った":4589,"って":1647,"っと":-2094,"てい":6144,"てき":3640,"てく":2551,"ては":-3110,"ても":-3065,"でい":2666,"でき":-1528,"でし":-3828,"です":-4761,"でも":-4203,"とい":1890,"とこ":-1746,"とと":-2279,"との":720,"とみ":5168,"とも":-3941,"ない":-2488,"なが":-1313,"など":-6509,"なの":2614,"なん":3099,"にお":-1615,"にし":2748,"にな":2454,"によ":-7236,"に対":-14943,"に従":-4688,"に関":-11388,"のか":2093,"ので":-7059,"のに":-6041,"のの":-6125,"はい":1073,"はが":-1033,"はず":-2532,"ばれ":1813,"まし":-1316,"まで":-6621,"まれ":5409,"めて":-3153,"もい":2230,"もの":-10713,"らか":-944,"らし":-1611,"らに":-1897,"りし":651,"りま":1620,"れた":4270,"れて":849,"れば":4114,"ろう":6067,"われ":7901,"を通":-11877,"んだ":728,"んな":-4115,"一人":602,"一方":-1375,"一日":970,"一部":-1051,"上が":-4479,"会社":-1116,"出て":2163,"分の":-7758,"同党":970,"同日":-913,"大阪":-2471,"委員":-1250,"少な":-1050,"年度":-8669,"年間":-1626,"府県":-2363,"手権":-1982,"新聞":-4066,"日新":-722,"日本":-7068,"日米":3372,"曜日":-601,"朝鮮":-2355,"本人":-2697,"東京":-1543,"然と":-1384,"社会":-1276,"立て":-990,"第に":-1612,"米国":-4268,"１１":-669};
          this.BW3__ = {"あた":-2194,"あり":719,"ある":3846,"い.":-1185,"い。":-1185,"いい":5308,"いえ":2079,"いく":3029,"いた":2056,"いっ":1883,"いる":5600,"いわ":1527,"うち":1117,"うと":4798,"えと":1454,"か.":2857,"か。":2857,"かけ":-743,"かっ":-4098,"かに":-669,"から":6520,"かり":-2670,"が,":1816,"が、":1816,"がき":-4855,"がけ":-1127,"がっ":-913,"がら":-4977,"がり":-2064,"きた":1645,"けど":1374,"こと":7397,"この":1542,"ころ":-2757,"さい":-714,"さを":976,"し,":1557,"し、":1557,"しい":-3714,"した":3562,"して":1449,"しな":2608,"しま":1200,"す.":-1310,"す。":-1310,"する":6521,"ず,":3426,"ず、":3426,"ずに":841,"そう":428,"た.":8875,"た。":8875,"たい":-594,"たの":812,"たり":-1183,"たる":-853,"だ.":4098,"だ。":4098,"だっ":1004,"った":-4748,"って":300,"てい":6240,"てお":855,"ても":302,"です":1437,"でに":-1482,"では":2295,"とう":-1387,"とし":2266,"との":541,"とも":-3543,"どう":4664,"ない":1796,"なく":-903,"など":2135,"に,":-1021,"に、":-1021,"にし":1771,"にな":1906,"には":2644,"の,":-724,"の、":-724,"の子":-1000,"は,":1337,"は、":1337,"べき":2181,"まし":1113,"ます":6943,"まっ":-1549,"まで":6154,"まれ":-793,"らし":1479,"られ":6820,"るる":3818,"れ,":854,"れ、":854,"れた":1850,"れて":1375,"れば":-3246,"れる":1091,"われ":-605,"んだ":606,"んで":798,"カ月":990,"会議":860,"入り":1232,"大会":2217,"始め":1681,"市":965,"新聞":-5055,"日,":974,"日、":974,"社会":2024,"ｶ月":990};
          this.TC1__ = {"AAA":1093,"HHH":1029,"HHM":580,"HII":998,"HOH":-390,"HOM":-331,"IHI":1169,"IOH":-142,"IOI":-1015,"IOM":467,"MMH":187,"OOI":-1832};
          this.TC2__ = {"HHO":2088,"HII":-1023,"HMM":-1154,"IHI":-1965,"KKH":703,"OII":-2649};
          this.TC3__ = {"AAA":-294,"HHH":346,"HHI":-341,"HII":-1088,"HIK":731,"HOH":-1486,"IHH":128,"IHI":-3041,"IHO":-1935,"IIH":-825,"IIM":-1035,"IOI":-542,"KHH":-1216,"KKA":491,"KKH":-1217,"KOK":-1009,"MHH":-2694,"MHM":-457,"MHO":123,"MMH":-471,"NNH":-1689,"NNO":662,"OHO":-3393};
          this.TC4__ = {"HHH":-203,"HHI":1344,"HHK":365,"HHM":-122,"HHN":182,"HHO":669,"HIH":804,"HII":679,"HOH":446,"IHH":695,"IHO":-2324,"IIH":321,"III":1497,"IIO":656,"IOO":54,"KAK":4845,"KKA":3386,"KKK":3065,"MHH":-405,"MHI":201,"MMH":-241,"MMM":661,"MOM":841};
          this.TQ1__ = {"BHHH":-227,"BHHI":316,"BHIH":-132,"BIHH":60,"BIII":1595,"BNHH":-744,"BOHH":225,"BOOO":-908,"OAKK":482,"OHHH":281,"OHIH":249,"OIHI":200,"OIIH":-68};
          this.TQ2__ = {"BIHH":-1401,"BIII":-1033,"BKAK":-543,"BOOO":-5591};
          this.TQ3__ = {"BHHH":478,"BHHM":-1073,"BHIH":222,"BHII":-504,"BIIH":-116,"BIII":-105,"BMHI":-863,"BMHM":-464,"BOMH":620,"OHHH":346,"OHHI":1729,"OHII":997,"OHMH":481,"OIHH":623,"OIIH":1344,"OKAK":2792,"OKHH":587,"OKKA":679,"OOHH":110,"OOII":-685};
          this.TQ4__ = {"BHHH":-721,"BHHM":-3604,"BHII":-966,"BIIH":-607,"BIII":-2181,"OAAA":-2763,"OAKK":180,"OHHH":-294,"OHHI":2446,"OHHO":480,"OHIH":-1573,"OIHH":1935,"OIHI":-493,"OIIH":626,"OIII":-4007,"OKAK":-8156};
          this.TW1__ = {"につい":-4681,"東京都":2026};
          this.TW2__ = {"ある程":-2049,"いった":-1256,"ころが":-2434,"しょう":3873,"その後":-4430,"だって":-1049,"ていた":1833,"として":-4657,"ともに":-4517,"もので":1882,"一気に":-792,"初めて":-1512,"同時に":-8097,"大きな":-1255,"対して":-2721,"社会党":-3216};
          this.TW3__ = {"いただ":-1734,"してい":1314,"として":-4314,"につい":-5483,"にとっ":-5989,"に当た":-6247,"ので,":-727,"ので、":-727,"のもの":-600,"れから":-3752,"十二月":-2287};
          this.TW4__ = {"いう.":8576,"いう。":8576,"からな":-2348,"してい":2958,"たが,":1516,"たが、":1516,"ている":1538,"という":1349,"ました":5543,"ません":1097,"ようと":-4258,"よると":5865};
          this.UC1__ = {"A":484,"K":93,"M":645,"O":-505};
          this.UC2__ = {"A":819,"H":1059,"I":409,"M":3987,"N":5775,"O":646};
          this.UC3__ = {"A":-1370,"I":2311};
          this.UC4__ = {"A":-2643,"H":1809,"I":-1032,"K":-3450,"M":3565,"N":3876,"O":6646};
          this.UC5__ = {"H":313,"I":-1238,"K":-799,"M":539,"O":-831};
          this.UC6__ = {"H":-506,"I":-253,"K":87,"M":247,"O":-387};
          this.UP1__ = {"O":-214};
          this.UP2__ = {"B":69,"O":935};
          this.UP3__ = {"B":189};
          this.UQ1__ = {"BH":21,"BI":-12,"BK":-99,"BN":142,"BO":-56,"OH":-95,"OI":477,"OK":410,"OO":-2422};
          this.UQ2__ = {"BH":216,"BI":113,"OK":1759};
          this.UQ3__ = {"BA":-479,"BH":42,"BI":1913,"BK":-7198,"BM":3160,"BN":6427,"BO":14761,"OI":-827,"ON":-3212};
          this.UW1__ = {",":156,"、":156,"「":-463,"あ":-941,"う":-127,"が":-553,"き":121,"こ":505,"で":-201,"と":-547,"ど":-123,"に":-789,"の":-185,"は":-847,"も":-466,"や":-470,"よ":182,"ら":-292,"り":208,"れ":169,"を":-446,"ん":-137,"・":-135,"主":-402,"京":-268,"区":-912,"午":871,"国":-460,"大":561,"委":729,"市":-411,"日":-141,"理":361,"生":-408,"県":-386,"都":-718,"｢":-463,"･":-135};
          this.UW2__ = {",":-829,"、":-829,"〇":892,"「":-645,"」":3145,"あ":-538,"い":505,"う":134,"お":-502,"か":1454,"が":-856,"く":-412,"こ":1141,"さ":878,"ざ":540,"し":1529,"す":-675,"せ":300,"そ":-1011,"た":188,"だ":1837,"つ":-949,"て":-291,"で":-268,"と":-981,"ど":1273,"な":1063,"に":-1764,"の":130,"は":-409,"ひ":-1273,"べ":1261,"ま":600,"も":-1263,"や":-402,"よ":1639,"り":-579,"る":-694,"れ":571,"を":-2516,"ん":2095,"ア":-587,"カ":306,"キ":568,"ッ":831,"三":-758,"不":-2150,"世":-302,"中":-968,"主":-861,"事":492,"人":-123,"会":978,"保":362,"入":548,"初":-3025,"副":-1566,"北":-3414,"区":-422,"大":-1769,"天":-865,"太":-483,"子":-1519,"学":760,"実":1023,"小":-2009,"市":-813,"年":-1060,"強":1067,"手":-1519,"揺":-1033,"政":1522,"文":-1355,"新":-1682,"日":-1815,"明":-1462,"最":-630,"朝":-1843,"本":-1650,"東":-931,"果":-665,"次":-2378,"民":-180,"気":-1740,"理":752,"発":529,"目":-1584,"相":-242,"県":-1165,"立":-763,"第":810,"米":509,"自":-1353,"行":838,"西":-744,"見":-3874,"調":1010,"議":1198,"込":3041,"開":1758,"間":-1257,"｢":-645,"｣":3145,"ｯ":831,"ｱ":-587,"ｶ":306,"ｷ":568};
          this.UW3__ = {",":4889,"1":-800,"−":-1723,"、":4889,"々":-2311,"〇":5827,"」":2670,"〓":-3573,"あ":-2696,"い":1006,"う":2342,"え":1983,"お":-4864,"か":-1163,"が":3271,"く":1004,"け":388,"げ":401,"こ":-3552,"ご":-3116,"さ":-1058,"し":-395,"す":584,"せ":3685,"そ":-5228,"た":842,"ち":-521,"っ":-1444,"つ":-1081,"て":6167,"で":2318,"と":1691,"ど":-899,"な":-2788,"に":2745,"の":4056,"は":4555,"ひ":-2171,"ふ":-1798,"へ":1199,"ほ":-5516,"ま":-4384,"み":-120,"め":1205,"も":2323,"や":-788,"よ":-202,"ら":727,"り":649,"る":5905,"れ":2773,"わ":-1207,"を":6620,"ん":-518,"ア":551,"グ":1319,"ス":874,"ッ":-1350,"ト":521,"ム":1109,"ル":1591,"ロ":2201,"ン":278,"・":-3794,"一":-1619,"下":-1759,"世":-2087,"両":3815,"中":653,"主":-758,"予":-1193,"二":974,"人":2742,"今":792,"他":1889,"以":-1368,"低":811,"何":4265,"作":-361,"保":-2439,"元":4858,"党":3593,"全":1574,"公":-3030,"六":755,"共":-1880,"円":5807,"再":3095,"分":457,"初":2475,"別":1129,"前":2286,"副":4437,"力":365,"動":-949,"務":-1872,"化":1327,"北":-1038,"区":4646,"千":-2309,"午":-783,"協":-1006,"口":483,"右":1233,"各":3588,"合":-241,"同":3906,"和":-837,"員":4513,"国":642,"型":1389,"場":1219,"外":-241,"妻":2016,"学":-1356,"安":-423,"実":-1008,"家":1078,"小":-513,"少":-3102,"州":1155,"市":3197,"平":-1804,"年":2416,"広":-1030,"府":1605,"度":1452,"建":-2352,"当":-3885,"得":1905,"思":-1291,"性":1822,"戸":-488,"指":-3973,"政":-2013,"教":-1479,"数":3222,"文":-1489,"新":1764,"日":2099,"旧":5792,"昨":-661,"時":-1248,"曜":-951,"最":-937,"月":4125,"期":360,"李":3094,"村":364,"東":-805,"核":5156,"森":2438,"業":484,"氏":2613,"民":-1694,"決":-1073,"法":1868,"海":-495,"無":979,"物":461,"特":-3850,"生":-273,"用":914,"町":1215,"的":7313,"直":-1835,"省":792,"県":6293,"知":-1528,"私":4231,"税":401,"立":-960,"第":1201,"米":7767,"系":3066,"約":3663,"級":1384,"統":-4229,"総":1163,"線":1255,"者":6457,"能":725,"自":-2869,"英":785,"見":1044,"調":-562,"財":-733,"費":1777,"車":1835,"軍":1375,"込":-1504,"通":-1136,"選":-681,"郎":1026,"郡":4404,"部":1200,"金":2163,"長":421,"開":-1432,"間":1302,"関":-1282,"雨":2009,"電":-1045,"非":2066,"駅":1620,"１":-800,"｣":2670,"･":-3794,"ｯ":-1350,"ｱ":551,"ｸﾞ":1319,"ｽ":874,"ﾄ":521,"ﾑ":1109,"ﾙ":1591,"ﾛ":2201,"ﾝ":278};
          this.UW4__ = {",":3930,".":3508,"―":-4841,"、":3930,"。":3508,"〇":4999,"「":1895,"」":3798,"〓":-5156,"あ":4752,"い":-3435,"う":-640,"え":-2514,"お":2405,"か":530,"が":6006,"き":-4482,"ぎ":-3821,"く":-3788,"け":-4376,"げ":-4734,"こ":2255,"ご":1979,"さ":2864,"し":-843,"じ":-2506,"す":-731,"ず":1251,"せ":181,"そ":4091,"た":5034,"だ":5408,"ち":-3654,"っ":-5882,"つ":-1659,"て":3994,"で":7410,"と":4547,"な":5433,"に":6499,"ぬ":1853,"ね":1413,"の":7396,"は":8578,"ば":1940,"ひ":4249,"び":-4134,"ふ":1345,"へ":6665,"べ":-744,"ほ":1464,"ま":1051,"み":-2082,"む":-882,"め":-5046,"も":4169,"ゃ":-2666,"や":2795,"ょ":-1544,"よ":3351,"ら":-2922,"り":-9726,"る":-14896,"れ":-2613,"ろ":-4570,"わ":-1783,"を":13150,"ん":-2352,"カ":2145,"コ":1789,"セ":1287,"ッ":-724,"ト":-403,"メ":-1635,"ラ":-881,"リ":-541,"ル":-856,"ン":-3637,"・":-4371,"ー":-11870,"一":-2069,"中":2210,"予":782,"事":-190,"井":-1768,"人":1036,"以":544,"会":950,"体":-1286,"作":530,"側":4292,"先":601,"党":-2006,"共":-1212,"内":584,"円":788,"初":1347,"前":1623,"副":3879,"力":-302,"動":-740,"務":-2715,"化":776,"区":4517,"協":1013,"参":1555,"合":-1834,"和":-681,"員":-910,"器":-851,"回":1500,"国":-619,"園":-1200,"地":866,"場":-1410,"塁":-2094,"士":-1413,"多":1067,"大":571,"子":-4802,"学":-1397,"定":-1057,"寺":-809,"小":1910,"屋":-1328,"山":-1500,"島":-2056,"川":-2667,"市":2771,"年":374,"庁":-4556,"後":456,"性":553,"感":916,"所":-1566,"支":856,"改":787,"政":2182,"教":704,"文":522,"方":-856,"日":1798,"時":1829,"最":845,"月":-9066,"木":-485,"来":-442,"校":-360,"業":-1043,"氏":5388,"民":-2716,"気":-910,"沢":-939,"済":-543,"物":-735,"率":672,"球":-1267,"生":-1286,"産":-1101,"田":-2900,"町":1826,"的":2586,"目":922,"省":-3485,"県":2997,"空":-867,"立":-2112,"第":788,"米":2937,"系":786,"約":2171,"経":1146,"統":-1169,"総":940,"線":-994,"署":749,"者":2145,"能":-730,"般":-852,"行":-792,"規":792,"警":-1184,"議":-244,"谷":-1000,"賞":730,"車":-1481,"軍":1158,"輪":-1433,"込":-3370,"近":929,"道":-1291,"選":2596,"郎":-4866,"都":1192,"野":-1100,"銀":-2213,"長":357,"間":-2344,"院":-2297,"際":-2604,"電":-878,"領":-1659,"題":-792,"館":-1984,"首":1749,"高":2120,"｢":1895,"｣":3798,"･":-4371,"ｯ":-724,"ｰ":-11870,"ｶ":2145,"ｺ":1789,"ｾ":1287,"ﾄ":-403,"ﾒ":-1635,"ﾗ":-881,"ﾘ":-541,"ﾙ":-856,"ﾝ":-3637};
          this.UW5__ = {",":465,".":-299,"1":-514,"E2":-32768,"]":-2762,"、":465,"。":-299,"「":363,"あ":1655,"い":331,"う":-503,"え":1199,"お":527,"か":647,"が":-421,"き":1624,"ぎ":1971,"く":312,"げ":-983,"さ":-1537,"し":-1371,"す":-852,"だ":-1186,"ち":1093,"っ":52,"つ":921,"て":-18,"で":-850,"と":-127,"ど":1682,"な":-787,"に":-1224,"の":-635,"は":-578,"べ":1001,"み":502,"め":865,"ゃ":3350,"ょ":854,"り":-208,"る":429,"れ":504,"わ":419,"を":-1264,"ん":327,"イ":241,"ル":451,"ン":-343,"中":-871,"京":722,"会":-1153,"党":-654,"務":3519,"区":-901,"告":848,"員":2104,"大":-1296,"学":-548,"定":1785,"嵐":-1304,"市":-2991,"席":921,"年":1763,"思":872,"所":-814,"挙":1618,"新":-1682,"日":218,"月":-4353,"査":932,"格":1356,"機":-1508,"氏":-1347,"田":240,"町":-3912,"的":-3149,"相":1319,"省":-1052,"県":-4003,"研":-997,"社":-278,"空":-813,"統":1955,"者":-2233,"表":663,"語":-1073,"議":1219,"選":-1018,"郎":-368,"長":786,"間":1191,"題":2368,"館":-689,"１":-514,"Ｅ２":-32768,"｢":363,"ｲ":241,"ﾙ":451,"ﾝ":-343};
          this.UW6__ = {",":227,".":808,"1":-270,"E1":306,"、":227,"。":808,"あ":-307,"う":189,"か":241,"が":-73,"く":-121,"こ":-200,"じ":1782,"す":383,"た":-428,"っ":573,"て":-1014,"で":101,"と":-105,"な":-253,"に":-149,"の":-417,"は":-236,"も":-206,"り":187,"る":-135,"を":195,"ル":-673,"ン":-496,"一":-277,"中":201,"件":-800,"会":624,"前":302,"区":1792,"員":-1212,"委":798,"学":-960,"市":887,"広":-695,"後":535,"業":-697,"相":753,"社":-507,"福":974,"空":-822,"者":1811,"連":463,"郎":1082,"１":-270,"Ｅ１":306,"ﾙ":-673,"ﾝ":-496};
          
          return this;
        }
        TinySegmenter.prototype.ctype_ = function(str) {
          for (var i in this.chartype_) {
            if (str.match(this.chartype_[i][0])) {
              return this.chartype_[i][1];
            }
          }
          return "O";
        }

        TinySegmenter.prototype.ts_ = function(v) {
          if (v) { return v; }
          return 0;
        }

        TinySegmenter.prototype.segment = function(input) {
          if (input == null || input == undefined || input == "") {
            return [];
          }
          var result = [];
          var seg = ["B3","B2","B1"];
          var ctype = ["O","O","O"];
          var o = input.split("");
          for (i = 0; i < o.length; ++i) {
            seg.push(o[i]);
            ctype.push(this.ctype_(o[i]))
          }
          seg.push("E1");
          seg.push("E2");
          seg.push("E3");
          ctype.push("O");
          ctype.push("O");
          ctype.push("O");
          var word = seg[3];
          var p1 = "U";
          var p2 = "U";
          var p3 = "U";
          for (var i = 4; i < seg.length - 3; ++i) {
            var score = this.BIAS__;
            var w1 = seg[i-3];
            var w2 = seg[i-2];
            var w3 = seg[i-1];
            var w4 = seg[i];
            var w5 = seg[i+1];
            var w6 = seg[i+2];
            var c1 = ctype[i-3];
            var c2 = ctype[i-2];
            var c3 = ctype[i-1];
            var c4 = ctype[i];
            var c5 = ctype[i+1];
            var c6 = ctype[i+2];
            score += this.ts_(this.UP1__[p1]);
            score += this.ts_(this.UP2__[p2]);
            score += this.ts_(this.UP3__[p3]);
            score += this.ts_(this.BP1__[p1 + p2]);
            score += this.ts_(this.BP2__[p2 + p3]);
            score += this.ts_(this.UW1__[w1]);
            score += this.ts_(this.UW2__[w2]);
            score += this.ts_(this.UW3__[w3]);
            score += this.ts_(this.UW4__[w4]);
            score += this.ts_(this.UW5__[w5]);
            score += this.ts_(this.UW6__[w6]);
            score += this.ts_(this.BW1__[w2 + w3]);
            score += this.ts_(this.BW2__[w3 + w4]);
            score += this.ts_(this.BW3__[w4 + w5]);
            score += this.ts_(this.TW1__[w1 + w2 + w3]);
            score += this.ts_(this.TW2__[w2 + w3 + w4]);
            score += this.ts_(this.TW3__[w3 + w4 + w5]);
            score += this.ts_(this.TW4__[w4 + w5 + w6]);
            score += this.ts_(this.UC1__[c1]);
            score += this.ts_(this.UC2__[c2]);
            score += this.ts_(this.UC3__[c3]);
            score += this.ts_(this.UC4__[c4]);
            score += this.ts_(this.UC5__[c5]);
            score += this.ts_(this.UC6__[c6]);
            score += this.ts_(this.BC1__[c2 + c3]);
            score += this.ts_(this.BC2__[c3 + c4]);
            score += this.ts_(this.BC3__[c4 + c5]);
            score += this.ts_(this.TC1__[c1 + c2 + c3]);
            score += this.ts_(this.TC2__[c2 + c3 + c4]);
            score += this.ts_(this.TC3__[c3 + c4 + c5]);
            score += this.ts_(this.TC4__[c4 + c5 + c6]);
        //  score += this.ts_(this.TC5__[c4 + c5 + c6]);    
            score += this.ts_(this.UQ1__[p1 + c1]);
            score += this.ts_(this.UQ2__[p2 + c2]);
            score += this.ts_(this.UQ3__[p3 + c3]);
            score += this.ts_(this.BQ1__[p2 + c2 + c3]);
            score += this.ts_(this.BQ2__[p2 + c3 + c4]);
            score += this.ts_(this.BQ3__[p3 + c2 + c3]);
            score += this.ts_(this.BQ4__[p3 + c3 + c4]);
            score += this.ts_(this.TQ1__[p2 + c1 + c2 + c3]);
            score += this.ts_(this.TQ2__[p2 + c2 + c3 + c4]);
            score += this.ts_(this.TQ3__[p3 + c1 + c2 + c3]);
            score += this.ts_(this.TQ4__[p3 + c2 + c3 + c4]);
            var p = "O";
            if (score > 0) {
              result.push(word);
              word = "";
              p = "B";
            }
            p1 = p2;
            p2 = p3;
            p3 = p;
            word += seg[i];
          }
          result.push(word);

          return result;
        }

        lunr.TinySegmenter = TinySegmenter;
    };

}));

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `German` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.de = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.de.trimmer,
        lunr.de.stopWordFilter,
        lunr.de.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.de.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.de.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.de.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.de.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.de.trimmer, 'trimmer-de');

    /* lunr stemmer function */
    lunr.de.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function GermanStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("U", 0, 2),
              new Among("Y", 0, 1), new Among("\u00E4", 0, 3),
              new Among("\u00F6", 0, 4), new Among("\u00FC", 0, 5)
            ],
            a_1 = [
              new Among("e", -1, 2), new Among("em", -1, 1),
              new Among("en", -1, 2), new Among("ern", -1, 1),
              new Among("er", -1, 1), new Among("s", -1, 3),
              new Among("es", 5, 2)
            ],
            a_2 = [new Among("en", -1, 1),
              new Among("er", -1, 1), new Among("st", -1, 2),
              new Among("est", 2, 1)
            ],
            a_3 = [new Among("ig", -1, 1),
              new Among("lich", -1, 1)
            ],
            a_4 = [new Among("end", -1, 1),
              new Among("ig", -1, 2), new Among("ung", -1, 1),
              new Among("lich", -1, 3), new Among("isch", -1, 2),
              new Among("ik", -1, 2), new Among("heit", -1, 3),
              new Among("keit", -1, 4)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 8, 0, 32, 8
            ],
            g_s_ending = [117, 30, 5],
            g_st_ending = [
              117, 30, 4
            ],
            I_x, I_p2, I_p1, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 252)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var v_1 = sbp.cursor,
              v_2, v_3, v_4, v_5;
            while (true) {
              v_2 = sbp.cursor;
              sbp.bra = v_2;
              if (sbp.eq_s(1, "\u00DF")) {
                sbp.ket = sbp.cursor;
                sbp.slice_from("ss");
              } else {
                if (v_2 >= sbp.limit)
                  break;
                sbp.cursor = v_2 + 1;
              }
            }
            sbp.cursor = v_1;
            while (true) {
              v_3 = sbp.cursor;
              while (true) {
                v_4 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 252)) {
                  v_5 = sbp.cursor;
                  sbp.bra = v_5;
                  if (habr1("u", "U", v_4))
                    break;
                  sbp.cursor = v_5;
                  if (habr1("y", "Y", v_4))
                    break;
                }
                if (v_4 >= sbp.limit) {
                  sbp.cursor = v_3;
                  return;
                }
                sbp.cursor = v_4 + 1;
              }
            }
          }

          function habr2() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            I_p1 = sbp.limit;
            I_p2 = I_p1;
            var c = sbp.cursor + 3;
            if (0 <= c && c <= sbp.limit) {
              I_x = c;
              if (!habr2()) {
                I_p1 = sbp.cursor;
                if (I_p1 < I_x)
                  I_p1 = I_x;
                if (!habr2())
                  I_p2 = sbp.cursor;
              }
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_0, 6);
              if (!among_var)
                return;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("y");
                  break;
                case 2:
                case 5:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("a");
                  break;
                case 4:
                  sbp.slice_from("o");
                  break;
                case 6:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_3, v_4;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_1, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "s")) {
                      sbp.bra = sbp.cursor;
                      if (sbp.eq_s_b(3, "nis"))
                        sbp.slice_del();
                    }
                    break;
                  case 3:
                    if (sbp.in_grouping_b(g_s_ending, 98, 116))
                      sbp.slice_del();
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_2, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R1()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    if (sbp.in_grouping_b(g_st_ending, 98, 116)) {
                      var c = sbp.cursor - 3;
                      if (sbp.limit_backward <= c && c <= sbp.limit) {
                        sbp.cursor = c;
                        sbp.slice_del();
                      }
                    }
                    break;
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (r_R2()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ig")) {
                      sbp.bra = sbp.cursor;
                      v_2 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "e")) {
                        sbp.cursor = sbp.limit - v_2;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                    break;
                  case 2:
                    v_3 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(1, "e")) {
                      sbp.cursor = sbp.limit - v_3;
                      sbp.slice_del();
                    }
                    break;
                  case 3:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_4 = sbp.limit - sbp.cursor;
                    if (!sbp.eq_s_b(2, "er")) {
                      sbp.cursor = sbp.limit - v_4;
                      if (!sbp.eq_s_b(2, "en"))
                        break;
                    }
                    sbp.bra = sbp.cursor;
                    if (r_R1())
                      sbp.slice_del();
                    break;
                  case 4:
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    among_var = sbp.find_among_b(a_3, 2);
                    if (among_var) {
                      sbp.bra = sbp.cursor;
                      if (r_R2() && among_var == 1)
                        sbp.slice_del();
                    }
                    break;
                }
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_standard_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.de.stemmer, 'stemmer-de');

    lunr.de.stopWordFilter = lunr.generateStopWordFilter('aber alle allem allen aller alles als also am an ander andere anderem anderen anderer anderes anderm andern anderr anders auch auf aus bei bin bis bist da damit dann das dasselbe dazu daß dein deine deinem deinen deiner deines dem demselben den denn denselben der derer derselbe derselben des desselben dessen dich die dies diese dieselbe dieselben diesem diesen dieser dieses dir doch dort du durch ein eine einem einen einer eines einig einige einigem einigen einiger einiges einmal er es etwas euch euer eure eurem euren eurer eures für gegen gewesen hab habe haben hat hatte hatten hier hin hinter ich ihm ihn ihnen ihr ihre ihrem ihren ihrer ihres im in indem ins ist jede jedem jeden jeder jedes jene jenem jenen jener jenes jetzt kann kein keine keinem keinen keiner keines können könnte machen man manche manchem manchen mancher manches mein meine meinem meinen meiner meines mich mir mit muss musste nach nicht nichts noch nun nur ob oder ohne sehr sein seine seinem seinen seiner seines selbst sich sie sind so solche solchem solchen solcher solches soll sollte sondern sonst um und uns unse unsem unsen unser unses unter viel vom von vor war waren warst was weg weil weiter welche welchem welchen welcher welches wenn werde werden wie wieder will wir wird wirst wo wollen wollte während würde würden zu zum zur zwar zwischen über'.split(' '));

    lunr.Pipeline.registerFunction(lunr.de.stopWordFilter, 'stopWordFilter-de');
  };
}))

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Spanish` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.es = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.es.trimmer,
        lunr.es.stopWordFilter,
        lunr.es.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.es.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.es.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.es.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.es.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.es.trimmer, 'trimmer-es');

    /* lunr stemmer function */
    lunr.es.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function SpanishStemmer() {
          var a_0 = [new Among("", -1, 6), new Among("\u00E1", 0, 1),
              new Among("\u00E9", 0, 2), new Among("\u00ED", 0, 3),
              new Among("\u00F3", 0, 4), new Among("\u00FA", 0, 5)
            ],
            a_1 = [
              new Among("la", -1, -1), new Among("sela", 0, -1),
              new Among("le", -1, -1), new Among("me", -1, -1),
              new Among("se", -1, -1), new Among("lo", -1, -1),
              new Among("selo", 5, -1), new Among("las", -1, -1),
              new Among("selas", 7, -1), new Among("les", -1, -1),
              new Among("los", -1, -1), new Among("selos", 10, -1),
              new Among("nos", -1, -1)
            ],
            a_2 = [new Among("ando", -1, 6),
              new Among("iendo", -1, 6), new Among("yendo", -1, 7),
              new Among("\u00E1ndo", -1, 2), new Among("i\u00E9ndo", -1, 1),
              new Among("ar", -1, 6), new Among("er", -1, 6),
              new Among("ir", -1, 6), new Among("\u00E1r", -1, 3),
              new Among("\u00E9r", -1, 4), new Among("\u00EDr", -1, 5)
            ],
            a_3 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_4 = [
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 1)
            ],
            a_5 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_6 = [
              new Among("ica", -1, 1), new Among("ancia", -1, 2),
              new Among("encia", -1, 5), new Among("adora", -1, 2),
              new Among("osa", -1, 1), new Among("ista", -1, 1),
              new Among("iva", -1, 9), new Among("anza", -1, 1),
              new Among("log\u00EDa", -1, 3), new Among("idad", -1, 8),
              new Among("able", -1, 1), new Among("ible", -1, 1),
              new Among("ante", -1, 2), new Among("mente", -1, 7),
              new Among("amente", 13, 6), new Among("aci\u00F3n", -1, 2),
              new Among("uci\u00F3n", -1, 4), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amiento", -1, 1), new Among("imiento", -1, 1),
              new Among("ivo", -1, 9), new Among("ador", -1, 2),
              new Among("icas", -1, 1), new Among("ancias", -1, 2),
              new Among("encias", -1, 5), new Among("adoras", -1, 2),
              new Among("osas", -1, 1), new Among("istas", -1, 1),
              new Among("ivas", -1, 9), new Among("anzas", -1, 1),
              new Among("log\u00EDas", -1, 3), new Among("idades", -1, 8),
              new Among("ables", -1, 1), new Among("ibles", -1, 1),
              new Among("aciones", -1, 2), new Among("uciones", -1, 4),
              new Among("adores", -1, 2), new Among("antes", -1, 2),
              new Among("icos", -1, 1), new Among("ismos", -1, 1),
              new Among("osos", -1, 1), new Among("amientos", -1, 1),
              new Among("imientos", -1, 1), new Among("ivos", -1, 9)
            ],
            a_7 = [
              new Among("ya", -1, 1), new Among("ye", -1, 1),
              new Among("yan", -1, 1), new Among("yen", -1, 1),
              new Among("yeron", -1, 1), new Among("yendo", -1, 1),
              new Among("yo", -1, 1), new Among("yas", -1, 1),
              new Among("yes", -1, 1), new Among("yais", -1, 1),
              new Among("yamos", -1, 1), new Among("y\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("aba", -1, 2), new Among("ada", -1, 2),
              new Among("ida", -1, 2), new Among("ara", -1, 2),
              new Among("iera", -1, 2), new Among("\u00EDa", -1, 2),
              new Among("ar\u00EDa", 5, 2), new Among("er\u00EDa", 5, 2),
              new Among("ir\u00EDa", 5, 2), new Among("ad", -1, 2),
              new Among("ed", -1, 2), new Among("id", -1, 2),
              new Among("ase", -1, 2), new Among("iese", -1, 2),
              new Among("aste", -1, 2), new Among("iste", -1, 2),
              new Among("an", -1, 2), new Among("aban", 16, 2),
              new Among("aran", 16, 2), new Among("ieran", 16, 2),
              new Among("\u00EDan", 16, 2), new Among("ar\u00EDan", 20, 2),
              new Among("er\u00EDan", 20, 2), new Among("ir\u00EDan", 20, 2),
              new Among("en", -1, 1), new Among("asen", 24, 2),
              new Among("iesen", 24, 2), new Among("aron", -1, 2),
              new Among("ieron", -1, 2), new Among("ar\u00E1n", -1, 2),
              new Among("er\u00E1n", -1, 2), new Among("ir\u00E1n", -1, 2),
              new Among("ado", -1, 2), new Among("ido", -1, 2),
              new Among("ando", -1, 2), new Among("iendo", -1, 2),
              new Among("ar", -1, 2), new Among("er", -1, 2),
              new Among("ir", -1, 2), new Among("as", -1, 2),
              new Among("abas", 39, 2), new Among("adas", 39, 2),
              new Among("idas", 39, 2), new Among("aras", 39, 2),
              new Among("ieras", 39, 2), new Among("\u00EDas", 39, 2),
              new Among("ar\u00EDas", 45, 2), new Among("er\u00EDas", 45, 2),
              new Among("ir\u00EDas", 45, 2), new Among("es", -1, 1),
              new Among("ases", 49, 2), new Among("ieses", 49, 2),
              new Among("abais", -1, 2), new Among("arais", -1, 2),
              new Among("ierais", -1, 2), new Among("\u00EDais", -1, 2),
              new Among("ar\u00EDais", 55, 2), new Among("er\u00EDais", 55, 2),
              new Among("ir\u00EDais", 55, 2), new Among("aseis", -1, 2),
              new Among("ieseis", -1, 2), new Among("asteis", -1, 2),
              new Among("isteis", -1, 2), new Among("\u00E1is", -1, 2),
              new Among("\u00E9is", -1, 1), new Among("ar\u00E9is", 64, 2),
              new Among("er\u00E9is", 64, 2), new Among("ir\u00E9is", 64, 2),
              new Among("ados", -1, 2), new Among("idos", -1, 2),
              new Among("amos", -1, 2), new Among("\u00E1bamos", 70, 2),
              new Among("\u00E1ramos", 70, 2), new Among("i\u00E9ramos", 70, 2),
              new Among("\u00EDamos", 70, 2), new Among("ar\u00EDamos", 74, 2),
              new Among("er\u00EDamos", 74, 2), new Among("ir\u00EDamos", 74, 2),
              new Among("emos", -1, 1), new Among("aremos", 78, 2),
              new Among("eremos", 78, 2), new Among("iremos", 78, 2),
              new Among("\u00E1semos", 78, 2), new Among("i\u00E9semos", 78, 2),
              new Among("imos", -1, 2), new Among("ar\u00E1s", -1, 2),
              new Among("er\u00E1s", -1, 2), new Among("ir\u00E1s", -1, 2),
              new Among("\u00EDs", -1, 2), new Among("ar\u00E1", -1, 2),
              new Among("er\u00E1", -1, 2), new Among("ir\u00E1", -1, 2),
              new Among("ar\u00E9", -1, 2), new Among("er\u00E9", -1, 2),
              new Among("ir\u00E9", -1, 2), new Among("i\u00F3", -1, 2)
            ],
            a_9 = [
              new Among("a", -1, 1), new Among("e", -1, 2),
              new Among("o", -1, 1), new Among("os", -1, 1),
              new Among("\u00E1", -1, 1), new Among("\u00E9", -1, 2),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 17, 4, 10
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1() {
            if (sbp.out_grouping(g_v, 97, 252)) {
              while (!sbp.in_grouping(g_v, 97, 252)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr2() {
            if (sbp.in_grouping(g_v, 97, 252)) {
              var v_1 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_1;
                if (!sbp.in_grouping(g_v, 97, 252))
                  return true;
                while (!sbp.out_grouping(g_v, 97, 252)) {
                  if (sbp.cursor >= sbp.limit)
                    return true;
                  sbp.cursor++;
                }
              }
              return false;
            }
            return true;
          }

          function habr3() {
            var v_1 = sbp.cursor,
              v_2;
            if (habr2()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 252))
                return;
              v_2 = sbp.cursor;
              if (habr1()) {
                sbp.cursor = v_2;
                if (!sbp.in_grouping(g_v, 97, 252) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
          }

          function habr4() {
            while (!sbp.in_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 252)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr3();
            sbp.cursor = v_1;
            if (habr4()) {
              I_p1 = sbp.cursor;
              if (habr4())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 6);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a");
                    continue;
                  case 2:
                    sbp.slice_from("e");
                    continue;
                  case 3:
                    sbp.slice_from("i");
                    continue;
                  case 4:
                    sbp.slice_from("o");
                    continue;
                  case 5:
                    sbp.slice_from("u");
                    continue;
                  case 6:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_1, 13)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_2, 11);
              if (among_var && r_RV())
                switch (among_var) {
                  case 1:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("iendo");
                    break;
                  case 2:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ando");
                    break;
                  case 3:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ar");
                    break;
                  case 4:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("er");
                    break;
                  case 5:
                    sbp.bra = sbp.cursor;
                    sbp.slice_from("ir");
                    break;
                  case 6:
                    sbp.slice_del();
                    break;
                  case 7:
                    if (sbp.eq_s_b(1, "u"))
                      sbp.slice_del();
                    break;
                }
            }
          }

          function habr5(a, n) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            var among_var = sbp.find_among_b(a, n);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1 && r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function habr6(c1) {
            if (!r_R2())
              return true;
            sbp.slice_del();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(2, c1)) {
              sbp.bra = sbp.cursor;
              if (r_R2())
                sbp.slice_del();
            }
            return false;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 46);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (habr6("ic"))
                    return false;
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ente");
                  break;
                case 6:
                  if (!r_R1())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 4);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      if (among_var == 1) {
                        sbp.ket = sbp.cursor;
                        if (sbp.eq_s_b(2, "at")) {
                          sbp.bra = sbp.cursor;
                          if (r_R2())
                            sbp.slice_del();
                        }
                      }
                    }
                  }
                  break;
                case 7:
                  if (habr5(a_4, 3))
                    return false;
                  break;
                case 8:
                  if (habr5(a_5, 3))
                    return false;
                  break;
                case 9:
                  if (habr6("at"))
                    return false;
                  break;
              }
              return true;
            }
            return false;
          }

          function r_y_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 12);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1) {
                  if (!sbp.eq_s_b(1, "u"))
                    return false;
                  sbp.slice_del();
                }
                return true;
              }
            }
            return false;
          }

          function r_verb_suffix() {
            var among_var, v_1, v_2, v_3;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_8, 96);
              sbp.limit_backward = v_1;
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    v_2 = sbp.limit - sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      v_3 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g"))
                        sbp.cursor = sbp.limit - v_3;
                      else
                        sbp.cursor = sbp.limit - v_2;
                    } else
                      sbp.cursor = sbp.limit - v_2;
                    sbp.bra = sbp.cursor;
                  case 2:
                    sbp.slice_del();
                    break;
                }
              }
            }
          }

          function r_residual_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_9, 8);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV())
                    sbp.slice_del();
                  break;
                case 2:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(1, "u")) {
                      sbp.bra = sbp.cursor;
                      v_1 = sbp.limit - sbp.cursor;
                      if (sbp.eq_s_b(1, "g")) {
                        sbp.cursor = sbp.limit - v_1;
                        if (r_RV())
                          sbp.slice_del();
                      }
                    }
                  }
                  break;
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_y_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_verb_suffix();
              }
            }
            sbp.cursor = sbp.limit;
            r_residual_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.es.stemmer, 'stemmer-es');

    lunr.es.stopWordFilter = lunr.generateStopWordFilter('a al algo algunas algunos ante antes como con contra cual cuando de del desde donde durante e el ella ellas ellos en entre era erais eran eras eres es esa esas ese eso esos esta estaba estabais estaban estabas estad estada estadas estado estados estamos estando estar estaremos estará estarán estarás estaré estaréis estaría estaríais estaríamos estarían estarías estas este estemos esto estos estoy estuve estuviera estuvierais estuvieran estuvieras estuvieron estuviese estuvieseis estuviesen estuvieses estuvimos estuviste estuvisteis estuviéramos estuviésemos estuvo está estábamos estáis están estás esté estéis estén estés fue fuera fuerais fueran fueras fueron fuese fueseis fuesen fueses fui fuimos fuiste fuisteis fuéramos fuésemos ha habida habidas habido habidos habiendo habremos habrá habrán habrás habré habréis habría habríais habríamos habrían habrías habéis había habíais habíamos habían habías han has hasta hay haya hayamos hayan hayas hayáis he hemos hube hubiera hubierais hubieran hubieras hubieron hubiese hubieseis hubiesen hubieses hubimos hubiste hubisteis hubiéramos hubiésemos hubo la las le les lo los me mi mis mucho muchos muy más mí mía mías mío míos nada ni no nos nosotras nosotros nuestra nuestras nuestro nuestros o os otra otras otro otros para pero poco por porque que quien quienes qué se sea seamos sean seas seremos será serán serás seré seréis sería seríais seríamos serían serías seáis sido siendo sin sobre sois somos son soy su sus suya suyas suyo suyos sí también tanto te tendremos tendrá tendrán tendrás tendré tendréis tendría tendríais tendríamos tendrían tendrías tened tenemos tenga tengamos tengan tengas tengo tengáis tenida tenidas tenido tenidos teniendo tenéis tenía teníais teníamos tenían tenías ti tiene tienen tienes todo todos tu tus tuve tuviera tuvierais tuvieran tuvieras tuvieron tuviese tuvieseis tuviesen tuvieses tuvimos tuviste tuvisteis tuviéramos tuviésemos tuvo tuya tuyas tuyo tuyos tú un una uno unos vosotras vosotros vuestra vuestras vuestro vuestros y ya yo él éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.es.stopWordFilter, 'stopWordFilter-es');
  };
}))

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `French` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.fr = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.fr.trimmer,
        lunr.fr.stopWordFilter,
        lunr.fr.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.fr.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.fr.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.fr.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.fr.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.fr.trimmer, 'trimmer-fr');

    /* lunr stemmer function */
    lunr.fr.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function FrenchStemmer() {
          var a_0 = [new Among("col", -1, -1), new Among("par", -1, -1),
              new Among("tap", -1, -1)
            ],
            a_1 = [new Among("", -1, 4),
              new Among("I", 0, 1), new Among("U", 0, 2), new Among("Y", 0, 3)
            ],
            a_2 = [
              new Among("iqU", -1, 3), new Among("abl", -1, 3),
              new Among("I\u00E8r", -1, 4), new Among("i\u00E8r", -1, 4),
              new Among("eus", -1, 2), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ic", -1, 2), new Among("abil", -1, 1),
              new Among("iv", -1, 3)
            ],
            a_4 = [new Among("iqUe", -1, 1),
              new Among("atrice", -1, 2), new Among("ance", -1, 1),
              new Among("ence", -1, 5), new Among("logie", -1, 3),
              new Among("able", -1, 1), new Among("isme", -1, 1),
              new Among("euse", -1, 11), new Among("iste", -1, 1),
              new Among("ive", -1, 8), new Among("if", -1, 8),
              new Among("usion", -1, 4), new Among("ation", -1, 2),
              new Among("ution", -1, 4), new Among("ateur", -1, 2),
              new Among("iqUes", -1, 1), new Among("atrices", -1, 2),
              new Among("ances", -1, 1), new Among("ences", -1, 5),
              new Among("logies", -1, 3), new Among("ables", -1, 1),
              new Among("ismes", -1, 1), new Among("euses", -1, 11),
              new Among("istes", -1, 1), new Among("ives", -1, 8),
              new Among("ifs", -1, 8), new Among("usions", -1, 4),
              new Among("ations", -1, 2), new Among("utions", -1, 4),
              new Among("ateurs", -1, 2), new Among("ments", -1, 15),
              new Among("ements", 30, 6), new Among("issements", 31, 12),
              new Among("it\u00E9s", -1, 7), new Among("ment", -1, 15),
              new Among("ement", 34, 6), new Among("issement", 35, 12),
              new Among("amment", 34, 13), new Among("emment", 34, 14),
              new Among("aux", -1, 10), new Among("eaux", 39, 9),
              new Among("eux", -1, 1), new Among("it\u00E9", -1, 7)
            ],
            a_5 = [
              new Among("ira", -1, 1), new Among("ie", -1, 1),
              new Among("isse", -1, 1), new Among("issante", -1, 1),
              new Among("i", -1, 1), new Among("irai", 4, 1),
              new Among("ir", -1, 1), new Among("iras", -1, 1),
              new Among("ies", -1, 1), new Among("\u00EEmes", -1, 1),
              new Among("isses", -1, 1), new Among("issantes", -1, 1),
              new Among("\u00EEtes", -1, 1), new Among("is", -1, 1),
              new Among("irais", 13, 1), new Among("issais", 13, 1),
              new Among("irions", -1, 1), new Among("issions", -1, 1),
              new Among("irons", -1, 1), new Among("issons", -1, 1),
              new Among("issants", -1, 1), new Among("it", -1, 1),
              new Among("irait", 21, 1), new Among("issait", 21, 1),
              new Among("issant", -1, 1), new Among("iraIent", -1, 1),
              new Among("issaIent", -1, 1), new Among("irent", -1, 1),
              new Among("issent", -1, 1), new Among("iront", -1, 1),
              new Among("\u00EEt", -1, 1), new Among("iriez", -1, 1),
              new Among("issiez", -1, 1), new Among("irez", -1, 1),
              new Among("issez", -1, 1)
            ],
            a_6 = [new Among("a", -1, 3),
              new Among("era", 0, 2), new Among("asse", -1, 3),
              new Among("ante", -1, 3), new Among("\u00E9e", -1, 2),
              new Among("ai", -1, 3), new Among("erai", 5, 2),
              new Among("er", -1, 2), new Among("as", -1, 3),
              new Among("eras", 8, 2), new Among("\u00E2mes", -1, 3),
              new Among("asses", -1, 3), new Among("antes", -1, 3),
              new Among("\u00E2tes", -1, 3), new Among("\u00E9es", -1, 2),
              new Among("ais", -1, 3), new Among("erais", 15, 2),
              new Among("ions", -1, 1), new Among("erions", 17, 2),
              new Among("assions", 17, 3), new Among("erons", -1, 2),
              new Among("ants", -1, 3), new Among("\u00E9s", -1, 2),
              new Among("ait", -1, 3), new Among("erait", 23, 2),
              new Among("ant", -1, 3), new Among("aIent", -1, 3),
              new Among("eraIent", 26, 2), new Among("\u00E8rent", -1, 2),
              new Among("assent", -1, 3), new Among("eront", -1, 2),
              new Among("\u00E2t", -1, 3), new Among("ez", -1, 2),
              new Among("iez", 32, 2), new Among("eriez", 33, 2),
              new Among("assiez", 33, 3), new Among("erez", 32, 2),
              new Among("\u00E9", -1, 2)
            ],
            a_7 = [new Among("e", -1, 3),
              new Among("I\u00E8re", 0, 2), new Among("i\u00E8re", 0, 2),
              new Among("ion", -1, 1), new Among("Ier", -1, 2),
              new Among("ier", -1, 2), new Among("\u00EB", -1, 4)
            ],
            a_8 = [
              new Among("ell", -1, -1), new Among("eill", -1, -1),
              new Among("enn", -1, -1), new Among("onn", -1, -1),
              new Among("ett", -1, -1)
            ],
            g_v = [17, 65, 16, 1, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 128, 130, 103, 8, 5
            ],
            g_keep_with_s = [1, 65, 20, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 128
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function habr2(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              sbp.slice_from(c2);
              sbp.cursor = v_1;
              return true;
            }
            return false;
          }

          function r_prelude() {
            var v_1, v_2;
            while (true) {
              v_1 = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 251)) {
                sbp.bra = sbp.cursor;
                v_2 = sbp.cursor;
                if (habr1("u", "U", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr1("i", "I", v_1))
                  continue;
                sbp.cursor = v_2;
                if (habr2("y", "Y", v_1))
                  continue;
              }
              sbp.cursor = v_1;
              sbp.bra = v_1;
              if (!habr1("y", "Y", v_1)) {
                sbp.cursor = v_1;
                if (sbp.eq_s(1, "q")) {
                  sbp.bra = sbp.cursor;
                  if (habr2("u", "U", v_1))
                    continue;
                }
                sbp.cursor = v_1;
                if (v_1 >= sbp.limit)
                  return;
                sbp.cursor++;
              }
            }
          }

          function habr3() {
            while (!sbp.in_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 251)) {
              if (sbp.cursor >= sbp.limit)
                return true;
              sbp.cursor++;
            }
            return false;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            if (sbp.in_grouping(g_v, 97, 251) && sbp.in_grouping(g_v, 97, 251) &&
              sbp.cursor < sbp.limit)
              sbp.cursor++;
            else {
              sbp.cursor = v_1;
              if (!sbp.find_among(a_0, 3)) {
                sbp.cursor = v_1;
                do {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = I_pV;
                    break;
                  }
                  sbp.cursor++;
                } while (!sbp.in_grouping(g_v, 97, 251));
              }
            }
            I_pV = sbp.cursor;
            sbp.cursor = v_1;
            if (!habr3()) {
              I_p1 = sbp.cursor;
              if (!habr3())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var, v_1;
            while (true) {
              v_1 = sbp.cursor;
              sbp.bra = v_1;
              among_var = sbp.find_among(a_1, 4);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  sbp.slice_from("y");
                  break;
                case 4:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var, v_1;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_4, 43);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  break;
                case 2:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "ic")) {
                    sbp.bra = sbp.cursor;
                    if (!r_R2())
                      sbp.slice_from("iqU");
                    else
                      sbp.slice_del();
                  }
                  break;
                case 3:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("log");
                  break;
                case 4:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("u");
                  break;
                case 5:
                  if (!r_R2())
                    return false;
                  sbp.slice_from("ent");
                  break;
                case 6:
                  if (!r_RV())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_2, 6);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2()) {
                          sbp.slice_del();
                          sbp.ket = sbp.cursor;
                          if (sbp.eq_s_b(2, "at")) {
                            sbp.bra = sbp.cursor;
                            if (r_R2())
                              sbp.slice_del();
                          }
                        }
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else if (r_R1())
                          sbp.slice_from("eux");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                      case 4:
                        if (r_RV())
                          sbp.slice_from("i");
                        break;
                    }
                  }
                  break;
                case 7:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  among_var = sbp.find_among_b(a_3, 3);
                  if (among_var) {
                    sbp.bra = sbp.cursor;
                    switch (among_var) {
                      case 1:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("abl");
                        break;
                      case 2:
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      case 3:
                        if (r_R2())
                          sbp.slice_del();
                        break;
                    }
                  }
                  break;
                case 8:
                  if (!r_R2())
                    return false;
                  sbp.slice_del();
                  sbp.ket = sbp.cursor;
                  if (sbp.eq_s_b(2, "at")) {
                    sbp.bra = sbp.cursor;
                    if (r_R2()) {
                      sbp.slice_del();
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "ic")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                        else
                          sbp.slice_from("iqU");
                        break;
                      }
                    }
                  }
                  break;
                case 9:
                  sbp.slice_from("eau");
                  break;
                case 10:
                  if (!r_R1())
                    return false;
                  sbp.slice_from("al");
                  break;
                case 11:
                  if (r_R2())
                    sbp.slice_del();
                  else if (!r_R1())
                    return false;
                  else
                    sbp.slice_from("eux");
                  break;
                case 12:
                  if (!r_R1() || !sbp.out_grouping_b(g_v, 97, 251))
                    return false;
                  sbp.slice_del();
                  break;
                case 13:
                  if (r_RV())
                    sbp.slice_from("ant");
                  return false;
                case 14:
                  if (r_RV())
                    sbp.slice_from("ent");
                  return false;
                case 15:
                  v_1 = sbp.limit - sbp.cursor;
                  if (sbp.in_grouping_b(g_v, 97, 251) && r_RV()) {
                    sbp.cursor = sbp.limit - v_1;
                    sbp.slice_del();
                  }
                  return false;
              }
              return true;
            }
            return false;
          }

          function r_i_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor < I_pV)
              return false;
            v_1 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 35);
            if (!among_var) {
              sbp.limit_backward = v_1;
              return false;
            }
            sbp.bra = sbp.cursor;
            if (among_var == 1) {
              if (!sbp.out_grouping_b(g_v, 97, 251)) {
                sbp.limit_backward = v_1;
                return false;
              }
              sbp.slice_del();
            }
            sbp.limit_backward = v_1;
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_2, v_3;
            if (sbp.cursor < I_pV)
              return false;
            v_2 = sbp.limit_backward;
            sbp.limit_backward = I_pV;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 38);
            if (!among_var) {
              sbp.limit_backward = v_2;
              return false;
            }
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2()) {
                  sbp.limit_backward = v_2;
                  return false;
                }
                sbp.slice_del();
                break;
              case 2:
                sbp.slice_del();
                break;
              case 3:
                sbp.slice_del();
                v_3 = sbp.limit - sbp.cursor;
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "e")) {
                  sbp.bra = sbp.cursor;
                  sbp.slice_del();
                } else
                  sbp.cursor = sbp.limit - v_3;
                break;
            }
            sbp.limit_backward = v_2;
            return true;
          }

          function r_residual_suffix() {
            var among_var, v_1 = sbp.limit - sbp.cursor,
              v_2, v_4, v_5;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "s")) {
              sbp.bra = sbp.cursor;
              v_2 = sbp.limit - sbp.cursor;
              if (sbp.out_grouping_b(g_keep_with_s, 97, 232)) {
                sbp.cursor = sbp.limit - v_2;
                sbp.slice_del();
              } else
                sbp.cursor = sbp.limit - v_1;
            } else
              sbp.cursor = sbp.limit - v_1;
            if (sbp.cursor >= I_pV) {
              v_4 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 7);
              if (among_var) {
                sbp.bra = sbp.cursor;
                switch (among_var) {
                  case 1:
                    if (r_R2()) {
                      v_5 = sbp.limit - sbp.cursor;
                      if (!sbp.eq_s_b(1, "s")) {
                        sbp.cursor = sbp.limit - v_5;
                        if (!sbp.eq_s_b(1, "t"))
                          break;
                      }
                      sbp.slice_del();
                    }
                    break;
                  case 2:
                    sbp.slice_from("i");
                    break;
                  case 3:
                    sbp.slice_del();
                    break;
                  case 4:
                    if (sbp.eq_s_b(2, "gu"))
                      sbp.slice_del();
                    break;
                }
              }
              sbp.limit_backward = v_4;
            }
          }

          function r_un_double() {
            var v_1 = sbp.limit - sbp.cursor;
            if (sbp.find_among_b(a_8, 5)) {
              sbp.cursor = sbp.limit - v_1;
              sbp.ket = sbp.cursor;
              if (sbp.cursor > sbp.limit_backward) {
                sbp.cursor--;
                sbp.bra = sbp.cursor;
                sbp.slice_del();
              }
            }
          }

          function r_un_accent() {
            var v_1, v_2 = 1;
            while (sbp.out_grouping_b(g_v, 97, 251))
              v_2--;
            if (v_2 <= 0) {
              sbp.ket = sbp.cursor;
              v_1 = sbp.limit - sbp.cursor;
              if (!sbp.eq_s_b(1, "\u00E9")) {
                sbp.cursor = sbp.limit - v_1;
                if (!sbp.eq_s_b(1, "\u00E8"))
                  return;
              }
              sbp.bra = sbp.cursor;
              sbp.slice_from("e");
            }
          }

          function habr5() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_i_verb_suffix()) {
                sbp.cursor = sbp.limit;
                if (!r_verb_suffix()) {
                  sbp.cursor = sbp.limit;
                  r_residual_suffix();
                  return;
                }
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "Y")) {
              sbp.bra = sbp.cursor;
              sbp.slice_from("i");
            } else {
              sbp.cursor = sbp.limit;
              if (sbp.eq_s_b(1, "\u00E7")) {
                sbp.bra = sbp.cursor;
                sbp.slice_from("c");
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr5();
            sbp.cursor = sbp.limit;
            r_un_double();
            sbp.cursor = sbp.limit;
            r_un_accent();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.fr.stemmer, 'stemmer-fr');

    lunr.fr.stopWordFilter = lunr.generateStopWordFilter('ai aie aient aies ait as au aura aurai auraient aurais aurait auras aurez auriez aurions aurons auront aux avaient avais avait avec avez aviez avions avons ayant ayez ayons c ce ceci celà ces cet cette d dans de des du elle en es est et eu eue eues eurent eus eusse eussent eusses eussiez eussions eut eux eûmes eût eûtes furent fus fusse fussent fusses fussiez fussions fut fûmes fût fûtes ici il ils j je l la le les leur leurs lui m ma mais me mes moi mon même n ne nos notre nous on ont ou par pas pour qu que quel quelle quelles quels qui s sa sans se sera serai seraient serais serait seras serez seriez serions serons seront ses soi soient sois soit sommes son sont soyez soyons suis sur t ta te tes toi ton tu un une vos votre vous y à étaient étais était étant étiez étions été étée étées étés êtes'.split(' '));

    lunr.Pipeline.registerFunction(lunr.fr.stopWordFilter, 'stopWordFilter-fr');
  };
}))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Italian` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.it = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.it.trimmer,
        lunr.it.stopWordFilter,
        lunr.it.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.it.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.it.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.it.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.it.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.it.trimmer, 'trimmer-it');

    /* lunr stemmer function */
    lunr.it.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function ItalianStemmer() {
          var a_0 = [new Among("", -1, 7), new Among("qu", 0, 6),
              new Among("\u00E1", 0, 1), new Among("\u00E9", 0, 2),
              new Among("\u00ED", 0, 3), new Among("\u00F3", 0, 4),
              new Among("\u00FA", 0, 5)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("I", 0, 1), new Among("U", 0, 2)
            ],
            a_2 = [
              new Among("la", -1, -1), new Among("cela", 0, -1),
              new Among("gliela", 0, -1), new Among("mela", 0, -1),
              new Among("tela", 0, -1), new Among("vela", 0, -1),
              new Among("le", -1, -1), new Among("cele", 6, -1),
              new Among("gliele", 6, -1), new Among("mele", 6, -1),
              new Among("tele", 6, -1), new Among("vele", 6, -1),
              new Among("ne", -1, -1), new Among("cene", 12, -1),
              new Among("gliene", 12, -1), new Among("mene", 12, -1),
              new Among("sene", 12, -1), new Among("tene", 12, -1),
              new Among("vene", 12, -1), new Among("ci", -1, -1),
              new Among("li", -1, -1), new Among("celi", 20, -1),
              new Among("glieli", 20, -1), new Among("meli", 20, -1),
              new Among("teli", 20, -1), new Among("veli", 20, -1),
              new Among("gli", 20, -1), new Among("mi", -1, -1),
              new Among("si", -1, -1), new Among("ti", -1, -1),
              new Among("vi", -1, -1), new Among("lo", -1, -1),
              new Among("celo", 31, -1), new Among("glielo", 31, -1),
              new Among("melo", 31, -1), new Among("telo", 31, -1),
              new Among("velo", 31, -1)
            ],
            a_3 = [new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("ar", -1, 2),
              new Among("er", -1, 2), new Among("ir", -1, 2)
            ],
            a_4 = [
              new Among("ic", -1, -1), new Among("abil", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ic", -1, 1), new Among("abil", -1, 1),
              new Among("iv", -1, 1)
            ],
            a_6 = [new Among("ica", -1, 1),
              new Among("logia", -1, 3), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 9),
              new Among("anza", -1, 1), new Among("enza", -1, 5),
              new Among("ice", -1, 1), new Among("atrice", 7, 1),
              new Among("iche", -1, 1), new Among("logie", -1, 3),
              new Among("abile", -1, 1), new Among("ibile", -1, 1),
              new Among("usione", -1, 4), new Among("azione", -1, 2),
              new Among("uzione", -1, 4), new Among("atore", -1, 2),
              new Among("ose", -1, 1), new Among("ante", -1, 1),
              new Among("mente", -1, 1), new Among("amente", 19, 7),
              new Among("iste", -1, 1), new Among("ive", -1, 9),
              new Among("anze", -1, 1), new Among("enze", -1, 5),
              new Among("ici", -1, 1), new Among("atrici", 25, 1),
              new Among("ichi", -1, 1), new Among("abili", -1, 1),
              new Among("ibili", -1, 1), new Among("ismi", -1, 1),
              new Among("usioni", -1, 4), new Among("azioni", -1, 2),
              new Among("uzioni", -1, 4), new Among("atori", -1, 2),
              new Among("osi", -1, 1), new Among("anti", -1, 1),
              new Among("amenti", -1, 6), new Among("imenti", -1, 6),
              new Among("isti", -1, 1), new Among("ivi", -1, 9),
              new Among("ico", -1, 1), new Among("ismo", -1, 1),
              new Among("oso", -1, 1), new Among("amento", -1, 6),
              new Among("imento", -1, 6), new Among("ivo", -1, 9),
              new Among("it\u00E0", -1, 8), new Among("ist\u00E0", -1, 1),
              new Among("ist\u00E8", -1, 1), new Among("ist\u00EC", -1, 1)
            ],
            a_7 = [
              new Among("isca", -1, 1), new Among("enda", -1, 1),
              new Among("ata", -1, 1), new Among("ita", -1, 1),
              new Among("uta", -1, 1), new Among("ava", -1, 1),
              new Among("eva", -1, 1), new Among("iva", -1, 1),
              new Among("erebbe", -1, 1), new Among("irebbe", -1, 1),
              new Among("isce", -1, 1), new Among("ende", -1, 1),
              new Among("are", -1, 1), new Among("ere", -1, 1),
              new Among("ire", -1, 1), new Among("asse", -1, 1),
              new Among("ate", -1, 1), new Among("avate", 16, 1),
              new Among("evate", 16, 1), new Among("ivate", 16, 1),
              new Among("ete", -1, 1), new Among("erete", 20, 1),
              new Among("irete", 20, 1), new Among("ite", -1, 1),
              new Among("ereste", -1, 1), new Among("ireste", -1, 1),
              new Among("ute", -1, 1), new Among("erai", -1, 1),
              new Among("irai", -1, 1), new Among("isci", -1, 1),
              new Among("endi", -1, 1), new Among("erei", -1, 1),
              new Among("irei", -1, 1), new Among("assi", -1, 1),
              new Among("ati", -1, 1), new Among("iti", -1, 1),
              new Among("eresti", -1, 1), new Among("iresti", -1, 1),
              new Among("uti", -1, 1), new Among("avi", -1, 1),
              new Among("evi", -1, 1), new Among("ivi", -1, 1),
              new Among("isco", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("Yamo", -1, 1),
              new Among("iamo", -1, 1), new Among("avamo", -1, 1),
              new Among("evamo", -1, 1), new Among("ivamo", -1, 1),
              new Among("eremo", -1, 1), new Among("iremo", -1, 1),
              new Among("assimo", -1, 1), new Among("ammo", -1, 1),
              new Among("emmo", -1, 1), new Among("eremmo", 54, 1),
              new Among("iremmo", 54, 1), new Among("immo", -1, 1),
              new Among("ano", -1, 1), new Among("iscano", 58, 1),
              new Among("avano", 58, 1), new Among("evano", 58, 1),
              new Among("ivano", 58, 1), new Among("eranno", -1, 1),
              new Among("iranno", -1, 1), new Among("ono", -1, 1),
              new Among("iscono", 65, 1), new Among("arono", 65, 1),
              new Among("erono", 65, 1), new Among("irono", 65, 1),
              new Among("erebbero", -1, 1), new Among("irebbero", -1, 1),
              new Among("assero", -1, 1), new Among("essero", -1, 1),
              new Among("issero", -1, 1), new Among("ato", -1, 1),
              new Among("ito", -1, 1), new Among("uto", -1, 1),
              new Among("avo", -1, 1), new Among("evo", -1, 1),
              new Among("ivo", -1, 1), new Among("ar", -1, 1),
              new Among("ir", -1, 1), new Among("er\u00E0", -1, 1),
              new Among("ir\u00E0", -1, 1), new Among("er\u00F2", -1, 1),
              new Among("ir\u00F2", -1, 1)
            ],
            g_v = [17, 65, 16, 0, 0, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 128, 128, 8, 2, 1
            ],
            g_AEIO = [17, 65, 0, 0, 0, 0,
              0, 0, 0, 0, 0, 0, 0, 0, 0, 128, 128, 8, 2
            ],
            g_CG = [17],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function habr1(c1, c2, v_1) {
            if (sbp.eq_s(1, c1)) {
              sbp.ket = sbp.cursor;
              if (sbp.in_grouping(g_v, 97, 249)) {
                sbp.slice_from(c2);
                sbp.cursor = v_1;
                return true;
              }
            }
            return false;
          }

          function r_prelude() {
            var among_var, v_1 = sbp.cursor,
              v_2, v_3, v_4;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 7);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E0");
                    continue;
                  case 2:
                    sbp.slice_from("\u00E8");
                    continue;
                  case 3:
                    sbp.slice_from("\u00EC");
                    continue;
                  case 4:
                    sbp.slice_from("\u00F2");
                    continue;
                  case 5:
                    sbp.slice_from("\u00F9");
                    continue;
                  case 6:
                    sbp.slice_from("qU");
                    continue;
                  case 7:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
            sbp.cursor = v_1;
            while (true) {
              v_2 = sbp.cursor;
              while (true) {
                v_3 = sbp.cursor;
                if (sbp.in_grouping(g_v, 97, 249)) {
                  sbp.bra = sbp.cursor;
                  v_4 = sbp.cursor;
                  if (habr1("u", "U", v_3))
                    break;
                  sbp.cursor = v_4;
                  if (habr1("i", "I", v_3))
                    break;
                }
                sbp.cursor = v_3;
                if (sbp.cursor >= sbp.limit) {
                  sbp.cursor = v_2;
                  return;
                }
                sbp.cursor++;
              }
            }
          }

          function habr2(v_1) {
            sbp.cursor = v_1;
            if (!sbp.in_grouping(g_v, 97, 249))
              return false;
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 249)) {
              var v_1 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit)
                    return habr2(v_1);
                  sbp.cursor++;
                }
                return true;
              }
              return habr2(v_1);
            }
            return false;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2;
            if (!habr3()) {
              sbp.cursor = v_1;
              if (!sbp.out_grouping(g_v, 97, 249))
                return;
              v_2 = sbp.cursor;
              if (sbp.out_grouping(g_v, 97, 249)) {
                while (!sbp.in_grouping(g_v, 97, 249)) {
                  if (sbp.cursor >= sbp.limit) {
                    sbp.cursor = v_2;
                    if (sbp.in_grouping(g_v, 97, 249) &&
                      sbp.cursor < sbp.limit)
                      sbp.cursor++;
                    return;
                  }
                  sbp.cursor++;
                }
                I_pV = sbp.cursor;
                return;
              }
              sbp.cursor = v_2;
              if (!sbp.in_grouping(g_v, 97, 249) || sbp.cursor >= sbp.limit)
                return;
              sbp.cursor++;
            }
            I_pV = sbp.cursor;
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 249)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (!among_var)
                break;
              sbp.ket = sbp.cursor;
              switch (among_var) {
                case 1:
                  sbp.slice_from("i");
                  break;
                case 2:
                  sbp.slice_from("u");
                  break;
                case 3:
                  if (sbp.cursor >= sbp.limit)
                    return;
                  sbp.cursor++;
                  break;
              }
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_attached_pronoun() {
            var among_var;
            sbp.ket = sbp.cursor;
            if (sbp.find_among_b(a_2, 37)) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among_b(a_3, 5);
              if (among_var && r_RV()) {
                switch (among_var) {
                  case 1:
                    sbp.slice_del();
                    break;
                  case 2:
                    sbp.slice_from("e");
                    break;
                }
              }
            }
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_6, 51);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "ic")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 5:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 6:
                if (!r_RV())
                  return false;
                sbp.slice_del();
                break;
              case 7:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_5, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 9:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    if (sbp.eq_s_b(2, "ic")) {
                      sbp.bra = sbp.cursor;
                      if (r_R2())
                        sbp.slice_del();
                    }
                  }
                }
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_7, 87);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
              }
              sbp.limit_backward = v_1;
            }
          }

          function habr6() {
            var v_1 = sbp.limit - sbp.cursor;
            sbp.ket = sbp.cursor;
            if (sbp.in_grouping_b(g_AEIO, 97, 242)) {
              sbp.bra = sbp.cursor;
              if (r_RV()) {
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(1, "i")) {
                  sbp.bra = sbp.cursor;
                  if (r_RV()) {
                    sbp.slice_del();
                    return;
                  }
                }
              }
            }
            sbp.cursor = sbp.limit - v_1;
          }

          function r_vowel_suffix() {
            habr6();
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "h")) {
              sbp.bra = sbp.cursor;
              if (sbp.in_grouping_b(g_CG, 99, 103))
                if (r_RV())
                  sbp.slice_del();
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            r_attached_pronoun();
            sbp.cursor = sbp.limit;
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              r_verb_suffix();
            }
            sbp.cursor = sbp.limit;
            r_vowel_suffix();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.it.stemmer, 'stemmer-it');

    lunr.it.stopWordFilter = lunr.generateStopWordFilter('a abbia abbiamo abbiano abbiate ad agl agli ai al all alla alle allo anche avemmo avendo avesse avessero avessi avessimo aveste avesti avete aveva avevamo avevano avevate avevi avevo avrai avranno avrebbe avrebbero avrei avremmo avremo avreste avresti avrete avrà avrò avuta avute avuti avuto c che chi ci coi col come con contro cui da dagl dagli dai dal dall dalla dalle dallo degl degli dei del dell della delle dello di dov dove e ebbe ebbero ebbi ed era erano eravamo eravate eri ero essendo faccia facciamo facciano facciate faccio facemmo facendo facesse facessero facessi facessimo faceste facesti faceva facevamo facevano facevate facevi facevo fai fanno farai faranno farebbe farebbero farei faremmo faremo fareste faresti farete farà farò fece fecero feci fosse fossero fossi fossimo foste fosti fu fui fummo furono gli ha hai hanno ho i il in io l la le lei li lo loro lui ma mi mia mie miei mio ne negl negli nei nel nell nella nelle nello noi non nostra nostre nostri nostro o per perché più quale quanta quante quanti quanto quella quelle quelli quello questa queste questi questo sarai saranno sarebbe sarebbero sarei saremmo saremo sareste saresti sarete sarà sarò se sei si sia siamo siano siate siete sono sta stai stando stanno starai staranno starebbe starebbero starei staremmo staremo stareste staresti starete starà starò stava stavamo stavano stavate stavi stavo stemmo stesse stessero stessi stessimo steste stesti stette stettero stetti stia stiamo stiano stiate sto su sua sue sugl sugli sui sul sull sulla sulle sullo suo suoi ti tra tu tua tue tuo tuoi tutti tutto un una uno vi voi vostra vostre vostri vostro è'.split(' '));

    lunr.Pipeline.registerFunction(lunr.it.stopWordFilter, 'stopWordFilter-it');
  };
}))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Japanese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Chad Liu
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /*
    Japanese tokenization is trickier, since it does not
    take into account spaces.
    Since the tokenization function is represented different
    internally for each of the Lunr versions, this had to be done
    in order to try to try to pick the best way of doing this based
    on the Lunr version
     */
    var isLunr2 = lunr.version[0] == "2";

    /* register specific locale function */
    lunr.ja = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.ja.trimmer,
        lunr.ja.stopWordFilter,
        lunr.ja.stemmer
      );

      // change the tokenizer for japanese one
      if (isLunr2) { // for lunr version 2.0.0
        this.tokenizer = lunr.ja.tokenizer;
      } else {
        if (lunr.tokenizer) { // for lunr version 0.6.0
          lunr.tokenizer = lunr.ja.tokenizer;
        }
        if (this.tokenizerFn) { // for lunr version 0.7.0 -> 1.0.0
          this.tokenizerFn = lunr.ja.tokenizer;
        }
      }
    };
    var segmenter = new lunr.TinySegmenter(); // インスタンス生成

    lunr.ja.tokenizer = function(obj) {
      var i;
      var str;
      var len;
      var segs;
      var tokens;
      var char;
      var sliceLength;
      var sliceStart;
      var sliceEnd;
      var segStart;

      if (!arguments.length || obj == null || obj == undefined)
        return [];

      if (Array.isArray(obj)) {
        return obj.map(
          function(t) {
            return isLunr2 ? new lunr.Token(t.toLowerCase()) : t.toLowerCase();
          }
        );
      }

      str = obj.toString().toLowerCase().replace(/^\s+/, '');
      for (i = str.length - 1; i >= 0; i--) {
        if (/\S/.test(str.charAt(i))) {
          str = str.substring(0, i + 1);
          break;
        }
      }

      tokens = [];
      len = str.length;
      for (sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
        char = str.charAt(sliceEnd);
        sliceLength = sliceEnd - sliceStart;

        if ((char.match(/\s/) || sliceEnd == len)) {
          if (sliceLength > 0) {
            segs = segmenter.segment(str.slice(sliceStart, sliceEnd)).filter(
              function(token) {
                return !!token;
              }
            );

            segStart = sliceStart;
            for (i = 0; i < segs.length; i++) {
              if (isLunr2) {
                tokens.push(
                  new lunr.Token(
                    segs[i], {
                      position: [segStart, segs[i].length],
                      index: tokens.length
                    }
                  )
                );
              } else {
                tokens.push(segs[i]);
              }
              segStart += segs[i].length;
            }
          }

          sliceStart = sliceEnd + 1;
        }
      }

      return tokens;
    }

    /* lunr stemmer function */
    lunr.ja.stemmer = (function() {

      /* TODO japanese stemmer  */
      return function(word) {
        return word;
      }
    })();
    lunr.Pipeline.registerFunction(lunr.ja.stemmer, 'stemmer-ja');

    /* lunr trimmer function */
    lunr.ja.wordCharacters = "一二三四五六七八九十百千万億兆一-龠々〆ヵヶぁ-んァ-ヴーｱ-ﾝﾞa-zA-Zａ-ｚＡ-Ｚ0-9０-９";
    lunr.ja.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.ja.wordCharacters);
    lunr.Pipeline.registerFunction(lunr.ja.trimmer, 'trimmer-ja');

    /* lunr stop word filter. see http://www.ranks.nl/stopwords/japanese */
    lunr.ja.stopWordFilter = lunr.generateStopWordFilter(
      'これ それ あれ この その あの ここ そこ あそこ こちら どこ だれ なに なん 何 私 貴方 貴方方 我々 私達 あの人 あのかた 彼女 彼 です あります おります います は が の に を で え から まで より も どの と し それで しかし'.split(' '));
    lunr.Pipeline.registerFunction(lunr.ja.stopWordFilter, 'stopWordFilter-ja');

    // alias ja => jp for backward-compatibility.
    // jp is the country code, while ja is the language code
    // a new lunr.ja.js has been created, but in order to
    // keep the backward compatibility, we'll leave the lunr.jp.js
    // here for a while, and just make it use the new lunr.ja.js
    lunr.jp = lunr.ja;
    lunr.Pipeline.registerFunction(lunr.jp.stemmer, 'stemmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.trimmer, 'trimmer-jp');
    lunr.Pipeline.registerFunction(lunr.jp.stopWordFilter, 'stopWordFilter-jp');
  };
}))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lunr languages, `Portuguese` language
 * https://github.com/MihaiValentin/lunr-languages
 *
 * Copyright 2014, Mihai Valentin
 * http://www.mozilla.org/MPL/
 */
/*!
 * based on
 * Snowball JavaScript Library v0.3
 * http://code.google.com/p/urim/
 * http://snowball.tartarus.org/
 *
 * Copyright 2010, Oleg Mazko
 * http://www.mozilla.org/MPL/
 */

/**
 * export the module via AMD, CommonJS or as a browser global
 * Export code from https://github.com/umdjs/umd/blob/master/returnExports.js
 */
;
(function(root, factory) {
  if (true) {
    // AMD. Register as an anonymous module.
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
  } else if (typeof exports === 'object') {
    /**
     * Node. Does not work with strict CommonJS, but
     * only CommonJS-like environments that support module.exports,
     * like Node.
     */
    module.exports = factory()
  } else {
    // Browser globals (root is window)
    factory()(root.lunr);
  }
}(this, function() {
  /**
   * Just return a value to define the module export.
   * This example returns an object, but the module
   * can return a function as the exported value.
   */
  return function(lunr) {
    /* throw error if lunr is not yet included */
    if ('undefined' === typeof lunr) {
      throw new Error('Lunr is not present. Please include / require Lunr before this script.');
    }

    /* throw error if lunr stemmer support is not yet included */
    if ('undefined' === typeof lunr.stemmerSupport) {
      throw new Error('Lunr stemmer support is not present. Please include / require Lunr stemmer support before this script.');
    }

    /* register specific locale function */
    lunr.pt = function() {
      this.pipeline.reset();
      this.pipeline.add(
        lunr.pt.trimmer,
        lunr.pt.stopWordFilter,
        lunr.pt.stemmer
      );

      // for lunr version 2
      // this is necessary so that every searched word is also stemmed before
      // in lunr <= 1 this is not needed, as it is done using the normal pipeline
      if (this.searchPipeline) {
        this.searchPipeline.reset();
        this.searchPipeline.add(lunr.pt.stemmer)
      }
    };

    /* lunr trimmer function */
    lunr.pt.wordCharacters = "A-Za-z\xAA\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02B8\u02E0-\u02E4\u1D00-\u1D25\u1D2C-\u1D5C\u1D62-\u1D65\u1D6B-\u1D77\u1D79-\u1DBE\u1E00-\u1EFF\u2071\u207F\u2090-\u209C\u212A\u212B\u2132\u214E\u2160-\u2188\u2C60-\u2C7F\uA722-\uA787\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA7FF\uAB30-\uAB5A\uAB5C-\uAB64\uFB00-\uFB06\uFF21-\uFF3A\uFF41-\uFF5A";
    lunr.pt.trimmer = lunr.trimmerSupport.generateTrimmer(lunr.pt.wordCharacters);

    lunr.Pipeline.registerFunction(lunr.pt.trimmer, 'trimmer-pt');

    /* lunr stemmer function */
    lunr.pt.stemmer = (function() {
      /* create the wrapped stemmer object */
      var Among = lunr.stemmerSupport.Among,
        SnowballProgram = lunr.stemmerSupport.SnowballProgram,
        st = new function PortugueseStemmer() {
          var a_0 = [new Among("", -1, 3), new Among("\u00E3", 0, 1),
              new Among("\u00F5", 0, 2)
            ],
            a_1 = [new Among("", -1, 3),
              new Among("a~", 0, 1), new Among("o~", 0, 2)
            ],
            a_2 = [
              new Among("ic", -1, -1), new Among("ad", -1, -1),
              new Among("os", -1, -1), new Among("iv", -1, 1)
            ],
            a_3 = [
              new Among("ante", -1, 1), new Among("avel", -1, 1),
              new Among("\u00EDvel", -1, 1)
            ],
            a_4 = [new Among("ic", -1, 1),
              new Among("abil", -1, 1), new Among("iv", -1, 1)
            ],
            a_5 = [
              new Among("ica", -1, 1), new Among("\u00E2ncia", -1, 1),
              new Among("\u00EAncia", -1, 4), new Among("ira", -1, 9),
              new Among("adora", -1, 1), new Among("osa", -1, 1),
              new Among("ista", -1, 1), new Among("iva", -1, 8),
              new Among("eza", -1, 1), new Among("log\u00EDa", -1, 2),
              new Among("idade", -1, 7), new Among("ante", -1, 1),
              new Among("mente", -1, 6), new Among("amente", 12, 5),
              new Among("\u00E1vel", -1, 1), new Among("\u00EDvel", -1, 1),
              new Among("uci\u00F3n", -1, 3), new Among("ico", -1, 1),
              new Among("ismo", -1, 1), new Among("oso", -1, 1),
              new Among("amento", -1, 1), new Among("imento", -1, 1),
              new Among("ivo", -1, 8), new Among("a\u00E7a~o", -1, 1),
              new Among("ador", -1, 1), new Among("icas", -1, 1),
              new Among("\u00EAncias", -1, 4), new Among("iras", -1, 9),
              new Among("adoras", -1, 1), new Among("osas", -1, 1),
              new Among("istas", -1, 1), new Among("ivas", -1, 8),
              new Among("ezas", -1, 1), new Among("log\u00EDas", -1, 2),
              new Among("idades", -1, 7), new Among("uciones", -1, 3),
              new Among("adores", -1, 1), new Among("antes", -1, 1),
              new Among("a\u00E7o~es", -1, 1), new Among("icos", -1, 1),
              new Among("ismos", -1, 1), new Among("osos", -1, 1),
              new Among("amentos", -1, 1), new Among("imentos", -1, 1),
              new Among("ivos", -1, 8)
            ],
            a_6 = [new Among("ada", -1, 1),
              new Among("ida", -1, 1), new Among("ia", -1, 1),
              new Among("aria", 2, 1), new Among("eria", 2, 1),
              new Among("iria", 2, 1), new Among("ara", -1, 1),
              new Among("era", -1, 1), new Among("ira", -1, 1),
              new Among("ava", -1, 1), new Among("asse", -1, 1),
              new Among("esse", -1, 1), new Among("isse", -1, 1),
              new Among("aste", -1, 1), new Among("este", -1, 1),
              new Among("iste", -1, 1), new Among("ei", -1, 1),
              new Among("arei", 16, 1), new Among("erei", 16, 1),
              new Among("irei", 16, 1), new Among("am", -1, 1),
              new Among("iam", 20, 1), new Among("ariam", 21, 1),
              new Among("eriam", 21, 1), new Among("iriam", 21, 1),
              new Among("aram", 20, 1), new Among("eram", 20, 1),
              new Among("iram", 20, 1), new Among("avam", 20, 1),
              new Among("em", -1, 1), new Among("arem", 29, 1),
              new Among("erem", 29, 1), new Among("irem", 29, 1),
              new Among("assem", 29, 1), new Among("essem", 29, 1),
              new Among("issem", 29, 1), new Among("ado", -1, 1),
              new Among("ido", -1, 1), new Among("ando", -1, 1),
              new Among("endo", -1, 1), new Among("indo", -1, 1),
              new Among("ara~o", -1, 1), new Among("era~o", -1, 1),
              new Among("ira~o", -1, 1), new Among("ar", -1, 1),
              new Among("er", -1, 1), new Among("ir", -1, 1),
              new Among("as", -1, 1), new Among("adas", 47, 1),
              new Among("idas", 47, 1), new Among("ias", 47, 1),
              new Among("arias", 50, 1), new Among("erias", 50, 1),
              new Among("irias", 50, 1), new Among("aras", 47, 1),
              new Among("eras", 47, 1), new Among("iras", 47, 1),
              new Among("avas", 47, 1), new Among("es", -1, 1),
              new Among("ardes", 58, 1), new Among("erdes", 58, 1),
              new Among("irdes", 58, 1), new Among("ares", 58, 1),
              new Among("eres", 58, 1), new Among("ires", 58, 1),
              new Among("asses", 58, 1), new Among("esses", 58, 1),
              new Among("isses", 58, 1), new Among("astes", 58, 1),
              new Among("estes", 58, 1), new Among("istes", 58, 1),
              new Among("is", -1, 1), new Among("ais", 71, 1),
              new Among("eis", 71, 1), new Among("areis", 73, 1),
              new Among("ereis", 73, 1), new Among("ireis", 73, 1),
              new Among("\u00E1reis", 73, 1), new Among("\u00E9reis", 73, 1),
              new Among("\u00EDreis", 73, 1), new Among("\u00E1sseis", 73, 1),
              new Among("\u00E9sseis", 73, 1), new Among("\u00EDsseis", 73, 1),
              new Among("\u00E1veis", 73, 1), new Among("\u00EDeis", 73, 1),
              new Among("ar\u00EDeis", 84, 1), new Among("er\u00EDeis", 84, 1),
              new Among("ir\u00EDeis", 84, 1), new Among("ados", -1, 1),
              new Among("idos", -1, 1), new Among("amos", -1, 1),
              new Among("\u00E1ramos", 90, 1), new Among("\u00E9ramos", 90, 1),
              new Among("\u00EDramos", 90, 1), new Among("\u00E1vamos", 90, 1),
              new Among("\u00EDamos", 90, 1), new Among("ar\u00EDamos", 95, 1),
              new Among("er\u00EDamos", 95, 1), new Among("ir\u00EDamos", 95, 1),
              new Among("emos", -1, 1), new Among("aremos", 99, 1),
              new Among("eremos", 99, 1), new Among("iremos", 99, 1),
              new Among("\u00E1ssemos", 99, 1), new Among("\u00EAssemos", 99, 1),
              new Among("\u00EDssemos", 99, 1), new Among("imos", -1, 1),
              new Among("armos", -1, 1), new Among("ermos", -1, 1),
              new Among("irmos", -1, 1), new Among("\u00E1mos", -1, 1),
              new Among("ar\u00E1s", -1, 1), new Among("er\u00E1s", -1, 1),
              new Among("ir\u00E1s", -1, 1), new Among("eu", -1, 1),
              new Among("iu", -1, 1), new Among("ou", -1, 1),
              new Among("ar\u00E1", -1, 1), new Among("er\u00E1", -1, 1),
              new Among("ir\u00E1", -1, 1)
            ],
            a_7 = [new Among("a", -1, 1),
              new Among("i", -1, 1), new Among("o", -1, 1),
              new Among("os", -1, 1), new Among("\u00E1", -1, 1),
              new Among("\u00ED", -1, 1), new Among("\u00F3", -1, 1)
            ],
            a_8 = [
              new Among("e", -1, 1), new Among("\u00E7", -1, 2),
              new Among("\u00E9", -1, 1), new Among("\u00EA", -1, 1)
            ],
            g_v = [17,
              65, 16, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 19, 12, 2
            ],
            I_p2, I_p1, I_pV, sbp = new SnowballProgram();
          this.setCurrent = function(word) {
            sbp.setCurrent(word);
          };
          this.getCurrent = function() {
            return sbp.getCurrent();
          };

          function r_prelude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_0, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("a~");
                    continue;
                  case 2:
                    sbp.slice_from("o~");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function habr2() {
            if (sbp.out_grouping(g_v, 97, 250)) {
              while (!sbp.in_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return true;
                sbp.cursor++;
              }
              return false;
            }
            return true;
          }

          function habr3() {
            if (sbp.in_grouping(g_v, 97, 250)) {
              while (!sbp.out_grouping(g_v, 97, 250)) {
                if (sbp.cursor >= sbp.limit)
                  return false;
                sbp.cursor++;
              }
            }
            I_pV = sbp.cursor;
            return true;
          }

          function habr4() {
            var v_1 = sbp.cursor,
              v_2, v_3;
            if (sbp.in_grouping(g_v, 97, 250)) {
              v_2 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_2;
                if (habr3())
                  return;
              } else
                I_pV = sbp.cursor;
            }
            sbp.cursor = v_1;
            if (sbp.out_grouping(g_v, 97, 250)) {
              v_3 = sbp.cursor;
              if (habr2()) {
                sbp.cursor = v_3;
                if (!sbp.in_grouping(g_v, 97, 250) || sbp.cursor >= sbp.limit)
                  return;
                sbp.cursor++;
              }
              I_pV = sbp.cursor;
            }
          }

          function habr5() {
            while (!sbp.in_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            while (!sbp.out_grouping(g_v, 97, 250)) {
              if (sbp.cursor >= sbp.limit)
                return false;
              sbp.cursor++;
            }
            return true;
          }

          function r_mark_regions() {
            var v_1 = sbp.cursor;
            I_pV = sbp.limit;
            I_p1 = I_pV;
            I_p2 = I_pV;
            habr4();
            sbp.cursor = v_1;
            if (habr5()) {
              I_p1 = sbp.cursor;
              if (habr5())
                I_p2 = sbp.cursor;
            }
          }

          function r_postlude() {
            var among_var;
            while (true) {
              sbp.bra = sbp.cursor;
              among_var = sbp.find_among(a_1, 3);
              if (among_var) {
                sbp.ket = sbp.cursor;
                switch (among_var) {
                  case 1:
                    sbp.slice_from("\u00E3");
                    continue;
                  case 2:
                    sbp.slice_from("\u00F5");
                    continue;
                  case 3:
                    if (sbp.cursor >= sbp.limit)
                      break;
                    sbp.cursor++;
                    continue;
                }
              }
              break;
            }
          }

          function r_RV() {
            return I_pV <= sbp.cursor;
          }

          function r_R1() {
            return I_p1 <= sbp.cursor;
          }

          function r_R2() {
            return I_p2 <= sbp.cursor;
          }

          function r_standard_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_5, 45);
            if (!among_var)
              return false;
            sbp.bra = sbp.cursor;
            switch (among_var) {
              case 1:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                break;
              case 2:
                if (!r_R2())
                  return false;
                sbp.slice_from("log");
                break;
              case 3:
                if (!r_R2())
                  return false;
                sbp.slice_from("u");
                break;
              case 4:
                if (!r_R2())
                  return false;
                sbp.slice_from("ente");
                break;
              case 5:
                if (!r_R1())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_2, 4);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (r_R2()) {
                    sbp.slice_del();
                    if (among_var == 1) {
                      sbp.ket = sbp.cursor;
                      if (sbp.eq_s_b(2, "at")) {
                        sbp.bra = sbp.cursor;
                        if (r_R2())
                          sbp.slice_del();
                      }
                    }
                  }
                }
                break;
              case 6:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_3, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 7:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                among_var = sbp.find_among_b(a_4, 3);
                if (among_var) {
                  sbp.bra = sbp.cursor;
                  if (among_var == 1)
                    if (r_R2())
                      sbp.slice_del();
                }
                break;
              case 8:
                if (!r_R2())
                  return false;
                sbp.slice_del();
                sbp.ket = sbp.cursor;
                if (sbp.eq_s_b(2, "at")) {
                  sbp.bra = sbp.cursor;
                  if (r_R2())
                    sbp.slice_del();
                }
                break;
              case 9:
                if (!r_RV() || !sbp.eq_s_b(1, "e"))
                  return false;
                sbp.slice_from("ir");
                break;
            }
            return true;
          }

          function r_verb_suffix() {
            var among_var, v_1;
            if (sbp.cursor >= I_pV) {
              v_1 = sbp.limit_backward;
              sbp.limit_backward = I_pV;
              sbp.ket = sbp.cursor;
              among_var = sbp.find_among_b(a_6, 120);
              if (among_var) {
                sbp.bra = sbp.cursor;
                if (among_var == 1)
                  sbp.slice_del();
                sbp.limit_backward = v_1;
                return true;
              }
              sbp.limit_backward = v_1;
            }
            return false;
          }

          function r_residual_suffix() {
            var among_var;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_7, 7);
            if (among_var) {
              sbp.bra = sbp.cursor;
              if (among_var == 1)
                if (r_RV())
                  sbp.slice_del();
            }
          }

          function habr6(c1, c2) {
            if (sbp.eq_s_b(1, c1)) {
              sbp.bra = sbp.cursor;
              var v_1 = sbp.limit - sbp.cursor;
              if (sbp.eq_s_b(1, c2)) {
                sbp.cursor = sbp.limit - v_1;
                if (r_RV())
                  sbp.slice_del();
                return false;
              }
            }
            return true;
          }

          function r_residual_form() {
            var among_var, v_1, v_2, v_3;
            sbp.ket = sbp.cursor;
            among_var = sbp.find_among_b(a_8, 4);
            if (among_var) {
              sbp.bra = sbp.cursor;
              switch (among_var) {
                case 1:
                  if (r_RV()) {
                    sbp.slice_del();
                    sbp.ket = sbp.cursor;
                    v_1 = sbp.limit - sbp.cursor;
                    if (habr6("u", "g"))
                      habr6("i", "c")
                  }
                  break;
                case 2:
                  sbp.slice_from("c");
                  break;
              }
            }
          }

          function habr1() {
            if (!r_standard_suffix()) {
              sbp.cursor = sbp.limit;
              if (!r_verb_suffix()) {
                sbp.cursor = sbp.limit;
                r_residual_suffix();
                return;
              }
            }
            sbp.cursor = sbp.limit;
            sbp.ket = sbp.cursor;
            if (sbp.eq_s_b(1, "i")) {
              sbp.bra = sbp.cursor;
              if (sbp.eq_s_b(1, "c")) {
                sbp.cursor = sbp.limit;
                if (r_RV())
                  sbp.slice_del();
              }
            }
          }
          this.stem = function() {
            var v_1 = sbp.cursor;
            r_prelude();
            sbp.cursor = v_1;
            r_mark_regions();
            sbp.limit_backward = v_1;
            sbp.cursor = sbp.limit;
            habr1();
            sbp.cursor = sbp.limit;
            r_residual_form();
            sbp.cursor = sbp.limit_backward;
            r_postlude();
            return true;
          }
        };

      /* and return a function that stems a word for the current locale */
      return function(token) {
        // for lunr version 2
        if (typeof token.update === "function") {
          return token.update(function(word) {
            st.setCurrent(word);
            st.stem();
            return st.getCurrent();
          })
        } else { // for lunr version <= 1
          st.setCurrent(token);
          st.stem();
          return st.getCurrent();
        }
      }
    })();

    lunr.Pipeline.registerFunction(lunr.pt.stemmer, 'stemmer-pt');

    lunr.pt.stopWordFilter = lunr.generateStopWordFilter('a ao aos aquela aquelas aquele aqueles aquilo as até com como da das de dela delas dele deles depois do dos e ela elas ele eles em entre era eram essa essas esse esses esta estamos estas estava estavam este esteja estejam estejamos estes esteve estive estivemos estiver estivera estiveram estiverem estivermos estivesse estivessem estivéramos estivéssemos estou está estávamos estão eu foi fomos for fora foram forem formos fosse fossem fui fôramos fôssemos haja hajam hajamos havemos hei houve houvemos houver houvera houveram houverei houverem houveremos houveria houveriam houvermos houverá houverão houveríamos houvesse houvessem houvéramos houvéssemos há hão isso isto já lhe lhes mais mas me mesmo meu meus minha minhas muito na nas nem no nos nossa nossas nosso nossos num numa não nós o os ou para pela pelas pelo pelos por qual quando que quem se seja sejam sejamos sem serei seremos seria seriam será serão seríamos seu seus somos sou sua suas são só também te tem temos tenha tenham tenhamos tenho terei teremos teria teriam terá terão teríamos teu teus teve tinha tinham tive tivemos tiver tivera tiveram tiverem tivermos tivesse tivessem tivéramos tivéssemos tu tua tuas tém tínhamos um uma você vocês vos à às éramos'.split(' '));

    lunr.Pipeline.registerFunction(lunr.pt.stopWordFilter, 'stopWordFilter-pt');
  };
}))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"form__field"},[_c('div',{staticClass:"cell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"ids_topicSearch",attrs:{"id":"ctl00_ids_contentPlaceHolder_ids_topicSearch","name":"ctl00$ids_contentPlaceHolder$ids_topicSearch","placeholder":"Search Contents","type":"text"},domProps:{"value":(_vm.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.queryResults($event)},"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),(_vm.search)?_c('div',{staticClass:"search_button"},[_c('button',{staticClass:"close-icon",on:{"click":_vm.clearResult}},[_vm._v("\n    ×\n   ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search_button"},[_c('button',{on:{"click":_vm.queryResults}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-1 l-pad-top",attrs:{"id":"results"}},[_c('div',[_c('p',{staticClass:"toc-2-style",staticStyle:{"margin-bottom":"10px"}},[(_vm.resultsCount != 0)?_c('strong',[_vm._v("\n     ("+_vm._s(_vm.resultsCount)+") Results Found\n    ")]):(_vm.resultsActual)?_c('strong',[_vm._v("\n     No Results Found\n    ")]):_vm._e()])]),_vm._v(" "),_vm._l((_vm.resultsActual),function(result){return _c('div',[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":result.link,"keywords":result.keywords,"onclick":"reload(this.href, this.getAttribute('keywords'))"}},[_vm._v("\n     "+_vm._s(result.title)+"\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-3-style"},[_vm._v("\n    "+_vm._s(result.desc)+"\n   ")])])})],2),_vm._v(" "),(!_vm.resultsActual)?_c('div',{staticClass:"side-toc"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_vm._m(13),_vm._v(" "),_vm._m(14),_vm._v(" "),_vm._m(15),_vm._v(" "),_vm._m(16),_vm._v(" "),_vm._m(17),_vm._v(" "),_vm._m(18),_vm._v(" "),_vm._m(19),_vm._v(" "),_vm._m(20),_vm._v(" "),_vm._m(21),_vm._v(" "),_vm._m(22),_vm._v(" "),_vm._m(23),_vm._v(" "),_vm._m(24),_vm._v(" "),_vm._m(25),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"cover.html","title":"Multifunkčn&eacute; tlačiarne MX532, MX632, XM3350"}},[_vm._v("\n    Multifunkčné tlačiarne MX532, MX632, XM3350\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"safety.html#safety_sk","title":"Bezpečnostn&eacute; inform&aacute;cie"}},[_vm._v("\n    Bezpečnostné informácie\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e18"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":".html#d0e23","title":"Zauž&iacute;van&eacute; označenie"}},[_vm._v("\n     Zaužívané označenie\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"safety-cable-topic.html#d0e40","title":"Vyhl&aacute;senia o&nbsp;produkte"}},[_vm._v("\n     Vyhlásenia o produkte\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"learning-about-printer-chapter.html#learning-about-printer-chapter_sk","title":"Obozn&aacute;menie sa s&nbsp;tlačiarňou"}},[_vm._v("\n    Oboznámenie sa s tlačiarňou\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e175"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-information-about-printer-topic.html#finding-information-about-printer_sk","title":"Vyhľad&aacute;vanie inform&aacute;ci&iacute; o&nbsp;tlačiarni"}},[_vm._v("\n     Vyhľadávanie informácií o tlačiarni\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"finding-printer-serial-number-topic.html#finding-printer-serial-number_sk","title":"Vyhľadanie s&eacute;riov&eacute;ho č&iacute;sla tlačiarne"}},[_vm._v("\n     Vyhľadanie sériového čísla tlačiarne\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-configurations-topic.html#printer-configurations_sk","title":"Konfigur&aacute;cie tlačiarne"}},[_vm._v("\n     Konfigurácie tlačiarne\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-control-panel-topic.html#using-control-panel_sk","title":"Použ&iacute;vanie ovl&aacute;dacieho panela"}},[_vm._v("\n     Používanie ovládacieho panela\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_sk","title":"Vysvetlenie stavu svetla indik&aacute;tora"}},[_vm._v("\n     Vysvetlenie stavu svetla indikátora\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-paper-group.html#d0e500","title":"V&yacute;ber papiera"}},[_vm._v("\n     Výber papiera\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_sk","title":"Pr&iacute;prava na použ&iacute;vanie, in&scaron;tal&aacute;cia a&nbsp;konfigur&aacute;cia"}},[_vm._v("\n    Príprava na používanie, inštalácia a konfigurácia\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e1569"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"selecting-location-printer-topic.html#selecting-location-printer_sk","title":"V&yacute;ber miesta pre tlačiareň"}},[_vm._v("\n     Výber miesta pre tlačiareň\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"attaching-cables-topic.html#attaching-cables_sk","title":"Prip&aacute;janie k&aacute;blov"}},[_vm._v("\n     Pripájanie káblov\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-home-screen-topic.html#d0e1764","title":"Nastavenie a&nbsp;použ&iacute;vanie aplik&aacute;ci&iacute; na domovskej obrazovke"}},[_vm._v("\n     Nastavenie a používanie aplikácií na domovskej obrazovke\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"activating-voice-guidance-topic.html#d0e2409","title":"Nastavenie a&nbsp;použ&iacute;vanie funkci&iacute; zjednodu&scaron;enia ovl&aacute;dania"}},[_vm._v("\n     Nastavenie a používanie funkcií zjednodušenia ovládania\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-printer-to-fax-group.html#d0e2710","title":"Nastavenie tlačiarne na faxovanie"}},[_vm._v("\n     Nastavenie tlačiarne na faxovanie\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-smtp-server-for-e-mail-topic.html#configuring-smtp-server-for-e-mail_sk","title":"Konfigur&aacute;cia nastaven&iacute; protokolu e-mail SMTP"}},[_vm._v("\n     Konfigurácia nastavení protokolu e-mail SMTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-paper-size-and-type-topic.html#d0e4567","title":"Vkladanie papiera a&nbsp;&scaron;peci&aacute;lnych m&eacute;di&iacute;"}},[_vm._v("\n     Vkladanie papiera a špeciálnych médií\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"installing-printer-software-topic.html#d0e4733","title":"In&scaron;tal&aacute;cia a&nbsp;aktualiz&aacute;cia softv&eacute;ru, ovl&aacute;dačov a&nbsp;firmv&eacute;ru"}},[_vm._v("\n     Inštalácia a aktualizácia softvéru, ovládačov a firmvéru\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"available-internal-options-topic.html#d0e5014","title":"In&scaron;tal&aacute;cia hardv&eacute;rov&yacute;ch voliteľn&yacute;ch prvkov"}},[_vm._v("\n     Inštalácia hardvérových voliteľných prvkov\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"wireless-support-topic.html#d0e5323","title":"Pripojenie k&nbsp;sieti"}},[_vm._v("\n     Pripojenie k sieti\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"securing-the-printer.html#securing-the-printer_sk","title":"Zabezpečenie tlačiarne"}},[_vm._v("\n    Zabezpečenie tlačiarne\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5741"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"locating-security-slot-topic.html#locating-security-slot_sk","title":"Umiestnenie bezpečnostnej z&aacute;suvky"}},[_vm._v("\n     Umiestnenie bezpečnostnej zásuvky\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-memory-topic.html#erasing-printer-memory_sk","title":"Vymazanie pam&auml;te tlačiarne"}},[_vm._v("\n     Vymazanie pamäte tlačiarne\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_sk","title":"Vymazanie &uacute;ložn&eacute;ho disku tlačiarne"}},[_vm._v("\n     Vymazanie úložného disku tlačiarne\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"restoring-factory-default-settings-topic.html#restoring-factory-default-settings_sk","title":"Obnovenie predvolen&yacute;ch v&yacute;robn&yacute;ch nastaven&iacute;"}},[_vm._v("\n     Obnovenie predvolených výrobných nastavení\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"statement-of-volatility-topic.html#statement-of-volatility_sk","title":"Vyhl&aacute;senie o nest&aacute;losti"}},[_vm._v("\n     Vyhlásenie o nestálosti\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"printing-chapter.html#printing-chapter_sk","title":"Tlač"}},[_vm._v("\n    Tlač\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e5930"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-computer-h2-topic.html#printing-from-computer-h2_sk","title":"Tlač z poč&iacute;tača"}},[_vm._v("\n     Tlač z počítača\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-mobile-device-using-lexmark-print-topic.html#d0e5956","title":"Tlač z&nbsp;mobiln&eacute;ho zariadenia"}},[_vm._v("\n     Tlač z mobilného zariadenia\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-from-flash-drive-topic.html#printing-from-flash-drive_sk","title":"Tlač z&nbsp;pam&auml;ťovej jednotky flash"}},[_vm._v("\n     Tlač z pamäťovej jednotky flash\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_sk","title":"Podporovan&eacute; jednotky flash a&nbsp;typy s&uacute;borov"}},[_vm._v("\n     Podporované jednotky flash a typy súborov\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-confidential-jobs-topic.html#configuring-confidential-jobs_sk","title":"Konfigur&aacute;cia d&ocirc;vern&yacute;ch &uacute;loh"}},[_vm._v("\n     Konfigurácia dôverných úloh\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_sk","title":"Tlač d&ocirc;vern&yacute;ch a&nbsp;in&yacute;ch zadržan&yacute;ch &uacute;loh"}},[_vm._v("\n     Tlač dôverných a iných zadržaných úloh\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_sk","title":"Tlač zoznamu uk&aacute;žok p&iacute;siem"}},[_vm._v("\n     Tlač zoznamu ukážok písiem\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-directory-list-h2-topic.html#printing-directory-list-h2_sk","title":"Tlač zoznamu adres&aacute;ra"}},[_vm._v("\n     Tlač zoznamu adresára\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-topic.html#placing-separator-sheets_sk","title":"Umiestnenie oddeľovac&iacute;ch h&aacute;rkov medzi k&oacute;pie"}},[_vm._v("\n     Umiestnenie oddeľovacích hárkov medzi kópie\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"canceling-print-job-topic.html#canceling-print-job_sk","title":"Zru&scaron;enie tlačovej &uacute;lohy"}},[_vm._v("\n     Zrušenie tlačovej úlohy\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-toner-darkness-topic.html#adjusting-toner-darkness_sk","title":"&Uacute;prava tmavosti tonera"}},[_vm._v("\n     Úprava tmavosti tonera\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"copying.html#copying_sk","title":"Kop&iacute;rovanie"}},[_vm._v("\n    Kopírovanie\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e6546"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_sk","title":"Použ&iacute;vanie automatick&eacute;ho pod&aacute;vača dokumentov a&nbsp;skenovacieho skla"}},[_vm._v("\n     Používanie automatického podávača dokumentov a skenovacieho skla\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"making-copies-topic.html#making-copies_sk","title":"Vytv&aacute;ranie k&oacute;pi&iacute;"}},[_vm._v("\n     Vytváranie kópií\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-photos-topic.html#copying-photos_sk","title":"Kop&iacute;rovanie fotografi&iacute;"}},[_vm._v("\n     Kopírovanie fotografií\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-transparencies-or-letterhead-topic.html#copying-transparencies-or-letterhead_sk","title":"Kop&iacute;rovanie na hlavičkov&yacute; papier"}},[_vm._v("\n     Kopírovanie na hlavičkový papier\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_sk","title":"Kop&iacute;rovanie na obe strany papiera"}},[_vm._v("\n     Kopírovanie na obe strany papiera\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"reducing-enlarging-copies-topic.html#reducing-enlarging-copies_sk","title":"Zmen&scaron;enie alebo zv&auml;č&scaron;enie k&oacute;pi&iacute;"}},[_vm._v("\n     Zmenšenie alebo zväčšenie kópií\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"collating-copies-topic.html#collating-copies_sk","title":"Zoradenie k&oacute;pi&iacute;"}},[_vm._v("\n     Zoradenie kópií\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_sk","title":"Umiestnenie oddeľovac&iacute;ch h&aacute;rkov medzi k&oacute;pie"}},[_vm._v("\n     Umiestnenie oddeľovacích hárkov medzi kópie\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"saving-paper-topic.html#saving-paper_sk","title":"Kop&iacute;rovanie viacer&yacute;ch str&aacute;nok na jeden h&aacute;rok"}},[_vm._v("\n     Kopírovanie viacerých stránok na jeden hárok\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copying-cards-topic.html#copying-cards_sk","title":"Kop&iacute;rovanie preukazov"}},[_vm._v("\n     Kopírovanie preukazov\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-copy-shortcut-topic.html#creating-copy-shortcut_sk","title":"Vytvorenie skratky na kop&iacute;rovanie"}},[_vm._v("\n     Vytvorenie skratky na kopírovanie\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"E-mailing.html#E-mailing_sk","title":"E-mail"}},[_vm._v("\n    E-mail\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e6856"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-e-mail-topic.html#using-ADF-and-scanner-glass-e-mail_sk","title":"Použ&iacute;vanie automatick&eacute;ho pod&aacute;vača dokumentov a&nbsp;skenovacieho skla"}},[_vm._v("\n     Používanie automatického podávača dokumentov a skenovacieho skla\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-email-topic.html#sending-email_sk","title":"Odoslanie e-mailovej spr&aacute;vy"}},[_vm._v("\n     Odoslanie e-mailovej správy\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_sk","title":"Vytvorenie skratky pre e-mail"}},[_vm._v("\n     Vytvorenie skratky pre e-mail\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"Faxing.html#Faxing_sk","title":"Fax"}},[_vm._v("\n    Fax\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e6950"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-fax-topic.html#using-ADF-and-scanner-glass-fax_sk","title":"Použ&iacute;vanie automatick&eacute;ho pod&aacute;vača dokumentov a&nbsp;skenovacieho skla"}},[_vm._v("\n     Používanie automatického podávača dokumentov a skenovacieho skla\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"sending-fax-topic.html#sending-fax_sk","title":"Odoslanie faxu"}},[_vm._v("\n     Odoslanie faxu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scheduling-fax-topic.html#scheduling-fax_sk","title":"Napl&aacute;novanie odoslania faxu"}},[_vm._v("\n     Naplánovanie odoslania faxu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_sk","title":"Vytvorenie skratky pre cieľov&eacute; umiestnenie pre fax"}},[_vm._v("\n     Vytvorenie skratky pre cieľové umiestnenie pre fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"changing-fax-resolution-topic.html#changing-fax-resolution_sk","title":"Zmena rozl&iacute;&scaron;enia faxu"}},[_vm._v("\n     Zmena rozlíšenia faxu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"adjusting-fax-darkness-topic.html#adjusting-fax-darkness_sk","title":"Nastavenie tmavosti faxu"}},[_vm._v("\n     Nastavenie tmavosti faxu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-fax-log-topic.html#printing-fax-log_sk","title":"Tlač denn&iacute;ka faxov"}},[_vm._v("\n     Tlač denníka faxov\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"blocking-junk-faxes-topic.html#blocking-junk-faxes_sk","title":"Blokovanie nevyžiadan&yacute;ch faxov"}},[_vm._v("\n     Blokovanie nevyžiadaných faxov\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"holding-faxes-topic.html#holding-faxes_sk","title":"Zadržiavanie faxov"}},[_vm._v("\n     Zadržiavanie faxov\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forwarding-fax-topic.html#forwarding-fax_sk","title":"Posielanie faxov ďalej"}},[_vm._v("\n     Posielanie faxov ďalej\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"FTP.html#FTP_sk","title":"Skenovanie"}},[_vm._v("\n    Skenovanie\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e7314"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"using-ADF-and-scanner-glass-scan-topic.html#using-ADF-and-scanner-glass-scan_sk","title":"Použ&iacute;vanie automatick&eacute;ho pod&aacute;vača dokumentov a&nbsp;skenovacieho skla"}},[_vm._v("\n     Používanie automatického podávača dokumentov a skenovacieho skla\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-computer-topic.html#scanning-to-computer_sk","title":"Skenovanie do poč&iacute;tača"}},[_vm._v("\n     Skenovanie do počítača\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_sk","title":"Skenovanie na server FTP"}},[_vm._v("\n     Skenovanie na server FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-FTP-shortcut-topic.html#creating-FTP-shortcut_sk","title":"Vytvorenie skratky pre FTP"}},[_vm._v("\n     Vytvorenie skratky pre FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"s2a-scanning-to-network-folders-topic.html#s2a-scanning-to-network-folders_sk","title":"Skenovanie do sieťov&eacute;ho priečinka"}},[_vm._v("\n     Skenovanie do sieťového priečinka\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_sk","title":"Vytvorenie skratky pre sieťov&yacute; priečinok"}},[_vm._v("\n     Vytvorenie skratky pre sieťový priečinok\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"scanning-to-flash-drive-topic.html#scanning-to-flash-drive_sk","title":"Skenovanie na pam&auml;ťov&uacute; jednotku flash"}},[_vm._v("\n     Skenovanie na pamäťovú jednotku flash\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_sk","title":"Použ&iacute;vanie pon&uacute;k tlačiarne"}},[_vm._v("\n    Používanie ponúk tlačiarne\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e7614"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-map-mfp-topic.html#menu-map-mfp_sk","title":"Mapa pon&uacute;k"}},[_vm._v("\n     Mapa ponúk\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"preferences-topic.html#d0e7995","title":"Zariadenie"}},[_vm._v("\n     Zariadenie\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"layout-topic.html#d0e10329","title":"Tlač"}},[_vm._v("\n     Tlač\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"tray-configuration-topic.html#d0e11492","title":"Papier"}},[_vm._v("\n     Papier\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"copy-defaults-topic.html#d0e11852","title":"Kop&iacute;rovanie"}},[_vm._v("\n     Kopírovanie\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"fax-defaults-subgroup.html#d0e12425","title":"Fax"}},[_vm._v("\n     Fax\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"email-setup-topic.html#d0e14853","title":"E-mail"}},[_vm._v("\n     E-mail\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ftp-defaults-topic.html#d0e15869","title":"FTP"}},[_vm._v("\n     FTP\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"flash-drive-scan-topic.html#d0e16515","title":"Jednotka USB"}},[_vm._v("\n     Jednotka USB\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"network-overview-topic.html#d0e17316","title":"Sieť/porty"}},[_vm._v("\n     Sieť/porty\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"login-methods-subgroup.html#d0e19460","title":"Zabezpečenie"}},[_vm._v("\n     Zabezpečenie\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cloud-services-enrollment-topic.html#d0e20610","title":"Cloudov&eacute; služby"}},[_vm._v("\n     Cloudové služby\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"menu-settings-page-topic.html#d0e20667","title":"Spr&aacute;vy"}},[_vm._v("\n     Správy\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"troubleshooting-menu-topic.html#troubleshooting-menu_sk","title":"Rie&scaron;enie probl&eacute;mov"}},[_vm._v("\n     Riešenie problémov\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"forms-merge-topic.html#forms-merge_sk","title":"Forms Merge"}},[_vm._v("\n     Forms Merge\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printing-menu-settings-page-topic.html#printing-menu-settings-page_sk","title":"Tlač strany nastaven&iacute; pon&uacute;k"}},[_vm._v("\n     Tlač strany nastavení ponúk\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"maintain-printer-chapter.html#maintain-printer-chapter_sk","title":"&Uacute;držba tlačiarne"}},[_vm._v("\n    Údržba tlačiarne\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e21210"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_sk","title":"Kontrola stavu s&uacute;čast&iacute; a&nbsp;spotrebn&eacute;ho materi&aacute;lu"}},[_vm._v("\n     Kontrola stavu súčastí a spotrebného materiálu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-supply-notifications-topic.html#configuring-supply-notifications_sk","title":"Konfigur&aacute;cia ozn&aacute;men&iacute; o&nbsp;spotrebnom materi&aacute;li"}},[_vm._v("\n     Konfigurácia oznámení o spotrebnom materiáli\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_sk","title":"Nastavenie upozornen&iacute; e-mailom"}},[_vm._v("\n     Nastavenie upozornení e-mailom\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"viewing-reports-topic.html#viewing-reports_sk","title":"Zobrazenie spr&aacute;v"}},[_vm._v("\n     Zobrazenie správ\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"ordering-supplies-group.html#ordering-supplies-group_sk","title":"Objedn&aacute;vanie s&uacute;čast&iacute; a&nbsp;spotrebn&eacute;ho materi&aacute;lu"}},[_vm._v("\n     Objednávanie súčastí a spotrebného materiálu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"replacing-toner-cartridge-topic.html#d0e21541","title":"V&yacute;mena s&uacute;čast&iacute; a&nbsp;spotrebn&eacute;ho materi&aacute;lu"}},[_vm._v("\n     Výmena súčastí a spotrebného materiálu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"cleaning-printer-topic.html#d0e21882","title":"Čistenie s&uacute;čast&iacute; tlačiarne"}},[_vm._v("\n     Čistenie súčastí tlačiarne\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"configuring-power-save-mode-settings-topic.html#d0e22029","title":"&Uacute;spora energie a&nbsp;papiera"}},[_vm._v("\n     Úspora energie a papiera\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"moving-printer-topic.html#moving-printer_sk","title":"Premiestnenie tlačiarne na in&eacute; miesto"}},[_vm._v("\n     Premiestnenie tlačiarne na iné miesto\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"shipping-printer-topic.html#shipping-printer_sk","title":"Doprava tlačiarne"}},[_vm._v("\n     Doprava tlačiarne\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"troubleshooting-chapter.html#troubleshooting-chapter_sk","title":"Rie&scaron;enie probl&eacute;mov"}},[_vm._v("\n    Riešenie problémov\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e22182"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"print-quality-problems-picker-topic.html#print-quality-problems-picker_sk","title":"Probl&eacute;my s kvalitou tlače"}},[_vm._v("\n     Problémy s kvalitou tlače\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"printer-error-codes-topic.html#printer-error-codes_sk","title":"Chybov&eacute; k&oacute;dy tlačiarne"}},[_vm._v("\n     Chybové kódy tlačiarne\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"solving-printing-problems.html#solving-printing-problems_sk","title":"Probl&eacute;my s&nbsp;tlačou"}},[_vm._v("\n     Problémy s tlačou\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-printer-not-responding-topic.html#trb-printer-not-responding_sk","title":"Tlačiareň nereaguje"}},[_vm._v("\n     Tlačiareň nereaguje\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_sk","title":"Nemožno č&iacute;tať pam&auml;ťov&uacute; jednotku flash"}},[_vm._v("\n     Nemožno čítať pamäťovú jednotku flash\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"enabling-usb-port-topic.html#enabling-usb-port_sk","title":"Zapnutie portu USB"}},[_vm._v("\n     Zapnutie portu USB\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"clearing-jams.html#clearing-jams_sk","title":"Odstr&aacute;nenie zaseknut&eacute;ho papiera"}},[_vm._v("\n     Odstránenie zaseknutého papiera\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-open-embedded-web-server-topic.html#d0e25832","title":"Probl&eacute;my so sieťov&yacute;m pripojen&iacute;m"}},[_vm._v("\n     Problémy so sieťovým pripojením\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-detect-internal-option-topic.html#d0e26060","title":"Probl&eacute;my s&nbsp;hardv&eacute;rov&yacute;mi voliteľn&yacute;mi prvkami"}},[_vm._v("\n     Problémy s hardvérovými voliteľnými prvkami\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"message-replace-cartridge-printer-region-mismatch-topic.html#d0e26208","title":"Probl&eacute;my so&nbsp;spotrebn&yacute;m materi&aacute;lom"}},[_vm._v("\n     Problémy so spotrebným materiálom\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-envelope-seals-when-printing-topic.html#d0e26328","title":"Probl&eacute;my s&nbsp;pod&aacute;van&iacute;m papiera"}},[_vm._v("\n     Problémy s podávaním papiera\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"disabling-smtp-server-not-setup-error-topic.html#d0e26690","title":"Probl&eacute;my s&nbsp;e-mailami"}},[_vm._v("\n     Problémy s e-mailami\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-caller-id-not-shown-topic.html#d0e26782","title":"Probl&eacute;my s&nbsp;faxovan&iacute;m"}},[_vm._v("\n     Problémy s faxovaním\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-cannot-scan-to-computer-topic.html#d0e27419","title":"Probl&eacute;my so skenovan&iacute;m"}},[_vm._v("\n     Problémy so skenovaním\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"trb-contacting-customer-support-topic.html#trb-contacting-customer-support_sk","title":"Kontaktovanie podpory pre z&aacute;kazn&iacute;kov"}},[_vm._v("\n     Kontaktovanie podpory pre zákazníkov\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"recycle-dispose-chapter.html#recycle-dispose-chapter_sk","title":"Recykl&aacute;cia a likvid&aacute;cia"}},[_vm._v("\n    Recyklácia a likvidácia\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e28196"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-products-topic.html#recycling-lexmark-products_sk","title":"Recykl&aacute;cia produktov Lexmark"}},[_vm._v("\n     Recyklácia produktov Lexmark\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_sk","title":"Recykl&aacute;cia obalov Lexmark"}},[_vm._v("\n     Recyklácia obalov Lexmark\n    ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"toc-1-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser_ug_notices_sk","title":"Ozn&aacute;menia"}},[_vm._v("\n    Oznámenia\n   ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"divd0e28233"}},[_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28236","title":"Inform&aacute;cie o&nbsp;produkte"}},[_vm._v("\n     Informácie o produkte\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28253","title":"Pozn&aacute;mky k&nbsp;vydaniu"}},[_vm._v("\n     Poznámky k vydaniu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#trademarks_sk","title":"Ochrann&eacute; zn&aacute;mky"}},[_vm._v("\n     Ochranné známky\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#licensing-notices_sk","title":"Inform&aacute;cie o&nbsp;licencovan&iacute;"}},[_vm._v("\n     Informácie o licencovaní\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#noise-emission-levels_sk","title":"Hladiny emisi&iacute; hluku"}},[_vm._v("\n     Hladiny emisií hluku\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#weee-directive_sk","title":"Smernica o&nbsp;odpade z&nbsp;elektrick&yacute;ch a&nbsp;elektronick&yacute;ch zariaden&iacute; (WEEE)"}},[_vm._v("\n     Smernica o odpade z elektrických a elektronických zariadení (WEEE)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28359","title":"Nab&iacute;jateľn&aacute; l&iacute;tium-i&oacute;nov&aacute; bat&eacute;ria"}},[_vm._v("\n     Nabíjateľná lítium-iónová batéria\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#eu-battery-directive-2023-1542_sk","title":"Nariadenie (E&Uacute;) 2023/1542"}},[_vm._v("\n     Nariadenie (EÚ) 2023/1542\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28397","title":"Environmental labeling for packaging"}},[_vm._v("\n     Environmental labeling for packaging\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#product-disposal_sk","title":"Likvid&aacute;cia produktu"}},[_vm._v("\n     Likvidácia produktu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_sk","title":"Vr&aacute;tenie kaziet Lexmark na op&auml;tovn&eacute; použitie alebo recykl&aacute;ciu"}},[_vm._v("\n     Vrátenie kaziet Lexmark na opätovné použitie alebo recykláciu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#static-sensitivity-notice_sk","title":"Upozornenie o&nbsp;statickej citlivosti"}},[_vm._v("\n     Upozornenie o statickej citlivosti\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#energy-star_sk","title":"ENERGY STAR"}},[_vm._v("\n     ENERGY STAR\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#temperature-information_sk","title":"Inform&aacute;cie o teplot&aacute;ch"}},[_vm._v("\n     Informácie o teplotách\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#laser-notice_sk","title":"Vyhl&aacute;senie o&nbsp;laserovom zariaden&iacute;"}},[_vm._v("\n     Vyhlásenie o laserovom zariadení\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#power-consumption_sk","title":"Spotreba energie"}},[_vm._v("\n     Spotreba energie\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#regulatory-notices-for-telecommunication-terminal-equipment_sk","title":"Regulačn&eacute; upozornenia t&yacute;kaj&uacute;ce sa koncov&yacute;ch telekomunikačn&yacute;ch zariaden&iacute;"}},[_vm._v("\n     Regulačné upozornenia týkajúce sa koncových telekomunikačných zariadení\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28661","title":"Regulačn&eacute; upozornenia t&yacute;kaj&uacute;ce sa bezdr&ocirc;tov&yacute;ch produktov."}},[_vm._v("\n     Regulačné upozornenia týkajúce sa bezdrôtových produktov.\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#modular-component-notice_sk","title":"Pozn&aacute;mka o&nbsp;&scaron;tandardn&yacute;ch komponentoch"}},[_vm._v("\n     Poznámka o štandardných komponentoch\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#exposure-to-radio-frequency-radiation_sk","title":"Vystavenie r&aacute;diofrekvenčn&eacute;mu žiareniu"}},[_vm._v("\n     Vystavenie rádiofrekvenčnému žiareniu\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#d0e28686","title":"Zhoda so smernicami Eur&oacute;pskeho spoločenstva (ES)"}},[_vm._v("\n     Zhoda so smernicami Európskeho spoločenstva (ES)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#european-community-ec-directives-conformity-class-a_sk","title":"Zhoda so smernicami Eur&oacute;pskeho spoločenstva (ES)"}},[_vm._v("\n     Zhoda so smernicami Európskeho spoločenstva (ES)\n    ")])]),_vm._v(" "),_c('p',{staticClass:"toc-2-style"},[_c('a',{attrs:{"href":"laser_ug_notices.html#radio-interference-notice_sk","title":"Upozornenie o&nbsp;r&aacute;diovej interferencii"}},[_vm._v("\n     Upozornenie o rádiovej interferencii\n    ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// build.js